/* eslint-disable max-len */
const exchangesobject = [
    {
        id: 'paribu',
        name: 'Paribu',
        // eslint-disable-next-line max-len
        description: 'Paribu, which was established in Turkey in 2017, is a digital assets trading platform with the highest transaction volume in Turkey. Paribu offers TRY fiat currency/crypto currency transaction services to its users while providing them with 24/7 support and trading services. Paribu trades in 18 crypto currencies including Bitcoin.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        twitter: 'https://twitter.com/paribucom',
        website: 'https://www.paribu.com/',
        markets_data_fetched: true,
        adjusted_rank: 78,
        reported_rank: 89,
        currencies: 34,
        markets: 43,
        fiats: [
            {
                name: 'Turkish Lira',
                symbol: 'TRY',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 81951883.6504997,
                adjusted_volume_24h: 81951883.6504997,
                reported_volume_7d: 634051137.4397386,
                adjusted_volume_7d: 634051137.4397386,
                reported_volume_30d: 3385857283.90987,
                adjusted_volume_30d: 3385857283.90987,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 4870000,
        confidence_score: 0.337855,
    },
    {
        id: 'bl3p',
        name: 'BL3P',
        description: 'Founded in 2012 Bitonic, the company behind BL3P operates out of the Netherlands and more importantly is one of the leading companies in the world of cryptocurrencies there. They have gained a sold reputation after cooperating with the well-known entities in banking and academia. ',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        twitter: 'https://twitter.com/bl3peu',
        website: 'https://bl3p.eu/trade',
        markets_data_fetched: true,
        adjusted_rank: 219,
        reported_rank: 233,
        currencies: 1,
        markets: 1,
        fiats: [
            {
                name: 'Euro',
                symbol: 'EUR',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 658332.25843569,
                adjusted_volume_24h: 658332.25843569,
                reported_volume_7d: 2825509.23519452,
                adjusted_volume_7d: 2825509.23519452,
                reported_volume_30d: 11291985.47931303,
                adjusted_volume_30d: 11291985.47931303,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0.346107,
    },
    {
        id: 'furxe',
        name: 'Furxe',
        description: 'We are Global most user-friendly, comprehensive, and secure trading platform to trade in the spot, futures, and options market with multiple funding options, high liquidity, and fast execution. Our coin trade platform, is built for everyone. From beginners to experts, anyone can now buy, sell, trade, and hold cryptocurrencies in worldwide in an easy, fast, and effortless way.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
            twitter: 'https://twitter.com/furxe1',
            website: 'https://furxe.com/home',
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 18199.71352567,
                adjusted_volume_7d: 18199.71352567,
                reported_volume_30d: 3100622.38720685,
                adjusted_volume_30d: 3100622.38720685,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'gemini',
        name: 'Gemini',
        description: 'Gemini is based in New York. The company was founded in 2014. The company is fully regulated and fully compliant. They’re regulated by the New York State Department of Financial Services (NYSDFS). They also abide by capital reserve requirements and banking compliance standards.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
            twitter: 'https://twitter.com/GeminiDotCom',
            website: 'https://gemini.com/',
        markets_data_fetched: true,
        adjusted_rank: 80,
        reported_rank: 91,
        currencies: 44,
        markets: 69,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
            {
                name: 'Euro',
                symbol: 'EUR',
            },
            {
                name: 'Pound Sterling',
                symbol: 'GBP',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 80777321.99527471,
                adjusted_volume_24h: 80777321.99527471,
                reported_volume_7d: 617345028.2320613,
                adjusted_volume_7d: 617345028.2320613,
                reported_volume_30d: 3027472017.1957016,
                adjusted_volume_30d: 3027472017.1957016,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 23400000,
        confidence_score: 0.790875,
    },
    {
        id: 'trexexchange',
        name: 'Trexexchange',
        description: 'TREX-EXCHANGE The TREX platform is a transaction-mining system.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
            twitter: 'https://twitter.com/ExchangeTrex',
            website: 'https://trexexchange.io',
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'wbb-exchange',
        name: 'WBB Exchange',
        description: 'WBB Exchange is a modern, safe Trading Platform for accessing cryptocurrency exchange markets with very simple interface and low trading fees. Our own API is easy-to-use, supplied with an instructional manual. Our Support Service communicates in Russian and English and replies to the Customers’ requests 7 days a week within working hours (UTC+3).',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        twitter: 'https://twitter.com/WorldBitBank',
        website: 'https://wbbexchange.pro',
        markets_data_fetched: true,
        adjusted_rank: 365,
        reported_rank: 364,
        currencies: 14,
        markets: 44,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
            {
                name: 'Russian Ruble',
                symbol: 'RUB',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'mushino',
        name: 'Mushino',
        description: 'Mushino is a peer-to-peer cryptocurrency futures exchange that was established in 2019. Based in Hong Kong, it serves a global client base of both retail and institutional traders.\r\n\r\nThe platform features a unique ladder interface that is ideal for scalpers, daytraders and anyone who wants to capitalize on short term price movements.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        twitter: 'https://twitter.com/mushinodotcom',
        website: 'https://mushino.com',
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'bitasset',
        name: 'BitAsset',
        description: "BitAsset is a leading global financial trading platform of digital assets. It supports a variety financial services such as fiat currency deposits with numerous deposit methods and currencies, wallet custody, spot trading, margin trading and short selling. With BitAsset, users have access to various professional financial products for digital assets such as futures, derivatives and index ETFs. The platform also provides an automated market monitoring system to warn users of transaction risks in advance and guarantee the safety of users' asset. BitAsset forms a complete digital banking system with a professional team composing more than 1,000 account managers to provide 24/7 advisory services and support to traders.",
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        twitter: 'https://twitter.com/BitAssetUS',
        website: 'https://www.bitasset.com',
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'fex',
        name: 'fex',
        description: 'FEX is a crypto-to-crypto exchange operating out of Hong Kong and mostly targeting the Chinese audience. Trading is done against BTC, ETH and USDT.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        twitter: 'https://twitter.com/FEXHK1',
        website: 'https://fexpro.net/',
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'vexchange',
        name: 'Vexchange',
        description: 'Vexchange is a fork of Uniswap with support for governance-adjustable swap & platform fees. The swap fees can be adjusted from 5bps to 200bps and the platform fees can be adjusted from 0bps to 5000bps (platform fee is charged on LP profits, swap fee is trade fee).\r\n\r\nVexchange runs on the VeChainThor blockchain and is a integral part of the VeChain DeFi ecosystem',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        twitter: 'https://twitter.com/vexchangeio',
        website: 'https://vexchange.io/',
        markets_data_fetched: true,
        adjusted_rank: 236,
        reported_rank: 250,
        currencies: 7,
        markets: 16,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 263839.66301046,
                adjusted_volume_24h: 263839.66301046,
                reported_volume_7d: 1546244.64079779,
                adjusted_volume_7d: 1546244.64079779,
                reported_volume_30d: 7487776.87197258,
                adjusted_volume_30d: 7487776.87197258,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 190000,
        confidence_score: 0,
    },
    {
        id: 'kanga-exchange',
        name: 'Kanga',
        description: 'Kanga Exchange is a dedicated platform for all ICO market participants, i.e. investors, creators, brokers, and so on. The heart of the project is a cryptocurrency and token exchange; however, the founders’ goal is to create a site that not only allows for cryptographic asset trading but also\r\nprovides token creation tools, transaction processing mechanisms for ICO project customers preferring means of payment other that the ICO token (e.g. BTC, USD, EUR, etc.), and many other features.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        twitter: 'https://twitter.com/KangaExchange',
        website: 'https://kanga.exchange',
        markets_data_fetched: true,
        adjusted_rank: 125,
        reported_rank: 138,
        currencies: 34,
        markets: 53,
        fiats: [
            {
                name: 'Euro',
                symbol: 'EUR',
            },
            {
                name: 'Polish Zloty',
                symbol: 'PLN',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 17594607.64207846,
                adjusted_volume_24h: 17594607.64207846,
                reported_volume_7d: 122415517.08146463,
                adjusted_volume_7d: 122415517.08146463,
                reported_volume_30d: 328386714.37403345,
                adjusted_volume_30d: 328386714.37403345,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 170000,
        confidence_score: 0.155894,
    },
    {
        id: 'quickswap',
        name: 'QuickSwap',
        description: 'Next-gen Layer 2 DEX. Trade at lightning-fast speeds with near-zero gas fees. Powered by Polygon Network.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        twitter: 'https://twitter.com/QuickswapDEX',
        website: 'https://quickswap.exchange/',
        markets_data_fetched: true,
        adjusted_rank: 112,
        reported_rank: 124,
        currencies: 168,
        markets: 549,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 26436059.24013561,
                adjusted_volume_24h: 26436059.24013561,
                reported_volume_7d: 205478870.66013262,
                adjusted_volume_7d: 205478870.66013262,
                reported_volume_30d: 755681982.3494188,
                adjusted_volume_30d: 755681982.3494188,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 6260000,
        confidence_score: 0.002529,
    },
    {
        id: 'xbtpro',
        name: 'XBTPro',
        description: 'XBTPro is a new cryptocurrency exchange, which claims to aim to provide users around the globe with a fast and secure trading experience.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        twitter: 'https://twitter.com/@xbtpro',
        website: 'https://xbtpro.com',
        markets_data_fetched: true,
        adjusted_rank: 191,
        reported_rank: 205,
        currencies: 11,
        markets: 15,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 1972604.52188955,
                adjusted_volume_24h: 1972604.52188955,
                reported_volume_7d: 14381392.40137507,
                adjusted_volume_7d: 14381392.40137507,
                reported_volume_30d: 62389524.48669069,
                adjusted_volume_30d: 62389524.48669069,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0.707948,
    },
    {
        id: 'united-exchange',
        name: 'United Exchange',
        description: 'United Exchange has become a one-stop destination for the trading of digital assets as we provide trading in multiple currencies such as Bitcoin, Ethereum, Litecoin, Ripple and more, so any client of ours would not need to go through hundreds and thousands of other websites to compare and execute all their trading needs. The website which mostly acts as a gateway for the trading of digital assets also provides a safe space for the user to store their cryptocurrency, which are cold wallets- the most secure way to store cryptocurrencies. Cold wallets are the most secure way to store cryptocurrencies for the sole reason that they are inaccessible via the internet, i.e. it’s impossible to reach them through the internet as they are physical devices without any link to online systems. So, it would be virtually impossible to hack into the ‘cold wallets’ and thus the client’s funds are in literal safe hands. Unlike other exchanges, funds stored on United Exchange cannot be accessed in any way whatsoever by any third-party other than the clients and the exchange. To put it simple, United Exchange and the funds stored on it are hack-proof.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        twitter: 'https://twitter.com/exchange_united',
        website: 'https://unitedexchange.io',
        markets_data_fetched: true,
        adjusted_rank: 186,
        reported_rank: 200,
        currencies: 10,
        markets: 9,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 2611681.59260705,
                adjusted_volume_24h: 2611681.59260705,
                reported_volume_7d: 4260107.57448662,
                adjusted_volume_7d: 4260107.57448662,
                reported_volume_30d: 20315267.59597057,
                adjusted_volume_30d: 20315267.59597057,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 20000,
        confidence_score: 0.000008,
    },
    {
        id: 'primexbt',
        name: 'PrimeXBT',
        description: 'A revolutionary trading platform that features the most extensive trading toolset in the market. \r\n\r\nPrimeXBT offers features unlike any other trading platform, but is still using a simple user interface so both professional traders and beginner traders can make the most use of the platform.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        twitter: 'https://twitter.com/primexbt',
        website: 'https://primexbt.com/',
        markets_data_fetched: true,
        adjusted_rank: 44,
        reported_rank: 51,
        currencies: 5,
        markets: 9,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 311734492.16142744,
                adjusted_volume_24h: 311734492.16142744,
                reported_volume_7d: 3017416204.77563,
                adjusted_volume_7d: 3017416204.77563,
                reported_volume_30d: 13599340525.891813,
                adjusted_volume_30d: 13599340525.891813,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 4120000,
        confidence_score: 0.750258,
    },
    {
        id: 'cryptlocex',
        name: 'CryptloCEX',
        description: "CryptloCEX is a centralized exchange with it's native token Cryptlo (CLO).",
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        twitter: 'https://twitter.com/CryptloDEX',
        website: 'https://cryptlocex.com',
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'acx',
        name: 'ACX',
        description: 'ACX is an Australian cryptocurrency exchange that operates since 2016. It is owned by the Hong Kong-based Peak HK Limited. The company also operates a Cryptocurrency Arbitrage Fund since 2013. ACX works only with Australian bank accounts and does not provide support for other fiat currencies than AUD.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        twitter: 'https://twitter.com/ACXTWEET',
        website: 'https://acx.io/',
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'coinroom',
        name: 'Coinroom',
        description: 'Coinroom is a Polish digital currency exchange where people can buy or sell several of the larger digital currencies. According to the timeline on its own site, it was incepted in 2015 and launched in April 2017. It says it provides services in almost all countries across the world, except Russia and USA.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'Coinroom was closed on 2nd April 2019. There are reports of difficulties with withdrawing assets from the exchange after the closure.',
        twitter: 'https://twitter.com/Coinroom_com',
        website: 'https://coinroom.com/',
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'coincorner',
        name: 'CoinCorner',
        description: 'The company behind the CoinCorner site is CoinCorner Ltd, and it is based at 2nd Floor Office Suite, St. James’ Chambers, 64A Athol Street, Douglas, IM1 1JE, Isle of Man. CoinCorner is registered under the number 129003C and it is authorized by Isle of Man authorities to conduct business involving virtual currencies, founded in 2014. CoinCorner is a cryptocurrency exchange focused on European (initially primarily UK) operations. Only EUR and GBP are supported as fiat currencies. CoinCorner’s co-founders are Bitcoin celebrities Phil Collins and Daniel Scott.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        twitter: 'https://twitter.com/CoinCorner',
        website: 'https://www.coincorner.com/',
        markets_data_fetched: true,
        adjusted_rank: 227,
        reported_rank: 241,
        currencies: 1,
        markets: 2,
        fiats: [
            {
                name: 'Euro',
                symbol: 'EUR',
            },
            {
                name: 'Pound Sterling',
                symbol: 'GBP',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 434418.85248947,
                adjusted_volume_24h: 434418.85248947,
                reported_volume_7d: 3210886.36717766,
                adjusted_volume_7d: 3210886.36717766,
                reported_volume_30d: 16165167.64541891,
                adjusted_volume_30d: 16165167.64541891,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 50000,
        confidence_score: 0,
    },
    {
        id: 'apollox-dex',
        name: 'ApolloX DEX',
        description: 'Launched on 15 November 2021, ApolloX DEX is a decentralized exchange that supports trading of perpetual futures contracts, making ApolloX the first CEX-DEX hybrid derivatives exchange. The ApolloX CEX was launched in September 2021.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        twitter: 'https://twitter.com/ApolloX_com',
        website: 'https://www.apollox.finance/en',
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 270000,
        confidence_score: 0,
    },
    {
        id: 'c-patex',
        name: 'C-Patex',
        description: 'C-PatEx is a digital asset platform, based in Argentina. It offers low-cost trading in quite a lot cryptocurrencies. In order to use C-PatEx, crypto-traders need to verify their e-mail address. To withdraw, they must verified their identity either by Two Factor Authentication (2FA) or a code sent via SMS. C-PatEx is a a relatively small exchange, launched and operated by a family team from Patagonia, Argentina. Behind the brand is the company MAG Sistemas, founded and managed by Miguel Angel Grau. ',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        twitter: 'https://twitter.com/c_patex',
        website: 'https://c-patex.com/',
        markets_data_fetched: true,
        adjusted_rank: 309,
        reported_rank: 324,
        currencies: 36,
        markets: 83,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 85.06917699,
                adjusted_volume_24h: 85.06917699,
                reported_volume_7d: 1237.04906094,
                adjusted_volume_7d: 1237.04906094,
                reported_volume_30d: 7008.47611137,
                adjusted_volume_30d: 7008.47611137,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 20000,
        confidence_score: 0,
    },
    {
        id: 'coinjar-exchange',
        name: 'CoinJar',
        description: 'CoinJar Exchange is an advanced digital currency exchange that supports high-frequency, low-latency execution for experienced traders. Founded in Australia, CoinJar also offers brokerage and wallet service.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        twitter: 'https://twitter.com/GetCoinJar',
        website: 'https://exchange.coinjar.com/',
        markets_data_fetched: true,
        adjusted_rank: 192,
        reported_rank: 206,
        currencies: 7,
        markets: 18,
        fiats: [
            {
                name: 'Australian Dollar',
                symbol: 'AUD',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 1914777.84668864,
                adjusted_volume_24h: 1914777.84668864,
                reported_volume_7d: 24823152.00655873,
                adjusted_volume_7d: 24823152.00655873,
                reported_volume_30d: 159412472.99110228,
                adjusted_volume_30d: 159412472.99110228,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 450000,
        confidence_score: 0.020921,
    },
    {
        id: 'coinchangex',
        name: 'CoinChangeX',
        description: 'CoinChangeX is a decentralized Ethereum Token Exchange that allows users to securely trade ETH and Ethereum-based tokens.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
            twitter: 'https://twitter.com/coinchangex',
            website: 'https://www.coinchangex.com',
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'chainrift',
        name: 'ChainRift',
        description: 'High-performance cryptocurrency exchange led by an agile team - prime focus is listing legitimate cryptocurrency tokens.\r\n\r\nIncorporated in Wyoming USA, we are dedicated to doing things by the book and following regulatory guidelines in both our listing process, as well as our management of liquidity and market making on the exchange.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        twitter: 'https://twitter.com/chainrift',
        website: 'https://www.chainrift.com/',
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'bitflyer',
        name: 'bitFlyer',
        description: 'BitFlyer is a Japanese bitcoin exchange founded in 2014. the Japanese-based bitcoin exchange has raised $36.11 million in 7 rounds from 10 investors since being founded. Those investors include big names like Digital Currency Group.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        twitter: 'https://twitter.com/bitFlyer',
        website: 'https://bitflyer.com/en-eu/',
        ts_data_fetched: true,
        adjusted_rank: 81,
        reported_rank: 92,
        currencies: 3,
        markets: 6,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
            {
                name: 'Euro',
                symbol: 'EUR',
            },
            {
                name: 'Japanese Yen',
                symbol: 'JPY',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 75583094.06520835,
                adjusted_volume_24h: 75583094.06520835,
                reported_volume_7d: 658357101.4337604,
                adjusted_volume_7d: 658357101.4337604,
                reported_volume_30d: 3729196116.7383847,
                adjusted_volume_30d: 3729196116.7383847,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 60000,
        confidence_score: 0.800024,
    },
    {
        id: 'btcex',
        name: 'BTCEX',
        description: 'BTCEX is a highly extensible digital asset trading platform, which provides spot, spot leverage, futures, perpetual contracts, and USDT-settled options. In addition, it also supports multi-product portfolio margin models to improve the utilization of user funds.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        twitter: 'https://twitter.com/BTCEX_exchange',
        website: 'https://www.btcex.com/',
        markets_data_fetched: true,
        adjusted_rank: 34,
        reported_rank: 41,
        currencies: 15,
        markets: 14,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 548280332.8986275,
                adjusted_volume_24h: 548280332.8986275,
                reported_volume_7d: 4204070903.2557144,
                adjusted_volume_7d: 4204070903.2557144,
                reported_volume_30d: 13322146695.224623,
                adjusted_volume_30d: 13322146695.224623,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 5470000,
        confidence_score: 0.003206,
    },
    {
        id: 'xt',
        name: 'XT',
        description: "Founded in 2018, XT Exchange is the world's first socialized digital asset trading platform. The platform has a global top-level domain name XT.com, with more than 2 million registered users, more than 200,000 active users monthly, and more than 7 million users in the ecosystem.",
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        twitter: 'https://twitter.com/XTexchange',
        website: 'https://www.xt.com/',
        markets_data_fetched: true,
        adjusted_rank: 25,
        reported_rank: 30,
        currencies: 166,
        markets: 181,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 854662841.6362981,
                adjusted_volume_24h: 854662841.6362981,
                reported_volume_7d: 5153618363.178389,
                adjusted_volume_7d: 5153618363.178389,
                reported_volume_30d: 33723000388.185307,
                adjusted_volume_30d: 33723000388.185307,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 25000000,
        confidence_score: 0.605333,
    },
    {
        id: 'picostocks',
        name: 'PicoStocks',
        description: 'High-tech startup fundraising, evaluation and profit sharing platform.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        twitter: 'https://twitter.com/picostocks',
        website: 'https://picostocks.com',
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'raido-finance',
        name: 'Raido Finance',
        description: 'Regulated Digital Asset Exchange.\r\nWe ensure the turnover of cryptocurrency assets and digitized assets. Our company is based in Estonia, Tallinn.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        twitter: 'https://twitter.com/financialraido',
        website: 'https://raidofinance.eu/',
        markets_data_fetched: true,
        adjusted_rank: 338,
        reported_rank: 361,
        currencies: 2,
        markets: 1,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'queendex-exchange',
        name: 'QueenDex Exchange',
        description: 'QueenDex Fast Growing Cryptocurrency Exchange Platform.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        twitter: 'https://twitter.com/QueenDex_io',
        website: 'http://queendex.io/',
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'satoexchange',
        name: 'SatoExchange',
        description: 'SatoExchange is a centralized crypto currency exchange trading alt coins in BTC, ETH, $SATX, USD and DOGE pairs. Started operations from 19th May, 2018 Simple/easy-to-use interface low trade and withdrawal fees excellent security swift support system fastest order and withdrawal processing, which have over 150k members and are happy.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/satoexchange',
            ],
            website: [
                'https://www.satoexchange.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 304,
        reported_rank: 319,
        currencies: 32,
        markets: 73,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 152.30719028,
                adjusted_volume_24h: 152.30719028,
                reported_volume_7d: 955.46961193,
                adjusted_volume_7d: 955.46961193,
                reported_volume_30d: 16600.06250716,
                adjusted_volume_30d: 16600.06250716,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 40000,
        confidence_score: 0,
    },
    {
        id: 'lgo',
        name: 'LGO',
        description: 'LGO exchange is a platform based on a new decentralized blockchain protocol that provides full transparency for users preventing any kind of manipulation in this way. It employs a hybrid model of exchange designed to combine the features of centralized and decentralized architectures thus using the best features of them both. They include, for instance, such benefits as fiat support, good authentication, simplicity, transparency, and fairness. The system of this kind merges the standards of traditional markets with the potential delivered by blockchain and cryptography. LGO assures that it is the number one Bitcoin exchange in France and number two in Europe by daily trading volume.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/LGOGroup_',
            ],
            website: [
                'https://lgo.group/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'coingi',
        name: 'Coingi',
        description: 'Coingi is a cryptocurrency exchange that launched in 2014. Initially it was only offering crypto-to-crypto trading, but recently it also introduced the option to trade cryptocurrency for EUR, USD and CZK. Coingi accepts client globally and has its site localized in a large number of languages, including the major European languages, several Central and East European, Russian, Arabic and Chinese.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/coingi',
            ],
            website: [
                'https://coingi.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 280,
        reported_rank: 295,
        currencies: 1,
        markets: 1,
        fiats: [
            {
                name: 'Czech Koruna',
                symbol: 'CZK',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 5986.63902424,
                adjusted_volume_24h: 5986.63902424,
                reported_volume_7d: 43895.43362478,
                adjusted_volume_7d: 43895.43362478,
                reported_volume_30d: 227554.83113573,
                adjusted_volume_30d: 227554.83113573,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'cryptocom-exchange',
        name: 'Crypto.com Exchange',
        description: 'Crypto.com exchange is powered by CRO, with deep liquidity, low fees and best execution prices, you can trade Bitcoin and Altcoins with the best experience.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/cryptocom',
            ],
            website: [
                'https://crypto.com/exchange',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 8,
        reported_rank: 11,
        currencies: 23,
        markets: 49,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 2531314837.7724614,
                adjusted_volume_24h: 2531314837.7724614,
                reported_volume_7d: 19975691464.476223,
                adjusted_volume_7d: 19975691464.476223,
                reported_volume_30d: 89360204009.77806,
                adjusted_volume_30d: 89360204009.77806,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 28900000,
        confidence_score: 0.060393,
    },
    {
        id: 'lukki',
        name: 'Lukki',
        description: 'We are Lukki exchange. Our name is in tune with the word “luck” not without reason. Our main goal is your convenience. Lukki is designed in such a way that you can start your trading path with maximum comfort and all the necessary tools. Trading on a crypto exchange is not always an exciting process that we usually see in movies. Most of the time, traders look at charts that jump from side to side.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/ExchangeLukki',
            ],
            website: [
                'https://lukki.io',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'utrade',
        name: 'uTrade',
        description: 'uTrade is the AMM built using Protocol smart contracts. uTrade V2 offers enhanced support and exciting new opportunities for DeFi developers.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/unifiprotocol',
            ],
            website: [
                'https://binance.unifiprotocol.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 60000,
        confidence_score: 0,
    },
    {
        id: 'bitkop',
        name: 'BitKop',
        description: 'The BitKop cryptocurrency exchange has over 200,000 registered users. Out of these, 40% use the platform’s native digital currency, KOP coin. The BitKop project understands that security in the blockchain sector requires the efforts of all stakeholders. To this end, the platform strives to ensure that it only admits genuine participants to its ecosystems.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/Bitkopexchange',
            ],
            website: [
                'https://www.bitkop.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'mybitexa',
        name: 'MyBitExa',
        description: 'Launched on 10/10/2019, MyBitExa is a centralized exchange based in 19 Waterfront Drive, Road Town, Tortola VG 1110, British Virgin Islands. It supports crypto trading pairs, crypto deposits, crypto withdrawals, and custodial wallets. The focus is on being a crypto firendly exchange. We also support masternode coins.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/MyBitExa',
            ],
            website: [
                'https://mybitexa.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'virtuse',
        name: 'Virtuse',
        description: 'Virtuse Exchange is a bridge between traditional assets and new crypto markets. The platform allows investors to trade crypto, stocks, commodities, ETFs and indices, all from a single, multi-asset account, without the need to convert to fiat.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://www.virtuse.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 172,
        reported_rank: 186,
        currencies: 4,
        markets: 3,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 3884809.48608241,
                adjusted_volume_24h: 3884809.48608241,
                reported_volume_7d: 29920781.99136712,
                adjusted_volume_7d: 29920781.99136712,
                reported_volume_30d: 130897952.35045,
                adjusted_volume_30d: 130897952.35045,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0.75,
    },
    {
        id: 'stellarterm',
        name: 'Stellarterm',
        description: null,
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://stellarterm.com/#markets',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 810000,
        confidence_score: 0,
    },
    {
        id: 'cryptoindex',
        name: 'CRYPTOINDEX',
        description: 'cryptoindex is a crypto exchange service that focuses on trading that connects Indonesia to global trade and also brings global trade to the role of its users in Indonesia.\r\n\r\nCryptoindex is committed to providing fast, easy, safe and comfortable services as well as competitive transaction fees with customer service services that are always ready to provide information and morning trading solutions for its users.\r\n\r\nCryptoindex is a very easy and easy-to-use platform from beginners to professional levels',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://cryptoindex.id/home',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'stellarport',
        name: 'Stellarport',
        description: 'This is a decentralized exchange that has the goal of bringing Stellar (XLM) to the masses. As a decentralized exchange, Stellarport allows traders to manage their Stellar wallets conveniently by storing their individual private keys. The exchange was launched in 2018 by Stellarport LLC. ',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/stellarportio',
            ],
            website: [
                'https://stellarport.io/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 30000,
        confidence_score: 0,
    },
    {
        id: 'huobi',
        name: 'Huobi',
        description: 'Huobi is a Singapore-based cryptocurrency exchange. Established in China in 2013.\r\n\r\nHuobi Group has been financed by ZhenFund and Sequoia Capital. Its accumulative turnover has exceeded 1.2 trillion USD. It has established compliance service teams in Singapore, Japan, South Korea, United Kingdom, Australia, Canada, Brazil and Hong Kong to deliver its secure and credible digital asset trading and asset management services to millions of users in over 130 countries.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/HuobiGlobal',
            ],
            website: [
                'https://www.hbg.com/en-us/',
                'https://www.hbg.com/?invite_code=hd454&invite_code=hd454&invite_code=hd454&invite_code=hd454&invite_code=hd454&invite_code=hd454&invite_code=hd454&invite_code=hd454&invite_code=hd454',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 12,
        reported_rank: 17,
        currencies: 339,
        markets: 724,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 1537686876.6593118,
                adjusted_volume_24h: 1537686876.6593118,
                reported_volume_7d: 12354005375.63767,
                adjusted_volume_7d: 12354005375.63767,
                reported_volume_30d: 48487578625.400505,
                adjusted_volume_30d: 48487578625.400505,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 90000,
        confidence_score: 0.279644,
    },
    {
        id: 'bibox',
        name: 'Bibox',
        description: 'The site has been in operation since 2017 and provides access to a wide range of coins, in addition, the site makes use of smart AI algorithms that have been designed to aid in the execution of optimal trades and transactions, and helps maximize any potential returns.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/Bibox365',
            ],
            website: [
                'https://www.bibox.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 45,
        reported_rank: 52,
        currencies: 126,
        markets: 184,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 263430773.2121211,
                adjusted_volume_24h: 263430773.2121211,
                reported_volume_7d: 2629012801.2206492,
                adjusted_volume_7d: 2629012801.2206492,
                reported_volume_30d: 10083049975.669388,
                adjusted_volume_30d: 10083049975.669388,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 1900000,
        confidence_score: 0.547321,
    },
    {
        id: 'bitcratic',
        name: 'Bitcratic',
        description: 'Since inception of the Blockchain Centralized Crypto Exchanges are dominating the crypto market and more than 95% transactions are taking place in such exchange. The objective of the Blockchain is to decentralize the world. Bitcratic is here to empower the decentralized exchange. Bitcratic is a decentralized exchange for ERC 20 Tokens. Bitcratic use off-chain order book with On-chain settlement.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/bitcratic',
            ],
            website: [
                'https://www.bitcratic.com',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 286,
        reported_rank: 301,
        currencies: 44,
        markets: 43,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 3798.51390843,
                adjusted_volume_24h: 3798.51390843,
                reported_volume_7d: 11937.23955532,
                adjusted_volume_7d: 11937.23955532,
                reported_volume_30d: 26080.34693754,
                adjusted_volume_30d: 26080.34693754,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'gleec-btc-exchange',
        name: 'Gleec BTC Exchange',
        description: 'Gleec BTC is an exchange that offers a simple interface to manage your crypto transactions and provides a great range of services to help you access the blockchain technology. Our mission is to make cryptocurrencies accessible to a very large audience.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/GleecOfficial',
            ],
            website: [
                'https://exchange.gleec.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 21,
        reported_rank: 26,
        currencies: 4,
        markets: 7,
        fiats: [
            {
                name: 'Euro',
                symbol: 'EUR',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 1156183062.989747,
                adjusted_volume_24h: 1156183062.989747,
                reported_volume_7d: 9450690336.904724,
                adjusted_volume_7d: 9450690336.904724,
                reported_volume_30d: 36168424118.03478,
                adjusted_volume_30d: 36168424118.03478,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 20000,
        confidence_score: 0.000008,
    },
    {
        id: 'bitkonan',
        name: 'BitKonan',
        description: 'BitKonan is a Croatian cryptocurrency exchange which has been running since 2014. The cryptocurrencies available at BitKonan are Bitcoin and Litecoin and they are traded against USD. One of the major benefits of using BitKonan is that this exchange supports USD. Deposits in Croatian Kuna (HRK) are automatically converted to USD. This basically means easy access to cryptocurrencies, which is usually appreciated by newcomers in the crypto-world.',
        active: true,
        website_status: false,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://bitkonan.com',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 314,
        reported_rank: 329,
        currencies: 2,
        markets: 2,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 51.68,
                adjusted_volume_24h: 51.68,
                reported_volume_7d: 3981.19579599,
                adjusted_volume_7d: 3981.19579599,
                reported_volume_30d: 5487.03200835,
                adjusted_volume_30d: 5487.03200835,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 70000,
        confidence_score: 0,
    },
    {
        id: 'mycoinstory',
        name: 'MyCoinStory',
        description: 'MCS is a Cryptocurrency Derivatives Trading Platform built to cater for traders of all kind. Currently offering 24/7 Customer Support and up to 100x Leverage on BTC/USDT trading pairs.\r\n\r\nAs a Trader Centric exchange, traders always come first on MCS. MCS aims to lead the trend of cryptocurrency derivatives trading with a fair, open and accessible platform by consistently evolving through continuous feedback. With MCS, anyone can trade derivatives products without barriers to geography, knowledge, and technology. MCS wants to give all the traders the power to trade like experts with inclusive trading support and sophisticated built-in trading systems to provide an amazing trading experience.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://mycoinstory.com',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 343,
        reported_rank: 143,
        currencies: 2,
        markets: 1,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 13431249.42345513,
                adjusted_volume_24h: 0,
                reported_volume_7d: 96067313.01856522,
                adjusted_volume_7d: 0,
                reported_volume_30d: 414606919.3071039,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'mercuriex',
        name: 'MercuriEx',
        description: '',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/_mercuriex_',
            ],
            website: [
                'https://mercuriex.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'einax',
        name: 'Einax',
        description: 'Einax is a comprehensive token exchange platform with unique features for token developers like off-chain Airdrops and redeemable Vouchers.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/einax_exchange',
            ],
            website: [
                'https://einax.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'bullgain',
        name: 'Bullgain',
        description: 'Bullgain is a Brazilian Exchange that accepts deposits in fiat currency (BRL) and cryptocurrencies.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://bullgain.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'wadax',
        name: 'Wadax',
        description: '',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/WadaxExchange',
            ],
            website: [
                'https://wadax.io',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'swiftex',
        name: 'Swiftex',
        description: 'Swiftex is designed to support new and upcoming currencies to help them gain traction and publicity in the market.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://www.twitter.com/swiftexco',
            ],
            website: [
                'https://www.swiftex.co',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'coinplace',
        name: 'CoinPlace',
        description: null,
        active: false,
        website_status: false,
        api_status: false,
        message: 'Exchange is not active',
        links: {
            twitter: [
                'https://twitter.com/coinplacepro',
            ],
            website: [
                'https://coinplace.pro/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'ftx',
        name: 'FTX (Spot)',
        description: 'FTX is a cryptocurrency derivatives exchange built by traders, for traders.  They strive to build a platform powerful enough for professional trading firms and intuitive enough for first-time users.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://ftx.com',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 20,
        reported_rank: 25,
        currencies: 103,
        markets: 157,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 1198895404.8587048,
                adjusted_volume_24h: 1198895404.8587048,
                reported_volume_7d: 10132354066.69029,
                adjusted_volume_7d: 10132354066.69029,
                reported_volume_30d: 49450702306.5194,
                adjusted_volume_30d: 49450702306.5194,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 28800000,
        confidence_score: 0.637552,
    },
    {
        id: 'huobi-hbus',
        name: 'Huobi US (HBUS)',
        description: '',
        active: false,
        website_status: true,
        api_status: true,
        message: "HBUS Cease to Operate.\n\n<a href='https://support.huobi.us/hc/en-us/articles/360037682891' target='_blank'>Read more about it</a>",
        links: {
            twitter: [
                'https://twitter.com/hbusofficial',
                'https://twitter.com/Huobi_US',
            ],
            website: [
                'https://www.huobi.us/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 22,
        markets: 49,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'bitpreo',
        name: 'BitPreço',
        description: 'BitPreço is a platform that aggregates orderbooks from several other exchanges to make it easier to its user to find always the best price.\r\n\r\nBesides that, BitPreço has special rebates due to its volume, so its customers can enjoy very special prices.\r\n\r\nThe platform is the fastest growing in brazilian market and today is the top 2 in bitcoin volume in Brazil.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/BitPreco',
            ],
            website: [
                'https://bitpreco.com',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 174,
        reported_rank: 188,
        currencies: 3,
        markets: 3,
        fiats: [
            {
                name: 'Brazil Real',
                symbol: 'BRL',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 3602533.87913239,
                adjusted_volume_24h: 3602533.87913239,
                reported_volume_7d: 37109651.48071941,
                adjusted_volume_7d: 37109651.48071941,
                reported_volume_30d: 162295074.26706,
                adjusted_volume_30d: 162295074.26706,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 30000,
        confidence_score: 0.750012,
    },
    {
        id: 'metronex',
        name: 'Metronex',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/Metronexio?s=09',
            ],
            website: [
                'https://metronex.io/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 317,
        reported_rank: 332,
        currencies: 2,
        markets: 1,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 19.70125691,
                adjusted_volume_24h: 19.70125691,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 123.54109703,
                adjusted_volume_30d: 123.54109703,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 10000,
        confidence_score: 0,
    },
    {
        id: 'turtlenetwork-dex',
        name: 'TurtleNetwork DEX',
        description: '',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/TurtleNetworkTN',
            ],
            website: [
                'https://wallet.turtlenetwork.eu/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 10000,
        confidence_score: 0,
    },
    {
        id: 'cobinhood',
        name: 'Cobinhood',
        description: 'Cobinhood claims to be the world’s first cryptocurrency exchange with zero trading fees. The exchange has no fees on spot trading and margin trading up to 10x leverage. At the same time, Cobinhood is developing an ICO underwriting service. Companies – including new blockchain startups and existing enterprises – can launch an ICO through Cobinhood and enjoy compliance testing, security auditing, and other services.',
        active: false,
        website_status: true,
        api_status: false,
        message: 'Cobinhood reportedly filed for bankruptcy, the exchange is closed.',
        links: {
            twitter: [
                'https://twitter.com/cobinhood',
            ],
            website: [
                'https://cobinhood.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 10000,
        confidence_score: 0,
    },
    {
        id: 'narkasa',
        name: 'Narkasa',
        description: 'Launched on 01/07/2020, Narkasa is a centralized exchange based in İstanbul/Turkey. It claims to support TRY deposit/withdrawals through its integration with Turkish banks. Narkasa currently offers Turkish Lira, USDT, and BTC pairs.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/narkasacom',
            ],
            website: [
                'https://narkasa.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 199,
        reported_rank: 212,
        currencies: 5,
        markets: 9,
        fiats: [
            {
                name: 'Turkish Lira',
                symbol: 'TRY',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 1515836.60771361,
                adjusted_volume_24h: 1515836.60771361,
                reported_volume_7d: 11565768.24290161,
                adjusted_volume_7d: 11565768.24290161,
                reported_volume_30d: 49596675.43043769,
                adjusted_volume_30d: 49596675.43043769,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 20000,
        confidence_score: 0.080182,
    },
    {
        id: 'troca-ninja',
        name: 'Troca Ninja',
        description: null,
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/trocaninja',
            ],
            website: [
                'https://troca.ninja/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'krypterz',
        name: 'Krypterz',
        description: 'Krypterz - Buy and sell cryptocurrencies and making trading more open and accessible globally in a secure environment. Our vision is to increase the freedom of money globally. We believe that by spreading this freedom, we can significantly improve lives around the world. Join us and start trading Bitcoin (BTC), Ethereum (ETH), Shiba Inu (SHIB), DOGE, Uniswap (UNI), Litecoin (LTC), BNB, Monero (XMR), Bitcoin Cash (BCH) and Ripple (XRP).',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/Krypterzxchange',
            ],
            website: [
                'https://www.krypterz.com',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 158,
        reported_rank: 172,
        currencies: 10,
        markets: 10,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 5972112.80854336,
                adjusted_volume_24h: 5972112.80854336,
                reported_volume_7d: 42697012.50238569,
                adjusted_volume_7d: 42697012.50238569,
                reported_volume_30d: 161612953.9035632,
                adjusted_volume_30d: 161612953.9035632,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'hitbtc',
        name: 'HitBTC',
        description: 'HitBTC is the world’s most advanced cryptocurrency exchange. Created by outstanding technical minds, high-level finance professionals and experienced traders, HitBTC is delivering the most reliable, fast and powerful platform solution on the market. The platform has earned its reputation for fault-tolerance, flawless uptime and high availability. Its core matching engine is among the best technological products in its class, offering traders a wide range of features such as real-time clearing and cutting-edge order matching algorithms.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/hitbtc',
            ],
            website: [
                'https://hitbtc.com',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 5,
        reported_rank: 8,
        currencies: 418,
        markets: 963,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 2872149864.827844,
                adjusted_volume_24h: 2872149864.827844,
                reported_volume_7d: 23095897387.180954,
                adjusted_volume_7d: 23095897387.180954,
                reported_volume_30d: 101166276862.62167,
                adjusted_volume_30d: 101166276862.62167,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 4250000,
        confidence_score: 0.748874,
    },
    {
        id: 'bitlish',
        name: 'Bitlish',
        description: 'Bitlish is a UK-based cryptocurrency exchange founded in 2015. The company accepts bank transfers and credit cards, supporting several fiat currencies, and offers trading in a decent amount of the major digital coins.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://bitlish.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'vindax',
        name: 'VinDAX',
        description: "The tool and resources that VinDAX provide can increase traders and investors' profit potential, performance and understandings.",
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/VinDAXOfficial',
            ],
            website: [
                'https://vindax.com',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 54,
        reported_rank: 62,
        currencies: 161,
        markets: 293,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 198449866.17286915,
                adjusted_volume_24h: 198449866.17286915,
                reported_volume_7d: 1561607223.0779037,
                adjusted_volume_7d: 1561607223.0779037,
                reported_volume_30d: 7462624727.431911,
                adjusted_volume_30d: 7462624727.431911,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 1100000,
        confidence_score: 0.000444,
    },
    {
        id: 'darbfinance',
        name: 'Darb Finance',
        description: 'Darb Trade focuses on supporting trading between FIAT and Cryptocurrencies with state of the art technology and financial instruments. Allowing anyone (no matter his/her experience with assets trading or blockchain technology) easy access to Crypto/FIAT, FIAT/ FIAT, and Crypto/crypto access. \r\n        \r\nWe are a grassroots community of people working on mass adoption of blockchain based assets. By understand the market, we put more focus on being the gateway for mass users to Crypto world,more focus on servicing B2B in Wallet and exchange of FIAT with Crypto, more effort on providing Better Interface for blockchain participants.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/FinanceDarb',
            ],
            website: [
                'https://darbfinance.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'autradex-systems',
        name: 'Autradex Systems',
        description: 'Fast, Reliable, Secure.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://wallet.autradex.systems',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'light-exchange',
        name: 'Light Exchange',
        description: '',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://lightexchange.io',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'blockchainio',
        name: 'Blockchain.io',
        description: 'Blockchain.io is your Gateway to the Internet of Value. It combines the efficiency of a low-latency full-featured centralized exchange with decentralized “trustless” cross-chain settlement. The project leverages the latest developments in cross-chain atomic swaps, cryptographic protocols, and payment networks such as Lightning and Raiden. These developments will overcome the scalability issues of decentralized blockchains, allow transactions across heterogenous blockchains, increase the speed and lower the cost of these transactions, making them ready for mass adoption.\r\nBlockchain.io is driven by the highly experienced team of cryptocurrency experts who, seven years ago, founded Paymium, a fiat/bitcoin exchange catering to the underserved Euro market.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/blockchainio',
            ],
            website: [
                'https://blockchain.io',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 10000,
        confidence_score: 0,
    },
    {
        id: 'sistemkoin',
        name: 'Sistemkoin',
        description: 'Sistemkoin is a Turkish cryptocurrency exchange which accepts bank transfers. ',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/Sistemkoin',
            ],
            website: [
                'https://sistemkoin.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 10000,
        confidence_score: 0,
    },
    {
        id: 'metrxchain',
        name: 'MeTrxChain',
        description: 'A Global Digital Asset Trading Platform With Low Fees and Best Execution Prices',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/metrxchain',
            ],
            website: [
                'https://metrxchain.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'bitvast',
        name: 'Bitvast',
        description: 'Bitvast is an international cryptocurrency exchange with trading pairs against BTC, USDC and TUSD. The Bitvast platform uses a unique liquidity pool to offer its users the deepest possible orderbooks. The company is headquartered and registered in South Africa.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/BITVAST',
            ],
            website: [
                'https://www.bitvast.com',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 93,
        reported_rank: 105,
        currencies: 9,
        markets: 12,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 43647182.02216323,
                adjusted_volume_24h: 43647182.02216323,
                reported_volume_7d: 366494479.66744775,
                adjusted_volume_7d: 366494479.66744775,
                reported_volume_30d: 1554740354.8168406,
                adjusted_volume_30d: 1554740354.8168406,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0.75,
    },
    {
        id: 'goswap',
        name: 'GoSwap',
        description: 'A decentralized exchange on GoChain. Like Uniswap without the insane gas fees.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/goswapper',
            ],
            website: [
                'https://goswap.exchange',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 354,
        reported_rank: 354,
        currencies: 6,
        markets: 11,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 2712.74950977,
                adjusted_volume_7d: 2712.74950977,
                reported_volume_30d: 16086.49792348,
                adjusted_volume_30d: 16086.49792348,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'qryptos',
        name: 'Qryptos',
        description: '',
        active: false,
        website_status: false,
        api_status: false,
        message: 'Exchange is not active',
        links: {
            website: [
                'https://www.qryptos.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'zonexh',
        name: 'Zonexh',
        description: 'Zonexh is a sophisticated and secure crypto-to-crypto transaction platform that was established in 2021 to provide consumers with secure and dependable digital asset exchange services. Zonexh exchange platform provides a cutting-edge novel API, as well as dependable security solutions, self-service management capabilities, and an effective alerting module. Zonexh is in a class by itself when it comes to client attractiveness, with a fixed trading cost of 0.1 percent, which is significantly lower than the global industry average of 0.25 percent. Zonexh also has a very robust trade engine framework that can process around 1,000 transactions per second.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/Zonexh1',
            ],
            website: [
                'https://zonexh.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 6,
        reported_rank: 9,
        currencies: 3,
        markets: 3,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 2827478534.7233677,
                adjusted_volume_24h: 2827478534.7233677,
                reported_volume_7d: 23237477018.19919,
                adjusted_volume_7d: 23237477018.19919,
                reported_volume_30d: 100122453257.80672,
                adjusted_volume_30d: 100122453257.80672,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 20000,
        confidence_score: 0.000008,
    },
    {
        id: 'panxora',
        name: 'Panxora',
        description: 'Panxora is one of the many cryptocurrency exchanges from Hong Kong. Initially First Global Credit, (now rebranded as the Panxora exchange) allowed traders to use their cryptocurrency capital to back trading other asset classes. Panxora prioritizes security and in this regard, it will store all the submitted documents in an encrypted format behind its firewall to prevent access by unauthorized third parties. ',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/panxoracrypto',
            ],
            website: [
                'https://panxora.io/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 193,
        reported_rank: 207,
        currencies: 8,
        markets: 15,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 1849433.89439531,
                adjusted_volume_24h: 1849433.89439531,
                reported_volume_7d: 19922324.98503811,
                adjusted_volume_7d: 19922324.98503811,
                reported_volume_30d: 85855285.79430446,
                adjusted_volume_30d: 85855285.79430446,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'bitonic',
        name: 'Bitonic',
        description: 'Bitonic is based in the Netherlands founded in 2012 and is one of the most renowned entities on the local market. They have been holding educational courses and presentations at major Dutch financial firms and universities. Additionally they provide a solution for online stores, who wish to start accepting Bitcoin. ',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/bitonic',
            ],
            website: [
                'https://bitonic.nl',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 222,
        reported_rank: 236,
        currencies: 1,
        markets: 1,
        fiats: [
            {
                name: 'Euro',
                symbol: 'EUR',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 586243.11801548,
                adjusted_volume_24h: 586243.11801548,
                reported_volume_7d: 4003662.11758801,
                adjusted_volume_7d: 4003662.11758801,
                reported_volume_30d: 18321415.76256024,
                adjusted_volume_30d: 18321415.76256024,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 30000,
        confidence_score: 0,
    },
    {
        id: 'indoex',
        name: 'Indoex',
        description: 'IndoEx Exchange claims to be the safest, fastest digital asset exchange',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/Indoex_LTD',
            ],
            website: [
                'https://indoex.io/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 11,
        reported_rank: 15,
        currencies: 29,
        markets: 99,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
            {
                name: 'Euro',
                symbol: 'EUR',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 1803758180.226402,
                adjusted_volume_24h: 1803758180.226402,
                reported_volume_7d: 18084540643.723656,
                adjusted_volume_7d: 18084540643.723656,
                reported_volume_30d: 78316000637.66284,
                adjusted_volume_30d: 78316000637.66284,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 2600000,
        confidence_score: 0.05105,
    },
    {
        id: 'bitenium-futures',
        name: 'Bitenium Futures',
        description: 'The Bitenium Exchange is a new-gen cryptocurrency trading platform. Automate your trading and take your emotion out of the equation. Use expert tools without coding skills. Invest in all cryptocurrencies that your exchange offers. High liquidity and secure wallet.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://bitenium.com/exchange/tradefuture',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 324,
        reported_rank: 5,
        currencies: 3,
        markets: 2,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 5454206393.960288,
                adjusted_volume_24h: 0,
                reported_volume_7d: 38017983582.888756,
                adjusted_volume_7d: 0,
                reported_volume_30d: 148670117866.33316,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'guldentrader',
        name: 'GuldenTrader',
        description: '',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/guldentrader',
            ],
            website: [
                'https://guldentrader.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'bitphantom',
        name: 'BitPhantom',
        description: '',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://pro.bitphantom.io/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'bybit-ex',
        name: 'Bybit',
        description: '',
        active: true,
        website_status: false,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/bybit_official',
            ],
            website: [
                'https://www.bybit.com/en-US',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 359,
        reported_rank: 40,
        currencies: 10,
        markets: 14,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 562359234.6085591,
                adjusted_volume_24h: 0,
                reported_volume_7d: 5438848505.575966,
                adjusted_volume_7d: 0,
                reported_volume_30d: 18227521657.40452,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 38500000,
        confidence_score: 0.377131,
    },
    {
        id: 'spectrocoin-pro',
        name: 'SpectroCoin Pro',
        description: "Re-launched in 2020, SpectroCoin Pro is a centralized trading and exchange platform under the SpectroCoin brand. Our exchange platform is built on years of expertise in the crypto and FinTech fields, with a team that strived to meet the needs of today's cryptocurrency users.\r\n\r\nSpectroCoin Pro also features trading tools and fee schedules that are some of the most competitive in the current crypto market. Here, market makers are not associated with fees and earn 0.05% rebates trading crypto-crypto and 0.1% crypto-fiat while trading. What's even better is that BNK trading pairs are free to trade for all types of traders.",
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/spectrocoin',
            ],
            website: [
                'https://exchange.spectrocoin.com',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 244,
        reported_rank: 259,
        currencies: 33,
        markets: 171,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
            {
                name: 'Euro',
                symbol: 'EUR',
            },
            {
                name: 'Pound Sterling',
                symbol: 'GBP',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 166755.07544148,
                adjusted_volume_24h: 166755.07544148,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 1460000,
        confidence_score: 0,
    },
    {
        id: 'coinexchange',
        name: 'CoinExchange',
        description: 'CoinExchange is a cryptocurrency exchange which operates solely on a crypto-to-crypto basis.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'CoinExchange has decided to close down the exchange. Trading and deposits will be suspended on the 15th of October 2019.',
        links: {
            twitter: [
                'https://twitter.com/CoinExchangeio',
                'https://twitter.com/coinexchange_io',
            ],
            website: [
                'https://www.coinexchange.io/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 30000,
        confidence_score: 0,
    },
    {
        id: 'tux-exchange',
        name: 'Tux Exchange',
        description: 'Tux Exchange is a Canadian cryptocurrency exchange that launched in August 2016. Tux Exchange does not work with fiat currencies and does not offer trading with them. Tux is not regulated. There are no specific regulation requirements for cryptocurrency exchanges on a national level in Canada.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'The exchange was shut down on July 6th 2019.',
        links: {
            twitter: [
                'https://twitter.com/tuxexchange',
            ],
            website: [
                'https://tuxexchange.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'coindirect',
        name: 'Coindirect',
        description: "Coindirect is the way to buy and sell the world's most valuable digital currencies, with a single wallet, all in one place. Whether you're looking to spend or save, convert your coins or build out an investment portfolio, there's a currency waiting for you.\r\nTo make sure Coindirect comply with international standards in terms of AML and CFT, company is registered as a designated business with the Isle of Man Financial Services Authority.",
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/coindirectcom',
            ],
            website: [
                'https://www.coindirect.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 90000,
        confidence_score: 0,
    },
    {
        id: 'tradecx',
        name: 'TradeCX',
        description: 'TradeCX is a robust and easy-to-use cryptocurrency exchange. We make the process of trading a super straightforward progress and eliminate all the nonsense and confusing parts about actually getting to the trading.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/trade_cx',
            ],
            website: [
                'https://tradecx.io',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'uex',
        name: 'UEX',
        description: 'UEX is a Singapore-based cryptocurrency exchange founded in 2017. This trading platform’s trading fees for takers are 0.15% and the trading fees for makers are 0.10%. UEX does not accept any deposits of fiat currency. ',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/UexComOfficial',
            ],
            website: [
                'https://www.uex.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'dove-wallet',
        name: 'Dove Wallet',
        description: 'DoveWallet is a market place for our crypto users who wants benefit the advantage of regular income through our daily bonus program. User can manage their portfolios through our wallet service and trade tokens on our exchange. We also have Banxa, Simplex payment service and lots of other fiat pairs as well.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/dovewallet_en',
            ],
            website: [
                'https://dovewallet.com/en',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 350,
        reported_rank: 350,
        currencies: 27,
        markets: 51,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 160000,
        confidence_score: 0,
    },
    {
        id: 'cashpayz-exchange',
        name: 'CashPayz Exchange',
        description: 'CashPayz is the place to trade cryptocurrencies. CashPayz’s app for iOS and Android allows users to buy and sell cryptocurrencies and track prices. It’s also a capable wallet for your money, and when it’s time to spend, CashPayz will help you find merchants who accept cryptocurrencies as payment.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/CashpayzE',
            ],
            website: [
                'https://cashpayz.exchange/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'pbank',
        name: 'PBank',
        description: 'PBank is a global digital asset service platform registered in Singapore and controlled by Dade bank of America, providing users around the world with safe, stable and convenient integrated digital asset service. PBank pays attention to compliance, and has obtained cooperation with local regulatory agencies in overseas countries. It has many compliance licenses and compliance support from America(MSB license), Kyrgyzstan and other overseas countries. PBank develops diversified business strategy. It not only has operation centers in many places around the world, but also includes digital asset bank, investment bank, digital asset exchange and digital asset wallet. PBank provides users with industry-leading transaction depth and safety and fast operation experience. Meanwhile, mobile terminal and multi-language switch make it convenient for users around the world to use anytime and anywhere.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/OfficialPbank',
            ],
            website: [
                'https://www.pbank.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'nacdaq',
        name: 'Nacdaq',
        description: 'Launched in 28.07.2018, Nacdaq is a centralized exchange platform located in China at 7/F MW TOWER 111, BONHAM STRAND, SNEUNG WAN, HONG KONG. NACDAQ is a platform on which transactions with digital assets and related services are performed. The platform is intended only to obtain information about digital assets, search for trading counterparties, conduct negotiations and conclude transactions with digital assets. NACDAQ does not participate in digital asset transactions as a buyer or seller and does not provide any services related to the replenishment and withdrawal of legally allowed currencies of any country. Fiat pairs, deposits, etc. are not supported.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/nacdaq_exchange',
            ],
            website: [
                'https://nacdaq.pro',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 187,
        reported_rank: 201,
        currencies: 10,
        markets: 12,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 2498562.53902565,
                adjusted_volume_24h: 2498562.53902565,
                reported_volume_7d: 21583206.32165685,
                adjusted_volume_7d: 21583206.32165685,
                reported_volume_30d: 94417786.59189355,
                adjusted_volume_30d: 94417786.59189355,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'honeyswap',
        name: 'Honeyswap',
        description: 'Honeyswap is a Decentralized Exchange built on xDai.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://honeyswap.org/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 326,
        reported_rank: 357,
        currencies: 8,
        markets: 12,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 360000,
        confidence_score: 0,
    },
    {
        id: 'bit2bit',
        name: 'Bit2Bit',
        description: "Bit2Bit.IN is an India based exchange targeting mainly Indian customers. It is sister company of TychExchange. It claims to be also the first exchange to do many things. We have a 100% clearing and settlement based system for all deposits, withdrawals and trades, like traditional stocks markets have. Bit2Bit.IN also has 100% cold storage wallets (the client's deposits are also direct to cold storage only). Even with the 100% cold storage, clients’ deposits are still instant in their accounts using our proprietary system. Most importantly, though everyone claims to be secure, Bit2Bit.IN claims that it has developed a system where they worked on being \"hack irrelevant\" rather than being hack resistant. In short, their system is claimed to be built in a way where client's funds and private data are secure even if the whole system is hacked.",
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://bit2bit.in',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'bitsdaq',
        name: 'Bitsdaq',
        description: null,
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/BitsdaqExchange',
            ],
            website: [
                'https://bitsdaq.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 40000,
        confidence_score: 0,
    },
    {
        id: 'bitflix',
        name: 'Bitflix',
        description: 'Bitflix is a future exchange. Our purpose is to provide a fair and secured trade to crypto community. Our purpose is not just to list coin rather focus is how to list new coin. We wil not charge usdt or btc or eth to list a new token neither our native coin. We sill charge a new coin that particular crypto which we allow to list. We believe once any exchange allow to list a new coin they must believe that community. So we charged in there crypto who list the coin.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/bitflixgroup',
            ],
            website: [
                'https://exchange.bitflix.online/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 155,
        reported_rank: 169,
        currencies: 13,
        markets: 13,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 6343885.86795458,
                adjusted_volume_24h: 6343885.86795458,
                reported_volume_7d: 45587956.54307483,
                adjusted_volume_7d: 45587956.54307483,
                reported_volume_30d: 173252188.34182993,
                adjusted_volume_30d: 173252188.34182993,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 20000,
        confidence_score: 0.000008,
    },
    {
        id: 'getbtc',
        name: 'GetBTC',
        description: 'GetBTC Financial Services Ltd. Is the company which operates this exchange. It is based in St. Vincent and the Grenadines. Bitcoin is the only cryptocurrency, supported by GetBTC.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/ExchangeGetBTC',
            ],
            website: [
                'https://getbtc.org',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'flame',
        name: 'Flame',
        description: 'Flame.Exchange focuses mainly on the following four points:\r\n\r\nSecurity - Built and maintained to the highest security practices to ensure our users and their funds are always protected. We encrypt your personal data and private keys with 256-bit encryption.\r\nReliability - We strive to keep the best uptime possible (5nines)\r\nPrivacy - You are not required to submit KYC documents until you trade $20,000+ in a space of 3 days\r\nSpeed - We use a high speed caching CDN to deliver the fastest connections around the world',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://www.flame.exchange/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 336,
        reported_rank: 338,
        currencies: 7,
        markets: 9,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'zebpay',
        name: 'Zebpay',
        description: '',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/zebpay',
            ],
            website: [
                'https://www.zebpay.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 2190000,
        confidence_score: 0,
    },
    {
        id: 'chamber-ex',
        name: 'Chamber Ex',
        description: 'We published that Robincash is implemented on 3M oper system. Robincash realized a free swap deal with each other cryptocurrencies on Chamber Ex.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://robinadaptor.github.io/chamber/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'sushiswap',
        name: 'SushiSwap',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://app.sushi.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 67,
        reported_rank: 76,
        currencies: 154,
        markets: 271,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 109216779.2953261,
                adjusted_volume_24h: 109216779.2953261,
                reported_volume_7d: 930560405.6855028,
                adjusted_volume_7d: 930560405.6855028,
                reported_volume_30d: 3925460366.9040294,
                adjusted_volume_30d: 3925460366.9040294,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 9520000,
        confidence_score: 0.003846,
    },
    {
        id: 'dexzbitz',
        name: 'Dexzbitz',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/dexzbitz',
            ],
            website: [
                'https://dexzbitz.live',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 55,
        reported_rank: 63,
        currencies: 72,
        markets: 86,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 190499108.03608096,
                adjusted_volume_24h: 190499108.03608096,
                reported_volume_7d: 1297706879.9306521,
                adjusted_volume_7d: 1297706879.9306521,
                reported_volume_30d: 5722883439.36312,
                adjusted_volume_30d: 5722883439.36312,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 140000,
        confidence_score: 0.347468,
    },
    {
        id: 'darb-finance',
        name: 'Darb Finance',
        description: null,
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/FinanceDarb',
            ],
            website: [
                'https://darbfinance.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'ethermium',
        name: 'EtherMium',
        description: 'EtherMium is an Ethereum-based cryptocurrency exchange platform that operates cryptocurrency pairs and tokens with an ERC20 standard compliance. EtherMium prioritizes on safety; therefore, it does not hold any of the funds. The funds are stored on smart contracts, which act as bank accounts; This implies that the smart contract will monitor transactions and facilitate the transactions.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/Ethermium',
            ],
            website: [
                'https://ethermium.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'yibi',
        name: 'Yibi',
        description: '',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/OfficialYibi',
            ],
            website: [
                'https://yibi.info/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'wohlstand-cex',
        name: 'Wohlstand CEX',
        description: 'Drive the World towards the Prosperity of Cryptocurrency\r\n\r\nWohlstand CEX exchange is regulated and registered in European Region.\r\nWohlstand CEX will be able to offer a wide array of services. With just an click on platform, users will be able to send and receive funds from their devices, as long as they have an internet connection.\r\n\r\nAn European-based exchange that allows users to access crypto with ease could open up a completely new world for them. As a result, it could offer them financial freedom, including lower charges when it comes to sending and receiving funds.\r\n\r\nFour Testaments of Wohlstand CEX:\r\nReliable, Robust, Reputable and Regulated',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/WOHLSTANDCEX',
            ],
            website: [
                'https://wohlstandcex.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'ataix',
        name: 'ATAIX',
        description: 'Headquartered in Estonia, ATAIX is a digital asset trading platform. It provides digital assets trading services such as Bitcoin and Ethereum to users around the world. Fees can be as low as 0%. The fee schedules are volume-based. The more the user trade, the lower its rate.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/ATAIXcom',
            ],
            website: [
                'https://ataix.com',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 70,
        reported_rank: 79,
        currencies: 11,
        markets: 21,
        fiats: [
            {
                name: 'Euro',
                symbol: 'EUR',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 104008548.32905181,
                adjusted_volume_24h: 104008548.32905181,
                reported_volume_7d: 757312649.1443216,
                adjusted_volume_7d: 757312649.1443216,
                reported_volume_30d: 3390999872.5469103,
                adjusted_volume_30d: 3390999872.5469103,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 30000,
        confidence_score: 0.081022,
    },
    {
        id: 'goexchange',
        name: 'GO.Exchange',
        description: 'GO.Exchange is the newest subsidiary of Omise Holdings, founded in September 2018. GO.Exchange is committed to upholding high standards for transparency to create a sustainable, long lasting exchange. GO.Exchange also provides a unique transaction fee and token burn model.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/goexchangehq',
            ],
            website: [
                'https://go.exchange/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'escodex',
        name: 'Escodex',
        description: 'Escodex is a cryptocurrency exchange from Estonia. Escodex is a decentralized exchange.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/escodexofficial',
            ],
            website: [
                'https://wallet.escodex.com/',
                'https://www.escodex.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'thxchain-digital-platform',
        name: 'THXCHAIN Digital Platform',
        description: 'THXCHAIN Digital Platform #TDP Collectively we create an end-to-end solution for the emerging digital asset market, specifically the trend of tokenized Assets— more commonly referred to as security tokens & Crypto Future Binary Options Esport Tokens & Tokenised Global assets like AAPL Netflix Tesla Crude Gold',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://thxchain.com/exchange',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 328,
        reported_rank: 348,
        currencies: 7,
        markets: 7,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'buda',
        name: 'Buda',
        description: 'Buda (which was previously known as SURBTC) is an entry-level cryptocurrency exchange launched in 2015, focused on some South American countries. They are based in Chile, but also service traders in Colombia and Peru.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/SurBTC',
                'https://twitter.com/BudaPuntoCom',
            ],
            website: [
                'https://www.buda.com',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 213,
        reported_rank: 227,
        currencies: 4,
        markets: 15,
        fiats: [
            {
                name: 'Chilean Peso',
                symbol: 'CLP',
            },
            {
                name: 'Colombian Peso',
                symbol: 'COP',
            },
            {
                name: 'Peruvian Sol',
                symbol: 'PEN',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 945589.00951867,
                adjusted_volume_24h: 945589.00951867,
                reported_volume_7d: 9598612.5738589,
                adjusted_volume_7d: 9598612.5738589,
                reported_volume_30d: 67199285.60503772,
                adjusted_volume_30d: 67199285.60503772,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 2700000,
        confidence_score: 0,
    },
    {
        id: 'play-royal',
        name: 'Play Royal',
        description: '',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/PlayRoyal_EN',
            ],
            website: [
                'https://playroyal.com/exchange/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'xbase',
        name: 'xBase',
        description: 'Marketplace for cryptocurrencies and crypto equities.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/xBase_exchange',
            ],
            website: [
                'https://xbase.exchange/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 10000,
        confidence_score: 0,
    },
    {
        id: 'eurekax',
        name: 'EurekaX',
        description: 'It is the worlds highest liquidity crypto Exchange. By integrating multiple orderbooks, we are able to bring together many of the biggest and best exchanges into one hub, creating a far simpler yet effective trading experience. Supporting all this is the EurekaX centralised exchange featuring the highest liquidity exchange by linking our order book with those of the top exchanges including Binance and OKEx.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/EurekaX3',
            ],
            website: [
                'https://eurekax.io',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 30000,
        confidence_score: 0,
    },
    {
        id: 'bitubu',
        name: 'BitUBU',
        description: 'Powered by BitUBU Technology Corporation, BitUBU is an advanced trading platform that is designed for experienced cryptocurreny traders and specializes in Altcoins, Algos and Performance. BitUBU, the ultimate trading platform for cryptocurrencies, provides advanced exchange functionalities to allow users to buy and sell coins/tokens.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/BitubuExchange',
            ],
            website: [
                'https://bitubu.com',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 163,
        reported_rank: 177,
        currencies: 19,
        markets: 34,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 4532910.78049413,
                adjusted_volume_24h: 4532910.78049413,
                reported_volume_7d: 30270779.16903006,
                adjusted_volume_7d: 30270779.16903006,
                reported_volume_30d: 169505407.48863277,
                adjusted_volume_30d: 169505407.48863277,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 20000,
        confidence_score: 0.247882,
    },
    {
        id: 'astroport',
        name: 'Astroport',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/astroport_fi',
            ],
            website: [
                'https://astroport.fi/en',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 48,
        reported_rank: 55,
        currencies: 7,
        markets: 6,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 232399018.02993652,
                adjusted_volume_24h: 232399018.02993652,
                reported_volume_7d: 2561472403.2660027,
                adjusted_volume_7d: 2561472403.2660027,
                reported_volume_30d: 3121816265.6525116,
                adjusted_volume_30d: 3121816265.6525116,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 3910000,
        confidence_score: 0.001579,
    },
    {
        id: 'altilly',
        name: 'Altilly',
        description: '',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/altillycom',
            ],
            website: [
                'https://www.altilly.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'bithumb-singapore',
        name: 'Bithumb Singapore',
        description: null,
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/bithumbsg',
            ],
            website: [
                'https://www.bithumbsg.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'btcbox',
        name: 'BTCBOX',
        description: 'BTCBOX is a Japanese cryptocurrency exchange, which is regulated by the Financial Services Agency (JFSA). ',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://www.btcbox.co.jp/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 118,
        reported_rank: 130,
        currencies: 1,
        markets: 1,
        fiats: [
            {
                name: 'Japanese Yen',
                symbol: 'JPY',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 22031925.12919856,
                adjusted_volume_24h: 22031925.12919856,
                reported_volume_7d: 139118995.85358903,
                adjusted_volume_7d: 139118995.85358903,
                reported_volume_30d: 622601883.5822706,
                adjusted_volume_30d: 622601883.5822706,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 80000,
        confidence_score: 0.050032,
    },
    {
        id: 'lykke-exchange',
        name: 'Lykke Exchange',
        description: 'Lykke is a cryptocurrency exchange that has steadily grown in volume since launching in 2015. The Swiss-based exchange lets you buy and sell a variety of cryptocurrencies and fiat currencies – including unique options like the Swiss France (CHF) and Lykke coins (LKK).',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/LykkeCity',
                'https://twitter.com/lykke',
            ],
            website: [
                'https://lykke.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 220,
        reported_rank: 234,
        currencies: 8,
        markets: 34,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
            {
                name: 'Euro',
                symbol: 'EUR',
            },
            {
                name: 'Pound Sterling',
                symbol: 'GBP',
            },
            {
                name: 'Japanese Yen',
                symbol: 'JPY',
            },
            {
                name: 'Swiss Franc',
                symbol: 'CHF',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 639693.99722258,
                adjusted_volume_24h: 639693.99722258,
                reported_volume_7d: 3165619.67884423,
                adjusted_volume_7d: 3165619.67884423,
                reported_volume_30d: 13142723.96671713,
                adjusted_volume_30d: 13142723.96671713,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 50000,
        confidence_score: 0,
    },
    {
        id: 'coin-galaxy',
        name: 'Coin Galaxy',
        description: 'The young and prospective Coin-Galaxy.com exchange is focused, above all, on traders who take their first steps in trading.\r\nThat is why we pay much attention to training. Aside from technical video tutorials, we also have a free training course "How to trade cryptocurrency from scratch". Moreover, Coin Galaxy constantly makes airdrops for its clients, thanks to which you can get top-rated crypto coins making simple actions. User fund security is also paid due regard.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/Coin_Galaxy_com',
            ],
            website: [
                'https://coin-galaxy.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 269,
        reported_rank: 284,
        currencies: 19,
        markets: 45,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
            {
                name: 'Russian Ruble',
                symbol: 'RUB',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 30359.21472849,
                adjusted_volume_24h: 30359.21472849,
                reported_volume_7d: 193859.22760423,
                adjusted_volume_7d: 193859.22760423,
                reported_volume_30d: 923008.94936551,
                adjusted_volume_30d: 923008.94936551,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 210000,
        confidence_score: 0.159311,
    },
    {
        id: 'pancakeswap-v2',
        name: 'PancakeSwap V2',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://pancakeswap.finance/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 33,
        reported_rank: 39,
        currencies: 5538,
        markets: 11417,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 585818804.8442366,
                adjusted_volume_24h: 585818804.8442366,
                reported_volume_7d: 6867627361.780112,
                adjusted_volume_7d: 6867627361.780112,
                reported_volume_30d: 27059508180.272507,
                adjusted_volume_30d: 27059508180.272507,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 21800000,
        confidence_score: 0.008806,
    },
    {
        id: 'bitmxittz',
        name: 'Bitmxittz',
        description: 'Bitmxittz - The Digital Assets Market, The real time cryptocoins, tokens exchange with Public API and Private API integration',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/bitmxittz',
            ],
            website: [
                'https://bitmxittz.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'tokpie',
        name: 'TOKPIE',
        description: 'TOKPIE is the first cryptocurrency exchange with Bounty Stakes Trading service.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/tokpie_io',
            ],
            website: [
                'https://tokpie.io/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 64,
        reported_rank: 73,
        currencies: 107,
        markets: 125,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 118913690.67990439,
                adjusted_volume_24h: 118913690.67990439,
                reported_volume_7d: 791078208.5251961,
                adjusted_volume_7d: 791078208.5251961,
                reported_volume_30d: 2948567543.3531384,
                adjusted_volume_30d: 2948567543.3531384,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 110000,
        confidence_score: 0.697426,
    },
    {
        id: 'scavo',
        name: 'SCAVO',
        description: 'Our company is established in Argentina and we are focused on blockchain services based such us wallet, exchange, payment gateway and mining farms. Currently the exchange was launched as our first public service.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/SCAVOTech',
            ],
            website: [
                'https://scavo.exchange',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'redot',
        name: 'Redot',
        description: 'REDOT is an EU regulated digital asset exchange. Run by a team of industry veterans, Redot sets the industry standard by providing institutional, professional and retail investors with a powerful platform to trade digital assets instantly and securely with the lowest commissions.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://redot.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 204,
        reported_rank: 217,
        currencies: 8,
        markets: 8,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 1281204.74904685,
                adjusted_volume_24h: 1281204.74904685,
                reported_volume_7d: 10290295.03090983,
                adjusted_volume_7d: 10290295.03090983,
                reported_volume_30d: 43241343.88959297,
                adjusted_volume_30d: 43241343.88959297,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 30000,
        confidence_score: 0.582652,
    },
    {
        id: 'wazirx',
        name: 'WazirX',
        description: 'The WazirX platform has been designed for Indian investors. It is run by Nischal Schetty, Sameer Mhatre and Siddharth Menon. The WazirX executive team, as listed on the company’s website, are all co-founders of a social media management app known as Crowdfire, which was created in 2010. ',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/WazirXIndia',
            ],
            website: [
                'https://wazirx.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 205,
        reported_rank: 219,
        currencies: 61,
        markets: 86,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 1274196.01194453,
                adjusted_volume_24h: 1274196.01194453,
                reported_volume_7d: 5818633.81313754,
                adjusted_volume_7d: 5818633.81313754,
                reported_volume_30d: 54982958.98560487,
                adjusted_volume_30d: 54982958.98560487,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 55500000,
        confidence_score: 0,
    },
    {
        id: 'coinamount',
        name: 'CoinAmount',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/CoinAmount',
            ],
            website: [
                'https://coinamount.com',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 161,
        reported_rank: 175,
        currencies: 25,
        markets: 61,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 5303000.06142894,
                adjusted_volume_24h: 5303000.06142894,
                reported_volume_7d: 44660493.84496523,
                adjusted_volume_7d: 44660493.84496523,
                reported_volume_30d: 189239335.74418682,
                adjusted_volume_30d: 189239335.74418682,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 270000,
        confidence_score: 0.741977,
    },
    {
        id: 'giottus',
        name: 'Giottus',
        description: 'Giottus is changing the way Indian users trade their digital assets by building a platform that is customer centric with a top-tier customer support on par with the world’s best International exchanges.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/giottus',
            ],
            website: [
                'https://giottus.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 96,
        reported_rank: 108,
        currencies: 6,
        markets: 5,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 40979796.47988846,
                adjusted_volume_24h: 40979796.47988846,
                reported_volume_7d: 80227035.41963565,
                adjusted_volume_7d: 80227035.41963565,
                reported_volume_30d: 169250814.20976368,
                adjusted_volume_30d: 169250814.20976368,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 730000,
        confidence_score: 0.000295,
    },
    {
        id: 'bequant',
        name: 'Bequant',
        description: 'BeQuant is a new cryptocurrency exchange that is promising to pioneer regulation in the sector. The team behind the exchange has stated in a recent press release that "BeQuant team of FCA compliant brokers and blockchain specialists has been in the business since 2012". BeQuant’s core product is partnered with established technology Multiexchange who aggregates liquidity and works with large institutions.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/bequantexchange',
            ],
            website: [
                'https://bequant.io/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 26,
        reported_rank: 31,
        currencies: 21,
        markets: 75,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 776705582.6636521,
                adjusted_volume_24h: 776705582.6636521,
                reported_volume_7d: 6923512420.44745,
                adjusted_volume_7d: 6923512420.44745,
                reported_volume_30d: 29576985680.90219,
                adjusted_volume_30d: 29576985680.90219,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 20000,
        confidence_score: 0.154383,
    },
    {
        id: 'ccxcanada',
        name: 'CCXCanada',
        description: 'CCX is ambitious, awesome, advanced and Canadian. Since 2017, we’ve taken the complexity out of trading and owning digital currencies for everyone in Canada and beyond. Our goal at CCX is to provide the highest quality, instant and simplified purchasing experience for customers looking to acquire Blockchain Backed assets, starting with Bitcoin.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/CCX_Canada',
            ],
            website: [
                'https://ccxcanada.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'emirex',
        name: 'Emirex',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://emirex.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 116,
        reported_rank: 128,
        currencies: 12,
        markets: 25,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
            {
                name: 'Euro',
                symbol: 'EUR',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 22471070.50908758,
                adjusted_volume_24h: 22471070.50908758,
                reported_volume_7d: 166264147.1653282,
                adjusted_volume_7d: 166264147.1653282,
                reported_volume_30d: 763460788.442295,
                adjusted_volume_30d: 763460788.442295,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 40000,
        confidence_score: 0.738106,
    },
    {
        id: 'abit',
        name: 'ABIT',
        description: 'Founded in Australia, ABIT.com was officially launched since October 2019. It is the next generation digital asset exchange, which claims to focus on legal compliance and asset security.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/abitofficial',
            ],
            website: [
                'https://www.abit.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'koinpro',
        name: 'KoinPro',
        description: 'KoinPro is a derivative or futures trading platform which offers a unique futures contract on crypto, major stock indices and commodities at one place for the crypto users.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/koinprocom',
            ],
            website: [
                'https://koinpro.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'airswap',
        name: 'AirSwap',
        description: 'AirSwap.io is decentralized exchange. Decentralized exchanges do not require a third party to store your funds, instead, you are always directly in control of your coins and you conduct transactions directly with whoever wants to buy or sell your coins. This makes it possible to create an account and right away be able to start trading. This exchange doesn’t charge any trading fees. ',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/airswap',
            ],
            website: [
                'https://www.airswap.io/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 70000,
        confidence_score: 0,
    },
    {
        id: 'newchange',
        name: 'Newchange',
        description: 'We are a brand new Centralised exchange. With low fees and a user-friendly design. The main features of our exchange are spot trading, staking pool, IEO (coming soon) and Airdrop. We are KYC certified and a registered crypto company in Hungary.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/Newchange_nce',
            ],
            website: [
                'https://newchange.io',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 20000,
        confidence_score: 0,
    },
    {
        id: 'maplechange',
        name: 'MapleChange',
        description: null,
        active: false,
        website_status: false,
        api_status: false,
        message: 'Official information: exchange was hacked and all BTC and LTC deposits are gone.',
        links: {
            twitter: [
                'https://twitter.com/maplechangeex',
            ],
            website: [
                'https://maplechange.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'mylocalcoin',
        name: 'Mylocalcoin',
        description: 'We have built Mylocalcoin Exchange with very precise objective which is to help both Buyers and Sellers accomplish their goal effortlessly and securely. Buy and sell popular digital currencies, keep track of them in the one place. For added security store your funds in vault with time delayed withdrawals.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://mylocalcoin.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'coinmate',
        name: 'CoinMate',
        description: 'CoinMate is a cryptocurrency exchange based in London, founded in 2014. The main fiat currencies are EUR and CZK. ',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://coinmate.io',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 212,
        reported_rank: 226,
        currencies: 6,
        markets: 17,
        fiats: [
            {
                name: 'Euro',
                symbol: 'EUR',
            },
            {
                name: 'Czech Koruna',
                symbol: 'CZK',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 972941.75607904,
                adjusted_volume_24h: 972941.75607904,
                reported_volume_7d: 5616477.37902015,
                adjusted_volume_7d: 5616477.37902015,
                reported_volume_30d: 44575648.57711512,
                adjusted_volume_30d: 44575648.57711512,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0.431301,
    },
    {
        id: 'elitex-exchange',
        name: 'EliteX Exchange',
        description: "We are fresh cryptocurrency exchange from Estonia, created 2021.\r\nElitex will provide besides staking, trading games, swap and spot also platform for learning and guiding others to become great traders.\r\n\r\nEnjoy hundreds of tokens and trading pairs. Buy cryptocurrency with debit/credit card, participate in games, ICO's and enjoy the high liquidity level, no matter how skilled trader you are today, It is made for everybody!",
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://elitex.exchange',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 105,
        reported_rank: 117,
        currencies: 7,
        markets: 12,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 33460891.43869001,
                adjusted_volume_24h: 33460891.43869001,
                reported_volume_7d: 121346223.87439641,
                adjusted_volume_7d: 121346223.87439641,
                reported_volume_30d: 339289242.45110863,
                adjusted_volume_30d: 339289242.45110863,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'crypton-exchange',
        name: 'Crypton Exchange',
        description: 'Crypton Exchange is a cutting-edge cryptocurrency trading platform. It is the first native Utopia ecosystem service providing the secure and comfortable way to buy and sell Crypton cryptocurrency.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://crp.is/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 261,
        reported_rank: 276,
        currencies: 4,
        markets: 3,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 53020.11885302,
                adjusted_volume_24h: 53020.11885302,
                reported_volume_7d: 800540.23171083,
                adjusted_volume_7d: 800540.23171083,
                reported_volume_30d: 3137259.20104286,
                adjusted_volume_30d: 3137259.20104286,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 20000,
        confidence_score: 0,
    },
    {
        id: 'binance',
        name: 'Binance',
        description: "CEO Changpeng Zhao had previously founded Fusion Systems in 2005 in Shanghai; the company built high-frequency trading systems for brokers. In 2013 he joined Blockchain.info as the third member of the portfolio team. He also worked at OKCoin as CTO for less than a year, a platform for the site that trades between fiat and digital assets\r\n\r\nThe company was founded in China but moved its servers and headquarters to Japan in anticipation of the Chinese government's ban on cryptocurrency trading in September 2017. In March 2018 the company established its offices in Taiwan\r\n\r\nIn January 2018 it successfully raised its token (BNB) to a market capitalisation of $1.3 billion.\r\n\r\nIn March 2018, Binance announced its intentions to open an office in Malta following tighter controls in Japan and China. In April 2018, Binance signed a Memorandum of Understanding (MoU) with the Government of Bermuda.4 Months later, a similar MoU was signed with the Malta Stock Exchange to develop a platform for token trade security. In 2019, the company announced Binance Jersey, a separate entity from its parent Binance.com exchange, with the goal of expanding its European influence. Jersey based exchange offers fiat-to-cryptocurrency pairs, including the Euro and the British Pound\r\nIn January 2019, Binance announced that it would partner with an Israel-based payment processor Simplex to enable purchases with debit cards and credit cards, including Visa and Mastercard. Purchases are made with Simplex's policies and local bank policies being limited to Bitcoin, Ethereum, Litecoin and Ripple XRP\r\n\r\nIn May 2019, Binance announced that it was the victim of a \"large-scale security breach\" in which hackers stole 7,000 Bitcoin with an estimated value of $40 million. Changpeng Zhao said the hackers \"used various techniques, including phishing, viruses and other attacks\" and structured their transaction \"in a way that passed our existing security controls.\" The site promised to reimburse affected customers\r\nBinance is not officially regulated by global entities. It is not known exactly in which country the company's headquarters are located. On 21 February 2020 the Malta Financial Services Authority issued a public statement noting that Binance \"is not licensed by MFSA to work in the cryptocurrency sphere, so it is not intended for regulatory oversight from MFSA. \r\n\r\nOn 28 October 2020, Forbes contributors published leaked documents confirming that Binance and Changpeng Zhao (also known as CZ) have created an elaborate corporate structure designed to premeditatedly deceive US regulators and achieve hidden profits from cryptocurrency investors\r\nOn April 20, 2021, Brian Brooks who served as the head of the Trump administration's Office of the Comptroller of the Currency (OCC) became the new CEO of Binance.US",
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/binance',
            ],
            website: [
                'https://www.binance.com',
                'https://www.binance.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 1,
        reported_rank: 2,
        currencies: 317,
        markets: 1247,
        fiats: [
            {
                name: 'Euro',
                symbol: 'EUR',
            },
            {
                name: 'Pound Sterling',
                symbol: 'GBP',
            },
            {
                name: 'Russian Ruble',
                symbol: 'RUB',
            },
            {
                name: 'Turkish Lira',
                symbol: 'TRY',
            },
            {
                name: 'Australian Dollar',
                symbol: 'AUD',
            },
            {
                name: 'Ukrainian Hryvnia',
                symbol: 'UAH',
            },
            {
                name: 'Nigerian Naira',
                symbol: 'NGN',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 11892849085.631912,
                adjusted_volume_24h: 11892849085.631912,
                reported_volume_7d: 93483078477.23833,
                adjusted_volume_7d: 93483078477.23833,
                reported_volume_30d: 492467569216.5783,
                adjusted_volume_30d: 492467569216.5783,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 495100000,
        confidence_score: 0.822095,
    },
    {
        id: 'bitopro',
        name: 'BitoPro',
        description: 'BitoPro is a centralized cryptocurrency exchange located in Taiwan.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://www.bitopro.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 139,
        reported_rank: 153,
        currencies: 12,
        markets: 22,
        fiats: [
            {
                name: 'Taiwan New Dollar',
                symbol: 'TWD',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 10703193.22256385,
                adjusted_volume_24h: 10703193.22256385,
                reported_volume_7d: 68260060.41443987,
                adjusted_volume_7d: 68260060.41443987,
                reported_volume_30d: 286627783.4481257,
                adjusted_volume_30d: 286627783.4481257,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 1640000,
        confidence_score: 0.749284,
    },
    {
        id: 'amanpuri',
        name: 'Amanpuri',
        description: "Amanpuri Exchange is a DLT exchange with an up to 200x leverage trading platform and a spot transaction platform and its main services through order matching systems with customer assets protection in mind. We value the proetection of customers asset and we'll ensure utmost safety of customers asset.",
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/AMANPURIEX',
            ],
            website: [
                'https://amanpuri.io/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'brexily',
        name: 'Brexily',
        description: 'Brexily is one of many prominent products developed by Everus Technologies in a mission to expand the Everus World Ecosystem to pioneer the widespread adoption of cryptocurrency.\r\n\r\nTargeted to mass crypto adopters, Brexily is a one-stop platform offering optimal services from procuring, spending to earning cryptocurrency. Aim to elevate the user’s trading experience, Brexily is developed to extend the usability of cryptocurrency by providing an easy solution that caters to the needs and demands of today’s market segment simultaneously, expanding the trading community.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://brexily.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'btctradeim',
        name: 'BtcTrade.im',
        description: 'BTCTrade.im is a Chinese cryptocurrency exchange. BTCTrade.im does not explicitly forbid US-investors from trading on its exchange. BTCTrade.im does not accept any other deposit method than cryptocurrencies.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/btctradeim',
            ],
            website: [
                'https://www.btctrade.im/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'polarity',
        name: 'Polarity',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://polarity.exchange/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 262,
        reported_rank: 277,
        currencies: 6,
        markets: 5,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 47433.48759012,
                adjusted_volume_24h: 47433.48759012,
                reported_volume_7d: 361815.06348026,
                adjusted_volume_7d: 361815.06348026,
                reported_volume_30d: 1547608.7899069,
                adjusted_volume_30d: 1547608.7899069,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 20000,
        confidence_score: 0,
    },
    {
        id: 'codex-exchange',
        name: 'CODEX Exchange',
        description: null,
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/CODEX_Exchange',
            ],
            website: [
                'https://codex.one/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'pangolin',
        name: 'Pangolin',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://pangolin.exchange/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 146,
        reported_rank: 160,
        currencies: 44,
        markets: 61,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 8305940.03277024,
                adjusted_volume_24h: 8305940.03277024,
                reported_volume_7d: 76644492.76873037,
                adjusted_volume_7d: 76644492.76873037,
                reported_volume_30d: 389079452.6940898,
                adjusted_volume_30d: 389079452.6940898,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 3300000,
        confidence_score: 0.001333,
    },
    {
        id: 'catex',
        name: 'Catex',
        description: 'Catex was founded in August 2018. Catex is the first truly community-managed exchange platform in the blockchain space. All major decisions are made by the community and voted. The Catex management team will only be responsible for platform operations, marketing and major perceptions. Landing and technical support, including the implementation of new features, APP development, Coin listing, Customer service etc.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/catexofficial',
            ],
            website: [
                'https://www.catex.io/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 79,
        reported_rank: 90,
        currencies: 44,
        markets: 81,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 81707686.15551758,
                adjusted_volume_24h: 81707686.15551758,
                reported_volume_7d: 362765947.2716858,
                adjusted_volume_7d: 362765947.2716858,
                reported_volume_30d: 2180547505.8368034,
                adjusted_volume_30d: 2180547505.8368034,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 1000000,
        confidence_score: 0.217853,
    },
    {
        id: 'coxi',
        name: 'COXI',
        description: 'COXI is a new and regulated cryptocurrency exchange, which was created by experienced specialists and supporters from the cryptocurrency industry. COXI platform is innovative and unique due to the possession of three separate markets for cryptocurrencies, IEO and company-personal tokens. The exchange distinguish pairs to FIAT currencies (PLN,USD,EUR) and instant deposits. COXI also offers rare features in comparison to other cryptocurrency exchange platforms such as the public OTC market and payment gateway.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/coxi_io',
            ],
            website: [
                'https://coxi.io',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'velvet',
        name: 'VELVET',
        description: 'Velvet Exchange is a platform where you can trade crypto-assets and euros without any limits. Deposit currency, make transfers and manage your money as you want it — regardless if you are an individual trader or a company. Velvet Exchange will provide you with all the necessary documents to confirm your income, aggregate your liquidity and offer other opportunities for profitable and convenient trading.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/VelvetBroker',
            ],
            website: [
                'https://velvet.exchange',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'fisco',
        name: 'Fisco',
        description: 'Fisco is a Japanese exchange that focuses on trading Bitcoin and several other other digital assets against the local currency, JPY. It also facilitates coin-to coin trades. The biggest advantage of Fisco exchange is the fact that it holds a license by JFSA, as required by local law.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/FCCE_jp',
            ],
            website: [
                'https://fcce.jp',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 10000,
        confidence_score: 0,
    },
    {
        id: 'spookyswap',
        name: 'SpookySwap',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://spookyswap.finance/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 63,
        reported_rank: 72,
        currencies: 145,
        markets: 197,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 120596152.03182413,
                adjusted_volume_24h: 120596152.03182413,
                reported_volume_7d: 750339866.8252892,
                adjusted_volume_7d: 750339866.8252892,
                reported_volume_30d: 3159352053.0682073,
                adjusted_volume_30d: 3159352053.0682073,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 7420000,
        confidence_score: 0.002997,
    },
    {
        id: 'coinzo',
        name: 'Coinzo',
        description: 'Coinzo is the crypto currency exchage that gives world class service as a standart. Distributing Neo-Gas "daily", improved api service, 24/7 expert customer support, multi-layered security architecture, supporting 6 different assets in 3 pair, own crypto currency to fee discount are some features of Coinzo.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/coinzocom',
            ],
            website: [
                'https://www.coinzo.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 40000,
        confidence_score: 0,
    },
    {
        id: 'carbonswap',
        name: 'Carbonswap',
        description: 'CarbonSwap is a family of interconnected green, sustainability-focused DeFi & NFT products, including initially an automated market-making (AMM) decentralized exchange (DEX) and a bi-directional ERC-to-ERC bridge (Omnibridge) between the Ethereum Mainnet and Energy Web Chain. ‌\r\nCarbonSwap is meant to be a long-term creator vision- and community-driven effort with a weighted token-based governance model and a lot of fun.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://carbonswap.exchange',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 30000,
        confidence_score: 0,
    },
    {
        id: 'hotbit',
        name: 'Hotbit',
        description: 'The people behind Hotbit outlines on their website that they believe in the core values of blockchain technology and Bitcoin. They feel that these principles, along with those of smart contracts and a distributed ledger, change the way that people trust each other. The team also feels that via blockchain technology, there will be an increased transactional efficiency, fewer barriers in place to stop transactions, and eventually, a large impact on the global economy.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/Hotbit_news',
            ],
            website: [
                'https://www.hotbit.io/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 74,
        reported_rank: 83,
        currencies: 920,
        markets: 1389,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 90211048.36078656,
                adjusted_volume_24h: 90211048.36078656,
                reported_volume_7d: 674780199.4028426,
                adjusted_volume_7d: 674780199.4028426,
                reported_volume_30d: 2950296191.700784,
                adjusted_volume_30d: 2950296191.700784,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 10200000,
        confidence_score: 0.489767,
    },
    {
        id: 'braziliex',
        name: 'Braziliex',
        description: '',
        active: false,
        website_status: true,
        api_status: false,
        message: 'Exchange is not active',
        links: {
            twitter: [
                'https://twitter.com/braziliextrades',
            ],
            website: [
                'https://braziliex.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'eco-exchange',
        name: 'Eco Exchange',
        description: '',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://ecoexchange.host/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'hoo',
        name: 'Hoo',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/hooexchange',
            ],
            website: [
                'https://hoo.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 29,
        reported_rank: 35,
        currencies: 97,
        markets: 98,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 658372385.5894687,
                adjusted_volume_24h: 658372385.5894687,
                reported_volume_7d: 4716572381.073175,
                adjusted_volume_7d: 4716572381.073175,
                reported_volume_30d: 18256515976.042152,
                adjusted_volume_30d: 18256515976.042152,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 2610000,
        confidence_score: 0.362222,
    },
    {
        id: 'kryptono',
        name: 'Kryptono',
        description: 'Kryptono, is a Singapore-based exchange that opened for account registration in 2018. Kryptono aims to facilitate widespread use of blockchain technology by making it as simple as possible to grow real-world crypto on a global scale.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/KryptonoEx',
            ],
            website: [
                'https://kryptono.exchange',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'allbit',
        name: 'Allbit',
        description: null,
        active: false,
        website_status: true,
        api_status: false,
        message: 'Exchange is not active',
        links: {
            twitter: [
                'https://twitter.com/allbitofficial',
            ],
            website: [
                'https://allbit.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 20000,
        confidence_score: 0,
    },
    {
        id: 'bitxchange',
        name: 'Bitxchange',
        description: 'A regulated crypto exchange that provide decentralize services. We are registered with ASIC on business regulation side and AUSTRAC for AML/CTF regulation side.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: null,
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'itbit',
        name: 'itBit',
        description: 'Since launching in 2012, the itBit team has strived to push the boundaries of sophistication in crypto asset trading. In May 2015, they obtained a trust company charter and opened regulated bitcoin exchange in the U.S.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://www.itbit.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 10000,
        confidence_score: 0,
    },
    {
        id: 'beldex',
        name: 'Beldex',
        description: 'Beldex envisions to create a free world where individual privacy is respected. Centralized cryptocurrency exchanges nowadays act no different from banks. While at the same time, there are several difficulties in using a decentralized exchange. To overcome these constraints, Beldex is coming up with a hybrid exchange.\r\n\r\nThe Beldex coin, a fork of Monero was created to protect transaction privacy. It is the ecosystem coin of the Beldex exchange. Beldex serves a global audience and strives to be inclusive in its services. Beldex is also the first Sharia’h compliant exchange catering to Islamic traders and crypto-enthusiasts all over the world.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://www.beldex.io/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 60000,
        confidence_score: 0,
    },
    {
        id: 'cryptomarket',
        name: 'CryptoMarket',
        description: 'CryptoMarket is a South American crypto exchange. It allows users to buy and sell Bitcoin, Ethereum and other cryptocurrencies directly with their local currencies - Argentinian Peso, Chilean Peso, Euro, and Brazilian Real.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/cryptomkt',
            ],
            website: [
                'https://www.cryptomkt.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 332,
        reported_rank: 365,
        currencies: 4,
        markets: 11,
        fiats: [
            {
                name: 'Brazil Real',
                symbol: 'BRL',
            },
            {
                name: 'Chilean Peso',
                symbol: 'CLP',
            },
            {
                name: 'Argentine Peso',
                symbol: 'ARS',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 1800000,
        confidence_score: 0,
    },
    {
        id: 'okx',
        name: 'OKX',
        description: 'OKX is a Malta based world-leading digital asset exchange, providing advanced financial services to global traders by using blockchain technology. OKEx is also one of the top digital asset exchanges in the world by trading volume, serving over 20 million customers in over 100 countries. Its BTC futures trade also has nearly $1.5B of volume daily, and is widely recognized as the gold standard for the industry. ',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/OKEx',
            ],
            website: [
                'https://www.okx.com',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 9,
        reported_rank: 12,
        currencies: 160,
        markets: 273,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 2386978710.839571,
                adjusted_volume_24h: 2386978710.839571,
                reported_volume_7d: 19064599310.743366,
                adjusted_volume_7d: 19064599310.743366,
                reported_volume_30d: 96670310329.10658,
                adjusted_volume_30d: 96670310329.10658,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 18900000,
        confidence_score: 0.366281,
    },
    {
        id: 'whitebit',
        name: 'WhiteBIT',
        description: 'Launched in Dec 2018, WhiteBIT is a European centralized exchange that offers crypto-to-crypto and crypto-to-fiat transactions with 0.1% trading fees. With European Exchange and Custody licenses, WhiteBIT meets KYC and AML requirements. It claims to have 150,000+ users from the EU, South America, and Asia registered on the platform. WhiteBIT offers instant transactions with P2P codes, possibility of staking, private and public API & a number of trading tools: limit, market, stop limit and stop market orders. Quick deposits and withdrawals are carried out with InstantSend by Dash.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/WhiteBit6',
            ],
            website: [
                'https://whitebit.com',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 38,
        reported_rank: 45,
        currencies: 35,
        markets: 71,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
            {
                name: 'Euro',
                symbol: 'EUR',
            },
            {
                name: 'Ukrainian Hryvnia',
                symbol: 'UAH',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 494152001.86209977,
                adjusted_volume_24h: 494152001.86209977,
                reported_volume_7d: 4854348636.995803,
                adjusted_volume_7d: 4854348636.995803,
                reported_volume_30d: 20660779402.619766,
                adjusted_volume_30d: 20660779402.619766,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 3000000,
        confidence_score: 0.373639,
    },
    {
        id: 'cryptoplanex',
        name: 'Cryptoplanex',
        description: "Cryptoplanex is a modern, safe Trading Platform for accessing cryptocurrency exchange markets with very simple interface and low trading fees. Our own API is easy-to-use, supplied with an instructional manual. Our Support Service communicates in Russian, English and Chinese and replies to the Customers' tickets 7 days a week within working hours (UTC+3). CryptoPlanex Exchange is a service for sale and purchase of cryptocurrency for cryptocurrecncy and for fiat money with large variety of trading tools; bots trading and arbitrage is also available and allowed. Our Customers may exchange, buy, sell, play on the rates fluctuations and make profits – same as at conventional exchanges. Except here they are dealing with a new type of money – cryptocurrency, which gives more room for maneuver and higher potential profit.",
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/cryptoplanex',
            ],
            website: [
                'https://cryptoplanex.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'tokenlon',
        name: 'Tokenlon',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/tokenlon',
            ],
            website: [
                'https://tokenlon.im/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 154,
        reported_rank: 168,
        currencies: 9,
        markets: 9,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 6355106.94220982,
                adjusted_volume_24h: 6355106.94220982,
                reported_volume_7d: 45004968.51607072,
                adjusted_volume_7d: 45004968.51607072,
                reported_volume_30d: 172224626.344946,
                adjusted_volume_30d: 172224626.344946,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 30000,
        confidence_score: 0.000012,
    },
    {
        id: 'bitladon',
        name: 'Bitladon',
        description: "Bitladon is the international name for Bitcoin Meester, who was founded in May 2017. Bitcoin Meester has proven to be a stable concept in The Netherlands and Europe ever since.\r\n\r\nWe provide a unique platform. It is not only possible to buy and sell coins, you can even trade any to any! Our platform is easily accessible, fast and cheap. In addition to our platform, we are also active on social media. You can find us on Telegram, Twitter, Instagram and Facebook.\r\nWe provide coins from a euro/coin pair. Everybody in europe can pay directly with euro's on our platform. ",
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/bitladon',
            ],
            website: [
                'https://bitladon.com',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 195,
        reported_rank: 209,
        currencies: 122,
        markets: 122,
        fiats: [
            {
                name: 'Euro',
                symbol: 'EUR',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 1778053.50105562,
                adjusted_volume_24h: 1778053.50105562,
                reported_volume_7d: 17636589.87216201,
                adjusted_volume_7d: 17636589.87216201,
                reported_volume_30d: 102050817.5960957,
                adjusted_volume_30d: 102050817.5960957,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'vebitcoin',
        name: 'Vebitcoin',
        description: 'Vebitcoin is a trading exchange founded in 2017 based in Turkey. It has more than 25 types of cryptocurrencies and planned to give users the opportunity to chart their financial paths in Turkey and the World. Three language options are available, Russian, Turkish and English. All information on the market can be accessed without registration. Our exchange provides 7/24 support. It is open to TRY/BTC withdrawals and deposits. All products on our stock exchange, which is a Bitgo partner, are covered by insurance.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/Vebitcointr',
            ],
            website: [
                'https://www.vebitcoin.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'limitlex',
        name: 'Limitlex',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://limitlex.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 252,
        reported_rank: 267,
        currencies: 17,
        markets: 33,
        fiats: [
            {
                name: 'Euro',
                symbol: 'EUR',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 103904.51657872,
                adjusted_volume_24h: 103904.51657872,
                reported_volume_7d: 738468.44527758,
                adjusted_volume_7d: 738468.44527758,
                reported_volume_30d: 2956290.00105194,
                adjusted_volume_30d: 2956290.00105194,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0.202019,
    },
    {
        id: 'nlexch',
        name: 'NLexch',
        description: 'NLexch is a Dutch cryptocurrency exchange platform that aims to make cryptocurrencies more accessible to everyone.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/NLexch',
            ],
            website: [
                'https://www.nlexch.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'garantex',
        name: 'Garantex',
        description: 'Garantex is a fast growing global cryptocurrency exchange that provides users secure access to the global crypto markets. The exchange provides a selected number of cryptoassets pairs - BTC, USDT, DAI, ETH against Russian Rubles, Hryvnia and US Dollars. Garantex is fully licensed as a virtual asset trading platform in the European Union under the Estonian Financial Authority.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://garantex.io/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 143,
        reported_rank: 157,
        currencies: 4,
        markets: 14,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
            {
                name: 'Russian Ruble',
                symbol: 'RUB',
            },
            {
                name: 'Ukrainian Hryvnia',
                symbol: 'UAH',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 9482609.87851332,
                adjusted_volume_24h: 9482609.87851332,
                reported_volume_7d: 57604687.1991208,
                adjusted_volume_7d: 57604687.1991208,
                reported_volume_30d: 447930198.464585,
                adjusted_volume_30d: 447930198.464585,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 770000,
        confidence_score: 0.75031,
    },
    {
        id: 'ezbtc',
        name: 'ezBtc',
        description: 'ezBtc is a Canadian cryptocurrency exchange that offers trading in major cryptocurrencies for Canadian dollars. In order to start trading, the client needs to get ID verification, as the company operates with “real money” and there are KYC and AML requirements that need to be met.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'There are many reports about customers being unable to withdraw their assets, according to various resources.',
        links: {
            twitter: [
                'https://twitter.com/ezBtcCanada',
            ],
            website: [
                'https://www.ezbtc.ca',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'bigmarkets-limited',
        name: 'Bigmarkets Limited',
        description: 'BIG MARKETS is a full-featured spot trading platform for major digital assets & cryptocurrencies. BIGMARKETS peer-to-peer funding market, allowing users to securely trade. ',
        active: false,
        website_status: false,
        api_status: false,
        message: 'Exchange is not active',
        links: {
            twitter: [
                'https://twitter.com/Bigmarkets_io',
            ],
            website: [
                'https://www.bigmarkets.io/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'coineal',
        name: 'Coineal',
        description: 'Coineal, found online at Coineal.com, is a cryptocurrency exchange founded by a team based in South Korea and China. The exchange was announced on April 24, 2018. Coineal currently maintains offices in South Korea and China. They’re also planning to launch offices in Japan, Singapore, the United States, Russia, and other countries. ',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/CoinealExchange',
            ],
            website: [
                'https://www.coineal.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 305535458.2441728,
                adjusted_volume_30d: 305535458.2441728,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 300000,
        confidence_score: 0,
    },
    {
        id: 'bitbank',
        name: 'Bitbank',
        description: 'The Bitbank exchange and services were launched in 2014 with their company being based out of Japan and is under the regulation of the Japanese Financial Services Agency (JFSA). The only fiat currency supported for exchanging with cryptocurrencies is the Japanese Yen (JPY).',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/bitbank_inc',
            ],
            website: [
                'https://bitbank.cc',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 117,
        reported_rank: 129,
        currencies: 6,
        markets: 8,
        fiats: [
            {
                name: 'Japanese Yen',
                symbol: 'JPY',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 22385113.16091745,
                adjusted_volume_24h: 22385113.16091745,
                reported_volume_7d: 175771073.67754793,
                adjusted_volume_7d: 175771073.67754793,
                reported_volume_30d: 914631654.1587565,
                adjusted_volume_30d: 914631654.1587565,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 5400000,
        confidence_score: 0.052181,
    },
    {
        id: 'xs2',
        name: 'XS2',
        description: 'XS2 Cryptocurrency exchange is the new player in crypto markets launched by an Australian based company in 2018. This blockchain initiative by XS2 is within the Australian laws where the parent company has been registered as a Cryptocurrency Exchange. In addition, the platform has also acquired the rights to act as a Dealer Independently. XS2 also enjoys Australia’s Digital Commerce Association (ADCA) membership. ',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/xs2exchange',
            ],
            website: [
                'https://xs2.exchange/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'minecraftcoin',
        name: 'MinecraftCoin',
        description: '',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/coin_minecraft',
            ],
            website: [
                'https://www.minecraftcoin.online/exchange-2/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'bitcoinvn',
        name: 'BitcoinVN',
        description: 'Instant Vietnamese Cryptocurency Exchange.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://bitcoinvn.io',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 10000,
        confidence_score: 0,
    },
    {
        id: 'probit-exchange',
        name: 'ProBit Exchange',
        description: 'ProBit Exchange is a global coin-to-coin exchange that accepts no listing fees. ProBit Exchange only lists deserving cryptocurrency projects. ProBit Exchange has order matching speed of more than 1.5m orders per second and has a customizable user interface. In addition, ProBit Exchange supports the option of a hardware security key in addition to software 2 Factor Authenticator.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/ProBit_Exchange',
            ],
            website: [
                'https://www.probit.com/',
                'https://www.probit.com/en-us/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 62,
        reported_rank: 71,
        currencies: 319,
        markets: 443,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 126817804.89515114,
                adjusted_volume_24h: 126817804.89515114,
                reported_volume_7d: 984534265.3360511,
                adjusted_volume_7d: 984534265.3360511,
                reported_volume_30d: 4158162061.042737,
                adjusted_volume_30d: 4158162061.042737,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 8700000,
        confidence_score: 0.092953,
    },
    {
        id: 'dasset',
        name: 'Dasset',
        description: 'Founded in 2017, New Zealand, Dasset is crypto asset exchange platform for Kiwis to trade bitcoin and over 50 other digital assets. Located in Auckland, New Zealand, our goal is to help create a world of universal financial access. Dasset is the place for Kiwis to buy, sell, and trade digital assets such as Bitcoin and Ethereum. Our trading platform is designed for retail customers, professional traders, and institutional customers.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/dassetx',
            ],
            website: [
                'https://dassetx.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 145,
        reported_rank: 159,
        currencies: 12,
        markets: 29,
        fiats: [
            {
                name: 'Euro',
                symbol: 'EUR',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 8946690.09057554,
                adjusted_volume_24h: 8946690.09057554,
                reported_volume_7d: 74486244.49723797,
                adjusted_volume_7d: 74486244.49723797,
                reported_volume_30d: 348383223.2941953,
                adjusted_volume_30d: 348383223.2941953,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 30000,
        confidence_score: 0.000012,
    },
    {
        id: 'xena-exchange',
        name: 'Xena Exchange',
        description: '',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/XenaExchange',
            ],
            website: [
                'https://xena.exchange/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 10000,
        confidence_score: 0,
    },
    {
        id: 'koinex',
        name: 'Koinex',
        description: 'Koinex is a cryptocurrency exchange based in India in 2017 that offers trading in some of the most popular cryptocurrencies against the local currency (INR). Although Koinex currently supports five cryptocurrencies, coin-to coin trading is not enabled on the exchange.',
        active: false,
        website_status: false,
        api_status: false,
        message: 'Exchange has terminated their service',
        links: {
            twitter: [
                'https://twitter.com/koinexindia',
            ],
            website: [
                'https://koinex.in/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 10000,
        confidence_score: 0,
    },
    {
        id: 'alcor-exchange',
        name: 'Alcor Exchange',
        description: 'Founded in 2020 Alcor is decentralized exchange based on EOSIO tech, that was first exchange allowed community to list their tokens with no validation and request permission. Which gives the opportunity for the community to carry out truly free trade.\r\n\r\nAlcor supports many wallets, such as Wax Cloud Wallet, Anchor, Scatter and others.\r\n\r\nThanks to eosio technology, the order book is located directly in the blockchain, which provides an absolutely secure trading opportunity.\r\n\r\nAt the moment, Alcor supports blockchains: WAX, EOS, Proton, Telos.\r\n\r\nThe community is actively involved in the development of the project. The project code is open on github and everyone has the right to really influence the project by offering their improvements.',
        active: true,
        website_status: false,
        api_status: false,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/alcorexchange',
            ],
            website: [
                'http://alcor.exchange/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 318,
        reported_rank: 333,
        currencies: 3,
        markets: 2,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 15.22693674,
                adjusted_volume_24h: 15.22693674,
                reported_volume_7d: 239.30499235,
                adjusted_volume_7d: 239.30499235,
                reported_volume_30d: 239.30499235,
                adjusted_volume_30d: 239.30499235,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 4850000,
        confidence_score: 0,
    },
    {
        id: 'arowex',
        name: 'ArowEx',
        description: 'ArowEx cryptocurrency exchange provides secure exchange, allowing customers to easily exchange cryptocurrencies.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/arowex',
            ],
            website: [
                'https://arowex.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 20000,
        confidence_score: 0,
    },
    {
        id: 'novadax',
        name: 'NovaDAX',
        description: 'We are NovaDAX, one of the best Brazilian exchanges, providing various crypto trading services to Brazilian traders: BTC,ETH, XRP, LTC, USDT, ADA, IOTA, DOGE, BCH, TRX, BTT with pairs BRL-CRYPTO and CRYPTO-CRYPTO.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/Nova_DAX',
            ],
            website: [
                'https://www.novadax.com.br',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 190,
        reported_rank: 204,
        currencies: 21,
        markets: 48,
        fiats: [
            {
                name: 'Brazil Real',
                symbol: 'BRL',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 2161905.88869266,
                adjusted_volume_24h: 2161905.88869266,
                reported_volume_7d: 15781362.09458689,
                adjusted_volume_7d: 15781362.09458689,
                reported_volume_30d: 84431616.45979658,
                adjusted_volume_30d: 84431616.45979658,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 30000,
        confidence_score: 0.750012,
    },
    {
        id: 'globecryptotrade',
        name: 'GlobeCryptoTrade',
        description: 'GlobeCryptoTrade Exchange',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/crypto_globe',
            ],
            website: [
                'https://globecryptotrade.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'digifinex',
        name: 'DigiFinex',
        description: 'Digifinex started operating in 2017 and is based in Singapore. ',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/digifinex',
            ],
            website: [
                'https://www.digifinex.com',
                'https://www.digifinex.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 17,
        reported_rank: 22,
        currencies: 110,
        markets: 156,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 1340002162.6903336,
                adjusted_volume_24h: 1340002162.6903336,
                reported_volume_7d: 9619380454.260674,
                adjusted_volume_7d: 9619380454.260674,
                reported_volume_30d: 30273246560.211414,
                adjusted_volume_30d: 30273246560.211414,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 361000000,
        confidence_score: 0.741637,
    },
    {
        id: 'coinfield',
        name: 'CoinField',
        description: "CoinField is a fully regulated European based cryptocurrency exchange operating in 193 countries from all corners of the globe. It is rapidly growing with over 200,000+ users with 6 fiat deposit + withdrawal options and over 20+ cryptos to trade. CoinField is also developing a project called Sologenic which will allow it's users to trade over 30,000 tokenized stocks and ETFs.",
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/CoinFieldEx',
            ],
            website: [
                'https://www.coinfield.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 141,
        reported_rank: 155,
        currencies: 22,
        markets: 79,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
            {
                name: 'Euro',
                symbol: 'EUR',
            },
            {
                name: 'Pound Sterling',
                symbol: 'GBP',
            },
            {
                name: 'Canadian Dollar',
                symbol: 'CAD',
            },
            {
                name: 'Japanese Yen',
                symbol: 'JPY',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 10026288.70652906,
                adjusted_volume_24h: 10026288.70652906,
                reported_volume_7d: 77614728.40315413,
                adjusted_volume_7d: 77614728.40315413,
                reported_volume_30d: 396513345.6674886,
                adjusted_volume_30d: 396513345.6674886,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 290000,
        confidence_score: 0.723256,
    },
    {
        id: 'aex',
        name: 'AEX',
        description: 'AEX is a cryptocurrency exchange oriented mainly towards the Chinese market. ',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://www.aex88.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 4931406803.882833,
                adjusted_volume_30d: 4931406803.882833,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'saddle-finance',
        name: 'Saddle Finance',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/saddlefinance',
            ],
            website: [
                'https://saddle.finance/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 182,
        reported_rank: 196,
        currencies: 7,
        markets: 6,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 2963891.85703212,
                adjusted_volume_24h: 2963891.85703212,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 20000,
        confidence_score: 0.000008,
    },
    {
        id: 'bitesax',
        name: 'Bitesax',
        description: 'Bitesax Exchange Powerful Centralized Crypto Trading Platform\r\nOur brand new high-speed platform supports a processing capacity of up to 25,000 transactions per second.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/ESAXTechnologi1',
            ],
            website: [
                'https://bitesax.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'oasisdex',
        name: 'OasisDEX',
        description: '',
        active: false,
        website_status: true,
        api_status: false,
        message: 'Exchange is not active',
        links: {
            twitter: [
                'https://twitter.com/makerdao',
            ],
            website: [
                'https://oasisdex.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'gokumarket',
        name: 'GokuMarket',
        description: 'GokuMarket is a European-licensed and one of the best cryptocurrency exchanges, wallet & marketplace providers. The exchange has been active since 2019 and is widely used in the UK, France, Poland, Czech Republic, Sweden, Norway, Japan, Thailand, Vietnam, Nigeria, South Africa, Ecuador and Colombia as the primary market.\r\n\r\nGokuMarket has Instant/Convert & Advanced trading categories as per the user’s convenience. Starting from beginners to seasoned traders, GokuMarket is easy to go along with the AI-based trading modules. The exchange has a lot of trading pairs and several other real world use cases with e-commerce shopping, staking, debit cards and more.\r\n\r\nGokuMarket exchange is one of the few that enables users to purchase cryptocurrencies by using VISA & Mastercard. It also provides direct fiat deposits and withdrawals of EUR via SEPA to and from their GokuMarket Wallet via their bank accounts. Launched in 2020, GokuMarket Credit (GMC) is the Ultimate DeFi E-commerce Token, powered by both the Ethereum smart contract and the Binance Smart Chain (BSC) DeFi blockchains.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/GokuMarket',
            ],
            website: [
                'https://gokumarket.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 57,
        reported_rank: 65,
        currencies: 27,
        markets: 55,
        fiats: [
            {
                name: 'Euro',
                symbol: 'EUR',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 171057243.0625166,
                adjusted_volume_24h: 171057243.0625166,
                reported_volume_7d: 1507543222.3431997,
                adjusted_volume_7d: 1507543222.3431997,
                reported_volume_30d: 6946103324.679403,
                adjusted_volume_30d: 6946103324.679403,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 2540000,
        confidence_score: 0.80058,
    },
    {
        id: 'terrabit',
        name: 'Terrabit',
        description: 'Terrabit is an all-inclusive web and mobile application supported by Terrabit, a highly secure and super-fast centralised cryptocurrency exchange, payment platform and Crypto mining. The App was designed to keep your funds safe at all times while allowing you access to it whenever you need it. Terrabit makes it effortless to send money, to pay for goods or to receive payments for services. It’s easy crypto management on the go!',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/Terrabitcrypto',
            ],
            website: [
                'https://www.terra-bit.io/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'dragonex',
        name: 'DragonEX',
        description: 'They were the first trading platform to introduce a dividend token, known as Dragon Token and they guaranteed that they would distribute all of the commission income from the daily transactions.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/Dragonex_io',
            ],
            website: [
                'https://dragonex.io',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 52,
        reported_rank: 59,
        currencies: 105,
        markets: 108,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 222268662.5779403,
                adjusted_volume_24h: 222173796.49026495,
                reported_volume_7d: 1646444516.9500668,
                adjusted_volume_7d: 1645779572.6494665,
                reported_volume_30d: 3378183346.1253567,
                adjusted_volume_30d: 3375298011.4833426,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0.000061,
    },
    {
        id: 'paintswap',
        name: 'PaintSwap',
        description: 'PaintSwap.finance is the most colorful DEX, yield Farm and NFT marketplace supporting both ERC721 & ERC1155 standards on the Fantom Opera network.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/paint_swap',
            ],
            website: [
                'https://paintswap.finance/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 128,
        reported_rank: 141,
        currencies: 9,
        markets: 11,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 14721369.73449244,
                adjusted_volume_24h: 14721369.73449244,
                reported_volume_7d: 106271737.71280177,
                adjusted_volume_7d: 106271737.71280177,
                reported_volume_30d: 469529091.1106875,
                adjusted_volume_30d: 469529091.1106875,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 1300000,
        confidence_score: 0.000525,
    },
    {
        id: 'bitinka',
        name: 'Bitinka',
        description: 'BitInka is a trading platform founded in 2013 with more than 60 trading pairs for Bitcoin, Ethereum, Dash, Ripple and other cryptocurrencies, which allow the users to buy and sell in more than 10 different currencies from America, Europe and Asia.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/bitinka',
            ],
            website: [
                'https://www.bitinka.com',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 109,
        reported_rank: 121,
        currencies: 15,
        markets: 65,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
            {
                name: 'Euro',
                symbol: 'EUR',
            },
            {
                name: 'Brazil Real',
                symbol: 'BRL',
            },
            {
                name: 'Chilean Peso',
                symbol: 'CLP',
            },
            {
                name: 'Bolivian Boliviano',
                symbol: 'BOB',
            },
            {
                name: 'Colombian Peso',
                symbol: 'COP',
            },
            {
                name: 'Peruvian Sol',
                symbol: 'PEN',
            },
            {
                name: 'Argentine Peso',
                symbol: 'ARS',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 27776058.09877558,
                adjusted_volume_24h: 27776058.09877558,
                reported_volume_7d: 196507733.36860886,
                adjusted_volume_7d: 196507733.36860886,
                reported_volume_30d: 3187001728.421844,
                adjusted_volume_30d: 3187001728.421844,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 10000,
        confidence_score: 0.675224,
    },
    {
        id: 'openledger-dex',
        name: 'OpenLedger DEX',
        description: 'OpenLedger DEX is a cryptocurrency trading platform founded in 2014. The platform caters to traders of all sizes and experience levels. The DEX, by the way, stands for “decentralized exchange”.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/OpenLedgerDC',
            ],
            website: [
                'https://openledger.io/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'cryptonick',
        name: 'CryptoNick',
        description: '',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/CryptonickE',
            ],
            website: [
                'https://cryptonick.exchange',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'zolex',
        name: 'Zolex',
        description: 'To provide a permanent solution to the Blockchain world is our goal. One of the greatest asset platforms.',
        active: false,
        website_status: false,
        api_status: false,
        message: 'Exchange is not active',
        links: {
            twitter: [
                'https://twitter.com/ZolexEcosystem',
            ],
            website: [
                'https://zolex.org/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'allcoin',
        name: 'Allcoin',
        description: 'Allcoin is owned by the company Cascadia Blockchain Group, which is listed on the Canadian Security Exchange. Allcoin was launched in the summer of 2016 and is registered on a federal level as a money services business by FINTRAC (Financial Transactions and Reports Analysis Centre). It also says it is under the supervision of Canadian Financial Regulatory authorities.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/AllCoinEx',
            ],
            website: [
                'https://www.allcoin.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'btc-exchange',
        name: 'BTC-exchange',
        description: null,
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://www.btc-exchange.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'kraken',
        name: 'Kraken',
        description: 'Founded in 2011, Kraken Digital Asset Exchange is one of the world’s oldest bitcoin exchanges with the widest selection of digital assets and national currencies. Based in San Francisco with offices around the world.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/krakenfx',
            ],
            website: [
                'https://www.kraken.com',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 28,
        reported_rank: 34,
        currencies: 89,
        markets: 357,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
            {
                name: 'Euro',
                symbol: 'EUR',
            },
            {
                name: 'Pound Sterling',
                symbol: 'GBP',
            },
            {
                name: 'Canadian Dollar',
                symbol: 'CAD',
            },
            {
                name: 'Japanese Yen',
                symbol: 'JPY',
            },
            {
                name: 'Swiss Franc',
                symbol: 'CHF',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 661166937.7727822,
                adjusted_volume_24h: 661166937.7727822,
                reported_volume_7d: 4854583022.486912,
                adjusted_volume_7d: 4854583022.486912,
                reported_volume_30d: 25270878593.727276,
                adjusted_volume_30d: 25270878593.727276,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 26900000,
        confidence_score: 0.810866,
    },
    {
        id: 'bitconx',
        name: 'BitConx',
        description: 'BitConx is a global cryptocurrency exchange that provides a platform for trading with zero fees.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/BitConx',
            ],
            website: [
                'https://bitconx.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'gozo',
        name: 'GOZO',
        description: 'XMT Gozo exchange is registered in Malta, thus benefiting from the EU regulatory infrastructure. Malta is the first country in the EU to enact comprehensive legal framework in the sphere of blockchain technology and digital assets. ',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://gozo.pro/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'instant-bitex',
        name: 'Instant Bitex',
        description: 'Instant Bitex is a coin exchange from the United Kingdom. The company running the exchange is INSTANT BITEX LIMITED (company number 11353300).',
        active: false,
        website_status: true,
        api_status: false,
        message: "Exchange has abruptly shut down, without proper notice.\n\n<a href='https://www.otcpm24.com/instantbitex-crypto-exchange-shuts-down/' target='_blank'>read more about it</a>",
        links: {
            twitter: [
                'https://twitter.com/instantbitex',
            ],
            website: [
                'https://instantbitex.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'hollaex',
        name: 'HollaEx',
        description: 'HollaEx is an open digital asset exchange built by cryptocurrency veterans and professionals for traders and businesses. Our mission is to bring open markets and trading in every corner of the world.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/hollaex',
            ],
            website: [
                'https://hollaex.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 151,
        reported_rank: 165,
        currencies: 13,
        markets: 12,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 6678806.18522365,
                adjusted_volume_24h: 6678806.18522365,
                reported_volume_7d: 40492477.98511362,
                adjusted_volume_7d: 40492477.98511362,
                reported_volume_30d: 145156913.2696244,
                adjusted_volume_30d: 145156913.2696244,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 140000,
        confidence_score: 0.000057,
    },
    {
        id: 'wbfex',
        name: 'WBFEX',
        description: 'WBFEX global digital assets exchange (WBFEX) is a digital currency exchange under the WBF financial group in New York. \r\nIt is registered in Singapore and aims to build a third-generation digital currency exchange that integrates the international trading ecosystem.\r\nWith strong strength, rich industry resources and profound blockchain technology strength, WBFEX global digital asset exchange will lead the development trend in digital asset security trading, international services, the whole industry ecology and other aspects.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/wbfex',
            ],
            website: [
                'http://www.wbfex.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'ravendax',
        name: 'Ravendax',
        description: 'We offer to traders, safety low trading fees and ability to interact with our utility coin ravengreen, we are a green exchange.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://www.ravendax.com',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 322,
        reported_rank: 337,
        currencies: 3,
        markets: 2,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0.37402732,
                adjusted_volume_24h: 0.37402732,
                reported_volume_7d: 10202449.74208746,
                adjusted_volume_7d: 10202449.74208746,
                reported_volume_30d: 117357742.3647361,
                adjusted_volume_30d: 117357742.3647361,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'eterbase',
        name: 'Eterbase',
        description: 'Eterbase is a cryptocurrency exchange platform with a focus on crypto to SEPA integration (via individual IBAN accounts), multi-asset support, and regulatory compliance. Eterbase aims to become a fully compliant platform that offers a broad range of B2C and B2B cryptocurrency-specialized solutions, such as a high-frequency trading platform, over-the-counter trading, treasury management and high-frequency server hosting with a direct-market access and incentive system for market makers in the form of negative trading fees.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/ETERBASE',
            ],
            website: [
                'https://www.eterbase.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'trade-by-trade',
        name: 'Trade By Trade',
        description: 'Trade By Trade is a crypto-exchange that offers only crypto-to-crypto spot trading, as well as margin trading. According their website, their service are owned by Trade By Trade Ltd., a Vanuatu IBC (Trade By Trade) with Dealers in Securities License #40198. The platform follows the European Data Protection Procedures.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'Warning! Exchange is having mostly negative opinions on social media and other websites, for their services.',
        links: {
            twitter: [
                'https://twitter.com/Tradebytradetbt',
            ],
            website: [
                'https://tradebytrade.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'amsterdex',
        name: 'Amsterdex',
        description: '',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/Amster_Dex',
            ],
            website: [
                'https://amsterdex.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'coinhub',
        name: 'Coinhub',
        description: 'CoinHub is Singapore based entry level cryptocurrency exchange (with an additional office in Dubai). CoinHub is an all new Digital Currency Exchange Hub that can be used to buy and sell crypto assets through the use of fiat currency.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/coinhubex',
            ],
            website: [
                'https://coinhub.io',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'hcoin',
        name: 'HCoin',
        description: 'HCoin is an overseas registered cryptocurrency trading platform dedicated to providing users with safe, fast and stable full services. The platform business covers comprehensive services such as cryptocurrency trading, big data analysis and digital asset management. HCoin.com receives Starlight Capital, Guanghe Capital, Engine Capital, Cloud Capital, Three-Chain Capital, Chain Capital, BD Fund, BW Fund, YC Fund, Richway Fund, NewBlock Capital, BlockRock Capital, SKYCC Capital, Beecool, etc. dozens of cornerstone strategic investments. HCoin.com has a top international financial management team, comprehensive and long-term development planning, and the future development potential is immeasurable.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/HCoinOfficial',
            ],
            website: [
                'https://www.hcoin86.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'gateio',
        name: 'Gate.io',
        description: 'Gate.io is a cryptocurrency exchange platform that started in 2017; the site is available in both English and Chinese and provides access to a wide range of cryptocurrencies. The team behind the exchange utilize both cold storage and a hot wallet in order to store funds and client accounts are secured by using two factor authentication and a combination of passwords.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/gate_io',
            ],
            website: [
                'https://www.gate.io/',
                'https://gate.io/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 22,
        reported_rank: 27,
        currencies: 673,
        markets: 1205,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 1101260639.051055,
                adjusted_volume_24h: 1101260639.051055,
                reported_volume_7d: 8522286714.655566,
                adjusted_volume_7d: 8522286714.655566,
                reported_volume_30d: 39692731817.64743,
                adjusted_volume_30d: 39692731817.64743,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 61300000,
        confidence_score: 0.340389,
    },
    {
        id: 'bit2c',
        name: 'Bit2C',
        description: 'Bit2C is an Israeli cryptocurrency exchange founded in 2013 that offers trading in several digital assets against the local fiat currency, ILS. Clients of this exchange are required to verify their identity and connect their account to an Israeli Bank account to be able to use the platform. ',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/bit2c',
            ],
            website: [
                'https://www.bit2c.co.il',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 237,
        reported_rank: 251,
        currencies: 3,
        markets: 3,
        fiats: [
            {
                name: 'Israeli Shekel',
                symbol: 'ILS',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 262692.83366606,
                adjusted_volume_24h: 262692.83366606,
                reported_volume_7d: 1063182.8649877,
                adjusted_volume_7d: 1063182.8649877,
                reported_volume_30d: 3877009.60479342,
                adjusted_volume_30d: 3877009.60479342,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 150000,
        confidence_score: 0,
    },
    {
        id: 'btse',
        name: 'BTSE',
        description: 'An Innovative Platform for Futures and Spot Trading, which settle profits in any currency or coin that maximize your capital with up to 100x leverage. Post margin with multiple currencies and coins simultaneously. Easily add and remove multiple collateralized assets on the fly that benefits from volatile markets without being susceptible to the volatility of cryptocurrencies. Better liquidity with all currencies sharing the same liquidity pool via one order book.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/btsecom',
            ],
            website: [
                'https://www.btse.com/en/home',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 39,
        reported_rank: 46,
        currencies: 8,
        markets: 26,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 458971828.84466267,
                adjusted_volume_24h: 458971828.84466267,
                reported_volume_7d: 2038503373.4439945,
                adjusted_volume_7d: 2038503373.4439945,
                reported_volume_30d: 12201081429.154034,
                adjusted_volume_30d: 12201081429.154034,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 250000,
        confidence_score: 0.750101,
    },
    {
        id: 'nut-money',
        name: 'NUT MONEY',
        description: 'NUT is a Protocol initialized on Huobi ECO Chain with lower gas cost and higher efficiency. Besides the basic loan function, NUT would bring more in the following steps, all is aiming for a Crunchy DeFi environment.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://nut.money/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 809.03885092,
                adjusted_volume_7d: 809.03885092,
                reported_volume_30d: 1300.46491613,
                adjusted_volume_30d: 1300.46491613,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'trade-crypto-king',
        name: 'Trade Crypto King',
        description: 'Tradecryptoking is a digital asset exchange and trading platform, offering a variety of features for both beginners and professional traders. Markets available: BTC, ETH, USD. Head office is in USA.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/TradeCKing',
            ],
            website: [
                'https://www.tradecryptoking.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'paymium',
        name: 'Paymium',
        description: 'Paymium is a French cryptocurrency exchange with headquarters in Paris, that offers trading between Bitcoin and EUR. It has been operating since 2011 and offers its services globally, including the USA. Paymium also allows for the opening of company accounts.  Paymium offers its own mobile trading application for Android and iOS devices. It allows users to create alerts, manage orders and positions and to pay in Bitcoins instantly. The only cryptocurrency Paymium offers, is Bitcoin.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/paymium',
            ],
            website: [
                'https://www.paymium.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 265,
        reported_rank: 280,
        currencies: 1,
        markets: 1,
        fiats: [
            {
                name: 'Euro',
                symbol: 'EUR',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 34427.35617058,
                adjusted_volume_24h: 34427.35617058,
                reported_volume_7d: 872630.42863323,
                adjusted_volume_7d: 872630.42863323,
                reported_volume_30d: 4041324.68388882,
                adjusted_volume_30d: 4041324.68388882,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 60000,
        confidence_score: 0,
    },
    {
        id: 'citex',
        name: 'CITEX',
        description: 'CITEX is a world leading digital asset trading platform and top POW coin trading platform.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'CITEX exchange has been disabled, due to inconsistency in their data reported by API endpoints and front-end of site.',
        links: {
            twitter: [
                'https://twitter.com/citexofficial',
            ],
            website: [
                'https://www.citex.co.kr/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 980000,
        confidence_score: 0,
    },
    {
        id: 'koinfit',
        name: 'KoinFit',
        description: 'KoinFit is a highly secured exchange using multi-sig wallets to secure your cryptos. Using industry leading security practices, we ensure that your crypto assets are safe.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/koinfit',
            ],
            website: [
                'https://koinfit.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'abcc',
        name: 'ABCC',
        description: 'ABCC Digital Asset Exchange (ABCC) is a world-class exchange launched in 2018, offering digital asset investment and trading solutions for users globally. Calvin Cheng founded ABCC Exchange. Cheng worked with co-founders who have a range of experience plus successful track records in financial services, management consulting, and internet firms. ',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/ABCC_Exchange',
            ],
            website: [
                'https://abcc.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 132,
        reported_rank: 146,
        currencies: 9,
        markets: 10,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 12770874.34223427,
                adjusted_volume_24h: 12770874.34223427,
                reported_volume_7d: 181555714.88744318,
                adjusted_volume_7d: 181555714.88744318,
                reported_volume_30d: 2507292837.7149696,
                adjusted_volume_30d: 2507292837.7149696,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 490000,
        confidence_score: 0.000198,
    },
    {
        id: 'zapple',
        name: 'Zapple',
        description: 'Zapple is a new digital currency exchange based in the UK. We allow you to convert and trade digital currencies in a safe and secure environment. We apply strong security standards ensuring that your funds are always kept safe. Our systems are designed to cope with load and failure - supporting your trades when you need them most. Our order processing engine aims to match orders in milliseconds - no more waiting for distributed exchanges.',
        active: false,
        website_status: true,
        api_status: false,
        message: 'Zapple exchange closed on December 31st 2020.',
        links: {
            twitter: [
                'https://twitter.com/zapple_exchange',
            ],
            website: [
                'https://zapple.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'bitenium',
        name: 'Bitenium',
        description: 'The Bitenium Exchange is a new-gen cryptocurrency trading platform. Automate your trading and take your emotion out of the equation. Use expert tools without coding skills. Invest in all cryptocurrencies that your exchange offers. High liquidity and secure wallet.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://bitenium.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 4,
        reported_rank: 7,
        currencies: 29,
        markets: 28,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 3732755433.1179514,
                adjusted_volume_24h: 3732755433.1179514,
                reported_volume_7d: 27075436476.615486,
                adjusted_volume_7d: 27075436476.615486,
                reported_volume_30d: 136460037788.00795,
                adjusted_volume_30d: 136460037788.00795,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'coinbe',
        name: 'Coinbe',
        description: 'Coinbe (formally Beatcoin) is a Polish exchange founded in 2017, that offered both fiat-to-crypto and crypto-to-crypto trading. Unfortunately, its fiat operations are temporarily suspended due to regulation issues.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'There are numerous customers complaints towards this exchange, about lack of possibility to withdraw their cryptocurrencies.',
        links: {
            website: [
                'https://coinbe.net/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'bcoinsg',
        name: 'BCoin.sg',
        description: 'The vision of BCoin.sg is to provide an all-encompassing cryptocurrency service platform for the new tokenized economy. ',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/Bcoinsg',
            ],
            website: [
                'https://www.bcoin.sg/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'bx-thailand',
        name: 'BX Thailand',
        description: 'BX Thailand is cryptocurrency exchange, which started in 2013. Bitcoin.Co.Ltd operates BX Thailand. The company allows the exchange between both crypto-to-crypto and crypto to fiat currency.',
        active: false,
        website_status: false,
        api_status: false,
        message: 'Bitcoin Co. Ltd. has decided to discontinue offering digital exchange services and wallet services at our BX.in.th website in order to focus on other business opportunities.',
        links: {
            website: [
                'https://bx.in.th',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'bakeryswap',
        name: 'Bakeryswap',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://www.bakeryswap.org/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 257,
        reported_rank: 272,
        currencies: 7,
        markets: 15,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 86550.40880019,
                adjusted_volume_24h: 86550.40880019,
                reported_volume_7d: 863666.39965449,
                adjusted_volume_7d: 863666.39965449,
                reported_volume_30d: 6581861.20369266,
                adjusted_volume_30d: 6581861.20369266,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 960000,
        confidence_score: 0,
    },
    {
        id: 'orca-dex',
        name: 'Orca DEX',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://www.orca.so/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 208,
        reported_rank: 222,
        currencies: 9,
        markets: 9,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 1100361.24567697,
                adjusted_volume_24h: 1100361.24567697,
                reported_volume_7d: 15553993.47451876,
                adjusted_volume_7d: 15553993.47451876,
                reported_volume_30d: 46718148.20513841,
                adjusted_volume_30d: 46718148.20513841,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 1400000,
        confidence_score: 0,
    },
    {
        id: 'shortex',
        name: 'SHORTEX',
        description: 'Rapidly growing digital asset platform with an incorporated P2P payments solution.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/ShortexExchange',
            ],
            website: [
                'https://shortex.net/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'bit-team',
        name: 'BitTeam',
        description: 'Bit Team is a P2P platform on which anyone can buy/sell cryptocurrency, at market price, without intermediaries, directly.\r\nBit Team - originally developed as a platform for users of any level, experienced traders will discover a new market, and beginner enthusiasts will be able to easily understand in an intuitive interface and securely acquire cryptocurrency.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://bit.team/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 130000,
        confidence_score: 0,
    },
    {
        id: 'bybit-spot',
        name: 'Bybit (Spot)',
        description: '',
        active: true,
        website_status: false,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://www.bybit.com/en-US/trade/spot/BTC/USDT',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 61,
        reported_rank: 70,
        currencies: 16,
        markets: 18,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 136627228.31485963,
                adjusted_volume_24h: 136627228.31485963,
                reported_volume_7d: 1790978102.22671,
                adjusted_volume_7d: 1790978102.22671,
                reported_volume_30d: 8573927674.234305,
                adjusted_volume_30d: 8573927674.234305,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 38500000,
        confidence_score: 0.015552,
    },
    {
        id: 'bkex',
        name: 'Bkex',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/ComBkex',
            ],
            website: [
                'https://www.bkex.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 32,
        reported_rank: 38,
        currencies: 293,
        markets: 314,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 590336129.6143595,
                adjusted_volume_24h: 590336129.6143595,
                reported_volume_7d: 3180520021.437746,
                adjusted_volume_7d: 3180520021.437746,
                reported_volume_30d: 14185630335.153597,
                adjusted_volume_30d: 14185630335.153597,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 3100000,
        confidence_score: 0.405375,
    },
    {
        id: 'exchangily',
        name: 'eXchangily',
        description: 'eXchangily is a new decentralized exchange model built on the prominent Fast Access Blockchain. It is the worlds first cross chain DEX. It carries the best of a centralized exchange, namely the speed and ease of use, with all the security benefits of a decentralized exchange.\r\n\r\nUsers retain control over their funds, their private keys, and their transaction information is transparent and secure. Individuals can trade, and enterprises can transact on eXchangily with ERC20 tokens and other cryptocurrencies. It is a fully democratic and autonomous platform.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/Exchangily',
            ],
            website: [
                'https://exchangily.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 110000,
        confidence_score: 0,
    },
    {
        id: 'float-sv',
        name: 'Float SV',
        description: "Float SV is a digital asset exchange that only supports tokenized real assets. The platform delivers a real asset exchange experience by committing to only list blockchains running Proof of Work SHA256 and real assets such as commodities and currencies.\r\n\r\nFloat SV's mission is to provide reliable trading experience and access to deep asset liquidity. Float SV is built by believers and practitioners of proof of work.",
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/FloatSVcom',
            ],
            website: [
                'https://www.floatsv.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'blocktane',
        name: 'Blocktane',
        description: 'Blocktane was designed and built in partnership with Tritum, a team of former financial services professionals who are focused on creating top tier quality solutions for securities and cryptocurrency markets using technology and business practices from their career histories in regulated securities markets. Tritum’s team has held senior roles at Nasdaq, Toronto Stock Exchange, securities regulators, broker dealers, and sophisticated high frequency trading firms.\r\nBlocktane operates a high performance digital asset exchange infrastructure designed with technology and principles from traditional financial markets to serve clients with equal confidence and quality as any other financial institution.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/blocktane',
            ],
            website: [
                'https://blocktane.io/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 268,
        reported_rank: 283,
        currencies: 4,
        markets: 6,
        fiats: [
            {
                name: 'Brazil Real',
                symbol: 'BRL',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 31346.28733521,
                adjusted_volume_24h: 31346.28733521,
                reported_volume_7d: 167449.55985376,
                adjusted_volume_7d: 167449.55985376,
                reported_volume_30d: 804153.10527161,
                adjusted_volume_30d: 804153.10527161,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 90000,
        confidence_score: 0,
    },
    {
        id: 'unnamed',
        name: 'Unnamed',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: "Forum thread about problems with users withdrawals.\n\n<a href='https://bitcointalk.org/index.php?topic=5320917.0' target='_blank'>Read more about it</a>",
        links: {
            twitter: [
                'https://twitter.com/exchangeunnamed',
            ],
            website: [
                'https://www.unnamed.exchange/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 290,
        reported_rank: 305,
        currencies: 129,
        markets: 445,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 2050.35328735,
                adjusted_volume_24h: 2050.35328735,
                reported_volume_7d: 4756.06106506,
                adjusted_volume_7d: 4756.06106506,
                reported_volume_30d: 33294.70318247,
                adjusted_volume_30d: 33294.70318247,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 90000,
        confidence_score: 0,
    },
    {
        id: 'embr',
        name: 'embr',
        description: 'embr is a one-stop decentralized investment platform on Avalanche leveraging the "Best in Breed" DeFi protocols to offer decentralized investment strategies. Built on BalancerV2, embr is the first next-generation AMM protocol on Avalanche.\r\nembr offers swap, staking, farming, weighted investment pools and compose your own pool options. Weighted investment pools transform the concept of an index fund: instead of paying fees to portfolio managers to rebalance your portfolio, you collect fees from traders, who auto-rebalance your portfolio as they follow arbitrage opportunities.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/EmbrFinance',
            ],
            website: [
                'https://embr.finance/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 40000,
        confidence_score: 0,
    },
    {
        id: 'bitfinex',
        name: 'Bitfinex',
        description: 'Bitfinex was founded in December 2012 as a peer-to-peer Bitcoin exchange, offering digital asset trading services to users around the world. Bitfinex initially started as a P2P margin lending platform for Bitcoin and later added support for more cryptocurrencies.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/bitfinex',
            ],
            website: [
                'https://bitfinex.com',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 41,
        reported_rank: 48,
        currencies: 110,
        markets: 239,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
            {
                name: 'Euro',
                symbol: 'EUR',
            },
            {
                name: 'Pound Sterling',
                symbol: 'GBP',
            },
            {
                name: 'Japanese Yen',
                symbol: 'JPY',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 378032776.74149805,
                adjusted_volume_24h: 378032776.74149805,
                reported_volume_7d: 2970717604.594101,
                adjusted_volume_7d: 2970717604.594101,
                reported_volume_30d: 15644471317.611347,
                adjusted_volume_30d: 15644471317.611347,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 102000000,
        confidence_score: 0.791086,
    },
    {
        id: 'bitfineon',
        name: 'Bitfineon',
        description: 'Bitfineon is a best-in-class crypto exchange with a heavy focus on optimized user experience for novice traders and professionals, alike.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/bitfineon',
            ],
            website: [
                'https://bitfineon.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'graviex',
        name: 'Graviex',
        description: 'Graviex is a cryptocurrency exchange associated with the Gravio project. The exchange launched in February 2018. Graviex is coin exchange that was originally created in Russia and has its data center there. Graviex recently moved their headquarters to the Malta.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/graviex_net',
            ],
            website: [
                'https://graviex.net/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 240,
        reported_rank: 254,
        currencies: 141,
        markets: 334,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
            {
                name: 'Euro',
                symbol: 'EUR',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 239757.13796836,
                adjusted_volume_24h: 239757.13796836,
                reported_volume_7d: 1853229.99059274,
                adjusted_volume_7d: 1853229.99059274,
                reported_volume_30d: 7182542.55550063,
                adjusted_volume_30d: 7182542.55550063,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 2360000,
        confidence_score: 0,
    },
    {
        id: 'b2bx',
        name: 'B2BX',
        description: 'B2BX’s team, according to the official website, “consists of 35 highly qualified specialists that are located in 3 different countries.” Key members of the team include Founder and CEO Artur Azizov, COO Evgeniya Mykulyak, CTO Vlad Posivenko, and CFO Olga Tkachenko. The company was founded in 2014, when they launched two products called White Label MT4/MT5 and Traders Room for brokers. B2BX aims to make it easier for customers to compete by working as an exchange aggregator, providing a pool of liquidity connecting the marketplace across multiple exchanges.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/b2bx_exchange',
            ],
            website: [
                'https://www.b2bx.exchange/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 136,
        reported_rank: 150,
        currencies: 10,
        markets: 22,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
            {
                name: 'Euro',
                symbol: 'EUR',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 12149823.63085418,
                adjusted_volume_24h: 12149823.63085418,
                reported_volume_7d: 91902966.18314095,
                adjusted_volume_7d: 91902966.18314095,
                reported_volume_30d: 425281781.8747969,
                adjusted_volume_30d: 425281781.8747969,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 40000,
        confidence_score: 0.000016,
    },
    {
        id: 'bitsten',
        name: 'Bitsten',
        description: 'Bitsten is an Indonesian cryptocurrency exchange launched in 2017.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/bitstendotcom',
            ],
            website: [
                'https://bitsten.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 238,
        reported_rank: 252,
        currencies: 10,
        markets: 11,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 246187.03971965,
                adjusted_volume_24h: 246187.03971965,
                reported_volume_7d: 1850739.64895321,
                adjusted_volume_7d: 1850739.64895321,
                reported_volume_30d: 7980687.90162599,
                adjusted_volume_30d: 7980687.90162599,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 30000,
        confidence_score: 0,
    },
    {
        id: 'satowallet-exchange',
        name: 'Satowallet',
        description: '',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/satowallet',
            ],
            website: [
                'https://satowallet.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'jewex',
        name: 'Jewex',
        description: 'Launched on 17 Oct 2019, Jewex is a centralized exchange located at Jewelpay OÜ, Harju maakond, Tallinn, Kesklinna linnaosa, Narva mnt 7-634, 10117, Estonia. It reportedly supports USD fiat pairs/fiat deposits/fiat withdrawals.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/jewelpay_org',
            ],
            website: [
                'https://jewex.io',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'c2cx',
        name: 'C2CX',
        description: 'C2CX is a Chinese cryptocurrency exchange launched in 2016 that is registered in Luxembourg.  It offers crypto-to-crypto spot trading in some of the most popular coins. Like more exchanges, C2CX utilizes Google two-factor authentication (2FA), but unverified users can also trade on the exchange. ',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/C2CXE',
            ],
            website: [
                'https://www.c2cx.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'rightbtc',
        name: 'RightBTC',
        description: 'Founded in 2014, RightBTC is a cryptocurrency exchange with advanced order types and 24/7 customer support. The exchange can be used on a desktop or on mobile with dedicated iOS and Android apps. RightBTC regularly adds support for new assets which meet listing criteria, and new trading products like the Leveraged ETF.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/Rightbtc_',
            ],
            website: [
                'https://www.rightbtc.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'mercatox',
        name: 'Mercatox',
        description: 'Mercatox is a cryptocurrency exchange launched in 2016. The firm operating the site and the brand is headquartered in London, UK.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/MercatoxCom',
            ],
            website: [
                'https://mercatox.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 120,
        reported_rank: 132,
        currencies: 234,
        markets: 439,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 21826020.6959678,
                adjusted_volume_24h: 21826020.6959678,
                reported_volume_7d: 160279902.129933,
                adjusted_volume_7d: 160279902.129933,
                reported_volume_30d: 714351494.6012182,
                adjusted_volume_30d: 714351494.6012182,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 990000,
        confidence_score: 0.0004,
    },
    {
        id: 'okcoincn',
        name: 'OKCoin.cn',
        description: '',
        active: false,
        website_status: false,
        api_status: false,
        message: 'Exchange is not active',
        links: {
            website: [
                'https://www.okcoin.cn',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 10000,
        confidence_score: 0,
    },
    {
        id: 'codex',
        name: 'CODEX',
        description: 'CODEX was established in May 2018, same month 2 licenses were obtained: for fiat/crypto exchange and crypto currencies storage. CODEX is registered in Estonia. CODEX is an EOS-oriented exchange, working closely with AtticLab and AtticPool, one of the top EOS Block Producers.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'CODEX exchange will be closed on 01/15/2020 due changes in the regulatory policy of the European Union. Please withdraw your funds before this date.',
        links: {
            twitter: [
                'https://twitter.com/CODEX_Exchange',
            ],
            website: [
                'https://codex.one',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'zonda',
        name: 'Zonda',
        description: 'Zonda (ex-BitBay) is one of the largest digital currency exchanges in Europe with over 1 million users. The company was established in 2014 and it is regulated by the Estonian Financial Intelligence Unit (FIU). The Zonda exchange has a policy against money laundering and terrorism financing and ensures the safety and security of the deposits and trading via the platform by applying strict AML and KYC procedures.\r\n\r\nUsers can make transactions in over 50 coins and tokens in pairs with traditional currencies (EUR, GBP and PLN), stablecoins (USDT and USDC), and BTC and ETH. Zonda is continually developing and expanding its business, which has resulted in the creation of such products as Zonda FIAT Exchange and Zonda Pay. \r\n\r\nZonda is on a mission to democratize the access to cryptocurrency. The company’s ambition is to develop simple intuitive tools, the education programmes, and the regulatory framework, that will help its customers to trade and spend confidently from a position of strength.',
        active: true,
        website_status: false,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/zondaglobal',
            ],
            website: [
                'https://bitbay.net/',
                'https://zondaglobal.com',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 165,
        reported_rank: 179,
        currencies: 50,
        markets: 183,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
            {
                name: 'Euro',
                symbol: 'EUR',
            },
            {
                name: 'Pound Sterling',
                symbol: 'GBP',
            },
            {
                name: 'Polish Zloty',
                symbol: 'PLN',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 4389321.76578071,
                adjusted_volume_24h: 4389321.76578071,
                reported_volume_7d: 41957131.61222035,
                adjusted_volume_7d: 41957131.61222035,
                reported_volume_30d: 210256232.4296617,
                adjusted_volume_30d: 210256232.4296617,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 40000,
        confidence_score: 0.78823,
    },
    {
        id: 'bilaxy',
        name: 'Bilaxy',
        description: 'The exchange launched in April 2018. At this exchange, you can trade a number of different altcoins, against the ETH. Bilaxy does not accept any deposits of fiat currency.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'Bilaxy was hacked - please refer to their site, for more information.',
        links: {
            twitter: [
                'https://twitter.com/bilaxy_exchange',
            ],
            website: [
                'https://bilaxy.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 175,
        reported_rank: 189,
        currencies: 141,
        markets: 143,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 3540406.74715377,
                adjusted_volume_24h: 3540406.74715377,
                reported_volume_7d: 31832109.8289211,
                adjusted_volume_7d: 31832109.8289211,
                reported_volume_30d: 166109958.6548617,
                adjusted_volume_30d: 166109958.6548617,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 210000,
        confidence_score: 0.000085,
    },
    {
        id: 'block-beats-exchange',
        name: 'BLOCK BEATS EXCHANGE',
        description: 'Blockbeats is a new generation exchange offering the most in-demand services on the market. Spot exchange, margin trading, crypto-backed loans. 24/7 support. We work best to be the first.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://blockbeats.exchange/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 248,
        reported_rank: 263,
        currencies: 4,
        markets: 3,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 127746.07922925,
                adjusted_volume_24h: 127746.07922925,
                reported_volume_7d: 4166781.93265095,
                adjusted_volume_7d: 4166781.93265095,
                reported_volume_30d: 20434733.46956725,
                adjusted_volume_30d: 20434733.46956725,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'cryptology',
        name: 'Cryptology',
        description: 'Cryptology, the startup based out of Singapore is looking to make cryptocurrency transactions easier, more affordable by creating a “next generation” cryptocurrency exchange, that would be one of the first new companies to combine and fiat transaction on a user platform. The site accepts bank deposits as it supports visa and MasterCard for fiat transactions. The site has a mobile application for users who would like to trade on the go.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/Cryptologyexch',
            ],
            website: [
                'https://cryptology.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 113,
        reported_rank: 125,
        currencies: 9,
        markets: 28,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
            {
                name: 'Euro',
                symbol: 'EUR',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 23416207.48741367,
                adjusted_volume_24h: 23416207.48741367,
                reported_volume_7d: 190083396.89174888,
                adjusted_volume_7d: 190083396.89174888,
                reported_volume_30d: 869560741.7817172,
                adjusted_volume_30d: 869560741.7817172,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 280000,
        confidence_score: 0.750113,
    },
    {
        id: 'easy-finance',
        name: 'Easy Finance',
        description: 'Working to make an all-in-one digital exchange.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/EasyCorpNews',
            ],
            website: [
                'https://www.easyfinance.live',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 296,
        reported_rank: 311,
        currencies: 7,
        markets: 10,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 626.24763522,
                adjusted_volume_24h: 626.24763522,
                reported_volume_7d: 3392.06094605,
                adjusted_volume_7d: 3392.06094605,
                reported_volume_30d: 94985.52041452,
                adjusted_volume_30d: 94985.52041452,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 20000,
        confidence_score: 0,
    },
    {
        id: 'daexs',
        name: 'Daexs',
        description: 'Daexs is a company that promotes the digitization and decentralization of the economy in Latin America through technological solutions that bring a fast, easy and safe environment for the exchange of cryptocurrencies and other assets based on the distributed ledger technologies between people, merchants and investors. Currently we operate the fastest growing cryptocurrency exchange in Latin America and our goal is to become the platform that aggregates the greatest number of users and transactional volumes in the region, with presence in more than 5 countries by 2020.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/daexstech',
            ],
            website: [
                'https://daexs.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'livecoin',
        name: 'Livecoin',
        description: 'Livecoin is a cryptocurrency trading platform that lets you trade bitcoins, altcoins, and fiat currencies. The exchange was launched in 2013 by a company named Delta E-Commerce Ltd (London). Current owner of the exchange is: Red Velvet Investments Ltd (based in Belize).',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/livecoin_net',
            ],
            website: [
                'https://www.livecoin.net/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'coinsbank',
        name: 'CoinsBank',
        description: 'CoinsBank was initially named BIT-X, but in April 2016 has undergone a complete redesign and emerged again renamed as CoinsBank. With CoinsBank users can trade Bitcoin (BTC) and Litecoin (LTC) against “traditional” (fiat) currencies, such as USD, EUR, GBP, CHF, AUD, JPY, and RUB.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/coins_bank',
            ],
            website: [
                'https://coinsbank.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 360,
        reported_rank: 360,
        currencies: 2,
        markets: 6,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
            {
                name: 'Euro',
                symbol: 'EUR',
            },
            {
                name: 'Pound Sterling',
                symbol: 'GBP',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 445.93448558,
                adjusted_volume_30d: 445.93448558,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 90000,
        confidence_score: 0,
    },
    {
        id: 'btcc',
        name: 'BTCC',
        description: "BTCC is a Hong Kong based bitcoin exchange that was once the world's second largest by volume in October 2014. Founded in June 2011 as BTCChina, it was China's first bitcoin exchange, and most of its customers are thought to be from the domestic market. In 2018 it is thought to now have almost 150 employees.",
        active: false,
        website_status: true,
        api_status: false,
        message: 'Exchange is not active',
        links: {
            twitter: [
                'https://twitter.com/yourbtcc',
            ],
            website: [
                'https://www.btcc.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 130000,
        confidence_score: 0,
    },
    {
        id: 'coinbuy-cash',
        name: 'Coinbuy cash',
        description: '',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/CoinbuyC',
            ],
            website: [
                'https://coinbuy.cash',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'altcoin-trader',
        name: 'Altcoin Trader',
        description: '',
        active: false,
        website_status: true,
        api_status: false,
        message: 'Exchange is not active',
        links: {
            twitter: [
                'https://twitter.com/AltCoinTraderSA',
            ],
            website: [
                'https://www.altcointrader.co.za/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 3080000,
        confidence_score: 0,
    },
    {
        id: 'tripe-dice-exchange',
        name: 'Tripe Dice Exchange',
        description: 'Triple Dice Exchange is a digital cryptocurrency exchange owned and operated by Mythology Holdings PTE Limited. CEO of Mythology Holdings PTE Limited, TAKUYA HASHIYADA (Japanese).\r\n\r\nTriple Dice Exchange is an advanced cryptocurrency (digital assets) trading platform created by our passion for the distributed ledger technology and digital assets. Triple Dice Exchange, a comprehensive cryptocurrency exchange, provides advanced exchange functionalities to allow users to buy and sell Bitcoins and other Altcoins.',
        active: false,
        website_status: false,
        api_status: false,
        message: 'TDX & DICEWALLET have closed as of September 12, 2019.',
        links: {
            website: [
                'https://mydicewallet.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'patriot-exchange',
        name: 'Patriot Exchange',
        description: 'The Patriot Exchange is a fully liquid Crypto Exchange based in the United States. We provide an easy to navigate trading platform with over 25 of your favorite coin/tokens. We offer best in class live & personal customer support.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/ExchangePatriot',
            ],
            website: [
                'https://patriotexchangeusa.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 173,
        reported_rank: 187,
        currencies: 17,
        markets: 16,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 3864888.21497596,
                adjusted_volume_24h: 3864888.21497596,
                reported_volume_7d: 26659063.23753214,
                adjusted_volume_7d: 26659063.23753214,
                reported_volume_30d: 103913617.31939562,
                adjusted_volume_30d: 103913617.31939562,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'ajubit',
        name: 'AjuBit',
        description: "The World's First Informative Crypto Platform! Our unique design, advance matching engine, each pair Global market Price Analysis Study and Overview gives real trading taste and environment!",
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/AjuBit_official',
            ],
            website: [
                'https://ajubit.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'kompler',
        name: 'Kompler',
        description: 'A Brand New Crypto Assets Trading Platform. A trading platform for crypto assets that focus on emerging cryptocurrencies and already consolidated projects.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/komplerexchange',
            ],
            website: [
                'https://www.kompler.exchange',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'thore-exchange',
        name: 'Thore Exchange',
        description: 'As part of the Thore Network (Thorecoin ThoreCash ThoreNext ThoreExchange) long term visions we have created our own exchange platform.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/Thr_Official',
            ],
            website: [
                'https://thoreexchange.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 335,
        reported_rank: 339,
        currencies: 7,
        markets: 12,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 4488914.68018228,
                adjusted_volume_7d: 4488914.68018228,
                reported_volume_30d: 43937637.48792349,
                adjusted_volume_30d: 43937637.48792349,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 50000,
        confidence_score: 0,
    },
    {
        id: 'serum-dex',
        name: 'Serum DEX',
        description: '',
        active: true,
        website_status: true,
        api_status: false,
        message: null,
        links: {
            website: [
                'https://portal.projectserum.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 230,
        reported_rank: 244,
        currencies: 10,
        markets: 12,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 416413.41564618,
                adjusted_volume_24h: 416413.41564618,
                reported_volume_7d: 24758560.71082036,
                adjusted_volume_7d: 24758560.71082036,
                reported_volume_30d: 216637131.60336402,
                adjusted_volume_30d: 216637131.60336402,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 920000,
        confidence_score: 0,
    },
    {
        id: 'sigen-pro',
        name: 'SIGEN.pro',
        description: 'Launched on 22.05.2015, SIGEN.pro is centralized exchange with P2P trading platform. Based in 17 Union Street, Suite 1, Dundee, DD1 4BG, Scotland, UK. Business legal name — Lergen Style LLP. SIGEN.pro exchange supports such cryptocurrencies as BITCOIN (BTC), LITECOIN (LTC), ETHEREUM (ETH), PRIZM (PZM). SIGEN P2P trading platform supports RUB, USD, UAH, EUR, KZT, CZK and such cryptocurrencies as BITCOIN (BTC), LITECOIN (LTC), ETHEREUM (ETH), PRIZM (PZM). SIGEN.pro is 3-in-1 trading platform, where you can: 1) Trade and store cryptocurrencies 2) Quickly swap cryptocurrencies using our automated exchange 3) Buy and sell cryptocurrencies on our P2P trading platform, using cards of different banks of the world and different payment services.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/SIGENpro/',
            ],
            website: [
                'https://sigen.pro/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 246,
        reported_rank: 261,
        currencies: 4,
        markets: 10,
        fiats: [
            {
                name: 'Euro',
                symbol: 'EUR',
            },
            {
                name: 'Russian Ruble',
                symbol: 'RUB',
            },
            {
                name: 'Ukrainian Hryvnia',
                symbol: 'UAH',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 136439.87098108,
                adjusted_volume_24h: 136439.87098108,
                reported_volume_7d: 771222.92045478,
                adjusted_volume_7d: 771222.92045478,
                reported_volume_30d: 15139670.44801924,
                adjusted_volume_30d: 15139670.44801924,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 440000,
        confidence_score: 0,
    },
    {
        id: 'bityard',
        name: 'BitYard',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://www.bityard.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 339,
        reported_rank: 104,
        currencies: 4,
        markets: 4,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 44429106.75376625,
                adjusted_volume_24h: 0,
                reported_volume_7d: 250129597.95993996,
                adjusted_volume_7d: 0,
                reported_volume_30d: 1090682775.025997,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 1000000,
        confidence_score: 0.050404,
    },
    {
        id: 'bitunivex',
        name: 'Bitunivex',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/Bitunivex',
            ],
            website: [
                'https://bitunivex.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 185,
        reported_rank: 199,
        currencies: 15,
        markets: 14,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 2797600.90446948,
                adjusted_volume_24h: 2797600.90446948,
                reported_volume_7d: 20045194.58833105,
                adjusted_volume_7d: 20045194.58833105,
                reported_volume_30d: 75324487.53920358,
                adjusted_volume_30d: 75324487.53920358,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 10000,
        confidence_score: 0.000004,
    },
    {
        id: 'go4mark',
        name: 'Go4mark',
        description: "GTF Exchange is the world's leading place to trade cryptocurrencies, GTF Exchange is one of the first ports of call for many when it comes to Bitcoin, Ethereum, and the rest. GTF Exchange 's app for iOS and Android allows users to buy and sell cryptocurrencies and track prices. It's also a capable wallet for your money, and when it's time to spend, GTF Exchange will help you find merchants who accept cryptocurrencies as payment.",
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/official_1gtf',
            ],
            website: [
                'https://go4mark.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'liquid',
        name: 'Liquid',
        description: 'Launched in September 2018, Quoine is the team behind this multi-crypto exchange platform called Liquid that also introduced two other crypto exchanges viz. Quoinex and Qryptos. Quoine, the parent company of Liquid is one of the few exchanges that is a registered and regulated under financial services authority in Japan, as per country’s new crypto regulations.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/Liquid_Global',
            ],
            website: [
                'https://www.liquid.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 75,
        reported_rank: 84,
        currencies: 83,
        markets: 171,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
            {
                name: 'Euro',
                symbol: 'EUR',
            },
            {
                name: 'Japanese Yen',
                symbol: 'JPY',
            },
            {
                name: 'Australian Dollar',
                symbol: 'AUD',
            },
            {
                name: 'Hong Kong Dollar',
                symbol: 'HKD',
            },
            {
                name: 'Singapore Dollar',
                symbol: 'SGD',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 89233938.15950066,
                adjusted_volume_24h: 89233938.15950066,
                reported_volume_7d: 622313612.7673513,
                adjusted_volume_7d: 622313612.7673513,
                reported_volume_30d: 2584485278.570166,
                adjusted_volume_30d: 2584485278.570166,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 1400000,
        confidence_score: 0.783837,
    },
    {
        id: 'fibercoin-exchange',
        name: 'Fibercoin Exchange',
        description: 'We have young and enthusiastic team. We have a good understanding of digital currency trading and know the needs of our customers. A trader must have a wide choice of assets for trading. Our list of trading pairs is constantly growing. We are always open to collaborating with cryptocurrency owners. Our interface is simple and straightforward for both experienced traders and beginners.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://fiberchange.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 316,
        reported_rank: 331,
        currencies: 19,
        markets: 18,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 22.24742469,
                adjusted_volume_24h: 22.24742469,
                reported_volume_7d: 253.6980937,
                adjusted_volume_7d: 253.6980937,
                reported_volume_30d: 617.31209577,
                adjusted_volume_30d: 617.31209577,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'geco-one',
        name: 'Geco one',
        description: 'Geco.one is a Bitcoin-based cryptocurrency margin trading platform with 1:100 leverage and instant order execution for all assets.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/GecoOne',
            ],
            website: [
                'https://www.geco.one/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 325,
        reported_rank: 88,
        currencies: 15,
        markets: 15,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 87045500,
                adjusted_volume_24h: 0,
                reported_volume_7d: 601978400,
                adjusted_volume_7d: 0,
                reported_volume_30d: 2588426300,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 20000,
        confidence_score: 0.050008,
    },
    {
        id: 'bscexchange',
        name: 'Bscexchange',
        description: 'India’s most secure cryptocurrency trading Exchange , which enables you to buy cryptos with INR at the best rate.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/bscexchangeio',
            ],
            website: [
                'https://bscexchange.io',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'nexdax',
        name: 'NexDAX',
        description: 'NexDAX is setting the gold standard for the exchange of the future. Easy to use for the beginner and powerful enough for the most experienced trader. NexDAX offers features never seen before. NexDAX does everything our competitors do, we just do it bigger, faster and better.\r\nWe formed based on a diverse group of thinkers and doers that are dedicated to making cryptocurrency available and accessible to our value users, investors and clients to enjoy the trading and other crypto services here.\r\nWe support multiple languages through various channels, mainly English and offer a wide range of derivatives; whether you are day trading, investing or hedging you will find the best tools to compliment your trading strategy. Earn money by simply moving your trading account to NexDAX and purchasing NT coin.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/nexdax_exchange',
            ],
            website: [
                'https://nexdax.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 110,
        reported_rank: 122,
        currencies: 9,
        markets: 15,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 27423653.36606515,
                adjusted_volume_24h: 27423653.36606515,
                reported_volume_7d: 195720243.413547,
                adjusted_volume_7d: 195720243.413547,
                reported_volume_30d: 1264695465.5487983,
                adjusted_volume_30d: 1264695465.5487983,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 20000,
        confidence_score: 0.000008,
    },
    {
        id: 'trader-joe',
        name: 'Trader Joe',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://www.traderjoexyz.com/#/home',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 90,
        reported_rank: 101,
        currencies: 101,
        markets: 119,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 53580475.77567407,
                adjusted_volume_24h: 53580475.77567407,
                reported_volume_7d: 483937025.52845633,
                adjusted_volume_7d: 483937025.52845633,
                reported_volume_30d: 2383834139.531982,
                adjusted_volume_30d: 2383834139.531982,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 17600000,
        confidence_score: 0.00711,
    },
    {
        id: 'blue-horizon',
        name: 'Blue Horizon',
        description: 'NFT platform for ARTISTS and COLLECTORS\r\n\r\nWelcome to Blue Horizon, a hybrid platform that embodies the best elements of NFTs, DeFi and blockchain. Blue Horizon combines an NFT marketplace, a token exchange, liquidity pooling, yield farming protocols, and much more. We actively seek out the artists and work with them to produce exclusive pieces for the Blue Horizon platform, imbuing our platform with artwork of a quality and exclusivity that you won’t find anywhere else.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/BlueHorizonNFT',
            ],
            website: [
                'https://app.bluehorizon.art',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 30000,
        confidence_score: 0,
    },
    {
        id: 'bleutrade',
        name: 'Bleutrade',
        description: 'Bleutrade is a cryptocurrency exchange. It has been launched in 2014 and claims to have around 30 000 users. Like most cryptocurrency exchanges Bleutrade has its own web-based trading platform.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/bleutrade',
            ],
            website: [
                'https://bleutrade.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 30000,
        confidence_score: 0,
    },
    {
        id: 'freebitcoins',
        name: 'FreeBitcoins',
        description: 'Xploited created Xchange. Xploited created CLAMCOIN and helped developed Digibyte. BayAreaCoins is the majority share holder of Xchange.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://freebitcoins.com/xchange/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 300,
        reported_rank: 315,
        currencies: 15,
        markets: 14,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 251.20680292,
                adjusted_volume_24h: 251.20680292,
                reported_volume_7d: 614.00070099,
                adjusted_volume_7d: 614.00070099,
                reported_volume_30d: 5480.17814258,
                adjusted_volume_30d: 5480.17814258,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 50000,
        confidence_score: 0,
    },
    {
        id: 'labrotix',
        name: 'Labrotix',
        description: 'By closely following the new developments in Labrotix exchange. By making strong improvements on the platform, it is closely following new technologies. Bitcoin supports all coins built on the pivx, Dash platform. We aim to provide an inexpensive environment for large and small investors with low commission rates.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/labrotix',
            ],
            website: [
                'https://www.labrotix.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 10000,
        confidence_score: 0,
    },
    {
        id: 'ustx-dex',
        name: 'USTX DEX',
        description: 'USTX DEX is a decentralized exchange on the Tron blockchain that allows to swap the USTX token for USDT, USDC, USDJ and TUSD.\r\nThe DEX is controlled by a smart contract that actively manages the liquidity inside the DEX to reduce the volatility of the USTX token, enabling long term growth of the asset while reducing the losses during adverse market periods.\r\nThe is no fee for buying and a 1% fee on sell operations.\r\nThe DEX can be accessed using Tronlink or Klever wallets.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/USTX6',
            ],
            website: [
                'https://dex.ustx.io/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 292,
        reported_rank: 307,
        currencies: 3,
        markets: 2,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 1179.47458308,
                adjusted_volume_24h: 1179.47458308,
                reported_volume_7d: 1898.37224245,
                adjusted_volume_7d: 1898.37224245,
                reported_volume_30d: 5541.87288496,
                adjusted_volume_30d: 5541.87288496,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 10000,
        confidence_score: 0,
    },
    {
        id: 'cryptex24',
        name: 'Cryptex24',
        description: 'Cryptex24 is a centralized cryptocurrency exchange registered in Seychelles launched in Mar 2019. It is supports major cryptocurrencies and gaming tokens built on the HIVE blockchain. Its trading platform is web-based with charts by TradingView.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/cryptex24_io',
            ],
            website: [
                'https://www.cryptex24.io',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 297,
        reported_rank: 312,
        currencies: 12,
        markets: 40,
        fiats: [
            {
                name: 'Euro',
                symbol: 'EUR',
            },
            {
                name: 'Ukrainian Hryvnia',
                symbol: 'UAH',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 452.76456884,
                adjusted_volume_24h: 452.76456884,
                reported_volume_7d: 1396.13779053,
                adjusted_volume_7d: 1396.13779053,
                reported_volume_30d: 11601.40197319,
                adjusted_volume_30d: 11601.40197319,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'coinzest',
        name: 'CoinZest',
        description: '',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/coinzest1',
            ],
            website: [
                'https://www.coinzest.co.kr',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'rudex',
        name: 'RuDEX',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/rudex_bitshares',
            ],
            website: [
                'https://market.rudex.org',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 284,
        reported_rank: 299,
        currencies: 12,
        markets: 29,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 3905.21297631,
                adjusted_volume_24h: 3905.21297631,
                reported_volume_7d: 45963.62874812,
                adjusted_volume_7d: 45963.62874812,
                reported_volume_30d: 159181.559995,
                adjusted_volume_30d: 159181.559995,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 10000,
        confidence_score: 0.151169,
    },
    {
        id: 'omicrex',
        name: 'Omicrex',
        description: 'Omicrex (Omicron Crypto Markets) is cryptocurrency exchange that launched in the beginning of 2018. It is located in Greece. The exchange allows trading in cryptocurrencies for fiat currencies (EUR, GBP and USD) and cryptocurrencies for cryptocurrencies.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/omicrex_crypto',
            ],
            website: [
                'https://omicrex.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'zeon',
        name: 'ZEON',
        description: 'Exchange cryptocurrency with ease.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://exchange.zeonhexalgo.fun/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 352,
        reported_rank: 352,
        currencies: 2,
        markets: 1,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'latoken',
        name: 'LATOKEN',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/latokens',
            ],
            website: [
                'https://latoken.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 69,
        reported_rank: 78,
        currencies: 172,
        markets: 241,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 107576226.14102875,
                adjusted_volume_24h: 107576226.14102875,
                reported_volume_7d: 841384905.9882758,
                adjusted_volume_7d: 841384905.9882758,
                reported_volume_30d: 4002760874.8995976,
                adjusted_volume_30d: 4002760874.8995976,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 3620000,
        confidence_score: 0.165821,
    },
    {
        id: 'indodax',
        name: 'Indodax',
        description: 'Indodax (Bitcoin Indonesia) is an Indonesian cryptocurrency exchange that launched in 2013. It offers its services worldwide, but accepts deposits in Indonesian Rupiah only.  As most other cryptocurrency exchanges, Indodax is not regulated. ',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/indodax',
                'https://twitter.com/indodaxOfficial',
            ],
            website: [
                'https://indodax.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 122,
        reported_rank: 134,
        currencies: 163,
        markets: 165,
        fiats: [
            {
                name: 'Indonesian Rupiah',
                symbol: 'IDR',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 21177594.85137048,
                adjusted_volume_24h: 21177594.85137048,
                reported_volume_7d: 155466429.40019515,
                adjusted_volume_7d: 155466429.40019515,
                reported_volume_30d: 876797619.6050897,
                adjusted_volume_30d: 876797619.6050897,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 6550000,
        confidence_score: 0.643318,
    },
    {
        id: 'prizmbit',
        name: 'Prizmbit',
        description: '',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://prizmbit.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 20000,
        confidence_score: 0,
    },
    {
        id: 'switcheo-network',
        name: 'Switcheo Network',
        description: 'Switcheo is a Singapore-based cryptocurrency exchange with a focus on NEO token. Switcheo is a non-custodian exchange, facilitating peer-to-peer transfers of digital assets. It is hybrid exchange combining some features of decentralized and centralized exchanges. Switcheo does not offer trading in crypto for fiat and vice versa.',
        active: true,
        website_status: false,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/SwitcheoNetwork',
            ],
            website: [
                'https://switcheo.network',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 340,
        reported_rank: 340,
        currencies: 58,
        markets: 64,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 10000,
        confidence_score: 0,
    },
    {
        id: 'ganza',
        name: 'Ganza',
        description: 'GANZA cryptocurrency exchange has been created as an independent exchange aimed at cryptocurrency popularization and producing opportunities of passive income gaining Up to date, the GANZA ecosystem includes • Charts with functionality that satisfies all analytical and artistic wishes of the client. • Secure #P2P lending • Large selection of strategies, due to the number of types of orders • GFT exchange token, which lays in the basis of the ecosystem of exchange financial instruments • GFT sales several rounds conduction',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/ganza_trade',
            ],
            website: [
                'https://ganza.trade',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'dgtmarket',
        name: 'Dgtmarket',
        description: 'DGT Market is a new Polish cryptocurrency exchange that offers trading in Bitcoin and Litecoin for PLN and LTC/BTC.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/dgtmarket_com',
            ],
            website: [
                'https://exchange.dgtmarket.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'topbtc',
        name: 'TOPBTC',
        description: 'TopBTC is a Chinese crypto-to-crypto exchange registered on Malta, which facilitates trading in a wide range of altcoins.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/topbtc_com',
            ],
            website: [
                'https://www.topbtc.one/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'cashierest',
        name: 'Cashierest',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://www.cashierest.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 229,
        reported_rank: 243,
        currencies: 14,
        markets: 13,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 421848.35826807,
                adjusted_volume_24h: 421848.35826807,
                reported_volume_7d: 62711692.51305042,
                adjusted_volume_7d: 62711692.51305042,
                reported_volume_30d: 374049407.4364657,
                adjusted_volume_30d: 374049407.4364657,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 460000,
        confidence_score: 0,
    },
    {
        id: 'hubi',
        name: 'Hubi',
        description: '',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/HubiExchange',
            ],
            website: [
                'https://www.hubi.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'bitexlive',
        name: 'Bitexlive',
        description: 'Bitexlive is a cryptocurrency exchange platform that allows their users to exchange different cryptocurrencies with other users. It is Turkey-based digital asset exchange launched in 2018. Supported languages at the moment: English, Turkish, Deutsch. ',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/bitexlive',
            ],
            website: [
                'https://bitexlive.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 103,
        reported_rank: 115,
        currencies: 21,
        markets: 40,
        fiats: [
            {
                name: 'Turkish Lira',
                symbol: 'TRY',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 34029699.65080265,
                adjusted_volume_24h: 34029699.65080265,
                reported_volume_7d: 231266411.2727734,
                adjusted_volume_7d: 231266411.2727734,
                reported_volume_30d: 1082353144.0872133,
                adjusted_volume_30d: 1082353144.0872133,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 10000,
        confidence_score: 0.000004,
    },
    {
        id: 'btcmex',
        name: 'BTCMEX',
        description: 'BTCMEX is a cryptocurrency derivatives exchange established in 2019. It’s headquartered in Hong Kong, with offices in Europe, Asia and America. The exchange was founded by famous crypto investor, and the biggest Bitcoin adopter in China, Li Xiaolai, who already established many successful crypto and blockchain projects. BTCMEX offers Bitcoin Perpetual Contracts trading with up to 100x Leverage at the lowest flexible fees in the industry. The platform boasts more than $50,000,000 in daily trading volume. The system guarantees real liquidity and no overloads with the matching engine that delivers 100,000 TPS per trading pair, and 10x the average industry speed with 1ms latency. All the digital assets are kept in a Multisig Cold Wallet.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/BTCMEXGlobal',
            ],
            website: [
                'https://www.btcmex.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'finexbox',
        name: 'FINEXBOX',
        description: 'FinexBox is a cryptocurrency exchange based in Hong Kong. FinexBox and the mobile apps issued under FinexBox are wholly owned and operated by subsidiary company of HDR Global Trading Limited (no relationship with BITMEX), a Republic of Seychelles incorporated entity or its relevant authorized affiliates. ',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/finexbox',
            ],
            website: [
                'https://www.finexbox.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 56,
        reported_rank: 64,
        currencies: 192,
        markets: 237,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 179160341.46857917,
                adjusted_volume_24h: 179160341.46857917,
                reported_volume_7d: 1337119368.2867787,
                adjusted_volume_7d: 1337119368.2867787,
                reported_volume_30d: 5561679076.001831,
                adjusted_volume_30d: 5561679076.001831,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 760000,
        confidence_score: 0.01336,
    },
    {
        id: 'fyb-sg',
        name: 'FYB-SG',
        description: 'FYB-SG is a Singapore cryptocurrency exchange that has been operating since 2014. It is owned by the company Dealworks Pte Ltd, which says it is registered as a Deposits stored value facility and does not require the approval of the Monetary Authority of Singapore (MAS).  FYB-SG has a mobile application for Android and iOS devices. It has the full functionality of the trading platform and allows placing, canceling and viewing of orders, price info, trade history and order book. ',
        active: true,
        website_status: false,
        api_status: false,
        message: 'FYB-SG is ceasing operations, due to bank account closure.',
        links: {
            website: [
                'https://www.fybsg.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 10000,
        confidence_score: 0,
    },
    {
        id: 'tidex',
        name: 'Tidex',
        description: 'Tidex is a Waves-integrated exchange that currently provides an address in the US but appears to be based in Russia, launched in 2017. The platform offers trading in more than 70 digital currencies.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/tidex_exchange',
            ],
            website: [
                'https://tidex.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 176,
        reported_rank: 190,
        currencies: 8,
        markets: 12,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 3469663.60732021,
                adjusted_volume_24h: 3469663.60732021,
                reported_volume_7d: 27430277.59889305,
                adjusted_volume_7d: 27430277.59889305,
                reported_volume_30d: 136170596.31405553,
                adjusted_volume_30d: 136170596.31405553,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 260000,
        confidence_score: 0.000105,
    },
    {
        id: 'bankera',
        name: 'Bankera',
        description: 'Bankera Exchange offers a global and secure cryptocurrency trading platform featuring a comfortable interface for all level traders. It is the second product by the team behind Bankera on a mission to develop the financial infrastructure for the blockchain era. Built on years of expertise in crypto and FinTech fields, the trading platform is designed to meet the needs of today’s cryptocurrency market.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://exchange.bankera.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 160000,
        confidence_score: 0,
    },
    {
        id: 'icoinbay',
        name: 'iCoinbay',
        description: "iCoinbay is a tokenized, community based digital asset exchange. The world's first exchange to issue insurance for token value. Members receive weekly income distribution for its contribution to the iCoinbay ecosystem.",
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/iCoinbay_info',
            ],
            website: [
                'https://www.icoinbay.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'bitocto-exchange',
        name: 'Bitocto Exchange',
        description: 'Cryptocurrency exchange based in Indonesia with fiat - Indonesia Rupiah (IDR) pairing.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/bitoctoexchange',
            ],
            website: [
                'https://bitocto.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 239,
        reported_rank: 253,
        currencies: 9,
        markets: 9,
        fiats: [
            {
                name: 'Indonesian Rupiah',
                symbol: 'IDR',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 239796.82140248,
                adjusted_volume_24h: 239796.82140248,
                reported_volume_7d: 2368781.61136691,
                adjusted_volume_7d: 2368781.61136691,
                reported_volume_30d: 12434631.44486184,
                adjusted_volume_30d: 12434631.44486184,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 10000,
        confidence_score: 0,
    },
    {
        id: 'fargobase',
        name: 'Fargobase',
        description: '',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://fargobase.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'cryptohub',
        name: 'Cryptohub',
        description: null,
        active: false,
        website_status: true,
        api_status: false,
        message: 'Exchange is not active',
        links: {
            twitter: [
                'https://twitter.com/CryptoHubONLINE',
            ],
            website: [
                'https://cryptohub.online/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'timebitex',
        name: 'TimebitEx',
        description: '',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/timebit_global',
            ],
            website: [
                'https://timebitex.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'excoincial',
        name: 'EXCOINCIAL',
        description: 'Excoincial claims to be an advanced multi-crypto exchange that is trader centric and hosts a range of promising features that facilitate smoother and safer crypto trading. It has advanced security features like Two Fach Authentication (2FA) and Elastic Multi-Stage Wallet Strategy. Its easy and quick e-KYC enables users to get registered and start trading right away. EXCOINCIAL has a very intuitive and user-friendly design that makes navigation easy and also provides for a great user experience.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://www.twitter.com/excoincial',
            ],
            website: [
                'https://www.excoincial.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'radar-relay',
        name: 'Radar Relay',
        description: 'The Radar Relay decentralized exchange enables peer-to-peer trading of cryptocurrencies. The Radar Relay Beta App launched in August 2017. Alan Curtis (CEO), Mike Roth (CTO), Brandon Arthur Roth (CCO), and Devin Eldridge (COO) lead the project. The team received early backing from Blockchain Capital in December 2017. ',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/radarrelay',
            ],
            website: [
                'https://radarrelay.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'paybito',
        name: 'PayBito',
        description: '',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/paybito',
            ],
            website: [
                'https://www.paybito.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 70000,
        confidence_score: 0,
    },
    {
        id: 'vitblock',
        name: 'VitBlock',
        description: 'VitBlock Exchange, founded in 2018 in Singapore, is a financial platform that makes it fast, safe, and convenient to buy and sell digital assets around the world. VitBlock is in a partnership with the No.1 exchange OKEx, who shares theirs 20 million users, liquidity and trading technology with VitBlock.\r\n\r\nWith proprietary Inverse Mining capability, VitBlock facilitates reducing token circulation by permanently locking-up trade transaction fees.',
        active: false,
        website_status: false,
        api_status: false,
        message: 'Exchange is not active',
        links: {
            twitter: [
                'https://www.twitter.com/vitblock',
            ],
            website: [
                'https://www.vitblock.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'bitflip',
        name: 'BitFlip',
        description: '',
        active: false,
        website_status: false,
        api_status: false,
        message: 'The BITEXBOOK Exchange undertakes to fix BitFlip customers balances in its system by issuing debt tokens in the equivalent of the currency in which balances have been remaining on BitFlip customers’ wallets.',
        links: {
            twitter: [
                'https://twitter.com/bitflipli',
            ],
            website: [
                'https://bitflip.li',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'bitfex',
        name: 'BitFex',
        description: 'Stock exchange which developing based on traders tasks and with the lowest fees.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/BitFexTrade',
            ],
            website: [
                'https://bitfex.trade/en/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 277,
        reported_rank: 292,
        currencies: 7,
        markets: 10,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 8672.40253214,
                adjusted_volume_24h: 8672.40253214,
                reported_volume_7d: 68602.22497588,
                adjusted_volume_7d: 68602.22497588,
                reported_volume_30d: 349791.60315184,
                adjusted_volume_30d: 349791.60315184,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 20000,
        confidence_score: 0,
    },
    {
        id: 'dex-trade',
        name: 'Dex-Trade',
        description: 'Dex-Trade is young but the most technical equipped crypto exchange, it offers traders easy-to-use interface and transactions safety. Since 2018, Dex-Trade team has the most fully range of security measures and security risk control measures in the industry. Dex-Trade welcomes global users and continues to expands digital currency in various countries to provide users with global trading opportunities. High-quality currencies are listed on Dex-Trade to offer traders comprehensive range of digital assets. By your side 24 hours a day, our support team will assist you with any issue or question you may have.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://dex-trade.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 65,
        reported_rank: 74,
        currencies: 66,
        markets: 113,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 118405303.87939373,
                adjusted_volume_24h: 118405303.87939373,
                reported_volume_7d: 876961175.6327252,
                adjusted_volume_7d: 876961175.6327252,
                reported_volume_30d: 4072216043.6895247,
                adjusted_volume_30d: 4072216043.6895247,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 1200000,
        confidence_score: 0.315666,
    },
    {
        id: 'btb',
        name: 'BTB',
        description: '',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://www.btb.io/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'oceanex',
        name: 'OceanEx',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/OceanexOfficial',
            ],
            website: [
                'https://oceanex.pro/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 87,
        reported_rank: 98,
        currencies: 30,
        markets: 56,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 56292685.93396807,
                adjusted_volume_24h: 56292685.93396807,
                reported_volume_7d: 445760043.76468074,
                adjusted_volume_7d: 445760043.76468074,
                reported_volume_30d: 2032103912.3023486,
                adjusted_volume_30d: 2032103912.3023486,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 30000,
        confidence_score: 0.11641,
    },
    {
        id: 'five-star-exchange',
        name: 'Five Star Exchange',
        description: 'Five Star Exchange is a P2P crypto-Products Trading platform. Five Star Exchange is the world’s most advanced cryptocurrency exchange, Launched on 26th January 2020. Five Star Exchange has been providing markets for FIVE star Coin, Bitcoin, Ethereum, TUSD, BNB, TRX and more than 65 cryptocurrencies in total. Five Star Exchange and the Mobile Apps issued under Five Star Exchange are wholly owned and operated by & Developed by Venaayat Tech Solutions Private Limited, India. The founding team at Five Star Exchange consists of High Class professionals in Web Development, Finance, and High Frequency Algorithmic Trading operations around the world. In addition, it also serves as a coin-to-coin and P2P trading platform geared to global market. Key Features : Website, Android Application. Real-time clearing and cutting-edge order matching algorithms. The most advanced API on the market Access to the crypto assets exchange platform technology is provided in accordance with the Terms of Service.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/fivestar_exch',
            ],
            website: [
                'https://fivestarexchange.in/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 120000,
        confidence_score: 0,
    },
    {
        id: 'orebz',
        name: 'Ore.Bz',
        description: 'Ore.bz exchange offers deposits via credit card, if you use the payment systems. They support fiat currency USD, Bitcoin and a few altcoins like Ethereum, DASH or ZCash.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://ore.bz/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'pancakeswap',
        name: 'PancakeSwap',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://pancakeswap.finance/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 225,
        reported_rank: 239,
        currencies: 44,
        markets: 81,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 492067.62325892,
                adjusted_volume_24h: 492067.62325892,
                reported_volume_7d: 5719737.44184525,
                adjusted_volume_7d: 5719737.44184525,
                reported_volume_30d: 43240951.42591193,
                adjusted_volume_30d: 43240951.42591193,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 21800000,
        confidence_score: 0,
    },
    {
        id: 'gbx-digital-asset-exchange',
        name: 'GBX Digital Asset Exchange',
        description: 'GBX Digital Asset Exchange is Gibraltar-based exchange.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/GibBlockEx',
            ],
            website: [
                'https://gbx.gi/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'resfinex',
        name: 'Resfinex',
        description: 'Resfinex is a digital asset trading platform for Ethereum tokens, Bitcoin and innovative blockchain. We focus on providing the highest level of security, transparency and customer service.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/resfinex',
            ],
            website: [
                'https://resfinex.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 97,
        reported_rank: 109,
        currencies: 14,
        markets: 17,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 39468797.37129447,
                adjusted_volume_24h: 39468797.37129447,
                reported_volume_7d: 262791286.21577293,
                adjusted_volume_7d: 262791286.21577293,
                reported_volume_30d: 1202511614.9173143,
                adjusted_volume_30d: 1202511614.9173143,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0.749909,
    },
    {
        id: 'tokenomica-dex',
        name: 'Tokenomica DEX',
        description: '',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://tokenomica.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'cbx',
        name: 'CBX',
        description: '',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://www.cbx.one/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'ex24',
        name: 'EX24',
        description: '',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/EX24IO',
            ],
            website: [
                'https://ex24.io',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'raydium',
        name: 'Raydium',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://raydium.io/swap/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 134,
        reported_rank: 148,
        currencies: 200,
        markets: 238,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 12691339.50235237,
                adjusted_volume_24h: 12691339.50235237,
                reported_volume_7d: 102066026.70907506,
                adjusted_volume_7d: 102066026.70907506,
                reported_volume_30d: 479135555.4577131,
                adjusted_volume_30d: 479135555.4577131,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 9190000,
        confidence_score: 0.003712,
    },
    {
        id: 'bidesk',
        name: 'Bidesk',
        description: "Bidesk exchange is a digital asset trading platform that has been built to provide a secure and safe environment for trading high quality tokens and coins whilst providing the best user experience to its users. With the advanced matching engine, all types of users; from beginners who're buying their first cryptocurrency, to the professional traders and hedge funds, are ensured of having the best trading experience. Bidesk also provide 24/7 customer support service which is always on hand to help, users are made certain of prompt response for any issue.",
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/bideskcom',
            ],
            website: [
                'https://www.bidesk.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'cryptobridge',
        name: 'CryptoBridge',
        description: 'CryptoBridge is a decentralized exchange created for all altcoin traders. All deposits, withdrawals, and order books that are a part of the CryptoBridge system are stored with transparency on the blockchain, where it is highly secure.',
        active: true,
        website_status: false,
        api_status: false,
        message: "Exchange is closing down, due to ‘increasing regulation’.\n\n<a href='https://www.theblockcrypto.com/linked/48784/decentralized-crypto-exchange-cryptobridge-shutting-down-citing-increasing-regulation' target='_blank'>Read more about it</a>",
        links: {
            twitter: [
                'https://twitter.com/cryptobridge',
            ],
            website: [
                'https://crypto-bridge.org/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'coinhouse',
        name: 'Coinhouse',
        description: '',
        active: false,
        website_status: false,
        api_status: false,
        message: "Coinhouse exchange was hacked, and their users funds are gone. <a href='https://www.reddit.com/r/Electra_Currency/comments/8hnjwk/coinhouse_just_published_this_statement_saying/' target='_blank'>About hack</a>",
        links: {
            twitter: [
                'https://twitter.com/CoinHouseu',
            ],
            website: [
                'https://coinhouse.eu/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'kuna',
        name: 'Kuna',
        description: 'Kuna is a Kiev-based cryptocurrency exchange that offers trading against UAH and BTC. Kuna does not accept fiat currency other than Ukrainian Hryvnia (UAH).',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/KunaExchange',
            ],
            website: [
                'https://kuna.io',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 200,
        reported_rank: 213,
        currencies: 17,
        markets: 29,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
            {
                name: 'Ukrainian Hryvnia',
                symbol: 'UAH',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 1478984.02879947,
                adjusted_volume_24h: 1478984.02879947,
                reported_volume_7d: 9728317.33997016,
                adjusted_volume_7d: 9728317.33997016,
                reported_volume_30d: 62022271.30707756,
                adjusted_volume_30d: 62022271.30707756,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 670000,
        confidence_score: 0,
    },
    {
        id: 'asia-exchange',
        name: 'Asia Exchange',
        description: 'Asia Exchange is a Crypto to Crypto spot exchange that will focus on low fees high quality liquidity for top world major coins. our mission is to create a multi-language customer support, competitive staking rewards and more features to our users.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://www.asiax.live/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'bitmex',
        name: 'BitMEX',
        description: 'BitMEX is a Peer-to-Peer Trading Platform that offers leveraged contracts that are bought and sold in Bitcoin. Founded by HDR Global Trading Limited in 2014 is operating in Hong Kong and registered in the Seychelles.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/BitMEXdotcom',
            ],
            website: [
                'https://www.bitmex.com',
                'https://www.bitmex.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 362,
        reported_rank: 33,
        currencies: 1,
        markets: 1,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 662418900,
                adjusted_volume_24h: 0,
                reported_volume_7d: 5436234900,
                adjusted_volume_7d: 0,
                reported_volume_30d: 24849706000,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 3330000,
        confidence_score: 0.751345,
    },
    {
        id: 'kyber-network',
        name: 'Kyber Network',
        description: 'Founded by Loi Luu, Victor Tran, and Yaron Velner in 2017, Kyber Network currently functions as a decentralized Ethereum-based exchange platform. Kyber provides detailed information on the team behind it, but company is not regulated.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/kybernetwork',
            ],
            website: [
                'https://kyber.network/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 164,
        reported_rank: 178,
        currencies: 11,
        markets: 14,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 4439603.35708474,
                adjusted_volume_24h: 4439603.35708474,
                reported_volume_7d: 8893313.64840462,
                adjusted_volume_7d: 8893313.64840462,
                reported_volume_30d: 8893313.64840462,
                adjusted_volume_30d: 8893313.64840462,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 140000,
        confidence_score: 0.000057,
    },
    {
        id: 'deversifi',
        name: 'DeversiFi',
        description: "DeversiFi gives traders ​the edge​ in fast-moving decentralised finance (DeFi) markets by allowing them to ​trade at lightning speed​ and ​with deep aggregated liquidity​, directly from their privately owned cryptocurrency wallet. DeversiFi was built with serious traders in mind and is a high-speed, self-custodial exchange allowing for 9,000+ tps and privacy-by-default, meaning traders can enjoy a speed and security advantage without sacrificing any of the corner-stones of profitable trading. With the exchange's native Nectar (NEC) token, DeversiFi traders can enjoy fee discounts of up 20% and membership in Nectar DAO (controlling 17,000 ETH).",
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/deversifi',
            ],
            website: [
                'https://deversifi.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 140000,
        confidence_score: 0,
    },
    {
        id: 'betconix',
        name: 'BETCONIX',
        description: 'BETCONIX is a centralized cryptocurrency exchange with a European license, the headquarters of the exchange is located in the Czech Republic.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/betconix',
            ],
            website: [
                'https://betconix.com',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 92,
        reported_rank: 103,
        currencies: 22,
        markets: 90,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
            {
                name: 'Euro',
                symbol: 'EUR',
            },
            {
                name: 'Russian Ruble',
                symbol: 'RUB',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 49755755.54635669,
                adjusted_volume_24h: 49755755.54635669,
                reported_volume_7d: 287062570.1619618,
                adjusted_volume_7d: 287062570.1619618,
                reported_volume_30d: 1296777152.0500991,
                adjusted_volume_30d: 1296777152.0500991,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 30000,
        confidence_score: 0.743284,
    },
    {
        id: 'cexland',
        name: 'Cexland',
        description: 'Cexland is Estonia based Centralized Crypto Exchange, buy and sell crypto easily with one click! offers Bitcoin, Ethereum, and other trading.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/cexland',
            ],
            website: [
                'https://cexland.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 9535959.1396869,
                adjusted_volume_7d: 9535959.1396869,
                reported_volume_30d: 99142781.90627831,
                adjusted_volume_30d: 99142781.90627831,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 50000,
        confidence_score: 0,
    },
    {
        id: 'p2pb2b',
        name: 'P2PB2B',
        description: 'Based in Estonia, P2PB2B is a multi cryptocurrency exchange platform. It provides users with the ability to trade (buy/sell) cryptocurrencies on the platform. The Exchange main currencies supported are BTC, ETH, and USD, the trading fees are free of cost and it has a free listing of any business app’s API. More than 95% of all currency are stored on cold wallets.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/p2pb2b',
            ],
            website: [
                'https://p2pb2b.io',
                'https://p2pb2b.io/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 35,
        reported_rank: 42,
        currencies: 69,
        markets: 140,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
            {
                name: 'Euro',
                symbol: 'EUR',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 536236920.64960045,
                adjusted_volume_24h: 536236920.64960045,
                reported_volume_7d: 4340379163.099538,
                adjusted_volume_7d: 4340379163.099538,
                reported_volume_30d: 28412609554.47384,
                adjusted_volume_30d: 28412609554.47384,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 1600000,
        confidence_score: 0.331434,
    },
    {
        id: 'liqui',
        name: 'Liqui',
        description: 'Liqui is a Ukrainian cryptocurrency exchange that also features savings accounts and intends to offer margin trading and lending in the future. Like most similar venues, trading at Liqui is done via a single account type and there are almost than 200 digital coins available. Besides, Liqui, keeps adding new ones.',
        active: false,
        website_status: false,
        api_status: false,
        message: "Exchange has shut down it's operation as of January 2019, due to low liquidity.",
        links: {
            twitter: [
                'https://twitter.com/liqui_exchange',
            ],
            website: [
                'https://liqui.io/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'buenbit',
        name: 'Buenbit',
        description: '',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/buenbit',
            ],
            website: [
                'https://buenbit.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 2200000,
        confidence_score: 0,
    },
    {
        id: 'asymetrex',
        name: 'Asymetrex',
        description: 'Asymetrex claim to offer a kyc free trading experience to its users, also claims to be fast and secure.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/asymetrex',
            ],
            website: [
                'https://asymetrex.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 345,
        reported_rank: 345,
        currencies: 7,
        markets: 8,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'currency-com',
        name: 'Currency.com',
        description: "Currency.com is the world's first regulated tokenised securities cryptoexchange which offers unique security and safety with best-in-class AML and KYC laws. It offers more than 1500 tokenised assets for trading along with cryptos and tokenised bonds. What makes this platform convenient and handy to use is a unique UX/UI and a broad list of payment methods including bank card, wire transfer, SEPA, cryptos, etc",
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/currencycom',
            ],
            website: [
                'https://currency.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 43,
        reported_rank: 50,
        currencies: 444,
        markets: 497,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
            {
                name: 'Polish Zloty',
                symbol: 'PLN',
            },
            {
                name: 'Russian Ruble',
                symbol: 'RUB',
            },
            {
                name: 'Turkish Lira',
                symbol: 'TRY',
            },
            {
                name: 'Hong Kong Dollar',
                symbol: 'HKD',
            },
            {
                name: 'Danish Krone',
                symbol: 'DKK',
            },
            {
                name: 'Norwegian Krone',
                symbol: 'NOK',
            },
            {
                name: 'Swedish Krona',
                symbol: 'SEK',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 362335661.66924185,
                adjusted_volume_24h: 362335661.66924185,
                reported_volume_7d: 3513161170.968558,
                adjusted_volume_7d: 3513161170.968558,
                reported_volume_30d: 30975497663.76169,
                adjusted_volume_30d: 30975497663.76169,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 2820000,
        confidence_score: 0.761808,
    },
    {
        id: 'jinance',
        name: 'Jinance',
        description: 'Built from the ground up, the Jinance platform launched in September 2018 and is now a major partner of Fintech Australia, the Fintech industry peak body.\r\n\r\nIn May 2018, Jinance became an AUSTRAC-regulated digital exchange, fulfilling the Anti-Money Laundering and Counter-Terrorism Financing Act 2006 (AML/CTF Act) obligation.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/au_jinance',
            ],
            website: [
                'https://jinance.com.au/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'bitshares-dex',
        name: 'BitShares DEX',
        description: 'The BitShares Blockchain is an industrial-grade decentralized platform built for high-performance financial smart contracts mostly known for: its token factory, a decentralized exchange as a built-in native dapp (known as the DEX) and its stablecoins or, as they are called in BitShares, Smartcoins. It represents the first decentralized autonomous community that lets its core token holders decide on its future direction and products by means of on-chain voting. It is also the first DPoS blockchain in existence and the first blockchain to implement stablecoins.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://bitshares.org/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 90000,
        confidence_score: 0,
    },
    {
        id: 'cex',
        name: 'CEX',
        description: '',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/WWWCEXCOM',
            ],
            website: [
                'https://www.cex.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 15044179054.883516,
                adjusted_volume_30d: 15044179054.883516,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'afrodex',
        name: 'AfroDex',
        description: '',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://afrodex.net',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 10000,
        confidence_score: 0,
    },
    {
        id: 'solidus',
        name: 'Solidus',
        description: 'Solidus is a trading platform, their team has been working on the project since 2019.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/ExchangeSolidus',
            ],
            website: [
                'https://exchange.solidus.finance/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'exrates',
        name: 'Exrates',
        description: 'Exrates has rich digital assets portfolio, and besides, it supports a lot of fiat currencies. This exchange is operated by Exrates Ltd – a company registered in the Republic of Armenia. Launched in April, 2016, Exrates is not regulated, as is the case with most similar venues across the globe.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/Exrates_Me',
            ],
            website: [
                'https://exrates.me/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 120000,
        confidence_score: 0,
    },
    {
        id: 'cexz',
        name: 'CexZ',
        description: 'CexZ offers an intuitive interface with real time orderbooks, charting tools, trade history, and a simple order process so you can trade from day one.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/_cexz_',
            ],
            website: [
                'https://www.cexz.ca',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'localcoin-dex',
        name: 'LocalCoin DEX',
        description: 'LocalCoin is the true democracy decentralized ecosystem where everyone is free to do what they want and say what they want. LocalCoin is not a company or a person, it is a community of people who shares the same libertarian values and freedoms.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/LocalCoinIS',
            ],
            website: [
                'https://localcoin.is',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'exbitron',
        name: 'Exbitron',
        description: 'Exbitron is centralized exchange, which is aiming to provide lowest fees as possible. We are mostly specializing in altcoins.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/exbitron',
            ],
            website: [
                'https://www.exbitron.com',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 273,
        reported_rank: 288,
        currencies: 46,
        markets: 121,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 11289.34056379,
                adjusted_volume_24h: 11289.34056379,
                reported_volume_7d: 68061.61133199,
                adjusted_volume_7d: 68061.61133199,
                reported_volume_30d: 279856.33297866,
                adjusted_volume_30d: 279856.33297866,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 680000,
        confidence_score: 0,
    },
    {
        id: 'binance-dex',
        name: 'Binance DEX',
        description: 'Binance DEX is a decentralized order matching engine,\r\npowered by the core Binance Chain technology.\r\n\r\nBinance DEX is a modern and secure marketplace for issuing\r\nand exchanging digital assets, and no-one other than you holds your keys. Trading your favorite assets has never been safer.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/binance_dex',
            ],
            website: [
                'https://www.binance.org/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 241,
        reported_rank: 255,
        currencies: 63,
        markets: 70,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 184880.74412946,
                adjusted_volume_24h: 184880.74412946,
                reported_volume_7d: 1482544.46557783,
                adjusted_volume_7d: 1482544.46557783,
                reported_volume_30d: 8167121.63265064,
                adjusted_volume_30d: 8167121.63265064,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 5790000,
        confidence_score: 0.138505,
    },
    {
        id: 'tradeio',
        name: 'Trade.io',
        description: 'Trade.io is a multi-asset blockchain exchange. The company’s unique offerings include 24/7 support (no long waits), low fees, a diversified portfolio, the liquidity pool – which enables users to earn interest daily – as well as an innovative crypto trading platform, with a user-friendly and flexible interface, and built with the trading community in mind.\r\n',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/TradeToken',
            ],
            website: [
                'https://exchange.trade.io',
                'https://exchange.trade.io/trade/guest',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 10000,
        confidence_score: 0,
    },
    {
        id: 'bithesap',
        name: 'Bithesap',
        description: "Bithesap is an entry level Turkish cryptocurrency exchange that offer trading in Bitcoin and Litecoin. The company behind this project is based in Istanbul and named 'Online People Internet Technologies AS'.",
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/bithesapcom',
            ],
            website: [
                'https://www.bithesap.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 346,
        reported_rank: 346,
        currencies: 2,
        markets: 2,
        fiats: [
            {
                name: 'Turkish Lira',
                symbol: 'TRY',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 30.55996366,
                adjusted_volume_7d: 30.55996366,
                reported_volume_30d: 351.43357516,
                adjusted_volume_30d: 351.43357516,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'bcp-go',
        name: 'BCP GO',
        description: 'Our message to international businesses and entrepreneurs is simple: attend our international Crypto Exchange and get in touch well before. We want to help as many entrepreneurs as possible to get the High Smart Trading and international opportunities via our trusted Users. When your business and your community prospers, everyone prospers.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://bcpgo.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'omgfin',
        name: 'Omgfin',
        description: 'OMGfin is the pioneer in building a trading system for digital assets focused on young investors and social network. By connecting with professional investors. Our goal is to bring together a community of traders who share experiences and help each other achieve their individual profit goals.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/omgfin',
            ],
            website: [
                'https://omgfin.com',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 123,
        reported_rank: 135,
        currencies: 13,
        markets: 33,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 20639845.77325078,
                adjusted_volume_24h: 20639845.77325078,
                reported_volume_7d: 150232402.16801333,
                adjusted_volume_7d: 150232402.16801333,
                reported_volume_30d: 678082908.3399197,
                adjusted_volume_30d: 678082908.3399197,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 5490000,
        confidence_score: 0.739055,
    },
    {
        id: 'ovex',
        name: 'OVEX',
        description: null,
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/OVEXIO',
            ],
            website: [
                'https://www.ovex.io/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 50000,
        confidence_score: 0,
    },
    {
        id: 'crypxie',
        name: 'Crypxie',
        description: 'Crypxie is crypto assets trading platform primarily to be used for :\r\nPayment of Trading Commissions\r\nIEO Participation\r\nStaking and Lending Program\r\nMargin Trading and Options Trading\r\nCoin Voting and Coin Listing\r\nCloud Mining Program\r\nCompetitions\r\nand Many Other in the Future',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/crypxie',
            ],
            website: [
                'https://crypxie.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'litebiteu',
        name: 'LiteBit.eu',
        description: 'LiteBit is founded in 2013 and is a platform where cryptocurrency can be traded easy and secure. The platform is set up to buy, sell and manage cryptocurrency. At an exchange, cryptocurrencies can only be traded for other cryptocurrencies. With LiteBit, cryptocurrencies can be purchased directly with euros and paid for with the most widely used payment methods such as credit card, iDeal, Bancontact, Sofort, Giropay, SEPA and MyBank.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://www.litebit.eu/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 210,
        reported_rank: 224,
        currencies: 33,
        markets: 33,
        fiats: [
            {
                name: 'Euro',
                symbol: 'EUR',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 1042175.8531982,
                adjusted_volume_24h: 1042175.8531982,
                reported_volume_7d: 8491593.8662047,
                adjusted_volume_7d: 8491593.8662047,
                reported_volume_30d: 45144337.03679222,
                adjusted_volume_30d: 45144337.03679222,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 180000,
        confidence_score: 0,
    },
    {
        id: 'boostx',
        name: 'BoostX',
        description: 'We have built Boost X Exchange with very precise objective which is to help both Buyers and Sellers accomplish their goal effortlessly and securely. Buy and sell popular digital currencies.keep track of them in the one place. For added security store your funds in vault with time delayed withdrawals.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/boostxexchange',
            ],
            website: [
                'https://boostxexchange.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'okex-korea',
        name: 'OKEx Korea',
        description: null,
        active: true,
        website_status: false,
        api_status: false,
        message: 'https://cryptobriefing.com/okex-korea-shutting-down-customers-must-withdraw-funds/',
        links: {
            twitter: [
                'https://twitter.com/OKExKR_Official',
            ],
            website: [
                'https://okex.co.kr/kr/view/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 10000,
        confidence_score: 0,
    },
    {
        id: 'lupbit',
        name: 'Lupbit',
        description: 'Our young and enthusiastic team has been working on the project since 2019. We have a good understanding of digital currency trading and know the needs of our customers. A trader must have a wide choice of assets for trading, therefore we offer not only popular cryptocurrencies (Bitcoin, Ethereum, Litecoinand others), but also rare ones. Our list of trading pairs is constantly growing. We are always open to collaborating with cryptocurrency owners.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/lupbitcom',
            ],
            website: [
                'https://www.lupbit.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'ccryptoex',
        name: 'CCRYPTOEX',
        description: 'Founded on 2019 and based on Singapore, Ccryptoex is a cryptocurrency exchange site that provides a platform for quick and easy trading.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/Ccryptoex',
            ],
            website: [
                'https://ccryptoex.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'coin163',
        name: 'Coin163',
        description: 'Coin163 is a cryptocurrency exchange located in Vietnam. The most active trading pair on Coin163 exchange is ETH/BTC. Coin163 is delivering the most reliable, fast and powerful platform solution on the market.It is established in year 2019.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/Coin163Org',
            ],
            website: [
                'https://www.coin163.org/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 40743191.90840957,
                adjusted_volume_7d: 40743191.90840957,
                reported_volume_30d: 803156160.5903556,
                adjusted_volume_30d: 803156160.5903556,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 10000,
        confidence_score: 0,
    },
    {
        id: 'goldexcoin',
        name: 'Goldexco.in',
        description: 'By staking the gldx token, you can trade all trading pairs without commission.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/goldexcointr',
            ],
            website: [
                'https://www.goldexco.in',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'crypto-services',
        name: 'Crypto-Services',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/cryptoservices3',
            ],
            website: [
                'https://crypto-services.exchange',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 299,
        reported_rank: 314,
        currencies: 15,
        markets: 34,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 374.10211296,
                adjusted_volume_24h: 374.10211296,
                reported_volume_7d: 493.77202141,
                adjusted_volume_7d: 493.77202141,
                reported_volume_30d: 635.34696918,
                adjusted_volume_30d: 635.34696918,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'idcm',
        name: 'IDCM',
        description: 'IDCM is a Chinese cryptocurrency exchange launched in April 2018. At this trading platform, they don’t charge different fees between takers and makers. They offer wire transfer as a deposit method, but you can’t deposit via credit card.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/IDCM_OFFICIAL',
            ],
            website: [
                'https://www.idcm.io/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 20000,
        confidence_score: 0,
    },
    {
        id: 'safetrade',
        name: 'SafeTrade',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://Safe.trade',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 270,
        reported_rank: 285,
        currencies: 28,
        markets: 55,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 19611.1034131,
                adjusted_volume_24h: 19611.1034131,
                reported_volume_7d: 216690.14970557,
                adjusted_volume_7d: 216690.14970557,
                reported_volume_30d: 1853238.89015216,
                adjusted_volume_30d: 1853238.89015216,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 690000,
        confidence_score: 0.084311,
    },
    {
        id: 'kuangex',
        name: 'KuangEX',
        description: "KuangEX was established on October 1, 2019 and is headquartered in Ireland, it is said to be formed by a professional blockchain technology team, a Wall Street investment advisory team, an excellent fund management team, and a group of miners; providing security, Professional and fast digital asset trading and asset management services are dedicated to building the world's top mining currency digital asset trading platform.",
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/kuangex',
            ],
            website: [
                'https://www.kuangex.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'exnce',
        name: 'EXNCE',
        description: '',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/exncecom?lang=en',
            ],
            website: [
                'https://www.exnce.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'energiswap',
        name: 'Energiswap',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/energi',
            ],
            website: [
                'https://app.energiswap.exchange/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 198,
        reported_rank: 211,
        currencies: 56,
        markets: 59,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 1658428.46653654,
                adjusted_volume_24h: 1658428.46653654,
                reported_volume_7d: 10737007.65264828,
                adjusted_volume_7d: 10737007.65264828,
                reported_volume_30d: 43888945.43019703,
                adjusted_volume_30d: 43888945.43019703,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 60000,
        confidence_score: 0,
    },
    {
        id: 'bitforex',
        name: 'BitForex',
        description: 'BitForex is an cryptocurrency exchange, providing a variety of crypto-currency trading pairs against USDT.\r\nThe company is headquartered in Singapore, registered in the Republic of Seychelles, has independent operating teams in Germany, Estonia, Hong Kong, Malaysia, the Philippines, other countries and regions.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/bitforexcom',
            ],
            website: [
                'https://www.bitforex.com/',
                'https://bitforex.com?inviterId=2285452',
                'https://bitforex.com',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 19,
        reported_rank: 24,
        currencies: 125,
        markets: 159,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 1232478833.5705106,
                adjusted_volume_24h: 1232478833.5705106,
                reported_volume_7d: 6816831006.271069,
                adjusted_volume_7d: 6816831006.271069,
                reported_volume_30d: 23410816657.626408,
                adjusted_volume_30d: 23410816657.626408,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 3450000,
        confidence_score: 0.032185,
    },
    {
        id: 'urdubit',
        name: 'UrduBit',
        description: null,
        active: false,
        website_status: true,
        api_status: false,
        message: 'UrduBit is shutting down! Withdraw Your funds to Your bank account or wallet as fast as possible.',
        links: {
            website: [
                'https://urdubit.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'bitso',
        name: 'Bitso',
        description: 'Bitso is a Mexican cryptocurrency exchange founded in 2014. It allows users to exchange Bitcoin and Ether for Mexican Pesos. Users can deposit and withdraw MXN through the Ripple Gateway among others. Bitso is committed to developing efficient financial services in Mexico.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/bitso',
            ],
            website: [
                'https://bitso.com',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 142,
        reported_rank: 156,
        currencies: 8,
        markets: 15,
        fiats: [
            {
                name: 'Mexican Peso',
                symbol: 'MXN',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 9490371.14522074,
                adjusted_volume_24h: 9490371.14522074,
                reported_volume_7d: 163661482.8325817,
                adjusted_volume_7d: 163661482.8325817,
                reported_volume_30d: 594379437.4847428,
                adjusted_volume_30d: 594379437.4847428,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 15800000,
        confidence_score: 0.756383,
    },
    {
        id: 'ccore',
        name: 'Ccore',
        description: 'In its basic essence, Ccore is a ‘Crypto Payment Platform’ that allows people to spend their crypto currency in various fiat based ‘online services and stores. Ccore platform has a module structure, which enables to connect multiple extensions (modules) to platform. 4 main extensions of platform over which our team is currently working: Exchange, Wallet, Payment, Information. ',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/ccore_io',
            ],
            website: [
                'https://ccore.io/exchange',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'apollox',
        name: 'ApolloX',
        description: "ApolloX was founded by professionals from traditional financial institutions, tech companies and top crypto exchanges. We want to make crypto accessible to everyone in the public, not only traders and quants. There is always room for more users to enter the crypto space and we\r\nwould like to assist in making that possible. At the same time, we aim to bring trustworthiness and customer-centricity in the crypto industry. That's why we created ApolloX - everyone’s preferred crypto exchange.",
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://www.apollox.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 348,
        reported_rank: 69,
        currencies: 14,
        markets: 13,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 136942145.98430422,
                adjusted_volume_24h: 0,
                reported_volume_7d: 1096249254.8070333,
                adjusted_volume_7d: 0,
                reported_volume_30d: 6697206576.168033,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 630000,
        confidence_score: 0.000254,
    },
    {
        id: 'bitker',
        name: 'BITKER',
        description: 'Founded in December 2017 in Singapore, BITKER aims at providing "One-Stop Digital Asset Exchange Service", which is always in the pursuit of financial product innovation, allowing its traders to use one account to manage all kinds of crypto-currency trade, such as spot trade, contract trade, margin trade, etc.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/Bitker1',
            ],
            website: [
                'https://www.bitker.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'crypcore',
        name: 'Crypcore',
        description: 'Crypcore is a secure digital assets trading platform that offers the first anonymous privacy coin for trading digital assets.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/crypcore',
            ],
            website: [
                'https://crypcore.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'iquant',
        name: 'Iquant',
        description: 'Quant is a Chinese cryptocurrency project. They plan to create a new blockchain environment, in which people can develop new applications and smart contracts, as well as, integrate traditional financial markets. ',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://www.5iqt.org/',
                'https://www.5iquant.org/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'bitebtc',
        name: 'BiteBTC',
        description: 'BiteBTC is a cryptocurrency exchange from Singapore. It launched in January 2018.',
        active: true,
        website_status: true,
        api_status: false,
        message: "There are numerous complains about BiteBTC and their customer service. Beware!\n\n<a href='https://www.ccn.com/singapore-bitcoin-exchange-bitebtc-com-claims-data-center-fire-on-proof-of-keys-day-exit-scam/' target='_blank'>Read more about it</a>",
        links: {
            twitter: [
                'https://twitter.com/bitebtccom',
            ],
            website: [
                'https://bitebtc.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 10000,
        confidence_score: 0,
    },
    {
        id: 'uniswap-v3',
        name: 'Uniswap V3',
        description: "Uniswap is a decentralised cryptocurrency exchange (also known as a decentralised exchange) that facilitates automated transactions between cryptocurrency tokens on the Ethereum blockchain through the use of smart contracts. As of October 2020, Uniswap is estimated to be the largest decentralised exchange and the fourth largest cryptocurrency exchanger overall by daily trading volume. As of March 2021, Uniswap was generating fees of approximately US $2-3 million daily for liquidity providers that facilitate liquid markets for cryptocurrencies to be exchanged.\r\n\r\nUniswap was created on 2 November 2018 by Hayden Adams, a former Siemens mechanical engineer.\r\n\r\nUniswap received investments from venture capital firms such as Andreessen Horowitz, Paradigm Venture Capital Union Square Ventures LLC and ParaFi. Union Square Ventures LLC and ParaFi. Uniswap's average daily trading volume was USD 220 million in October 2020. Traders and investors have used Uniswap because of its use in decentralised finance (DeFi).\r\n\r\nIn April 2020, Uniswap's website was temporarily taken down quantify after hackers unsuccessfully attempted to use a re-logging trick on the exchange. \r\n\r\nCapital named it alongside Maker, Compound, Ankr, Aave and Chainlink as some of DeFi's \"coins to watch\" in 2021\r\n\r\nUniswap is a decentralised finance protocol used to exchange cryptocurrencies and tokens; it is provided on blockchain networks that are decentralised and run open-source software, unlike any centralised intermediary. This contrasts with cryptocurrency exchanges that are run by centralised companies such as Coinbase, Binance and OKEx.\r\n\r\nOwners of a native cryptocurrency and a governance token called UNI vote on changes to the protocol, and then a team of developers implement them. UNI coins were initially distributed to early users of the protocol. Each Ethereum address that had interacted with Uniswap before 1 September 2020 received the ability to claim 400 UNI tokens (worth approximately $1,400 at that time). The market capitalisation of the UNI token is over $500 million as of October 2020.",
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://app.uniswap.org/#/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 14,
        reported_rank: 19,
        currencies: 223,
        markets: 449,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 1384041585.1903718,
                adjusted_volume_24h: 1384041585.1903718,
                reported_volume_7d: 7354621631.349889,
                adjusted_volume_7d: 7354621631.349889,
                reported_volume_30d: 33324443067.311043,
                adjusted_volume_30d: 33324443067.311043,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 12500000,
        confidence_score: 0.005049,
    },
    {
        id: 'btcturk',
        name: 'BTCTurk',
        description: 'BTCTurk, as the name suggests, is a Turkish cryptocurrency exchange. It offers trading in BTC, ETH and XRP for TRY. It has been in business since 2013.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/btcturk',
            ],
            website: [
                'https://www.btcturk.com',
                'https://pro.btcturk.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 94,
        reported_rank: 106,
        currencies: 7,
        markets: 17,
        fiats: [
            {
                name: 'Turkish Lira',
                symbol: 'TRY',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 42207111.88482943,
                adjusted_volume_24h: 42207111.88482943,
                reported_volume_7d: 413266004.8975235,
                adjusted_volume_7d: 413266004.8975235,
                reported_volume_30d: 2307543842.4381995,
                adjusted_volume_30d: 2307543842.4381995,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 7540000,
        confidence_score: 0.753046,
    },
    {
        id: 'coindeal-derivatives',
        name: 'CoinDeal Derivatives',
        description: "With crypto futures contracts, you can enter into crypto for a longer period of time to reduce risk or seek profits in volatile markets. CoinDeal Derivatives provides an easy-to-use platform. It allows traders to trade smoothly in order to move from spot to futures. CoinDeal Derivatives provides an easy-to-use platform that is close to you and currently offers one of the highest 50x margin levers among the major crypto exchanges. In addition, it also offers the world's first BTC/PLN leverage, making it one of the most competitive products on the market. We have created an almost ideal product thanks to our solid team, which always puts the well-being of its users first.",
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/CDDerivatives',
            ],
            website: [
                'https://derivatives-coindeal.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'mintme',
        name: 'MintMe',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/mintmeproject',
            ],
            website: [
                'https://www.mintme.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 291,
        reported_rank: 306,
        currencies: 7,
        markets: 6,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 1281.08257484,
                adjusted_volume_24h: 1281.08257484,
                reported_volume_7d: 19023.67284162,
                adjusted_volume_7d: 19023.67284162,
                reported_volume_30d: 56463.92048318,
                adjusted_volume_30d: 56463.92048318,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 3410000,
        confidence_score: 0,
    },
    {
        id: 'neblidex',
        name: 'NebliDex',
        description: 'A decentralized exchange where you can trade Neblio for Bitcoin, Litecoin and NTP1 tokens without use of payment gateways.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/neblidex',
            ],
            website: [
                'https://www.neblidex.xyz',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'coinmetro',
        name: 'CoinMetro',
        description: null,
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/CoinMetro',
            ],
            website: [
                'https://coinmetro.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 610000,
        confidence_score: 0,
    },
    {
        id: 'bitica',
        name: 'Bitica',
        description: 'Benefits of Bitica Exhange is an advanced trading platform that is designed for experienced digital assets traders and specializes in Altcoins.\r\n',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/BiticaExchange',
            ],
            website: [
                'https://bitica.exchange/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'cexio-broker',
        name: 'CEX.IO Broker',
        description: 'Established in 2019, CEX.IO Broker is a cryptocurrency margin trading platform based on a derivative instrument - contract for difference. The derivative markets available on the platform include: cryptocurrencies, major equities, traditional currencies, and precious metals. With multi-accounts and multi-currency options, CEX.IO Broker lets you execute leveraged trading strategies of any level of complexity, while managing your exposures.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://broker.cex.io/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 330,
        reported_rank: 218,
        currencies: 39,
        markets: 45,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
            {
                name: 'Euro',
                symbol: 'EUR',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 1274842.9313831,
                adjusted_volume_24h: 0,
                reported_volume_7d: 9462010.27948898,
                adjusted_volume_7d: 0,
                reported_volume_30d: 47160247.99092078,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 7480000,
        confidence_score: 0.535848,
    },
    {
        id: 'independent-reserve',
        name: 'Independent Reserve',
        description: 'Independent Reserve is a cryptocurrency exchange that is based out of Sydney, Australia. Having been founded in 2013, it is one of the first crypto services to make trading available in Australia and New Zealand. The exchange operates in line with all of the laws and regulations laid out by the Australian financial services, thereby allowing for asset exchange in a completely legal and safe manner.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://www.independentreserve.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 147,
        reported_rank: 161,
        currencies: 13,
        markets: 39,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
            {
                name: 'New Zealand Dollar',
                symbol: 'NZD',
            },
            {
                name: 'Australian Dollar',
                symbol: 'AUD',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 7344668.96030886,
                adjusted_volume_24h: 7344668.96030886,
                reported_volume_7d: 42302255.84130664,
                adjusted_volume_7d: 42302255.84130664,
                reported_volume_30d: 200678298.7048537,
                adjusted_volume_30d: 200678298.7048537,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 510000,
        confidence_score: 0.750169,
    },
    {
        id: 'ooobtc',
        name: 'ooobtc',
        description: 'OOOBTC is a cryptocurrency exchange that offers trading in cryptocurrencies only. There are not many details about where the company is located or when it was established.  OOOBTC offers 2-factor authentication and encryption of the users’ information. Funds are stored in offline cold storage.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/ooobtcExchange',
            ],
            website: [
                'https://www.ooobtc.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'market-exchange',
        name: 'Market Exchange',
        description: 'Market Exchange company with the aim of developing fintech and cryptocurrency. ME has created an exchange for the freedom of crypto and its movements.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/Marketexchange3',
            ],
            website: [
                'https://marketexchange.io',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 218,
        reported_rank: 232,
        currencies: 6,
        markets: 9,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 716849.00508372,
                adjusted_volume_24h: 716849.00508372,
                reported_volume_7d: 5310644.08928138,
                adjusted_volume_7d: 5310644.08928138,
                reported_volume_30d: 23407490.73515463,
                adjusted_volume_30d: 23407490.73515463,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'hotdex',
        name: 'HOTDEX',
        description: 'HotDex is the of top-tier crypto exchange. It is a fast, secure and easy to use the platform as your favorite exchange so that you don’t have to miss out on any trading opportunities. It provides access to established crypto-currencies while also allowing you to discover and trade up-and-coming tokens and altcoins in a variety of different trading pairs.\r\n\r\nHotdex is built on the BitShare platform. So the dex provides a high-performance decentralized exchange, with all the features you would expect in a trading platform. It can handle the trading volume of the NASDAQ, while settling orders the second you submit them.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/HotShotCoin',
            ],
            website: [
                'https://wallet.hotdex.eu/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'leoxchange',
        name: 'LEOxChange',
        description: 'LEOxChange is designed for holders of cryptocurrency including, but not limited to, LEOcoin, to allow them to trade their cryptocurrencies in the open market. LEOxChange is the official exchange for trading LEOcoin.\r\nSince the launch of LEOcoin on 22 June 2014, the LEOcoin community has grown to over 100,000 Members around the globe. Originally trading was conducted solely between LEO Members. Interest in the LEOcoin grew to such a level that it became clear that a public platform to trade LEOcoin was needed. The LEOxChange was born to meet this need.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/LEOxChangeHQ',
            ],
            website: [
                'https://leoxchange.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'upbit',
        name: 'Upbit',
        description: 'Upbit is a South Korean crypto exchange which released in October 2017. It was created by Korea’s biggest messaging app developer, Kakao, providing 111 altcoins when it was launched. Upbit offers more than 200 trading pairs, as it is in an active partnership with Bittrex. ',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/upbitglobal',
            ],
            website: [
                'https://upbit.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 24,
        reported_rank: 29,
        currencies: 112,
        markets: 195,
        fiats: [
            {
                name: 'South Korea Won',
                symbol: 'KRW',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 935369925.4377303,
                adjusted_volume_24h: 935369925.4377303,
                reported_volume_7d: 8855460605.502764,
                adjusted_volume_7d: 8855460605.502764,
                reported_volume_30d: 88304696223.19376,
                adjusted_volume_30d: 88304696223.19376,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 28700000,
        confidence_score: 0.261514,
    },
    {
        id: 'bw',
        name: 'BW',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://www.bw.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 95,
        reported_rank: 107,
        currencies: 18,
        markets: 19,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 41847508.35548027,
                adjusted_volume_24h: 41847508.35548027,
                reported_volume_7d: 319170794.8103931,
                adjusted_volume_7d: 319170794.8103931,
                reported_volume_30d: 1200135163.0941393,
                adjusted_volume_30d: 1200135163.0941393,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 70000,
        confidence_score: 0.000109,
    },
    {
        id: 'myxtrade',
        name: 'MyXtrade',
        description: 'MWallet SwapDex, Non Custodial Token Wallet on the Binance Smart Chain, has integrated with Transak Reliable Fiat / Off Transak Aggregator .\r\nThis partnership will allow users to purchase crypto through MWallet SwapDex directly to their Token Pocket Wallet or many other wallets using a credit card or bank transfer.\r\n\r\nMWallet is the first Malaysian DEX to implement these kind of crypto purchases directly onto non-custodial wallets via Transak and the partnership demonstrates the Defi’s commitment to making DeFi accessible to the average retail investor or User.\r\n\r\nMWallet SwapDex is a suite of DeFi tools that allows its users to engage in a myriad of different DeFi functions through one easy to use protocol. With MWallet SwapDex, users can add capital to liquidity pools, stake tokens, and yield farm all on one easy-to-use interface.\r\n\r\nMWallet SwapDex is the first Malaysian decentralized swap protocol to integrate a fiat gateway on Transak as part of its service.\r\nThe innovative new integration with Transak will allow MYMC Token Holders and Traders or swappers to transfer FIAT directly into crypto tokens without the need for going through a centralized Defi or Exchange.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/MymcToken',
            ],
            website: [
                'https://myxtrade.biz.my',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'marketexchange',
        name: 'MarketExchange',
        description: '',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://marketexchange.net/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'xbts',
        name: 'XBTS',
        description: 'XBTS is a Multi-chain decentralized exchange and DeFi operating at\r\nBitShares blockchain since 2018. XBTS is a leading-edge Dex for trade,\r\nDeFi, staking, exchange, holding cryptocurrencies, Cross-Chain\r\ntransactions, and an entry point to volumes of decentralized markets.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/xbtsdex',
            ],
            website: [
                'https://xbts.io/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 267,
        reported_rank: 282,
        currencies: 41,
        markets: 69,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
            {
                name: 'Russian Ruble',
                symbol: 'RUB',
            },
            {
                name: 'Yuan Renminbi',
                symbol: 'CNY',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 32863.71030959,
                adjusted_volume_24h: 32863.71030959,
                reported_volume_7d: 386109.63750075,
                adjusted_volume_7d: 386109.63750075,
                reported_volume_30d: 2000582.60470277,
                adjusted_volume_30d: 2000582.60470277,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 40000,
        confidence_score: 0.137061,
    },
    {
        id: 'bitengen',
        name: 'BITENGEN',
        description: '',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://bitengen.io/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 1000000,
        confidence_score: 0,
    },
    {
        id: 'cratex',
        name: 'Cratex',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/cratex_exchange',
            ],
            website: [
                'https://cratex.io/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 321,
        reported_rank: 336,
        currencies: 41,
        markets: 143,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0.81012384,
                adjusted_volume_24h: 0.81012384,
                reported_volume_7d: 4470.55692835,
                adjusted_volume_7d: 4470.55692835,
                reported_volume_30d: 16000.06944808,
                adjusted_volume_30d: 16000.06944808,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 80000,
        confidence_score: 0,
    },
    {
        id: 'kickex',
        name: 'KickEX',
        description: 'Launched on 25/05/2020, KickEX is an exchange based in Peterburi tee 47, Harju maakond, Lasnamäe linnaosa, Tallinn, 11415, Estonia. It supports crypto pairs and buying/selling crypto with credit cards. KickEX is licensed by the Estonian Financial Intelligence Unit (FIU) (license numbers: FVR001087, FRK000972).',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/KickEcosystem',
            ],
            website: [
                'https://kickex.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 104,
        reported_rank: 116,
        currencies: 9,
        markets: 11,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 33774663.82951913,
                adjusted_volume_24h: 33774663.82951913,
                reported_volume_7d: 240983903.3622465,
                adjusted_volume_7d: 240983903.3622465,
                reported_volume_30d: 1065533786.4135629,
                adjusted_volume_30d: 1065533786.4135629,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 620000,
        confidence_score: 0.396515,
    },
    {
        id: 'tokensnet',
        name: 'Tokens.net',
        description: 'Tokens.net describes itself as a trusted European Cryptocurrency Exchange. The platform represents distinctive trading engine and user-friendly interface built by crypto pioneers. Its unique design ensures 100% trading volume transparency.',
        active: true,
        website_status: false,
        api_status: false,
        message: "Tokens.net exchange is closing down.\n\n<a href='https://www.tokens.net/#announcement' target='_blank'>Read more about it</a>",
        links: {
            twitter: [
                'https://twitter.com/TokensNet',
            ],
            website: [
                'https://www.tokens.net/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'xbtce',
        name: 'xBTCe',
        description: 'xBTCe cryptocurrency exchange was founded by a group of experienced traders, finance professionals and crypto enthusiasts in 2015.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://www.xbtce.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'binance-jex-spot',
        name: 'Binance JEX (Spot)',
        description: '',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/BinanceJEX',
            ],
            website: [
                'https://www.jex.com/en',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 50000,
        confidence_score: 0,
    },
    {
        id: 'uniswap',
        name: 'Uniswap V1',
        description: 'Uniswap is a protocol for automated token exchange on Ethereum. It was launched on November 2, 2018. Uniswap describes itself as a simple smart contract interface for swapping ERC20 tokens. It has a formalized model for pooling liquidity reserves. It serves as an open-source frontend interface for traders and liquidity providers and is committed to providing free and decentralized asset exchange.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://uniswap.exchange/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 233,
        reported_rank: 247,
        currencies: 16,
        markets: 15,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 335254.18279817,
                adjusted_volume_24h: 335254.18279817,
                reported_volume_7d: 2450581.58891796,
                adjusted_volume_7d: 2450581.58891796,
                reported_volume_30d: 11235434.71473963,
                adjusted_volume_30d: 11235434.71473963,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'kucoin',
        name: 'Kucoin',
        description: 'Kucoin was founded by a group with a passion for the blockchain who had already built up strong reputations at industry giants, such as GF Securities, Ant Financial, Youling, Jianbang Communication, and iBOX PAY. To put Kucoin’s youth into perspective, the research and development team was only assembled in May 2017.',
        active: true,
        website_status: true,
        api_status: true,
        message: "Announcement after Kucoin security incident.\n\n<a href='https://www.kucoin.com/news/en-the-latest-updates-about-the-kucoin-security-incident' target='_blank'>Read more about it</a>",
        links: {
            twitter: [
                'https://twitter.com/kucoincom',
            ],
            website: [
                'https://www.kucoin.com?rcode=yyxsyd&rcode=yyxsyd&rcode=yyxsyd',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 15,
        reported_rank: 20,
        currencies: 351,
        markets: 682,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 1352940461.1969345,
                adjusted_volume_24h: 1352940461.1969345,
                reported_volume_7d: 10460864541.315332,
                adjusted_volume_7d: 10460864541.315332,
                reported_volume_30d: 51588984585.17666,
                adjusted_volume_30d: 51588984585.17666,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 42200000,
        confidence_score: 0.239918,
    },
    {
        id: 'anycoin-direct',
        name: 'Anycoin Direct',
        description: 'A Cryptocurrency broker / exchange established in 2013 and serving the whole of Europe since 2014.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/anycoindirect',
            ],
            website: [
                'https://anycoindirect.eu/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 251,
        reported_rank: 266,
        currencies: 24,
        markets: 24,
        fiats: [
            {
                name: 'Euro',
                symbol: 'EUR',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 104960.85728363,
                adjusted_volume_24h: 104960.85728363,
                reported_volume_7d: 1134799.61093803,
                adjusted_volume_7d: 1134799.61093803,
                reported_volume_30d: 5352571.45049227,
                adjusted_volume_30d: 5352571.45049227,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 70000,
        confidence_score: 0,
    },
    {
        id: 'waves-exchange',
        name: 'Waves Exchange',
        description: 'Founded in 2016, Waves Exchange is a hybrid market where users can trade waves-based assets, including Waves, Waves Assets, fiat tokens and cryptocurrency tokens like wBTC and wETH. On the Waves EX, users can trade with no counterparty risk as all operations take place on the Waves blockchain itself ensuring that no trust is required.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/wavesplatform',
            ],
            website: [
                'https://waves.exchange/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 86,
        reported_rank: 97,
        currencies: 18,
        markets: 35,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 57646410.16525078,
                adjusted_volume_24h: 57646410.16525078,
                reported_volume_7d: 227689218.51527834,
                adjusted_volume_7d: 227689218.51527834,
                reported_volume_30d: 504473167.2905584,
                adjusted_volume_30d: 504473167.2905584,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 4130000,
        confidence_score: 0.001668,
    },
    {
        id: 'gatecoin',
        name: 'Gatecoin',
        description: "Gatecoin is a bitcoin and ethereum token exchange based in Hong Kong. Founded in July 2013 by a former investment banker, Aurélien Menant. Gatecoin became the first cryptocurrency exchange to list ethereum's native token, ether (ETH) in August 2015 and has since specialised in listing ethereum tokens associated with decentralized applications.",
        active: true,
        website_status: true,
        api_status: false,
        message: "Gatecoin has shut down the operation due to problems with Payment Service Provider - according to official information.\n<a href='https://gatecoin.com/' target='_blank'>Read more here</a>",
        links: {
            twitter: [
                'https://twitter.com/gatecoin',
            ],
            website: [
                'https://www.gatecoin.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'deex',
        name: 'DEEX',
        description: 'Deex Exchange is a part of Deex Ecosystem - the large full-scale blockchain system which allows to conduct ICO campaigns, implement payment system and realize many financial functions using fastest blockchain technologies. Deex Exchange provides reliable and convenient platform to quickly trade, buy or sell cryptocurrencies. Currently more than 20 cryptocurrencies are available for trading including Bitcoin, Ethereum and many other popular and profitable altcoins. You can become a part of referral program and get an income by inviting traders. Deex Node program allows to get passive income by owning profitable financial instrument.',
        active: false,
        website_status: true,
        api_status: true,
        message: 'Exchange is not active',
        links: {
            twitter: [
                'https://twitter.com/deex_exchange',
            ],
            website: [
                'https://deex.exchange/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 6,
        markets: 11,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 110000,
        confidence_score: 0,
    },
    {
        id: 'coinex-market',
        name: 'CoinEx Market',
        description: '',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/coinexmarket',
            ],
            website: [
                'https://www.coinexmarket.io',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'kraken-futures',
        name: 'Kraken Futures',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/krakenfx',
            ],
            website: [
                'https://futures.kraken.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 364,
        reported_rank: 257,
        currencies: 5,
        markets: 5,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 181909.6551,
                adjusted_volume_24h: 0,
                reported_volume_7d: 1007399.3498,
                adjusted_volume_7d: 0,
                reported_volume_30d: 1004749390.7121999,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 26900000,
        confidence_score: 0.24076,
    },
    {
        id: 'token-store',
        name: 'Token Store',
        description: 'Token Store is one of the oldest, fully trustless decentralized exchanges in the ecosystem. It operates trustless exchanges on the ETH and EOS networks.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/TokenDotStore',
            ],
            website: [
                'https://token.store/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'yobit',
        name: 'YoBit',
        description: 'Yobit was founded in 2014. It has many cryptocurrencies on available to exchange including Bitcoin, Litecoin, Ethereum and Dogecoin. Yobit perpetuate their own "Pump" activities.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/YobitExchange',
            ],
            website: [
                'https://yobit.net?bonus=aDbXm&bonus=aDbXm&bonus=aDbXm&bonus=aDbXm&bonus=aDbXm',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 49,
        reported_rank: 56,
        currencies: 517,
        markets: 3122,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
            {
                name: 'Russian Ruble',
                symbol: 'RUB',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 227731612.54212862,
                adjusted_volume_24h: 227731612.54212862,
                reported_volume_7d: 1576864197.5325089,
                adjusted_volume_7d: 1576864197.5325089,
                reported_volume_30d: 7207308064.287328,
                adjusted_volume_30d: 7207308064.287328,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 7030000,
        confidence_score: 0.004399,
    },
    {
        id: 'coincheck',
        name: 'coincheck',
        description: 'Coincheck is cryptocurrency exchanges in Japan. Many users make use of Coincheck’s Android and iOS apps exchange. The company behind Coincheck was established in 2012 by Keisuke Wada and Yusuke Otsuka and the exchange itself began operating in 2014. Both founders are current directors with Wada acting as CEO and Otsuka COO. While nominally a Japanese exchange Coincheck is available internationally.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/coincheckjp',
            ],
            website: [
                'https://coincheck.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 84,
        reported_rank: 95,
        currencies: 1,
        markets: 1,
        fiats: [
            {
                name: 'Japanese Yen',
                symbol: 'JPY',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 62354204.03571019,
                adjusted_volume_24h: 62354204.03571019,
                reported_volume_7d: 446927557.7884954,
                adjusted_volume_7d: 446927557.7884954,
                reported_volume_30d: 2408081963.5245576,
                adjusted_volume_30d: 2408081963.5245576,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 5600000,
        confidence_score: 0.802262,
    },
    {
        id: 'binance-jersey',
        name: 'Binance Jersey',
        description: 'As of 16th January 2019, Binance has announced the launch of a new Fiat to Crypto exchange named “Binance Jersey“. The trading platform is live and active and allows you to trade in fiat currencies such as euros and pound sterling, with Europe being their target market.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/binanceje',
            ],
            website: [
                'https://www.binance.je/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 10000,
        confidence_score: 0,
    },
    {
        id: 'tokenize',
        name: 'Tokenize',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://tokenize.exchange/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 115,
        reported_rank: 127,
        currencies: 14,
        markets: 32,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 23042286.1644051,
                adjusted_volume_24h: 23042286.1644051,
                reported_volume_7d: 167632682.59932497,
                adjusted_volume_7d: 167632682.59932497,
                reported_volume_30d: 675564227.9562305,
                adjusted_volume_30d: 675564227.9562305,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 200000,
        confidence_score: 0.750081,
    },
    {
        id: 'altmarkets',
        name: 'AltMarkets',
        description: 'AltMarkets is a Cryptocurrency exchange based in UK, founded in 2018. ',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/altmarketsex',
            ],
            website: [
                'https://altmarkets.io/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 295,
        reported_rank: 310,
        currencies: 32,
        markets: 73,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 701.15438557,
                adjusted_volume_24h: 701.15438557,
                reported_volume_7d: 4438.86481095,
                adjusted_volume_7d: 4438.86481095,
                reported_volume_30d: 28216.75229063,
                adjusted_volume_30d: 28216.75229063,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 140000,
        confidence_score: 0,
    },
    {
        id: 'gdac',
        name: 'GDAC',
        description: 'GDAC is a South Korean exchange. On its website, it clearly states its registered address, the company behind it and its representative and company registration number. At GDAC, you can deposit fiat currency via bank transfer. However, as for most South Korean-exchanges, only KRW-deposits are available (not EUR or USD). ',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://www.gdac.co.kr/',
                'https://www.gdac.com',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 148,
        reported_rank: 162,
        currencies: 33,
        markets: 56,
        fiats: [
            {
                name: 'South Korea Won',
                symbol: 'KRW',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 7104557.07785014,
                adjusted_volume_24h: 7104557.07785014,
                reported_volume_7d: 49656648.62573791,
                adjusted_volume_7d: 49656648.62573791,
                reported_volume_30d: 223484583.55620784,
                adjusted_volume_30d: 223484583.55620784,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'etor',
        name: 'Etor',
        description: 'Etor Exchange is world’s first exchange with many segments in single platform like altcoin , margin trading , forex ,binary options, fiat currency exchange, gaming and many more .\r\nYou can utilise all these segments with your single wallet balance ,no need to create multiple wallets for different segments.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/etorexchange',
            ],
            website: [
                'https://www.etorexchange.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 240000,
        confidence_score: 0,
    },
    {
        id: 'txbit',
        name: 'Txbit',
        description: 'Txbit - a cryptocurrency exchange for the everyday trader. Our philosophy is simple; Security, Privacy and Reliability. Built and based in the Netherlands.\r\n\r\nA cryptocurrency exchange built from the ground up to meet today’s demands in security, privacy, reliability and speed. The proprietary trading engine and interface deliver a blazing-fast, world-class user experience catering to traders who enjoy spending some time behind the charts, but also to those who prefer to be in and out quickly.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/txbit_io',
            ],
            website: [
                'https://txbit.io',
                'https://txbit.io/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 209,
        reported_rank: 223,
        currencies: 32,
        markets: 49,
        fiats: [
            {
                name: 'Ukrainian Hryvnia',
                symbol: 'UAH',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 1079465.70516266,
                adjusted_volume_24h: 1079465.70516266,
                reported_volume_7d: 8960316.69902419,
                adjusted_volume_7d: 8960316.69902419,
                reported_volume_30d: 37255962.55732402,
                adjusted_volume_30d: 37255962.55732402,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 440000,
        confidence_score: 0,
    },
    {
        id: 'bitcointrade',
        name: 'BitcoinTrade',
        description: 'BitcoinTrade.Com.br is a cryptocurrency trading platform that can only be used for Brazilians. The company was founded by four people that were interested in bringing Bitcoin trading to the mainstream investors of Brazil. They are Carlos André Montenegro (CEO), a digital entrepreneur, Daniel Coquieri (COO), from the tech sector, Fabio Santos (CSO) which has a background of more than 20 years in the tech and security sector and Jorn Filho (CTO), also a digital entrepreneur. Based in Rio de Janeiro, Brazil, the company is fully audited and compliant with the Brazilian laws.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/br_bitcointrade',
            ],
            website: [
                'https://www.bitcointrade.com.br/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 231,
        reported_rank: 245,
        currencies: 6,
        markets: 6,
        fiats: [
            {
                name: 'Brazil Real',
                symbol: 'BRL',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 406581.98041571,
                adjusted_volume_24h: 406581.98041571,
                reported_volume_7d: 2884651.4432975,
                adjusted_volume_7d: 2884651.4432975,
                reported_volume_30d: 11794773.10879488,
                adjusted_volume_30d: 11794773.10879488,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0.273267,
    },
    {
        id: 'tradeogre',
        name: 'TradeOgre',
        description: 'TradeOgre is a digital assets exchange, which supports alternative coins with various privacy functions.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/tradeogre',
            ],
            website: [
                'https://tradeogre.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 223,
        reported_rank: 237,
        currencies: 81,
        markets: 98,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 579101.76141082,
                adjusted_volume_24h: 579101.76141082,
                reported_volume_7d: 9018016.63997347,
                adjusted_volume_7d: 9018016.63997347,
                reported_volume_30d: 40961913.91218603,
                adjusted_volume_30d: 40961913.91218603,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 2310000,
        confidence_score: 0.329261,
    },
    {
        id: 'dsx',
        name: 'DSX',
        description: 'London-based DSX crypto-exchange was launched in december, 2014. The company acts as a EMD Agent - an authorised representative of a firm regulated by Financial Conduct Authority (FCA). ',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/DSX_uk',
            ],
            website: [
                'https://dsx.uk',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'freiexchange',
        name: 'FreiExchange',
        description: 'FreiExchange is a Norwegian exchange which mainly facilitates altcoin trading. Founded in 2016, it is developed by a group of professionals, who are connected to a longstanding coin - Freicoin.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/fed_fab',
            ],
            website: [
                'https://freiexchange.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 279,
        reported_rank: 294,
        currencies: 115,
        markets: 141,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 7116.20027355,
                adjusted_volume_24h: 7116.20027355,
                reported_volume_7d: 60201.72013762,
                adjusted_volume_7d: 60201.72013762,
                reported_volume_30d: 289646.94822722,
                adjusted_volume_30d: 289646.94822722,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 50000,
        confidence_score: 0,
    },
    {
        id: 'gopax',
        name: 'GOPAX',
        description: 'Gopax is a South Korean cryptocurrency exchange. Gopax gives the details of the company which runs it and the people behind it. They do accept bank transfers in KRW, which allows locals to enter the cryptoverse.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://www.gopax.co.kr',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 178,
        reported_rank: 192,
        currencies: 46,
        markets: 45,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 3260399.34512586,
                adjusted_volume_24h: 3260399.34512586,
                reported_volume_7d: 18645420.14128627,
                adjusted_volume_7d: 18645420.14128627,
                reported_volume_30d: 94810877.79655224,
                adjusted_volume_30d: 94810877.79655224,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 530000,
        confidence_score: 0.067818,
    },
    {
        id: 'idex',
        name: 'IDEX',
        description: 'IDEX is a decentralized exchange on the DAO blockchain network. It offers fast exchange services and supports real-time trading in over 200 cryptocurrencies, in addition to Ethereum. The platform does not offer trading in Bitcoin. IDEX has a very detailed guide on how to use the platform, how to deposit and withdraw, how to unlock the wallet, etc.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/aurora_dao',
                'https://twitter.com/idexio',
            ],
            website: [
                'https://idex.io/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 135,
        reported_rank: 149,
        currencies: 9,
        markets: 10,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 12657463.4790393,
                adjusted_volume_24h: 12657463.4790393,
                reported_volume_7d: 41124663.06361659,
                adjusted_volume_7d: 41124663.06361659,
                reported_volume_30d: 110140687.05864348,
                adjusted_volume_30d: 110140687.05864348,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 440000,
        confidence_score: 0.000178,
    },
    {
        id: 'nexchange',
        name: 'n.exchange',
        description: 'n.exchange is a non-custodial instant crypto exchange, meaning no user funds are held on the platform. Serving as an intermediary between users and crypto exchanges, n.exchange aims to make this process as effortless as possible for everyone interested in buying and selling cryptocurrency. In operation since 2016, the service allows users to have fast transactions and enjoy high limits. n.exchange offers an easily recognizable crypto and non-crypto enthusiasts interface, favourable exchange rates, and secure transactions.\r\nn.exchange offers its API to any service that wishes to expand its audience reach and withstand any large volumes of transactions. Multiple crypto businesses already use the n.exchange API which grants the functionality with the instant swap feature.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://n.exchange/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 243,
        reported_rank: 258,
        currencies: 11,
        markets: 36,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 179301.50507506,
                adjusted_volume_24h: 179301.50507506,
                reported_volume_7d: 1951467.93142413,
                adjusted_volume_7d: 1951467.93142413,
                reported_volume_30d: 9124823.60833524,
                adjusted_volume_30d: 9124823.60833524,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 10000,
        confidence_score: 0,
    },
    {
        id: 'zbg',
        name: 'ZBG',
        description: 'ZBG is a Chinese cryptocurrency exchange. It launched in July 2018. It is actually a sub-platform of the much larger exchange ZB.com.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/ZBGLOBLE',
            ],
            website: [
                'https://www.zbg.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 2,
        reported_rank: 3,
        currencies: 33,
        markets: 45,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 7110718587.493985,
                adjusted_volume_24h: 7100854404.2406645,
                reported_volume_7d: 50931379571.11577,
                adjusted_volume_7d: 50845763534.47044,
                reported_volume_30d: 191607004470.53912,
                adjusted_volume_30d: 191176184780.8658,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 2500000,
        confidence_score: 0.00101,
    },
    {
        id: 'bihodl',
        name: 'BiHODL',
        description: "BiHODL Digital Asset Trading Platform has always been aiming at promoting the rapid development of the blockchain industry and is committed to aggregating high-quality digital assets in the world to provide a safe, stable and fair trading platform for the vast number of Cryptocurrency enthusiasts. The BiHODL team is spread all over the United States, Singapore and Japan. Its members are top Internet companies' technical experts and financial Systems architect. The platform relies on a strong development team and first-class technical strength to strive to create a perfect trading experience for users.",
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/BiHodl',
            ],
            website: [
                'https://www.bihodl.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'coin-republic',
        name: 'Coin Republic',
        description: 'Coin Republic is a mobile first crypto trading platform designed to trade, deposit and withdraw with ease. We offer competitive 0.1% flat trading fees and high liquidity to make it easy for our customers to find buyers and sellers. Our customers funds are secured by an independent, institutional grade digital asset custody.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://www.coinrepublic.exchange',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'criptoswaps',
        name: 'Criptoswaps',
        description: 'Many fans will be listed on our token and current token/coin exchange.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/criptoswaps',
            ],
            website: [
                'https://www.criptoswaps.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 351,
        reported_rank: 351,
        currencies: 5,
        markets: 5,
        fiats: [
            {
                name: 'Turkish Lira',
                symbol: 'TRY',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 50000,
        confidence_score: 0,
    },
    {
        id: 'qb',
        name: 'QB',
        description: 'QB is registered in the UK, aiming as a global high-quality digital asset trading platform, and the core team members have many years of experience in trading system development, security, and blockchain. Currently, QB holds Canadian digital asset trading license.',
        active: false,
        website_status: true,
        api_status: false,
        message: 'Exchange is not active',
        links: {
            twitter: [
                'https://twitter.com/QB_Exchange',
            ],
            website: [
                'https://www.qb.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'bitrue',
        name: 'Bitrue',
        description: 'Bitrue is one of the many cryptocurrency exchanges from Singapore. It launched in July 2018. Bitrue supports trading in a decent number of cryptocurrencies but does not accept any deposits of fiat currency.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/BitrueOfficial',
            ],
            website: [
                'https://www.bitrue.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 23,
        reported_rank: 28,
        currencies: 169,
        markets: 325,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 1062935048.6957014,
                adjusted_volume_24h: 1062935048.6957014,
                reported_volume_7d: 7602838648.81067,
                adjusted_volume_7d: 7602838648.81067,
                reported_volume_30d: 40803749848.51213,
                adjusted_volume_30d: 40803749848.51213,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 6400000,
        confidence_score: 0.156344,
    },
    {
        id: 'artis-turba',
        name: 'Artis Turba',
        description: 'Intuitive cryptocurrency exchange in South Africa built for individuals, traders and investors',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/artisturba',
            ],
            website: [
                'https://artisturba.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'bancor-network',
        name: 'Bancor Network',
        description: 'The Bancor Network is a project which facilitates the quick and easy conversion of different Etherum based tokens. The exchange launched after a successful ICO in 2017.  Decentralized exchanges do not require a third party to store your funds.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/bancor',
            ],
            website: [
                'https://www.bancor.network/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 202,
        reported_rank: 215,
        currencies: 10,
        markets: 15,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 1315617.91865225,
                adjusted_volume_24h: 1315617.91865225,
                reported_volume_7d: 9090353.83631856,
                adjusted_volume_7d: 9090353.83631856,
                reported_volume_30d: 61262742.27375562,
                adjusted_volume_30d: 61262742.27375562,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 1100000,
        confidence_score: 0,
    },
    {
        id: 'defi-scan',
        name: 'DeFi Scan',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/defichain',
            ],
            website: [
                'https://defiscan.live/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 121,
        reported_rank: 133,
        currencies: 5,
        markets: 4,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 21820815.11620854,
                adjusted_volume_24h: 21820815.11620854,
                reported_volume_7d: 101218942.65197167,
                adjusted_volume_7d: 101218942.65197167,
                reported_volume_30d: 421297850.35112965,
                adjusted_volume_30d: 421297850.35112965,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 110000,
        confidence_score: 0.000044,
    },
    {
        id: 'yoobtc',
        name: 'YOOBTC',
        description: 'Launched on 1/9/2019.\r\nYOOBTC is a centralized exchange based in Australia.\r\nWe use distributed server clusters, high-speed memory transaction engines, cold wallets, and hot wallet technologies to ensure the security, efficiency, and stability of transaction services',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://yoobtc.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'coinlogy',
        name: 'Coinlogy',
        description: 'We are a modern, safe Trading Platform for accessing cryptocurrency exchange markets with very simple interface and low trading fees. Our own API is easy-to-use, supplied with an instructional manual. Our Support Service communicates in Russian and English and replies to the Customers’ requests 7 days a week within working hours (UTC+3). Coinlogy.io is a service for sale and purchase of cryptocurrency for cryptocurrency and for fiat money with large variety of trading tools',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://coinlogy.io',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'bibo',
        name: 'Bibo',
        description: 'Bibo Exchange is a Europe-based cryptocurrency exchange integrated with a connected ecommerce platform (www.bibo.market), creating an ecosystem that allows its users to not only trade but also spend their crypto assets. Making use of cryptocurrency’s advantages in international payment settlement (fast, borderless and no middlemen), Bibo Market is aiming to empower merchants and online shoppers world-wide to buy and sell goods internationally with less intermediaries.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://www.bibo.gold/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 10000,
        confidence_score: 0,
    },
    {
        id: 'infinitycoin-exchange',
        name: 'InfinityCoin Exchange',
        description: 'InfinityCoin Exchange is a cryptocurrency exchange registered in the British Virgin Islands. It offers trading in two cryptocurrencies: BTC and the InfinityCoin (XIN). This trading venue does not accept any other deposit method than cryptocurrencies. ',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://infinitycoin.exchange/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 331,
        reported_rank: 343,
        currencies: 2,
        markets: 1,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'coinbig',
        name: 'COINBIG',
        description: 'COIBIG is an innovative “community of eco-autonomous digital asset trading platform” registered in New Zealand. We are the devout believers in the core ideas of bitcoin and blockchain. The core members of the team are top-level elite teams from world-renowned companies, technology finance and blockchain community operations, and also former OKcoin founders and operators.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/CoinBigExchange',
            ],
            website: [
                'https://www.coinbig.com/index.html',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'forkdelta',
        name: 'ForkDelta',
        description: 'ForkDelta is a decentralized exchange that offers many ERC20 (Ethereum) tokens for trade and keeps adding new ones (free of charge). As the name suggests, this exchange is a fork of EtherDelta and uses the smart contract of the latter. Any member of the ForkDelta community that participated in an ICO can request a token to be listed on ForkDelta.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/ForkDelta',
            ],
            website: [
                'https://forkdelta.app',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 30000,
        confidence_score: 0,
    },
    {
        id: 'tokok',
        name: 'TOKOK',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/Tokokcom',
            ],
            website: [
                'https://www.tokok.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 46,
        reported_rank: 53,
        currencies: 17,
        markets: 29,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 254511692.19733727,
                adjusted_volume_24h: 254511692.19733727,
                reported_volume_7d: 1847503250.545585,
                adjusted_volume_7d: 1847503250.545585,
                reported_volume_30d: 8011115296.478781,
                adjusted_volume_30d: 8011115296.478781,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 70000,
        confidence_score: 0.112461,
    },
    {
        id: 'digidinar',
        name: 'DigiDinar',
        description: '',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/digidinars',
            ],
            website: [
                'https://www.digidinar.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 10000,
        confidence_score: 0,
    },
    {
        id: 'bitbegin',
        name: 'BitBegin',
        description: 'The main purpose of Bitbegin is to build an exchange in which the community would share in the prosperity of the platform.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/binsofficial',
            ],
            website: [
                'https://bitbegin.io',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'zbcom',
        name: 'ZB.COM',
        description: 'ZB is a Chinese cryptocurrency exchange that launched in the aftermath of the ICO ban in in the country. It offers mainly crypto-to-crypto spot trading, but there is also some crypto-to-fiat trading. According to the information on its website, ZB.COM’s headquarters are in in North America (Canada, the United States), and it also has operations in Southeast Asia (Bangkok), West Asia (Dubai), as well as South Korea, and Switzerland. ',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/ZbTalk',
                'https://twitter.com/Zb_group',
            ],
            website: [
                'https://www.zb.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 36,
        reported_rank: 43,
        currencies: 67,
        markets: 109,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 501310387.5272399,
                adjusted_volume_24h: 501310387.5272399,
                reported_volume_7d: 4476303332.873267,
                adjusted_volume_7d: 4476303332.873267,
                reported_volume_30d: 20323634154.876175,
                adjusted_volume_30d: 20323634154.876175,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 390000,
        confidence_score: 0.137945,
    },
    {
        id: 'moonxbt',
        name: 'MoonXBT',
        description: "MoonXBT is the world's first social cryptocurrency trading platform. With headquarters in the Cayman Islands and offices in Singapore, Hong Kong, Malaysia, South Korea, Japan, and Vietnam. At present, we provide contract trading, social interaction, and one-click copy trading services for global traders and are committed to building a closer blockchain ecosystem.",
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/MoonXBT_Global',
            ],
            website: [
                'https://www.moonxbt.com/en-us/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 341,
        reported_rank: 61,
        currencies: 12,
        markets: 11,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 207850026.93872663,
                adjusted_volume_24h: 0,
                reported_volume_7d: 1456605443.2290561,
                adjusted_volume_7d: 0,
                reported_volume_30d: 6231939260.386724,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 260000,
        confidence_score: 0.000105,
    },
    {
        id: 'spero',
        name: 'SPERO',
        description: '',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://exchange.sperocoin.org/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'atomicdex',
        name: 'AtomicDEX',
        description: "AtomicDEX is a p2p DEX built by Komodo Platform to enable native blockchain to blockchain trading. There's no intermediaries, no proxy tokens, and it implementes the original hashlock-time contracts proposed by Tier Nolan in 2014.",
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://www.atomicdex.io/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 283,
        reported_rank: 298,
        currencies: 50,
        markets: 95,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 4082.72951544,
                adjusted_volume_24h: 4082.72951544,
                reported_volume_7d: 27388.02950397,
                adjusted_volume_7d: 27388.02950397,
                reported_volume_30d: 185489.58169945,
                adjusted_volume_30d: 185489.58169945,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 10000,
        confidence_score: 0,
    },
    {
        id: 'triple-dice-exchange',
        name: 'Triple Dice Exchange',
        description: null,
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://mydicewallet.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'decoin',
        name: 'Decoin',
        description: "Founded in 2017, Decoin is an exchange designed at its core by the crypto community for the crypto community. Decoin’s mission is to provide the most transparent and innovative Pro social Trading platform for Decoin's top traders, with maximum-security elements. Decoin’s exchange has an easy-to-use interface, for novice users, and advanced trading features for industry veterans. Decoin’s ecosystem also includes a coin called \"DTEP\", which is powered by an independent blockchain using a “PoS” consensus algorithm. Decoin is led by an experienced team of fintech experts, financial professionals, and experienced traders on a global scale.",
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://www.decoin.io/en/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 111,
        reported_rank: 123,
        currencies: 28,
        markets: 27,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 27366896.76868907,
                adjusted_volume_24h: 27366896.76868907,
                reported_volume_7d: 201496580.60549068,
                adjusted_volume_7d: 201496580.60549068,
                reported_volume_30d: 859263608.78063,
                adjusted_volume_30d: 859263608.78063,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 1300000,
        confidence_score: 0.000525,
    },
    {
        id: 'raisex',
        name: 'Raisex',
        description: 'RAISEX is a professional cryptocurrency exchange founded in 2017 in Malta. RAISEX core team are from world leading online finance companies and expert developers of cryptocurrency industry. RAISEX believes the blockchain technology will eliminate barriers to transactions, increase the efficiency of transactions across society, and eventually have a significant impact on the global economy.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/Raisex4',
            ],
            website: [
                'https://raisex.io/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: '1inch-liquidity-protocol-bsc',
        name: '1inch Liquidity Protocol (BSC)',
        description: '',
        active: true,
        website_status: false,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://app.1inch.io/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 282,
        reported_rank: 297,
        currencies: 5,
        markets: 6,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 4658.20019512,
                adjusted_volume_24h: 4658.20019512,
                reported_volume_7d: 56298.82542735,
                adjusted_volume_7d: 56298.82542735,
                reported_volume_30d: 371956.50964778,
                adjusted_volume_30d: 371956.50964778,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 7450000,
        confidence_score: 0,
    },
    {
        id: 'vinex',
        name: 'Vinex',
        description: '',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/vinexnetwork',
            ],
            website: [
                'https://vinex.network',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'ddex',
        name: 'DDEX',
        description: '',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/ddex_io',
                'https://twitter.com/ddexio2018',
            ],
            website: [
                'https://ddex.io/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 10000,
        confidence_score: 0,
    },
    {
        id: 'hypecoinexchange',
        name: 'Hypecoinexchange',
        description: '',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/Hypecoinmarket',
            ],
            website: [
                'https://hypecoinexchange.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'altsbit',
        name: 'Altsbit',
        description: '',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/altsbit',
            ],
            website: [
                'https://altsbit.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'bits-blockchain',
        name: 'Bits Blockchain',
        description: 'Bits Blockchain is an exchange that allows both coin-to-coin and coin-to-fiat trading with a focus on its own digital asset, ATM Coin (ATMC) which is a digital coin developed by the same company that runs the Bits Blockchain exchange.  The exchange is based in Macau, China.',
        active: false,
        website_status: false,
        api_status: false,
        message: 'Exchange is not active',
        links: {
            website: [
                'https://bitsblockchain.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'dflow',
        name: 'DFLOW',
        description: 'DFlow is an exchange designed to support the blockchain and cryptocurrency economy.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/DFlow_Official',
            ],
            website: [
                'https://dflowx.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'safecrex',
        name: 'Safecrex',
        description: 'Safecrex Cryptocurrency Exchange',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/safecrex',
            ],
            website: [
                'https://www.safecrex.trade/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'bittilo',
        name: 'Bittilo',
        description: 'Bittilo is a digital asset trading platform for the most popular cryptocurrencies.\r\nWe focus on providing the highest level of security, transparency and customer service.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://bittilo.com',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 150,
        reported_rank: 164,
        currencies: 16,
        markets: 16,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 6840746.62161793,
                adjusted_volume_24h: 6840746.62161793,
                reported_volume_7d: 48661170.81100958,
                adjusted_volume_7d: 48661170.81100958,
                reported_volume_30d: 186297584.8668326,
                adjusted_volume_30d: 186297584.8668326,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0.292285,
    },
    {
        id: 'isx',
        name: 'ISX',
        description: 'ISX is an Icelandic cryptocurrency exchange. It offers trading in two coins against the Icelandic national currency ISK: BTC and AUR. This Icelandic exchange offers wire transfer as a deposit method. You cannot, however, deposit funds through your debit or credit card.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://beta.isx.is',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 303,
        reported_rank: 318,
        currencies: 1,
        markets: 1,
        fiats: [
            {
                name: 'Icelandic krona',
                symbol: 'ISK',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 156.14315679,
                adjusted_volume_24h: 156.14315679,
                reported_volume_7d: 1650.97444729,
                adjusted_volume_7d: 1650.97444729,
                reported_volume_30d: 5960.69680961,
                adjusted_volume_30d: 5960.69680961,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'bitsails',
        name: 'BitSails',
        description: 'BitSails is a brand new p2p exchange platform hub where everyone can easily exchange cryptocurrencies with a counterparty flawlessly and securely.\r\n\r\nMain features: Ultra fast trading engine "Ocean", operated in EU country by early adopters and senior developers, military-grade network infrastructure security, low fees and wide range of markets supported, fast support & strong community.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/BitSails',
            ],
            website: [
                'https://bitsails.com',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 311,
        reported_rank: 326,
        currencies: 19,
        markets: 18,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 76.98297123,
                adjusted_volume_24h: 76.98297123,
                reported_volume_7d: 562.88267141,
                adjusted_volume_7d: 562.88267141,
                reported_volume_30d: 2439.18648067,
                adjusted_volume_30d: 2439.18648067,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'bitpanda-pro',
        name: 'Bitpanda Pro',
        description: 'Bitpanda Pro is an advanced trading platform and digital asset exchange for experienced traders, professionals and institutions where you can trade popular digital assets like Bitcoin, Ethereum and more.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/bitpanda',
            ],
            website: [
                'https://exchange.bitpanda.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 131,
        reported_rank: 145,
        currencies: 39,
        markets: 45,
        fiats: [
            {
                name: 'Euro',
                symbol: 'EUR',
            },
            {
                name: 'Pound Sterling',
                symbol: 'GBP',
            },
            {
                name: 'Swiss Franc',
                symbol: 'CHF',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 13018269.31570067,
                adjusted_volume_24h: 13018269.31570067,
                reported_volume_7d: 75695454.18995473,
                adjusted_volume_7d: 75695454.18995473,
                reported_volume_30d: 260724767.85119212,
                adjusted_volume_30d: 260724767.85119212,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 3200000,
        confidence_score: 0.801293,
    },
    {
        id: 'dodo-polygon-network',
        name: 'DODO (Polygon Network)',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://app.dodoex.io/exchange/ETH-USDC?network=matic',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 3,
        reported_rank: 6,
        currencies: 9,
        markets: 51,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 5351593187.051057,
                adjusted_volume_24h: 5351593187.051057,
                reported_volume_7d: 37526309461.43408,
                adjusted_volume_7d: 37526309461.43408,
                reported_volume_30d: 147314526392.5521,
                adjusted_volume_30d: 147314526392.5521,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 2200000,
        confidence_score: 0.000889,
    },
    {
        id: 'aphelion',
        name: 'Aphelion',
        description: null,
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/apheliontoken',
            ],
            website: [
                'https://aphelion.org/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'mercado-bitcoin',
        name: 'Mercado Bitcoin',
        description: 'Founded in 2017, Mercado Bitcoin is one of the leaders in the Brazilian cryptocurrency space. The company accepts Real (BRL) deposits and facilitates trading in a few of the most popular coins.',
        active: true,
        website_status: false,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/MercadoBitcoin',
            ],
            website: [
                'https://www.mercadobitcoin.com.br/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 206,
        reported_rank: 220,
        currencies: 3,
        markets: 3,
        fiats: [
            {
                name: 'Brazil Real',
                symbol: 'BRL',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 1173139.85608332,
                adjusted_volume_24h: 1173139.85608332,
                reported_volume_7d: 16009650.60218038,
                adjusted_volume_7d: 16009650.60218038,
                reported_volume_30d: 61421451.75588089,
                adjusted_volume_30d: 61421451.75588089,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 1300000,
        confidence_score: 0,
    },
    {
        id: 'binance-us',
        name: 'Binance US',
        description: 'Binance US is a secure platform for users to buy, sell, and store cryptocurrencies.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://www.binance.us/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 50,
        reported_rank: 57,
        currencies: 50,
        markets: 120,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 224752360.92400357,
                adjusted_volume_24h: 224752360.92400357,
                reported_volume_7d: 1408834425.7506433,
                adjusted_volume_7d: 1408834425.7506433,
                reported_volume_30d: 7551632320.942759,
                adjusted_volume_30d: 7551632320.942759,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 24300000,
        confidence_score: 0.782203,
    },
    {
        id: 'birich',
        name: 'Birich',
        description: 'Birich provide secure, trusted cryptocurrency derivatives trading services to users in more than 100 countries around the world.\r\n\r\nIt mainly provides derivative trading services for a series of blockchain assets such as Bitcoin and Ethereum.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/BIRICH13',
            ],
            website: [
                'https://www.birich.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'arthbit',
        name: 'ArthBit',
        description: 'ArthBit platform has been designed for all investors around the globe. It is run by CA Ajay K Jayswal. ArthBit offers USDT and INR Market, Arthbit providing fast withdrawal and Deposit service in Fiat Currency. established in 2020.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/ArthBitExchange',
            ],
            website: [
                'https://arthbit.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 107,
        reported_rank: 119,
        currencies: 6,
        markets: 5,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 32570724.41580048,
                adjusted_volume_24h: 32570724.41580048,
                reported_volume_7d: 246133624.33804122,
                adjusted_volume_7d: 246133624.33804122,
                reported_volume_30d: 1163940872.907817,
                adjusted_volume_30d: 1163940872.907817,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 10000,
        confidence_score: 0.750004,
    },
    {
        id: 'bisq',
        name: 'Bisq',
        description: 'Bisq, which was previously known as Bitsquare is a decentralized, peer-to-peer cryptocurrency exchange. Bisq is not a company, but a “Decentralized Autonomous Organization” (DAO). The project was started in 2014, by Manfred Karrer, as a means of keeping the original spirit of Bitcoin alive, even through the exchanges on which it is traded. ',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/bisq_network',
            ],
            website: [
                'https://bisq.network/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 249,
        reported_rank: 264,
        currencies: 15,
        markets: 32,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
            {
                name: 'Euro',
                symbol: 'EUR',
            },
            {
                name: 'Pound Sterling',
                symbol: 'GBP',
            },
            {
                name: 'Canadian Dollar',
                symbol: 'CAD',
            },
            {
                name: 'Japanese Yen',
                symbol: 'JPY',
            },
            {
                name: 'Polish Zloty',
                symbol: 'PLN',
            },
            {
                name: 'Russian Ruble',
                symbol: 'RUB',
            },
            {
                name: 'New Zealand Dollar',
                symbol: 'NZD',
            },
            {
                name: 'Australian Dollar',
                symbol: 'AUD',
            },
            {
                name: 'Swiss Franc',
                symbol: 'CHF',
            },
            {
                name: 'Mexican Peso',
                symbol: 'MXN',
            },
            {
                name: 'Brazil Real',
                symbol: 'BRL',
            },
            {
                name: 'Thai Baht',
                symbol: 'THB',
            },
            {
                name: 'Chilean Peso',
                symbol: 'CLP',
            },
            {
                name: 'Czech Koruna',
                symbol: 'CZK',
            },
            {
                name: 'Indian Rupee',
                symbol: 'INR',
            },
            {
                name: 'Swedish Krona',
                symbol: 'SEK',
            },
            {
                name: 'South African Rand',
                symbol: 'ZAR',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 119580.24993767,
                adjusted_volume_24h: 119580.24993767,
                reported_volume_7d: 2042116.2626056,
                adjusted_volume_7d: 2042116.2626056,
                reported_volume_30d: 6261833.24104085,
                adjusted_volume_30d: 6261833.24104085,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 110000,
        confidence_score: 0,
    },
    {
        id: 'bitnaru',
        name: 'Bitnaru',
        description: null,
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/Bitnaruofficial',
            ],
            website: [
                'https://www.bitnaru.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'bitvavo',
        name: 'Bitvavo',
        description: 'Bitvavo recenly changed from being a digital currency broker to a digital currency exchange. The users have the possibility to trade with 50 different digital currencies.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://bitvavo.com/en',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 76,
        reported_rank: 86,
        currencies: 141,
        markets: 141,
        fiats: [
            {
                name: 'Euro',
                symbol: 'EUR',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 88401612.67962469,
                adjusted_volume_24h: 88401612.67962469,
                reported_volume_7d: 704397456.0129699,
                adjusted_volume_7d: 704397456.0129699,
                reported_volume_30d: 4388128018.813663,
                adjusted_volume_30d: 4388128018.813663,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 890000,
        confidence_score: 0.80036,
    },
    {
        id: 'spiritswap',
        name: 'SpiritSwap',
        description: 'The SpiritSwap protocol adds incentives for Fantom network participants by introducing revenue sharing through the classic AMM model. We provide a platform for trading, staking, and farming. This is just the start. We are building more everyday.\r\n',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/Spirit_Swap',
            ],
            website: [
                'https://www.spiritswap.finance/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 153,
        reported_rank: 167,
        currencies: 12,
        markets: 17,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 6479375.49747772,
                adjusted_volume_24h: 6479375.49747772,
                reported_volume_7d: 27334299.73021323,
                adjusted_volume_7d: 27334299.73021323,
                reported_volume_30d: 98224948.04722874,
                adjusted_volume_30d: 98224948.04722874,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 4320000,
        confidence_score: 0.001745,
    },
    {
        id: 'nash',
        name: 'Nash',
        description: 'Nash exchange is non-custodial cross-chain digital asset exchange. Our system allows for cross-chain non-custodial trading between the Bitcoin, Ethereum, and NEO blockchain. We support crypto-to-crypto trading, and are currently awaiting approval for our fiat on-ramp. Nash is fully regulated by the FMA in Liechtenstein.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/nashsocial',
            ],
            website: [
                'https://nash.io/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 263,
        reported_rank: 278,
        currencies: 4,
        markets: 8,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 43681.38190256,
                adjusted_volume_24h: 43681.38190256,
                reported_volume_7d: 149034.18574047,
                adjusted_volume_7d: 149034.18574047,
                reported_volume_30d: 487838.6868642,
                adjusted_volume_30d: 487838.6868642,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 40000,
        confidence_score: 0.213122,
    },
    {
        id: 'blocktrade',
        name: 'Blocktrade',
        description: 'Blocktrade is a top-tier trading facility for Security Tokens, Crypto Assets, Crypto Traded Indices™ and other tokenised assets. With a clear vision a new ecosystem, we are about to become the first fully MiFID II compliant crypto exchange and are partnering with security token issuers, market makers and other financial institutions, sharing the same high standards and values. Acquiring the license for listing security tokens in a completely regulated manner, Blocktrade is opening the floodgates for institutional capital to join the crypto markets. In order to exceed expectations of retail as well as institutional traders, Blocktrade trading venue is built on high performance, superior security and outstanding customer experience.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/Blocktradecom',
            ],
            website: [
                'https://blocktrade.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 31,
        reported_rank: 37,
        currencies: 6,
        markets: 8,
        fiats: [
            {
                name: 'Euro',
                symbol: 'EUR',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 626401088.618568,
                adjusted_volume_24h: 626401088.618568,
                reported_volume_7d: 4737327136.735855,
                adjusted_volume_7d: 4737327136.735855,
                reported_volume_30d: 18654640039.278595,
                adjusted_volume_30d: 18654640039.278595,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 20000,
        confidence_score: 0.000008,
    },
    {
        id: 'bitcoiva',
        name: 'BITCOIVA',
        description: "India's high liquidity crypto exchange",
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://www.bitcoiva.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 140000,
        confidence_score: 0,
    },
    {
        id: 'ftx-futures',
        name: 'FTX Futures',
        description: 'FTX is a cryptocurrency derivatives exchange built by traders, for traders. They strive to build a platform powerful enough for professional trading firms and intuitive enough for first-time users.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://ftx.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 355,
        reported_rank: 4,
        currencies: 66,
        markets: 66,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 5537938118.617825,
                adjusted_volume_24h: 0,
                reported_volume_7d: 44825738240.27026,
                adjusted_volume_7d: 0,
                reported_volume_30d: 217692249450.13437,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 28800000,
        confidence_score: 0.430806,
    },
    {
        id: 'okcoin-international',
        name: 'OKCoin',
        description: 'Founded in 2013, OKCoin is a world digital asset trading platform. OKCoin currently provides fiat trading with major digital assets, including Bitcoin, Bitcoin Cash, Ethereum, Ethereum Classic, and Litecoin. OKCoin has recently expanded to the United States and is looking to serve more users around the world in the future.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/OKCoin',
            ],
            website: [
                'https://www.okcoin.com',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 98,
        reported_rank: 110,
        currencies: 18,
        markets: 26,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
            {
                name: 'Euro',
                symbol: 'EUR',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 39182368.66625563,
                adjusted_volume_24h: 39182368.66625563,
                reported_volume_7d: 203681443.1992367,
                adjusted_volume_7d: 203681443.1992367,
                reported_volume_30d: 766336432.2774636,
                adjusted_volume_30d: 766336432.2774636,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 2140000,
        confidence_score: 0.750432,
    },
    {
        id: 'insta-fx',
        name: 'Insta FX',
        description: '',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/TheInstaFx',
            ],
            website: [
                'https://instfx.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'unidax',
        name: 'UniDAX',
        description: 'UniDAX is a digital asset exchange that launched on March 2018. Their team be in Hong Kong and Singapore, and we provide professional services to users around the globe.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/Unidax_Official',
            ],
            website: [
                'https://www.unidax.com/index',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'deliondex',
        name: 'Deliondex',
        description: 'Deliondex is a decentralized cryptocurrency exchange operates on top of Bitshares blockchain. Our target market is Indonesian users which now has limited access to cryptocurrency world because there are only 2 exchanges currently operating in Indonesia. Also we are combining all services into one ecosystem for masternode coins, like masternode statistics, masternode monitoring service and masternode hosting service. Investors can do research, buy on deliondex, hosting their masternode and monitor the masternode all in one ecosystem provided by Delion Project.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/CoinDelion',
            ],
            website: [
                'https://dex.delion.online',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 313,
        reported_rank: 328,
        currencies: 31,
        markets: 113,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 73.65298893,
                adjusted_volume_24h: 73.65298893,
                reported_volume_7d: 730.68025861,
                adjusted_volume_7d: 730.68025861,
                reported_volume_30d: 3773.45804688,
                adjusted_volume_30d: 3773.45804688,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 10000,
        confidence_score: 0,
    },
    {
        id: 'otcbtc',
        name: 'OTCBTC',
        description: 'Taiwan-based OTCBTC is a blockchain company that offers OTC (over-the-counter) trading in digital assets, as well as a crypto exchange. Initially, OTCBTC started out as a OTC platform in September 2017. In January 2018, the Taiwanese team launched the crypto exchange. by a group of Taiwanese team fascinating blockchain science. ',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/otcbtc',
            ],
            website: [
                'https://otcbtc.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'fanticos-criptos',
        name: 'Fanáticos Criptos',
        description: 'Our team is available to help you anytime you need help. Miscellaneous assets Increase your profits by trading multiple assets in our markets. Low rates Only 0.1% per trade or 0.1 FCH regardless of the volume traded. Corporate Acquisition Platform built from scratch, acquired by Fanáticos Criptos and in constant evolution. The right market! A variety of markets for you to find the best trading pair for the asset you want to invest in and lead you to financial independence.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/fanacriptos',
            ],
            website: [
                'https://fanaticoscriptos.exchange',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'occe',
        name: 'OCCE',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://www.occe.io/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 319,
        reported_rank: 334,
        currencies: 18,
        markets: 32,
        fiats: [
            {
                name: 'Ukrainian Hryvnia',
                symbol: 'UAH',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 10.61140726,
                adjusted_volume_24h: 10.61140726,
                reported_volume_7d: 1290.50963615,
                adjusted_volume_7d: 1290.50963615,
                reported_volume_30d: 3180.12120078,
                adjusted_volume_30d: 3180.12120078,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 20000,
        confidence_score: 0.15,
    },
    {
        id: 'farhadmarket',
        name: 'FarhadMarket',
        description: 'FarhadMarket exchange is a cryptocurrency platform that was founded by a company from Iran. The team includes highly experienced experts and professional developers who are passionate about blockchain. The exchange supports the most popular cryptocurrencies such as Bitcoin, Ethereum, Litecoin, Bitcoin Cash, Tether, Chainlink, Tron and Cardano. As for the fiat money, the platform supports Iran Rial. Users can buy and sell digital assets using convenient functionality of the service.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://app.farhadmarket.com',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 207,
        reported_rank: 221,
        currencies: 10,
        markets: 17,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 1101617.54485405,
                adjusted_volume_24h: 1101617.54485405,
                reported_volume_7d: 8189252.09004092,
                adjusted_volume_7d: 8189252.09004092,
                reported_volume_30d: 35930594.13913192,
                adjusted_volume_30d: 35930594.13913192,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 110000,
        confidence_score: 0,
    },
    {
        id: '55-global-markets',
        name: '55 Global Markets',
        description: '',
        active: false,
        website_status: false,
        api_status: false,
        message: 'Exchange is not active',
        links: {
            twitter: [
                'https://twitter.com/55GlobalMarkets',
            ],
            website: [
                'https://www.55.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 40000,
        confidence_score: 0,
    },
    {
        id: 'bitbns',
        name: 'Bitbns',
        description: 'Bitbns is a new Indian cryptocurrency exchange launched in 2017 in over 50 cryptocurrencies for INR. Bitbns offers its users a wallet to store their cryptocurrencies. Or they can use third-party wallets, if they so choose. Bitbns does not allow anonymous trading and requires clients to verify themselves with an ID and a PAN card in order to deposit INR. Before verifying, one can only view the price charts and order book or deposit cryptocurrencies. ',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/bitbns',
            ],
            website: [
                'https://bitbns.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 168,
        reported_rank: 182,
        currencies: 79,
        markets: 79,
        fiats: [
            {
                name: 'Indian Rupee',
                symbol: 'INR',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 4170652.98339229,
                adjusted_volume_24h: 4170652.98339229,
                reported_volume_7d: 36213315.8291772,
                adjusted_volume_7d: 36213315.8291772,
                reported_volume_30d: 162112052.0545011,
                adjusted_volume_30d: 162112052.0545011,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 6400000,
        confidence_score: 0.002585,
    },
    {
        id: 'ndax',
        name: 'NDAX',
        description: 'National Digital Asset Exchange Inc. (NDAX) is a Canadian-based digital asset exchange that offers a world-class experience for individuals and institutions to buy and sell Bitcoin and other cryptocurrencies in the fastest, safest and most compliant manner. NDAX is fully integrated into the Canadian banking system, allowing for quick and efficient transfers from all Canadian banks, credit unions and financial institutions. Clients’ Canadian dollar (CAD) and US dollar (USD) transfers are safely deposited and stored with a crown-owned Canadian bank.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/ndaxio',
            ],
            website: [
                'https://ndax.io/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 171,
        reported_rank: 185,
        currencies: 23,
        markets: 24,
        fiats: [
            {
                name: 'Canadian Dollar',
                symbol: 'CAD',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 3904588.40588762,
                adjusted_volume_24h: 3904588.40588762,
                reported_volume_7d: 26422690.34342703,
                adjusted_volume_7d: 26422690.34342703,
                reported_volume_30d: 125662440.0473511,
                adjusted_volume_30d: 125662440.0473511,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 1800000,
        confidence_score: 0.050727,
    },
    {
        id: 'domitai',
        name: 'Domitai',
        description: 'Domitai is the first commerce-oriented crypto exchange and crypto service provider. Our services and infrastructure is designed to empower commerces allowing them to accept crypto currencies with ease.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/domitai',
            ],
            website: [
                'https://domitai.com',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 298,
        reported_rank: 313,
        currencies: 10,
        markets: 24,
        fiats: [
            {
                name: 'Mexican Peso',
                symbol: 'MXN',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 386.68267682,
                adjusted_volume_24h: 386.68267682,
                reported_volume_7d: 2343.3189838,
                adjusted_volume_7d: 2343.3189838,
                reported_volume_30d: 31124.30990095,
                adjusted_volume_30d: 31124.30990095,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'cryptox',
        name: 'Cryptox',
        description: 'Cryptox is a Polish cryptocurrency exchange. This exchange allows only deposits in cryptocurrencies.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://cryptox.pl/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'paramountdax',
        name: 'ParamountDax',
        description: "The ParamountDax exchange opened for cryptocurrency trading in April 2020 based in Estonia is a promising platform for cryptocurrency exchange, which has taken into account all the shortcomings of its competitors and created a unique platform for its users. ParamountDax has created a highly competent, stable, and secure crypto exchange. ParamountDax aims to revolutionize cryptocurrency trading by serving as an ideal platform for cryptocurrency trading, while also solving the problems faced by today's crypto industry.\r\nParamountDax gives users access to a robust set of trading tools, Market Detector, daily bonus rewards of up to 46% through the ParamountDax (PRDX) platform token, the simplicity of the Unique Trading From the Chart Interface is sure to meet the needs of any trader at any level of experience, with direct on-chart trades and a stable environment for digital asset trading, ParamountDax Exchange aims to serve millions of clients from many countries and regions.",
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/ParamountDax',
            ],
            website: [
                'https://www.paramountdax.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 138,
        reported_rank: 152,
        currencies: 6,
        markets: 5,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 10739590.72482295,
                adjusted_volume_24h: 10739590.72482295,
                reported_volume_7d: 76525792.74490225,
                adjusted_volume_7d: 76525792.74490225,
                reported_volume_30d: 357313069.4523963,
                adjusted_volume_30d: 357313069.4523963,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 570000,
        confidence_score: 0.744522,
    },
    {
        id: 'lcx-exchange',
        name: 'LCX Exchange',
        description: 'LCX Exchange is a regulated, compliant and secure trading platform for a variety of digital assets.\r\n\r\nLCX, the Liechtenstein Cryptoassets Exchange, was founded in 2018 with headquarters in Vaduz (Liechtenstein) and offices in Crypto-Valley Zug (Switzerland) and New Delhi (India). LCX has obtained 8 crypto-related registrations by the Financial Market Authority Liechtenstein, operates in accordance with the new blockchain laws and has introduced a comprehensive crypto compliance suite. LCX AG, the legal entity behind LCX.com, has a registered share capital of 1 Million CHF.\r\n\r\nThe LCX Token ($LCX) is the fuel of the LCX.com platform and LCX Cryptocurrency Exchange.\r\nLCX Token works as a long-term sustainable incentive mechanism to motivate various stakeholders to participate in the ecosystem.\r\n',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/lcx',
            ],
            website: [
                'https://exchange.lcx.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 226,
        reported_rank: 240,
        currencies: 6,
        markets: 11,
        fiats: [
            {
                name: 'Euro',
                symbol: 'EUR',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 468696.19037712,
                adjusted_volume_24h: 468696.19037712,
                reported_volume_7d: 2284680.37087864,
                adjusted_volume_7d: 2284680.37087864,
                reported_volume_30d: 8659827.41841461,
                adjusted_volume_30d: 8659827.41841461,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 1420000,
        confidence_score: 0,
    },
    {
        id: 'creekex',
        name: 'CreekEx',
        description: 'CreekEx is a new crypto exchange managed by Creek Capital Exchange LLC',
        active: true,
        website_status: true,
        api_status: false,
        message: 'Some coinpaprika users report problems with this exchange. Be careful!',
        links: {
            twitter: [
                'https://twitter.com/CreekExchange',
            ],
            website: [
                'https://creekex.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 60000,
        confidence_score: 0,
    },
    {
        id: 'crosstower',
        name: 'CrossTower',
        description: 'CrossTower is on a mission to mainstream digital asset investing and trading.\r\n\r\nWe believe that bringing the advanced trading tools, rigorous security, compliance safeguards, price efficiencies, and support models from the global equity markets into digital assets will make this a reality.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://crosstower.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 152,
        reported_rank: 166,
        currencies: 8,
        markets: 23,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 6607498.12765692,
                adjusted_volume_24h: 6607498.12765692,
                reported_volume_7d: 45032597.50301099,
                adjusted_volume_7d: 45032597.50301099,
                reported_volume_30d: 132739996.20566729,
                adjusted_volume_30d: 132739996.20566729,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 100000,
        confidence_score: 0.80004,
    },
    {
        id: 'coss',
        name: 'COSS',
        description: 'COSS is a cryptocurrency exchange based in Singapore. COSS officially launched in April 2017, following an ICO. ',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/cosscrypto',
            ],
            website: [
                'https://www.coss.io/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 215,
        reported_rank: 229,
        currencies: 10,
        markets: 12,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 939821.97422914,
                adjusted_volume_24h: 939821.97422914,
                reported_volume_7d: 7399331.87439423,
                adjusted_volume_7d: 7399331.87439423,
                reported_volume_30d: 33984001.36570177,
                adjusted_volume_30d: 33984001.36570177,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 20000,
        confidence_score: 0.056143,
    },
    {
        id: 'mergedex',
        name: 'MergeDEX',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/theprojectmerge',
            ],
            website: [
                'https://mergedex.com',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 353,
        reported_rank: 353,
        currencies: 7,
        markets: 10,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0.02046532,
                adjusted_volume_7d: 0.02046532,
                reported_volume_30d: 4084.55976636,
                adjusted_volume_30d: 4084.55976636,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'idax',
        name: 'IDAX',
        description: 'IDAX is an international exchange originating from GBC (Global Blockchain Research Centre). Providing IDAX users from all around the world with convenient and fast digital cryptocurrency transactions.',
        active: true,
        website_status: false,
        api_status: false,
        message: "IDAX admitted the news that its CEO went missing, locking the exchange out of the cold storage wallets.\n\n<a href='https://bitcoinist.com/breaking-idax-admits-ceo-has-vanished-with-cold-wallet-keys/' target='_blank'>Read more about it</a>",
        links: {
            twitter: [
                'https://twitter.com/IDAX11',
                'https://twitter.com/IDAXpro',
            ],
            website: [
                'https://www.idax.pro',
                'https://www.idax.pro/#/?inviteCode=mjggo3?inviteCode=mjggo3?inviteCode=mjggo3',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 50000,
        confidence_score: 0,
    },
    {
        id: 'stakecenter',
        name: 'StakeCenter',
        description: 'StakeCenter is a Pos pool and Exchange. Additional profit from using our exchange is that your coins are still staking.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/StakeCenterco',
            ],
            website: [
                'https://stakecenter.co',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 312,
        reported_rank: 327,
        currencies: 13,
        markets: 20,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 73.9295353,
                adjusted_volume_24h: 73.9295353,
                reported_volume_7d: 762.94113079,
                adjusted_volume_7d: 762.94113079,
                reported_volume_30d: 2491.08470744,
                adjusted_volume_30d: 2491.08470744,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 70000,
        confidence_score: 0,
    },
    {
        id: 'ninjaswap',
        name: 'NinjaSwap',
        description: 'NinjaSwap is a DEX that enables swapping, farming, and staking for BSC tokens. its AMM follows the tradition of Uniswap. But it gets its speed and affordable transaction fee from Binance Smart Chain. Besides that, unlike other swap platforms, a limited number of tokens are minted. The team has no interest in farming and staking, it provides all the income to the participants. It has a very novel token minting system called AMO (Automatic Minting Offering).',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/NinjaSwapApp/',
            ],
            website: [
                'https://ninjaswap.app/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 315,
        reported_rank: 330,
        currencies: 4,
        markets: 3,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 39.5958598,
                adjusted_volume_24h: 39.5958598,
                reported_volume_7d: 699.08117672,
                adjusted_volume_7d: 699.08117672,
                reported_volume_30d: 3166.21019961,
                adjusted_volume_30d: 3166.21019961,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 30000,
        confidence_score: 0,
    },
    {
        id: 'trade-satoshi',
        name: 'Trade Satoshi',
        description: 'Trade Satoshi is a cryptocurrency platform based in London, UK. It only supports crypto-crypto exchange and does not support FIAT currencies. It began operating in 2015. One of its founders is Francesco Alibrandi - a bitcoin entrepreneur from Australia.',
        active: true,
        website_status: false,
        api_status: false,
        message: "Trade Satoshi is closing down.\n\n<a href='https://tradesatoshi.com/News/476/Tradesatoshi-Is-Closing-Down' target='_blank'>Read more about it</a>",
        links: {
            twitter: [
                'https://twitter.com/TradeSatoshi',
            ],
            website: [
                'https://tradesatoshi.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'poloniex',
        name: 'Poloniex',
        description: 'Poloniex is a digital asset exchange offering a wide variety of digital assets. Founded in January 2014, Poloniex offers trading environment and provides advanced charts and data analysis tools to its customers.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/Poloniex',
            ],
            website: [
                'https://poloniex.com',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 102,
        reported_rank: 114,
        currencies: 112,
        markets: 191,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 36206020.9075067,
                adjusted_volume_24h: 36206020.9075067,
                reported_volume_7d: 268521310.56609833,
                adjusted_volume_7d: 268521310.56609833,
                reported_volume_30d: 1392048005.4576101,
                adjusted_volume_30d: 1392048005.4576101,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 13000000,
        confidence_score: 0.707524,
    },
    {
        id: 'saber',
        name: 'Saber',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://saber.so/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 160,
        reported_rank: 174,
        currencies: 9,
        markets: 7,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 5450216.48547277,
                adjusted_volume_24h: 5450216.48547277,
                reported_volume_7d: 58539662.90460502,
                adjusted_volume_7d: 58539662.90460502,
                reported_volume_30d: 396259490.55004215,
                adjusted_volume_30d: 396259490.55004215,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 1200000,
        confidence_score: 0.000485,
    },
    {
        id: '55com',
        name: '55.com',
        description: null,
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/55GlobalMarkets',
            ],
            website: [
                'https://www.55.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 40000,
        confidence_score: 0,
    },
    {
        id: 'utorg',
        name: 'Utorg',
        description: 'Utorg is a cryptocurrency exchange, where you can easily buy, sell and trade Bitcoins, Ethereum and other cryptocurrencies directly with fiat currencies such as RUB, UAH, USD. Utorg offers large selection of fiat gateways, including Advcash, Qiwi, Payeer, Perfect Money, Visa/Mastercard, Wire transfer. Fiat deposit fees start from 0,5%. Trading on Utorg is available for free since maker fee is 0%, and taker fee is as low as 0.2%.\r\n\r\nUtorg also acts as a service-provider for many businesses, which connect to Utorg and use the proprietary software developed in-house to automate processing of crypto and fiat, mostly exchangers and e-commerce services.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://utorg.io',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'saturn-network',
        name: 'Saturn Network',
        description: 'Saturn Network is the first multi-blockchain decentralized exchange. It requires no deposits and runs completely on the Ethereum blockchain, making it always accessible to everyone. Furthermore, it has been built with shared ownership in mind to ensure there are no imbalances of power: holding SATURN tokens means you are part of the Saturn DAO.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/SaturnProtocol',
            ],
            website: [
                'https://saturn.network',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'dobi-exchange',
        name: 'DOBI',
        description: '',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/Dobitrade_',
            ],
            website: [
                'https://www.dobiexchange.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'cpdax',
        name: 'CPDAX',
        description: 'CPDAX, also known as Coinplug Digital Assets Exchange, is the latest digital currency trading platform venture by highly acclaimed South Korean company Coinplug. It launched in September 2017. The exchange is available in the following languages: English, Korean and Chinese. CPDAX does not explicitly state that US-investors are prohibited from trading.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/cpdax',
            ],
            website: [
                'https://www.cpdax.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 10000,
        confidence_score: 0,
    },
    {
        id: 'turuko',
        name: 'TURUKO',
        description: 'Based in Istanbul, Turuko is an advanced but easy to use trading platform. The exchange is available for customers worldwide and translated into 7 different languages.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'twitter.com/turukocom',
            ],
            website: [
                'https://www.turuko.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'royal-exchange',
        name: 'Royal Exchange',
        description: 'Royal Exchange is a vibrant and robust Exchange for all cryptocurrencies and their users, with over 40 listings and climbing. As a lightening fast, reliable and smooth exchange, we offer and unrivalled trading experience for multiple tokens. Royal Exchange has cross-chain capability and support for hundreds of coins/tokens and will continue to develop exciting and innovative trading events.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/RoyalAltXchange',
            ],
            website: [
                'https://royal.exchange/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'neraex',
        name: 'Neraex',
        description: 'NERAEX is an entry-level cryptocurrency exchange based in Japan. At this point in time they are not regulated by the Financial Services Agency (FSA). ',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/neraexpro',
            ],
            website: [
                'https://neraex.pro/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'bitstorage',
        name: 'BITStorage',
        description: 'BITStorage Finance is a cryptocurrency exchange created with the goal of making cryptocurrency trading easier and more reliable. The BITStorage Finance is connected to most popular and recognized by internet community Payeer payment service, which made its reputation as reliable and stable electronic payment service for long years. helping to foster a closer integration between crypto and fiat currencies.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/BitstorageF',
            ],
            website: [
                'https://bitstorage.finance',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 81820789.6261974,
                adjusted_volume_30d: 81820789.6261974,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'uniswap-v2',
        name: 'Uniswap V2',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://app.uniswap.org/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 66,
        reported_rank: 75,
        currencies: 2592,
        markets: 2727,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 111614326.19657193,
                adjusted_volume_24h: 111614326.19657193,
                reported_volume_7d: 917107159.1500309,
                adjusted_volume_7d: 917107159.1500309,
                reported_volume_30d: 4645927123.191784,
                adjusted_volume_30d: 4645927123.191784,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 12500000,
        confidence_score: 0.005049,
    },
    {
        id: 'luxtrade',
        name: 'Luxtrade',
        description: '',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/marketluxtrade',
            ],
            website: [
                'https://luxtrade.exchange/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 170000,
        confidence_score: 0,
    },
    {
        id: 'bankcex',
        name: 'BankCEX',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/BankCexExchange',
            ],
            website: [
                'https://bankcex.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 60,
        reported_rank: 68,
        currencies: 39,
        markets: 86,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 164949374.29177216,
                adjusted_volume_24h: 164949374.29177216,
                reported_volume_7d: 1196870261.0537126,
                adjusted_volume_7d: 1196870261.0537126,
                reported_volume_30d: 5088890586.085051,
                adjusted_volume_30d: 5088890586.085051,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 800000,
        confidence_score: 0.000323,
    },
    {
        id: 'ex4ange',
        name: 'Ex4ange',
        description: 'We have been developing the exchange from scratch for several years now. Only recently we opened it for trading with the same young cryptocurrencies as we do.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://ex4ange.org/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 356,
        reported_rank: 356,
        currencies: 3,
        markets: 2,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 10000,
        confidence_score: 0,
    },
    {
        id: 'tagz',
        name: 'TAGZ',
        description: "The World's Largest Altcoin Exchange Hub.",
        active: true,
        website_status: true,
        api_status: false,
        message: 'Coinpaprika have received many complaints about this exchange - especially regarding problems with withdrawal. Be caution!',
        links: {
            website: [
                'https://tagz.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'yourtoken',
        name: 'Yourtoken',
        description: 'Launched in Apr 2019, YourToken is a centralized exchange located at Sepapaja tn 6 Tallinn Harjumaa 15551. It describes itself as a plug & play exchange powered by ThoreNetwork, and a community-lead crypto-to-cypto platform with features such as cashbacks, social trading, lending and rewards, and margin trading. To boost convenience and liquidity, YourToken also provides peer-to-peer crypto-fiat trading features, which reportedly allows users to trade any cryptocurrency listed on the exchange for fiat with other users within the Thore network.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://yourtoken.app/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'crex24',
        name: 'Crex24',
        description: 'CREX24 is cryptocurrency exchange targeting Russian-speaking clients. It was set up in 2017 and offers trading in cryptocurrencies for fiat currencies and cryptocurrencies for cryptocurrencies. CREX24 offers several payment options for fiat currencies: Bank cards, e-wallets (Skrill, WebMoney, Qiwi, etc.) and electronic payment platforms (Neteller, Payeer, etc.).',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/crex_24',
            ],
            website: [
                'https://crex24.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 167,
        reported_rank: 181,
        currencies: 198,
        markets: 252,
        fiats: [
            {
                name: 'Russian Ruble',
                symbol: 'RUB',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 4201351.86558706,
                adjusted_volume_24h: 4201351.86558706,
                reported_volume_7d: 26613672.08725779,
                adjusted_volume_7d: 26613672.08725779,
                reported_volume_30d: 124812399.40443541,
                adjusted_volume_30d: 124812399.40443541,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 4600000,
        confidence_score: 0.158582,
    },
    {
        id: 'araguaneybits',
        name: 'AraguaneyBits',
        description: 'Exchange cryptocurrency on the best terms, quickly and without complicated checks! AraguaneyBits is an instant and automatic exchange of Venezuelan cryptocurrencies such as BOLI, AREPA, ONIX, LKR, ANDES, RILCOIN among others. Their main focus is to support the exchange of the Altcoins that were born in Venezuela as well as others that are widely used as BTC and DASH.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://trade.araguaneybits.com/#/tradingview/BTC-USDC',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'cgcx',
        name: 'CGCX',
        description: "World's First Fully Insured Hybrid Crypto Platform.",
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/CGCXofficial',
            ],
            website: [
                'https://www.cgcx.io',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 106,
        reported_rank: 118,
        currencies: 9,
        markets: 9,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 32706701.77405045,
                adjusted_volume_24h: 32706701.77405045,
                reported_volume_7d: 247648820.92021155,
                adjusted_volume_7d: 247648820.92021155,
                reported_volume_30d: 1227668334.3539827,
                adjusted_volume_30d: 1227668334.3539827,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 30000,
        confidence_score: 0.000012,
    },
    {
        id: 'coinegg',
        name: 'CoinEgg',
        description: 'CoinEgg is a cryptocurrency exchange, based in the United Kingdom. The company only focuses on digital assets, without providing any form of fiat currency trading.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/CoinEgg_LTD',
            ],
            website: [
                'https://www.coinegg.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 20000,
        confidence_score: 0,
    },
    {
        id: 'hashfort',
        name: 'Hashfort',
        description: '',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://hashfort.exchange',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'aidosmarket',
        name: 'AidosMarket',
        description: 'Aidos Market is a platform that specializes in trading Aidos Kuneen (ADK). Aidos Market only offers the option to exchange the supported cryptocurrencies.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/AidosMarket',
            ],
            website: [
                'https://aidosmarket.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 363,
        reported_rank: 363,
        currencies: 2,
        markets: 1,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 40000,
        confidence_score: 0,
    },
    {
        id: 'bomesp-global',
        name: 'BOMESP Global',
        description: '',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://www.twitter.com/nbcbomespglobal/',
            ],
            website: [
                'https://www.bomesp.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'coinut',
        name: 'Coinut',
        description: 'Coinut is a Singapore-based cryptocurrency exchange for bitcoin, cryptocurrencies, futures, options and binary options trading. Founded in 2013, by one of the core developers of Litecoin, They are one of the earliest cryptocurrency exchanges in Singapore. They are headquartered in Singapore, with subsidiaries in North America (Canada) & Europe (Switzerland).',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/coinut_exchange',
            ],
            website: [
                'https://coinut.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 272,
        reported_rank: 287,
        currencies: 7,
        markets: 24,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
            {
                name: 'Canadian Dollar',
                symbol: 'CAD',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 15421.42917892,
                adjusted_volume_24h: 15421.42917892,
                reported_volume_7d: 142246.80935053,
                adjusted_volume_7d: 142246.80935053,
                reported_volume_30d: 468539.78913425,
                adjusted_volume_30d: 468539.78913425,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 750000,
        confidence_score: 0.128938,
    },
    {
        id: 'coinquista',
        name: 'Coinquista',
        description: 'Coinquista has been developed since 2017 - the company already has a distinctive product ready for efficient customer service. The stock exchange will allow secure trading and storage of cryptocurrencies. Thanks to the option of tracking the best investors and trading under the care of experts, as well as an intuitive interface, Coinquista will allow you to easily enter the world of investment. Access to extensive statistics and the most popular cryptocurrencies will meet the expectations of demanding and experienced users.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://www.coinquista.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'smdex',
        name: 'SMDEX',
        description: 'SMDEX is a global crypto-to-crypto exchange that offers a high-tech crypto asset trading platform to users all over the world. SMDEX allows users to trade on the web, Android and IOS',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'http://smdex.io/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 100000,
        confidence_score: 0,
    },
    {
        id: 'slicex',
        name: 'Slicex',
        description: 'Slicex claims to be powered by a state-of-the-art trading engine, with a strong focus on transparency, reliability, quality execution, and client support. Platform claims that it offers great crypto trading experience with all essential features and tools that traders expect.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/slicexcc',
            ],
            website: [
                'https://slicex.cc/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'fybse',
        name: 'FYB-SE',
        description: '',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://www.fybse.se',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'bitexblock',
        name: 'Bitexblock',
        description: 'BitexBlock is a Panama-based cryptocurrency exchange launched in July 2019. Its primary market is Panama, Ecuador, Colombia and Venezuela where the company has already been issued an operating license or is in the process of commercial registration.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://bitexblock.com',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 306,
        reported_rank: 321,
        currencies: 3,
        markets: 3,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 129.11925969,
                adjusted_volume_24h: 129.11925969,
                reported_volume_7d: 1746.4110927,
                adjusted_volume_7d: 1746.4110927,
                reported_volume_30d: 7262.68672428,
                adjusted_volume_30d: 7262.68672428,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 10000,
        confidence_score: 0,
    },
    {
        id: 'bitmaszyna',
        name: 'Bitmaszyna',
        description: 'BitMaszyna is a Polish entry-level cryptocurrency exchange.  BitMaszyna claims to be running from before the time Bitcoin was created. While this may sound illogical, at that point in time they were known as “Kantor e-gold”. E-gold was a centralized digital currency backed by gold before the age of cryptocurrencies and the team behind this exchange apparently operated with it.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://bitmaszyna.pl/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'dodo',
        name: 'DODO',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://dodoex.io/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 58,
        reported_rank: 66,
        currencies: 4,
        markets: 5,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 168858728.2042241,
                adjusted_volume_24h: 168858728.2042241,
                reported_volume_7d: 434127216.67964494,
                adjusted_volume_7d: 434127216.67964494,
                reported_volume_30d: 1297704627.9933,
                adjusted_volume_30d: 1297704627.9933,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 2200000,
        confidence_score: 0.000889,
    },
    {
        id: 'pars',
        name: 'PARS',
        description: 'First International Iranian User to User Exchange.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/parsxc',
            ],
            website: [
                'https://parsxc.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'hanbitco',
        name: 'Hanbitco',
        description: null,
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/hanbitco_info',
            ],
            website: [
                'https://www.hanbitco.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'coinall',
        name: 'Coinall',
        description: 'CoinAll is an exchange that is owned by Hong Kong-based digital asset trading platform OKEx. The exchange offers the opportunity for classic traders to trade over one hundred types of popular and emerging tokens. ',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://www.coinall.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 30000,
        confidence_score: 0,
    },
    {
        id: 'dogex-global',
        name: 'Dogex Global',
        description: 'Dogex was created on October 12, 2020. With the aim of increasing profitability in the cryptocurrency business, which already has more than 1 billion investors worldwide. Dogex is a centralized exchange that operates globally in all countries. Our bag is totally innovative, easy to use and with modern technologies. The Dogex platform offers features such as: crypto trading, data analysis, bot functionality, marketing and signaling buying and selling cryptocurrencies. The system also allows live trading with integration for the entry and exit of assets.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://dogex.net/en/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 329,
        reported_rank: 344,
        currencies: 7,
        markets: 11,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'enmanet',
        name: 'Enmanet',
        description: 'Enmanet is a centralized exchange from Mexico.',
        active: true,
        website_status: true,
        api_status: false,
        message: "According to reports Enmanet don't allow to withdraw cryptocurrencies from their website, and probably could be insolvent",
        links: {
            twitter: [
                'https://twitter.com/emanetproject',
            ],
            website: [
                'https://www.enmanet.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'bitparax',
        name: 'Bitparax',
        description: 'Bitparax Is young but the most technical equipped crypto exchange. It offers traders easy to use interface and transactions safety. Since 2019 March Bitparax team has the most fully range of security measures and security risk control measures in the industry. Bitparax welcomes global users and continues to expands digital currency in various countries to provide users with global trading opportunities. High-quality currencies are listed on Bitparax to offer traders comprehensive range of digital assets.\r\n',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/bitparax',
            ],
            website: [
                'https://bitparax.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'nagax',
        name: 'NAGAX',
        description: null,
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/nagainvesting',
            ],
            website: [
                'https://nagax.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 60000,
        confidence_score: 0,
    },
    {
        id: 'rokkex',
        name: 'ROKKEX',
        description: 'ROKKEX is a next-generation crypto exchange with a foundation of security and performance. ROKKEX enables both the beginner and advanced trader to exchange crypto assets instantly with maximum safety. The platform has been developed with the best practices of UX, which provides practical, experiential, effective, and meaningful ways to trade.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/ROKKEX_com',
            ],
            website: [
                'https://www.rokkex.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'coinswap-space',
        name: 'CoinSwap Space',
        description: 'CoinSwapSpace is an incentivized DEFI protocol, decentralized exchange, and an automated market maker (“AMM”) that gives two tokens an opportunity to be exchanged on the Binance Smart Chain Network. This network is fast, cheap, and allows anyone to participate with less or no gas fees at all. Our Dream? To provide utility and products where the community can benefit. We at CoinSwapSpace is aiming to become 1 of the best liquidity provider using the Binance Smart Chain, creating unique farming and staking mechanics, and giving our community the products and services they needed through the use of their CSS tokens.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/CoinSwap_Space',
            ],
            website: [
                'https://coinswap.space/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 247,
        reported_rank: 262,
        currencies: 12,
        markets: 15,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 136287.87863192,
                adjusted_volume_24h: 136287.87863192,
                reported_volume_7d: 969295.98982135,
                adjusted_volume_7d: 969295.98982135,
                reported_volume_30d: 3985795.68825259,
                adjusted_volume_30d: 3985795.68825259,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 60000,
        confidence_score: 0,
    },
    {
        id: 'flybit',
        name: 'Flybit',
        description: 'FLYBIT is fast growing digital asset exchange established by Korea Digital Exchange Co., Ltd. operating since 2018 with more than 80 trading pairs in KRW, BTC, USDT. FLYBIT boasts excellence in security, customer service, variety of altcoins, high liquidity, intuitive UX, and a member of the Korea Blockchain Association.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/FlybitOfficial',
            ],
            website: [
                'https://www.flybit.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 50000,
        confidence_score: 0,
    },
    {
        id: 'oex',
        name: 'OEX',
        description: 'OEX is a Chinese cryptocurrency exchange, which provides access to some well known altcoins. ',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/oexcom',
            ],
            website: [
                'https://www.oex.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'coinmargin',
        name: 'CoinMargin',
        description: 'A secure, fast and transparent crypto exchange platform that is not only providing exchange and trading services but also equipped with a unique feature that is valuing its users and their experience.\r\n\r\nThe main focus of CoinMargin is to provide all-inclusive trading ecosystem that incentivizes its users to learn, understand and experience the advantages brought by a decentralization platform.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/coinmargin',
            ],
            website: [
                'https://coinmargin.com/home',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 127,
        reported_rank: 140,
        currencies: 9,
        markets: 22,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 14843354.93147552,
                adjusted_volume_24h: 14843354.93147552,
                reported_volume_7d: 1431093873.8511136,
                adjusted_volume_7d: 1431093873.8511136,
                reported_volume_30d: 3255705963.000884,
                adjusted_volume_30d: 3255705963.000884,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0.711498,
    },
    {
        id: 'criptohub',
        name: 'CriptoHub',
        description: 'CriptoHub is the exchange with the highest amount of trading pairs, lowest rates and only one with affiliate program in Brazil.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://criptohub.com.br/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'nfxtrade',
        name: 'NFXTrade',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/nfxservice_',
            ],
            website: [
                'https://nfxtrade.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 302,
        reported_rank: 317,
        currencies: 2,
        markets: 1,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 158.7277351,
                adjusted_volume_24h: 158.7277351,
                reported_volume_7d: 1542.94419572,
                adjusted_volume_7d: 1542.94419572,
                reported_volume_30d: 3573.54373074,
                adjusted_volume_30d: 3573.54373074,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 20000,
        confidence_score: 0,
    },
    {
        id: 'boa',
        name: 'BOA',
        description: 'BOA, Bitcoin Or Altcoins. Not all tokens are created equally but most deserve a fair shake. BOA includes cryptographic proofs for absolute transparency of funds. Executing on a dream of absolute verification and transparency yet trust. We are a team of traders, technicians and crypto enthusiasts working tirelessly to improve industry standards. BOA is here to facilitate token listings, airdrops, trading competitions and more in the spirit of unity, trust and security for our members!',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/BoaExchange',
            ],
            website: [
                'https://boaexchange.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 10000,
        confidence_score: 0,
    },
    {
        id: 'binance-futures',
        name: 'Binance Futures',
        description: 'Binance Futures is a derivative exchange made by Binance.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/binance',
            ],
            website: [
                'https://www.binance.com/en/futures/BTCUSDT',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 357,
        reported_rank: 1,
        currencies: 94,
        markets: 99,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 33373568877.753197,
                adjusted_volume_24h: 0,
                reported_volume_7d: 196544302872.92056,
                adjusted_volume_7d: 0,
                reported_volume_30d: 927101602136.7451,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 495100000,
        confidence_score: 0.495399,
    },
    {
        id: 'extstock',
        name: 'ExtStock',
        description: 'ExtStock was registered in UK in 2018 and offer USD and EUR trading against BTC, ETH and other major coins. The daily volume reaches $12M and growing.',
        active: false,
        website_status: false,
        api_status: false,
        message: 'Exchange is not active',
        links: {
            twitter: [
                'https://twitter.com/extstock',
            ],
            website: [
                'https://extstock.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: '365-stream',
        name: '365 stream',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://365.stream/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 256,
        reported_rank: 271,
        currencies: 6,
        markets: 5,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 87001.24238639,
                adjusted_volume_24h: 87001.24238639,
                reported_volume_7d: 612774.0091977,
                adjusted_volume_7d: 612774.0091977,
                reported_volume_30d: 2615299.4161981,
                adjusted_volume_30d: 2615299.4161981,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'kineticex',
        name: 'Kineticex',
        description: 'Automated purchase/sale of virtual currencies, tokens, as well as purchase and sale for fiat money and CFD trading on virtual currencies. Wide range of clients terminals including Windows, Web and Mobile. Kinetic Revolution is providing APIs Web RESTFUL API, WebSocket and FIX to connect through easily. Margin trading, PAMM and exchange of an unlimited number of Crypto instruments with the possibility of adding your own or ICO tokens, including ERC20. Introducing unique liquidity aggregation technology.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/kineticexe',
            ],
            website: [
                'https://www.kineticex.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'bittex',
        name: 'Bittex',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/bittex_io',
            ],
            website: [
                'https://bittex.io',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 217,
        reported_rank: 231,
        currencies: 9,
        markets: 13,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 763934.00480884,
                adjusted_volume_24h: 763934.00480884,
                reported_volume_7d: 5212108.77200576,
                adjusted_volume_7d: 5212108.77200576,
                reported_volume_30d: 22850915.9942404,
                adjusted_volume_30d: 22850915.9942404,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 140000,
        confidence_score: 0,
    },
    {
        id: 'chiliz',
        name: 'Chiliz',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/chiliz',
            ],
            website: [
                'https://www.chiliz.net/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 189,
        reported_rank: 203,
        currencies: 12,
        markets: 16,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 2429270.16243564,
                adjusted_volume_24h: 2429270.16243564,
                reported_volume_7d: 19961129.76902306,
                adjusted_volume_7d: 19961129.76902306,
                reported_volume_30d: 71671454.34065615,
                adjusted_volume_30d: 71671454.34065615,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 260000,
        confidence_score: 0.250487,
    },
    {
        id: 'folgory',
        name: 'Folgory',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/folgory1',
            ],
            website: [
                'https://folgory.com',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 85,
        reported_rank: 96,
        currencies: 43,
        markets: 114,
        fiats: [
            {
                name: 'Euro',
                symbol: 'EUR',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 59579520.53961023,
                adjusted_volume_24h: 59579520.53961023,
                reported_volume_7d: 410920185.8961357,
                adjusted_volume_7d: 410920185.8961357,
                reported_volume_30d: 1710244099.8385637,
                adjusted_volume_30d: 1710244099.8385637,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 270000,
        confidence_score: 0.679138,
    },
    {
        id: 'rocketswap',
        name: 'Rocketswap',
        description: 'Rocketswap is a DEX / AMM which resides on the Lamden TAU blockchain. The purpose of rocketswap is to promote growth and foster innovation within the Lamden ecosystem.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/RSwapOfficial',
            ],
            website: [
                'https://rocketswap.exchange',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 281,
        reported_rank: 296,
        currencies: 16,
        markets: 15,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 5655.11363612,
                adjusted_volume_24h: 5655.11363612,
                reported_volume_7d: 108990.21762918,
                adjusted_volume_7d: 108990.21762918,
                reported_volume_30d: 891447.05146675,
                adjusted_volume_30d: 891447.05146675,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'materia',
        name: 'Materia',
        description: 'Materia represents a new paradigm in the growing ecosystem of Decentralized Finance as a Multi-standard Decentralized Exchange.\r\nMateria is the world-first, User-centric Decentralized EXchange controlled by On-Chain, Enterprise-Free Organization based on DFOHub protocol.\r\nBy implementing the new EthItem protocol, Materia can reduce some of the problems that plague DEXs by breaking into the world of gamification and NFT exchange.\r\nMateria’s token GIL is the backbone of the entire initiative. Token holders have full ownership of the project and its future, without any external control.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/DexMateria',
            ],
            website: [
                'https://materia.exchange/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 334,
        reported_rank: 341,
        currencies: 5,
        markets: 4,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'negocie-coins',
        name: 'Negocie Coins',
        description: 'Negocie Coins is one of the many Brazilian cryptocurrency exchanges. It is registered in 2014 with the company number CNPJ 20.692.244 / 0001-90, and has its main office in Alameda Doutor Carlos de Carvalho, 417, in Curitiba.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/negociecoins',
            ],
            website: [
                'http://www.negociecoins.com.br/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'birake',
        name: 'Birake',
        description: 'Birake has shared order book and active users within the whole Birake network, supporting market orders, network-zero fees, orders-free cancels and the ability to fill many trades at once.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/birakecom',
            ],
            website: [
                'https://birake.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 211,
        reported_rank: 225,
        currencies: 44,
        markets: 50,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 978628.17721005,
                adjusted_volume_24h: 978628.17721005,
                reported_volume_7d: 4696272.87977913,
                adjusted_volume_7d: 4696272.87977913,
                reported_volume_30d: 31465827.37639229,
                adjusted_volume_30d: 31465827.37639229,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 430000,
        confidence_score: 0,
    },
    {
        id: 'alteumx',
        name: 'Alteumx',
        description: 'Alteumx aims to connect the world with Latin America and encourage financial inclusion, by providing the peer-to-peer exchange of digital assets in a simple, secure, fast and transparent way throughout the region.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/Alteum_Official',
            ],
            website: [
                'https://alteumx.com/home',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'bitspay',
        name: 'BitsPay',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/Bitspay_io',
            ],
            website: [
                'https://bitspay.io',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 140,
        reported_rank: 154,
        currencies: 12,
        markets: 40,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 10072876.21881248,
                adjusted_volume_24h: 10072876.21881248,
                reported_volume_7d: 69606919.1723376,
                adjusted_volume_7d: 69606919.1723376,
                reported_volume_30d: 308987506.84300506,
                adjusted_volume_30d: 308987506.84300506,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0.05,
    },
    {
        id: 'tokkea',
        name: 'Tokkea',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://tokkea.exchange/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 177,
        reported_rank: 191,
        currencies: 6,
        markets: 7,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 3443864.66217093,
                adjusted_volume_24h: 3443864.66217093,
                reported_volume_7d: 26953426.02790254,
                adjusted_volume_7d: 26953426.02790254,
                reported_volume_30d: 127462888.31397516,
                adjusted_volume_30d: 127462888.31397516,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'gokuex',
        name: 'Gokuex',
        description: 'Gokuex is a centralized crypto exchange based in Brazil. It supports BTC pairs.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/ExchangeGokuex',
            ],
            website: [
                'https://gokuex.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'exc-cripto',
        name: 'EXC Cripto',
        description: 'Startup of the digital financial market, we are an Exchange that allows anyone in the world to buy and sell digital assets. The platform has simple navigation for the novice audience and also an advanced Exchange, with graphics and several useful tools that help the most experienced traders.\r\n\r\nOur greatest mission is to provide a transparent and secure environment for users to make transactions easily and securely.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://exccripto.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'azbit',
        name: 'Azbit',
        description: 'Azbit is a cryptocurrency exchange offering the most in-demand services on the market. Advised by industry leader Roger Ver, Azbit strives to allow any project to be listed for free.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/azbit_news',
            ],
            website: [
                'https://azbit.com',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 71,
        reported_rank: 80,
        currencies: 14,
        markets: 24,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 101186901.27899517,
                adjusted_volume_24h: 101186901.27899517,
                reported_volume_7d: 753503520.2279094,
                adjusted_volume_7d: 753503520.2279094,
                reported_volume_30d: 3281141388.433652,
                adjusted_volume_30d: 3281141388.433652,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 1500000,
        confidence_score: 0.007313,
    },
    {
        id: 'cexio',
        name: 'CEX.IO',
        description: "CEX.IO is the ecosystem of cryptocurrency products designed for the customers of all backgrounds.\r\n\r\nCEX.IO's retail-oriented products — Exchange, Broker, Earn, Loan, Mobile App, as well as business- and institutional-grade services — Prime and CEX Direct. \r\n\r\nSupported by the wide range of payment methods and industry-leading security, CEX.IO customers can buy, sell, trade, exchange, stake, and borrow against cryptocurrencies using CEX.IO products. ",
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/cex_io',
            ],
            website: [
                'https://cex.io/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 133,
        reported_rank: 147,
        currencies: 104,
        markets: 223,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
            {
                name: 'Euro',
                symbol: 'EUR',
            },
            {
                name: 'Pound Sterling',
                symbol: 'GBP',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 12721911.3300362,
                adjusted_volume_24h: 12721911.3300362,
                reported_volume_7d: 117697112.30903599,
                adjusted_volume_7d: 117697112.30903599,
                reported_volume_30d: 556423932.5996927,
                adjusted_volume_30d: 556423932.5996927,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 7480000,
        confidence_score: 0.801955,
    },
    {
        id: 'bitsane',
        name: 'Bitsane',
        description: 'Bitsane is a crypto-exchange founded in 2016, that offers a simple way to trade in some of the most popular digital coins. Today, the Irish startup’s headquarters are located in Fitzwilliam Street in central Dublin where its founder and CEO, Aidas Rupsys is strategically planning the upcoming launch of full-scale investment platform.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'Bitsane exchange has probably exit-scammed with users funds.',
        links: {
            twitter: [
                'https://twitter.com/bitsane_com',
            ],
            website: [
                'https://bitsane.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'fides-exchange',
        name: 'Fides Exchange',
        description: '',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://www.fides-ex.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'nanu-exchange',
        name: 'Nanu Exchange',
        description: 'Nanu Exchange is a comparatively small Brazilian cryptocurrency exchange that focuses on trading in NanuCoin (NNC). It also works with fiat (BRL), but is not exactly an entry-level service, as coin-to-coin trading is also enabled.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/nanuexchange',
            ],
            website: [
                'https://www.nanu.exchange',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'coinnest',
        name: 'Coinnest',
        description: 'Coinnest is a Korean cryptocurrency exchange that was launched in 2017. Coinnest has a mobile application for iOS and Android devices that can be used for trading and offers charts, notifications and other features.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://www.coinnest.co.kr/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'uv2-test',
        name: 'UV2 Test',
        description: '',
        active: false,
        website_status: false,
        api_status: false,
        message: 'Exchange is not active',
        links: null,
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'boltx',
        name: 'BoltX',
        description: '',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://boltx.io',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'balancer-polygon-network',
        name: 'Balancer (Polygon Network)',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://polygon.balancer.fi/#/trade',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 188,
        reported_rank: 202,
        currencies: 6,
        markets: 8,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 2493138.13244065,
                adjusted_volume_24h: 2493138.13244065,
                reported_volume_7d: 16064710.97796442,
                adjusted_volume_7d: 16064710.97796442,
                reported_volume_30d: 128525637.70522021,
                adjusted_volume_30d: 128525637.70522021,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 1400000,
        confidence_score: 0.000566,
    },
    {
        id: 'cryptonex',
        name: 'Cryptonex',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/Cryptonex_CNX',
            ],
            website: [
                'https://cryptonex.org',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 137,
        reported_rank: 151,
        currencies: 3,
        markets: 17,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
            {
                name: 'Euro',
                symbol: 'EUR',
            },
            {
                name: 'Pound Sterling',
                symbol: 'GBP',
            },
            {
                name: 'Russian Ruble',
                symbol: 'RUB',
            },
            {
                name: 'Brazil Real',
                symbol: 'BRL',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 11820638.22163741,
                adjusted_volume_24h: 11820638.22163741,
                reported_volume_7d: 108991791.0629418,
                adjusted_volume_7d: 108991791.0629418,
                reported_volume_30d: 478748870.78503156,
                adjusted_volume_30d: 478748870.78503156,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 10000,
        confidence_score: 0.750004,
    },
    {
        id: 'stronghands-exchange',
        name: 'StrongHands Exchange',
        description: 'Launched on May 2020, SHNDX is a new Hybrid exchange created in partnership with Birake Network easy-to-use for day traders and long term investors. Claims to have a great user interface to assess you in your cryptocurrency trading.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/shndxofficial',
            ],
            website: [
                'https://stronghands.exchange/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'jymdax',
        name: 'Jymdax',
        description: 'We are an exchange made up of the need to send money from anywhere in the world starting from Mexico to Cuba.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/jymdax',
            ],
            website: [
                'https://Jymdax.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'southxchange',
        name: 'SouthXchange',
        description: 'SouthXChange is an Argentinian cryptocurrency exchange launched February 2015. Like most similar venues, the exchange does not offer trading on margin and is not regulated. ',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/southxchange',
            ],
            website: [
                'https://www.southxchange.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 258,
        reported_rank: 273,
        currencies: 115,
        markets: 265,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 56525.27204334,
                adjusted_volume_24h: 56525.27204334,
                reported_volume_7d: 477919.36105721,
                adjusted_volume_7d: 477919.36105721,
                reported_volume_30d: 2340795.92381018,
                adjusted_volume_30d: 2340795.92381018,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 1100000,
        confidence_score: 0,
    },
    {
        id: 'bitbox',
        name: 'BITBOX',
        description: 'BTCBOX is a Japanese cryptocurrency exchange, which is regulated by the Financial Services Agency (JFSA). ',
        active: false,
        website_status: true,
        api_status: false,
        message: 'Exchange is not active',
        links: {
            twitter: [
                'https://twitter.com/bitbox_official',
            ],
            website: [
                'https://www.bitbox.me/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'coincasso',
        name: 'CoinCasso',
        description: 'Describes itself as a multifunctional and democratic crypto exchange. As the first on the market, we give financial benefits to active users. CoinCasso is a holistic project, which means implementing solutions on a few business layers regarding the cryptocurrency solutions to make\r\nusing easier for our users.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/coincasso',
            ],
            website: [
                'https://coincasso.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 180000,
        confidence_score: 0,
    },
    {
        id: 'erex',
        name: 'Erex',
        description: '',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://erex.io/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'qtrade',
        name: 'qTrade',
        description: 'qTrade LLC is a digital asset exchange launched in April 2018 and based in the United States, registered in Kansas. The qTrade platform provides split-second trade execution, industry-leading security practices, and a robust, scalable architecture. Their mission is to help drive blockchain technology forward by reducing the barriers faced by innovative new and emerging technology. ',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/qtradeio',
            ],
            website: [
                'https://qtrade.io',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 285,
        reported_rank: 300,
        currencies: 24,
        markets: 23,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 3872.09955599,
                adjusted_volume_24h: 3872.09955599,
                reported_volume_7d: 81433.87223619,
                adjusted_volume_7d: 81433.87223619,
                reported_volume_30d: 822303.17514269,
                adjusted_volume_30d: 822303.17514269,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 30000,
        confidence_score: 0,
    },
    {
        id: 'coinsuper',
        name: 'Coinsuper',
        description: 'Coinsuper is a relatively new cryptocurrency exchange founded in 2017, based in Hong Kong. Coinsuper accepts bank transfers, allowing one to buy cryptocurrencies for the first time. Due the restrictions on who can use Coinsuper, the exchange mostly targets traders in Europe, Australasia, Asia, and South America.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/Coinsuper_OFCL',
            ],
            website: [
                'https://www.coinsuper.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 10000,
        confidence_score: 0,
    },
    {
        id: 'bluebelt',
        name: 'Bluebelt',
        description: 'Bluebelt is a multi-cryptocurrency exchange with Service Centers based in Japan. This platform offers clients a multi-market, distributed and robust exchange ecosystem that is under a legally compliant and transparent management. At its core, Bluebelt is rich with a diverse group of local crypto exchanges across Australia, Hong Kong, Estonia, Indonesia, Cambodia, India and, South Korea.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/BluebeltAsia',
            ],
            website: [
                'https://www.bluebelt.asia/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'bhex',
        name: 'BHEX',
        description: '',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/BHEXOfficial',
            ],
            website: [
                'https://www.bhex.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'ubit',
        name: 'Ubit',
        description: '',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://ubit.pw',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'coinone',
        name: 'Coinone',
        description: 'Coinone has been around since 2014. Coinone accepts fiat currency deposits, via bank transfer. That being said, only Korean bank accounts can be registered with this exchange.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/coinone_info',
                'https://twitter.com/CoinoneOfficial',
            ],
            website: [
                'https://coinone.co.kr/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 77,
        reported_rank: 87,
        currencies: 92,
        markets: 92,
        fiats: [
            {
                name: 'South Korea Won',
                symbol: 'KRW',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 88340131.95236696,
                adjusted_volume_24h: 88340131.95236696,
                reported_volume_7d: 732386912.4103274,
                adjusted_volume_7d: 732386912.4103274,
                reported_volume_30d: 3494477096.3319893,
                adjusted_volume_30d: 3494477096.3319893,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 16600000,
        confidence_score: 0.465018,
    },
    {
        id: 'bitclude',
        name: 'Bitclude',
        description: 'Bitclude is first legal cryptocurrency exchange in Poland, which operate from polish company which held small electronic money license. The main goal is to offer fast, secure trading for most popular cryptocurrencies like Bitcoin, Litecoin etc. with FIAT pairs, providing high usability via fast payments, atms withdrawals and others.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/bitclude',
            ],
            website: [
                'https://bitclude.com',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 260,
        reported_rank: 275,
        currencies: 2,
        markets: 2,
        fiats: [
            {
                name: 'Polish Zloty',
                symbol: 'PLN',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 54161.13908406,
                adjusted_volume_24h: 54161.13908406,
                reported_volume_7d: 946840.82275409,
                adjusted_volume_7d: 946840.82275409,
                reported_volume_30d: 4050788.16577976,
                adjusted_volume_30d: 4050788.16577976,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'btrl',
        name: 'BTRL',
        description: 'BTRL is perhaps the best trade to have the option to showcase your digital forms of money, it concedes many exchanging sets its exchange to have the option to trade effectively and easily.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/bitcoin_regular',
            ],
            website: [
                'https://btrlexchange.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 370000,
        confidence_score: 0,
    },
    {
        id: 'shorelinecrypto',
        name: 'ShorelineCrypto',
        description: 'This is a low cost community open sourced exchange initially mainly in support of Nengcoin/Cheetahcoin. It now expanded in support of other small community coins such as Quebecoin/FckBankscoin/MetalMusicCoin etc as an alternative to more expensive choices. The long term goal of the exchange project is to democratize DIY crypto exchange for small community coins.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/shorelinecrypto',
            ],
            website: [
                'https://shorelinecrypto.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 10000,
        confidence_score: 0,
    },
    {
        id: 'zgtop',
        name: 'ZG.top',
        description: 'ZG.TOP is a global blockchain asset trading platform headquartered in Mongolia and is affiliated to Mongolia ZG Top Technology Co., Ltd. ZG.TOP has obtained investment of 10 million US dollars, from such companies as Songhe Capital, Bit Times AEX, Xiaoqiao Capital, Mousse Group, Waldorf Capital, Baihui Business Group, etc., and obtained the block issued by GBC of Mongolia Global Blockchain Research Center.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/zg_top',
            ],
            website: [
                'https://zgtop.io/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'bmex',
        name: 'BMEX',
        description: "BMEX is an exchange focused on digital asset derivatives services. The BMEX team relies on its deep accumulation in the Fintech field to launch the world's first innovative transaction service for digital asset contract transactions and insurance. In the future, BMEX will continue to innovate products and services, improve technical barriers, and provide safe and reliable digital asset trading and asset management services for global users.",
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://bmex.vip/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 2500000,
        confidence_score: 0,
    },
    {
        id: 'bitkub',
        name: 'Bitkub',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/bitkubofficial',
            ],
            website: [
                'https://www.bitkub.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 73,
        reported_rank: 82,
        currencies: 24,
        markets: 24,
        fiats: [
            {
                name: 'Thai Baht',
                symbol: 'THB',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 91500115.82283777,
                adjusted_volume_24h: 91500115.82283777,
                reported_volume_7d: 572003167.6553977,
                adjusted_volume_7d: 572003167.6553977,
                reported_volume_30d: 3573430243.9945774,
                adjusted_volume_30d: 3573430243.9945774,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 7690000,
        confidence_score: 0.63967,
    },
    {
        id: 'nicehash',
        name: 'NiceHash',
        description: 'NiceHash Exchange is a centralized cryptocurrency exchange integrated into the NiceHash platform and build for miners and traders.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/NiceHashMining',
            ],
            website: [
                'https://www.nicehash.com/exchange',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 224,
        reported_rank: 238,
        currencies: 16,
        markets: 22,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 509728.55088818,
                adjusted_volume_24h: 509728.55088818,
                reported_volume_7d: 3976420.45495738,
                adjusted_volume_7d: 3976420.45495738,
                reported_volume_30d: 24137853.64304099,
                adjusted_volume_30d: 24137853.64304099,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 18200000,
        confidence_score: 0.316818,
    },
    {
        id: 'exchange-bdcash',
        name: 'Exchange BDCASH',
        description: 'Exchange BDCASH is a decentralized platform focused on growing projects, based on our crypto, but with the possibility of new pairs after increased demand.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/BigdataCash',
            ],
            website: [
                'https://exchangebdcash.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'blockbid',
        name: 'Blockbid',
        description: 'An ultra secure altcoin exchange, fully regulated, user friendly, with fiat onramp.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/blockbid_io',
            ],
            website: [
                'https://blockbid.io',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'udon-trade',
        name: 'Udon Trade',
        description: 'UdonTrade is regulated and licensed by United Kingdom.\r\nIt aims to provide the most secure and legal-compliance\r\ncryptocurrency trading and digital derivatives\r\ntrading services to global investors.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/Udonex2021',
            ],
            website: [
                'https://www.udontrade.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 242,
        reported_rank: 256,
        currencies: 16,
        markets: 41,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 182552.3925831,
                adjusted_volume_24h: 182552.3925831,
                reported_volume_7d: 1729120.8026802,
                adjusted_volume_7d: 1729120.8026802,
                reported_volume_30d: 220669632.03102094,
                adjusted_volume_30d: 220669632.03102094,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 50000,
        confidence_score: 0,
    },
    {
        id: 'b4u-wallet',
        name: 'B4U Wallet',
        description: 'With a B4U Currency wallet, you can hold Bitcoin, Bitcoin Cash, Dash Coin, Ethereum, Lite Coin, ZCash, Ripple, RSCoin, Malaysian Ringgit, Singapore Dollar, US Dollar, and Euro all in one place. our goal is always the same providing the top-notch solution in cryptocurrency exchange. Our services facilitate users by giving them a chance of using a secure wallet and easy of exchanging currencies.B4U wallet is basically equivalent to a bank account. B4U wallet makes it possible for you to receive a store or spend directly through your wallet. Similar to your bank account B4U wallet also becomes your personal interface to the Bitcoin network. Our wallet is secure & it is useful to spend your coins everywhere.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://ewallet.b4uwallet.com/trading',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'wunderbit',
        name: 'Wunderbit',
        description: 'Wunderbit is a fintech that strives to facilitate the real world use of cryptocurrencies through a number of products and solutions. Wunderbit currently offers bitcoin & crypto exchange service, social trading platform, bitcoin payment processing service and over-the-counter service.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/wunder_bit',
            ],
            website: [
                'https://wunderbit.co/en',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 4757118.93366204,
                adjusted_volume_30d: 4757118.93366204,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 690000,
        confidence_score: 0,
    },
    {
        id: 'loopring',
        name: 'Loopring',
        description: 'Loopring is a protocol for building high-performance, non-custodial, orderbook exchanges on Ethereum using zkRollup. Our infrastructure leverages zkSNARKs to scale throughput, lower cost, and build DEXs that feel as performant as centralized alternatives - with 100% Ethereum security guarantees.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/loopringorg',
            ],
            website: [
                'https://loopring.io/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 232,
        reported_rank: 246,
        currencies: 6,
        markets: 8,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 384176.02037801,
                adjusted_volume_24h: 384176.02037801,
                reported_volume_7d: 2660755.73175132,
                adjusted_volume_7d: 2660755.73175132,
                reported_volume_30d: 15415555.77754028,
                adjusted_volume_30d: 15415555.77754028,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 1400000,
        confidence_score: 0.265422,
    },
    {
        id: 'weidex',
        name: 'WeiDex',
        description: 'WeiDex Foundation’s ultimate aim is to fix the broken blockchain ecosystem on the application layer. The team has one mission, we strive to deliver the best services and experience to the traders who use our ecosystem. We are all about the idea that nobody should depend on third-parties because it is better for users to have full control over their assets.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/weiDexExchange',
            ],
            website: [
                'https://weidex.market/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'beaxy',
        name: 'Beaxy',
        description: 'Beaxy is a next generation cryptocurrency exchange powered by the same technology driving Wall Street. With a revolutionary matching engine and more order types than any other spot exchange, Beaxy sets itself apart technologically. It further distinguished itself with a transparent and fair listing process, prompt customer support, and a dedication to building bridges between projects and players in the cryptocurrency community.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/BeaxyExchange',
            ],
            website: [
                'https://www.beaxy.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 294,
        reported_rank: 309,
        currencies: 20,
        markets: 21,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 752.14170649,
                adjusted_volume_24h: 752.14170649,
                reported_volume_7d: 7780.48315588,
                adjusted_volume_7d: 7780.48315588,
                reported_volume_30d: 127811.97854254,
                adjusted_volume_30d: 127811.97854254,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 50000,
        confidence_score: 0,
    },
    {
        id: 'satodax',
        name: 'Satodax',
        description: 'Satoex offers low trading fee "starting from 0.045%", here you can find the most important cryptocurrencies',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/satodax',
            ],
            website: [
                'https://www.satodax.net',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 40000,
        confidence_score: 0,
    },
    {
        id: 'mexc',
        name: 'MEXC',
        description: 'MEXC exchange is a world-famous exchange platform. We aim at providing Secure, Convenient, Smart blockchain asset trading service, covering the market and price of cryptocurrencies including BTC, LTC, ETH, ETC etc.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/MXC_Exchange',
            ],
            website: [
                'https://www.mexc.com',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 18,
        reported_rank: 23,
        currencies: 463,
        markets: 492,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 1260795540.9077632,
                adjusted_volume_24h: 1260795540.9077632,
                reported_volume_7d: 9674265063.56277,
                adjusted_volume_7d: 9674265063.56277,
                reported_volume_30d: 45172345474.62109,
                adjusted_volume_30d: 45172345474.62109,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 18200000,
        confidence_score: 0.007352,
    },
    {
        id: 'btc-alpha',
        name: 'BTC-Alpha',
        description: 'BTC-Alpha is a cryptocurrency exchange headquartered in the United Kingdom launched in 2016. BTC-Alpha offers trading in decent number of digital coins and also supports USD fiat currency. Its trading platform is web-based with charts by TradingView.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/btcalpha',
            ],
            website: [
                'https://btc-alpha.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 99,
        reported_rank: 111,
        currencies: 17,
        markets: 23,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 38801033.85828222,
                adjusted_volume_24h: 38801033.85828222,
                reported_volume_7d: 295850545.48174894,
                adjusted_volume_7d: 295850545.48174894,
                reported_volume_30d: 848920463.2346174,
                adjusted_volume_30d: 848920463.2346174,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 620000,
        confidence_score: 0.00025,
    },
    {
        id: 'guava-exchange',
        name: 'Guava',
        description: 'Guava helps busy people learn about, invest in and manage digital assets.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/guavaexchange',
            ],
            website: [
                'https://guava.africa/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'anxpro',
        name: 'ANXPro',
        description: 'ANXPRO is a Hong Kong-based online trading platform specializing in the exchange of fiat-to-crypto currencies. One of the major benefits of using ANXPRO is that this exchange works with fiat currency. Launched all the way back in 2013, ANXPRO (formerly ANXBTC) has around 6 years of experience. The company behind the brand, Mega Idea Holdings Limited, has a Money Services Operator license issued by the Hong Kong Customs and Excise Department.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/ANX_PRO',
            ],
            website: [
                'https://anxpro.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'bitexla',
        name: 'Bitex.la',
        description: 'Founded in 2014, Bitex.la claims it is the first real time bitcoin exchange in Latin America. It offers a Bitcoin-buying service aimed mostly at novice crypto investors in Argentina, Chile and other Latin American countries. It is being audited by Deloitte.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/bitexla',
            ],
            website: [
                'https://bitex.la',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 50000,
        confidence_score: 0,
    },
    {
        id: 'balancer',
        name: 'Balancer',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/BalancerLabs',
            ],
            website: [
                'https://balancer.finance/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 234,
        reported_rank: 248,
        currencies: 14,
        markets: 25,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 321282.25257716,
                adjusted_volume_24h: 321282.25257716,
                reported_volume_7d: 2598540.28968712,
                adjusted_volume_7d: 2598540.28968712,
                reported_volume_30d: 11537172.12926034,
                adjusted_volume_30d: 11537172.12926034,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'quadrigacx',
        name: 'QuadrigaCX',
        description: 'The company is based in Vancouver, Canada, and offers pairs like ETH/CAD and BTC/CAD. QuadrigaCX stores funds in encrypted cold storage. Users can protect their accounts using two factor authentication.',
        active: false,
        website_status: true,
        api_status: false,
        message: "The company's CEO and founder, Gerald Cotten died unexpectedly in December 2018 and up to C$250 million owed to 115,000 customers are missing or cannot be accessed as only he held the private keys.",
        links: {
            twitter: [
                'https://twitter.com/QuadrigaCoinEx',
            ],
            website: [
                'https://www.quadrigacx.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 20000,
        confidence_score: 0,
    },
    {
        id: 'btc-markets',
        name: 'BTC Markets',
        description: 'BTCMarkets.net is a cryptocurrency exchange based in Sydney, Australia. BTCMarkets was launched all the way back in September 2013, when Australian bitcoin enthusiast Martin Bajalan launched the platform in partnership with other members of the Australian chapter of the Bitcoin Foundation.',
        active: true,
        website_status: false,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/BTCMarkets',
            ],
            website: [
                'https://btcmarkets.net/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 180,
        reported_rank: 194,
        currencies: 14,
        markets: 17,
        fiats: [
            {
                name: 'Australian Dollar',
                symbol: 'AUD',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 3018282.45332569,
                adjusted_volume_24h: 3018282.45332569,
                reported_volume_7d: 33939533.30784003,
                adjusted_volume_7d: 33939533.30784003,
                reported_volume_30d: 163718223.85523987,
                adjusted_volume_30d: 163718223.85523987,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 1000000,
        confidence_score: 0.800404,
    },
    {
        id: 'coinfalcon',
        name: 'CoinFalcon',
        description: 'CoinFalcon is UK cryptocurrency founded in 2017. The CoinFalcon platform currently offers support for the purchase of Bitcoin, IOTA, Litecoin, and Ethereum, and offers a range of trading pairs.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/coinfalcon',
            ],
            website: [
                'https://coinfalcon.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 293,
        reported_rank: 308,
        currencies: 6,
        markets: 6,
        fiats: [
            {
                name: 'Euro',
                symbol: 'EUR',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 774.11206613,
                adjusted_volume_24h: 774.11206613,
                reported_volume_7d: 53022.2849518,
                adjusted_volume_7d: 53022.2849518,
                reported_volume_30d: 225302.0733496,
                adjusted_volume_30d: 225302.0733496,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 80000,
        confidence_score: 0,
    },
    {
        id: 'coinbase',
        name: 'Coinbase',
        description: "Founded in June of 2012, Coinbase is a digital currency wallet and exchange where merchants and consumers can transact with new digital currencies like bitcoin, ethereum, and litecoin. They're based in San Francisco, California.\r\nCoinbase Pro (previously: GDAX) is a professional trading platform targeted for traders.",
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/CoinbasePro',
            ],
            website: [
                'https://pro.coinbase.com',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 10,
        reported_rank: 14,
        currencies: 112,
        markets: 292,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
            {
                name: 'Euro',
                symbol: 'EUR',
            },
            {
                name: 'Pound Sterling',
                symbol: 'GBP',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 1914300303.8514454,
                adjusted_volume_24h: 1914300303.8514454,
                reported_volume_7d: 14407719631.392466,
                adjusted_volume_7d: 14407719631.392466,
                reported_volume_30d: 79654637755.89645,
                adjusted_volume_30d: 79654637755.89645,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 64500000,
        confidence_score: 0.826049,
    },
    {
        id: 'btc-trade-ua',
        name: 'BTC Trade UA',
        description: 'BTC Trade UA is a Ukrainian crypto-exchange founded in 2014 that offers trading against Ukrainian Hryvnia (UAH), as well as coin-to-coin trading. Like most exchanges, it has a single account type, uses Two-factor Authentication (2FA) for security reasons. BTC Trade UA offers deposits and withdrawal via convenient payment methods such as credit cards and bank wire transfers. ',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/btc_trade_ua',
            ],
            website: [
                'https://btc-trade.com.ua/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 259,
        reported_rank: 274,
        currencies: 18,
        markets: 19,
        fiats: [
            {
                name: 'Ukrainian Hryvnia',
                symbol: 'UAH',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 55102.32961323,
                adjusted_volume_24h: 55102.32961323,
                reported_volume_7d: 277648.60960534,
                adjusted_volume_7d: 277648.60960534,
                reported_volume_30d: 1783388.29066271,
                adjusted_volume_30d: 1783388.29066271,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 140000,
        confidence_score: 0,
    },
    {
        id: 'index',
        name: 'INDEX',
        description: 'INDEX claims to be the world class digital asset exchange which established in August 2019. INDEX provides secure, professional and convenient digital asset exchange services.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: null,
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'bololex',
        name: 'Bololex',
        description: "Launched in May 2020, Bololex exchange is a centralized crypto exchange platform with low fees, versatile funding options, and rigorous security standards. Various airdrops and giveaways, expanding list of trading pairs, 24/7 available customer support, and easy-navigating features are at the top of the exchange's advantages. Unlimited deposits and withdrawals, plus a non-mandatory KYC submission also fasten the trading processes. Earlier in July, Bololex also launched its own voting program with gamified features offering both big and newly-created projects get listed at Bololex.",
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/bololexcom',
            ],
            website: [
                'https://bololex.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 196,
        reported_rank: 210,
        currencies: 41,
        markets: 78,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 1758737.11694295,
                adjusted_volume_24h: 1758737.11694295,
                reported_volume_7d: 16824177.57699491,
                adjusted_volume_7d: 16824177.57699491,
                reported_volume_30d: 60005831.65501675,
                adjusted_volume_30d: 60005831.65501675,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 170000,
        confidence_score: 0,
    },
    {
        id: 'sunswap',
        name: 'Sunswap V1',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/defi_just',
            ],
            website: [
                'https://sunswap.com/#/home',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 129,
        reported_rank: 142,
        currencies: 4,
        markets: 3,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 13560943.24288314,
                adjusted_volume_24h: 13560943.24288314,
                reported_volume_7d: 204209704.0261585,
                adjusted_volume_7d: 204209704.0261585,
                reported_volume_30d: 752871776.3896029,
                adjusted_volume_30d: 752871776.3896029,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 1500000,
        confidence_score: 0.000606,
    },
    {
        id: 'primebit',
        name: 'PrimeBit',
        description: 'Fair Way to Trade Crypto. A game-changing P2P exchange using an unmatched Fair Pricing model. Trade Bitcoin, Ethereum and Litecoin with up to 200x leverage.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/primebit_com',
            ],
            website: [
                'https://primebit.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 60000,
        confidence_score: 0,
    },
    {
        id: 'bit-z',
        name: 'Bit-Z',
        description: 'Bit-Z founded in 2016 in Hong Kong, China, is one of the most popular digital assets trading exchanges. Bit-Z has established branches in 10 countries and regions including Singapore, Japan and South Korea. To keep customers secure, Bit-Z uses bank-level SSL technology.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/BitZ_Group',
            ],
            website: [
                'https://www.bit-z.com',
                'https://www.bitz.ai/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'chaince',
        name: 'Chaince',
        description: null,
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/Chaince_Group',
            ],
            website: [
                'https://chaince.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'wanswap',
        name: 'Wanswap',
        description: 'WanSwap is an innovative crosschain automatic market making (AMM) decentralized exchange (DEX).\r\n\r\n',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/wanswap',
                'https://t.me/wanswap_official',
            ],
            website: [
                'https://wanswap.finance',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 184,
        reported_rank: 198,
        currencies: 5,
        markets: 4,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 2895042.2037074,
                adjusted_volume_24h: 2895042.2037074,
                reported_volume_7d: 20647611.58809487,
                adjusted_volume_7d: 20647611.58809487,
                reported_volume_30d: 96544249.17229198,
                adjusted_volume_30d: 96544249.17229198,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 80000,
        confidence_score: 0.000032,
    },
    {
        id: 'xtheta-global',
        name: 'Xtheta Global',
        description: 'Launched in July 2020, Xtheta Global is a centralized cryptocurrency exchange. It is a member of Xtheta Holdings, which includes Xtheta Japan, a licensed Japanese cryptocurrency exchange.\r\n\r\nXtheta Global supports crypto to crypto trading, perpetual contracts, and OTC trading.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://www.xthetaglobal.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 10000,
        confidence_score: 0,
    },
    {
        id: 'crxzone',
        name: 'CRXzone',
        description: 'Based in Republic of Singapore and founded in February of 2014, Intellect Market Pte. Ltd. is a crypto currencies wallet platform where merchants and consumers can transact with the new digital currencies like Bitcoin, Litecoin, etc. Our mission is to provide a world class transparent, deeply liquid and safe environment for users to trade crypto-currencies, as well as to accept crypto-payments by online businesses in an efficient and easy to use manner.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/crxzone',
            ],
            website: [
                'https://www.crxzone.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'alterdice',
        name: 'Alterdice',
        description: 'Alterdice describes itself as a cryptocurrency trading platform with low commissions. The team claims to offer the most liquid exchange in the world that allows users to exchange cryptocurrencies for other assets. It also offers a host of order types to help traders manager different scenarios. Alterdice aims to provide a secure, reliable, and stable environment for digital assets trading through its mobile application and web interface.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/_alterdice',
                'https://twitter.com/AlterdiceSocial',
            ],
            website: [
                'https://alterdice.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 114,
        reported_rank: 126,
        currencies: 17,
        markets: 28,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 23233728.09478499,
                adjusted_volume_24h: 23233728.09478499,
                reported_volume_7d: 177989239.49849367,
                adjusted_volume_7d: 177989239.49849367,
                reported_volume_30d: 811697717.3412458,
                adjusted_volume_30d: 811697717.3412458,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 200000,
        confidence_score: 0.743189,
    },
    {
        id: 'korbit',
        name: 'Korbit',
        description: 'Korbit exchange is a Korean exchange that deals in some of the major cryptocurrencies. Korbit operated the first exchange between Bitcoin and Korean won (KRW). Korbit powered by Bitgo for multi-sig technology. In this process, every transaction needs to be approved by two or more users to complete the process. This adds an extra layer of security on the account.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://www.korbit.co.kr',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 144,
        reported_rank: 158,
        currencies: 12,
        markets: 12,
        fiats: [
            {
                name: 'South Korea Won',
                symbol: 'KRW',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 9408377.73095435,
                adjusted_volume_24h: 9408377.73095435,
                reported_volume_7d: 69938629.09453778,
                adjusted_volume_7d: 69938629.09453778,
                reported_volume_30d: 261311768.54512596,
                adjusted_volume_30d: 261311768.54512596,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 1000000,
        confidence_score: 0.750404,
    },
    {
        id: 'btcix',
        name: 'Btcix',
        description: 'Our Exchange is a Global Exchange and Soon We Will Establish Our Own Network With Swap System',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/Btcix1/',
            ],
            website: [
                'https://btcix.io',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 197,
        reported_rank: 85,
        currencies: 9,
        markets: 13,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 88680178.5725768,
                adjusted_volume_24h: 1676430.40506357,
                reported_volume_7d: 625276543.0743607,
                adjusted_volume_7d: 12004108.35970602,
                reported_volume_30d: 2746753599.868759,
                adjusted_volume_30d: 78120483.44204418,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 10000,
        confidence_score: 0.000004,
    },
    {
        id: 'globitex',
        name: 'Globitex',
        description: 'Globitex is a UK-based crypto-fiat exchange. The group company of Globitex - NexPay UAB received EMI (Electronic Money Institution) license from an EU regulator. Globitex team has created a professional Bitcoin marketplace to fill the need for institutional grade exchange platform with advanced IT solutions, suitable for both individual and institutional Bitcoin market participants. ',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/globitex_',
            ],
            website: [
                'https://globitex.com/',
                'https://globitex.com',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 235,
        reported_rank: 249,
        currencies: 4,
        markets: 5,
        fiats: [
            {
                name: 'Euro',
                symbol: 'EUR',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 319294.72381962,
                adjusted_volume_24h: 319294.72381962,
                reported_volume_7d: 1020856.4071011,
                adjusted_volume_7d: 1020856.4071011,
                reported_volume_30d: 3432706.82839489,
                adjusted_volume_30d: 3432706.82839489,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 10000,
        confidence_score: 0,
    },
    {
        id: 'atomdax',
        name: 'AtomDax',
        description: 'ATOMDAX is a new cryptocurrency exchange. The official website was launched in 2017. In the wake of the growing popularity of digital currencies.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/Atomdax1',
            ],
            website: [
                'https://atomdax.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'xeggex',
        name: 'Xeggex',
        description: 'Xeggex is a centralized exchange specializing in low cap assets. Xeggex is a privacy based and No-KYC exchange.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/xeggex',
            ],
            website: [
                'https://xeggex.com',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 264,
        reported_rank: 279,
        currencies: 17,
        markets: 45,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 39490.6690768,
                adjusted_volume_24h: 39490.6690768,
                reported_volume_7d: 332416.41144799,
                adjusted_volume_7d: 332416.41144799,
                reported_volume_30d: 1446586.37715422,
                adjusted_volume_30d: 1446586.37715422,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 30000,
        confidence_score: 0,
    },
    {
        id: 'dcoin',
        name: 'Dcoin',
        description: '',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/dcoinexchange',
            ],
            website: [
                'https://www.dcoin.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 50000,
        confidence_score: 0,
    },
    {
        id: 'gateio-futures',
        name: 'Gate.io Futures',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/gate_io',
            ],
            website: [
                'https://www.gate.io/futures_trade/BTC_USD',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 361,
        reported_rank: 137,
        currencies: 23,
        markets: 23,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 17947290.0993,
                adjusted_volume_24h: 0,
                reported_volume_7d: 151745179.1296,
                adjusted_volume_7d: 0,
                reported_volume_30d: 613981650.5810403,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 61300000,
        confidence_score: 0.024763,
    },
    {
        id: 'koinim',
        name: 'Koinim',
        description: 'Koinim is a Turkish cryptocurrency exchange founded in 2013, which accepts Lira bank transfers.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://koinim.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 271,
        reported_rank: 286,
        currencies: 6,
        markets: 6,
        fiats: [
            {
                name: 'Turkish Lira',
                symbol: 'TRY',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 17278.69823473,
                adjusted_volume_24h: 17278.69823473,
                reported_volume_7d: 112282.29832639,
                adjusted_volume_7d: 112282.29832639,
                reported_volume_30d: 545544.88557592,
                adjusted_volume_30d: 545544.88557592,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 90000,
        confidence_score: 0,
    },
    {
        id: 'globalcryptox',
        name: 'Globalcryptox',
        description: '',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://www.globalcryptox.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'umcswap',
        name: 'UMCSWAP',
        description: '',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://umcswap.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'terraswap',
        name: 'TerraSwap',
        description: 'This is the first DEX on Terra blockchain.\r\n\r\nInspired by Uniswap, Terraswap creates automatic, decentralized markets for token pairs allowing users to exchange assets directly on-chain. Pairs can be created between native Terra assets (Luna, UST, KRT, etc.) and CW20 tokens (user-defined tokens). Terraswap will debut with the current four active Terra stablecoins against Luna, competing against Terra’s native on-chain atomic swap. These starting pairs will diversify on-chain liquidity and provide a more robust means to arbitrage that does not alter the supply of Terra and Luna, thereby enhancing the stability mechanism.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/terraswap_io',
            ],
            website: [
                'https://app.terraswap.io/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 170,
        reported_rank: 184,
        currencies: 13,
        markets: 12,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 4087547.78845952,
                adjusted_volume_24h: 4087547.78845952,
                reported_volume_7d: 45524038.04277034,
                adjusted_volume_7d: 45524038.04277034,
                reported_volume_30d: 152167799.60183668,
                adjusted_volume_30d: 152167799.60183668,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 1400000,
        confidence_score: 0.000566,
    },
    {
        id: 'needyex',
        name: 'Needyex',
        description: '',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://trade.needyex.net',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 10000,
        confidence_score: 0,
    },
    {
        id: 'libopro',
        name: 'LiboPro',
        description: 'LiboPro offers Cryptocurrency assets exchange and trading through a comprehensive trading platform | P2P feature for fiat conversion, contract and services.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/libopro',
            ],
            website: [
                'https://libopro.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'bitget',
        name: 'Bitget',
        description: 'Bitget is the first cryptocurrency exchange to introduce both forward and reverse contract. It offers the most cryptocurrency variety for forward contract and we have been though many extreme market volatility conditions without server crashing. Up to date, the number of registered users has exceeded 785,000.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/bitgetbitget',
            ],
            website: [
                'https://www.bitget.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 37,
        reported_rank: 44,
        currencies: 19,
        markets: 27,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 495312271.01387113,
                adjusted_volume_24h: 495312271.01387113,
                reported_volume_7d: 2979714992.008687,
                adjusted_volume_7d: 2979714992.008687,
                reported_volume_30d: 14704218973.32782,
                adjusted_volume_30d: 14704218973.32782,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 6900000,
        confidence_score: 0.007577,
    },
    {
        id: 'cryptopia',
        name: 'Cryptopia',
        description: 'Cryptopia is based in New Zealand and offers trading multiple digital assets (altcoins). The company also offers New Zealanders a relatively easy access to the world of cryptocurrencies, via its banking service.',
        active: true,
        website_status: true,
        api_status: false,
        message: "Cryptopia suffered security breach resulting in significant losses <a href='https://twitter.com/Cryptopia_NZ/status/1085084168852291586' target='_blank'>(Twitter post).</a>\n\nCryptopia has suspended it's operation.",
        links: {
            twitter: [
                'https://twitter.com/Cryptopia_NZ',
            ],
            website: [
                'https://www.cryptopia.co.nz',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 220000,
        confidence_score: 0,
    },
    {
        id: 'bjs',
        name: 'BJS',
        description: "BJS was founded in 2017 and went online in November. It was officially launched in February 2018. It was founded by a group of bitcoin-affiliated blockchain enthusiasts and geeks. It is headquartered in the UK and has branches in Hong Kong, Singapore, and Shenzhen. The system architect comes from the core system of the bank's credit department. A strong technical R&D team ensures the security, stability, and efficiency of the system. BJS is committed to providing global users with secure, convenient personalized digital asset spot trading services. Information, transactions, hardware and software purses, and personalized services improve the ecological layout of community construction and the entire industry chain.",
        active: false,
        website_status: false,
        api_status: false,
        message: 'Exchange is not active',
        links: {
            twitter: [
                'https://twitter.com/bjs24141112',
            ],
            website: [
                'https://bjs.ai',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'lydia-finance',
        name: 'Lydia Finance',
        description: 'Lydia Finance is an audited Automated Market Maker, Yield Farming, and Staking platform on Avalanche. We have a dedicated team of experienced devs, who have been in the crypto space for years. $LYD is the native currency of our platform. Stake, pool, and earn $LYD and many other token utilities all on Lydia Finance.',
        active: true,
        website_status: true,
        api_status: false,
        message: null,
        links: {
            website: [
                'https://exchange.lydia.finance/#/swap',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 308,
        reported_rank: 323,
        currencies: 3,
        markets: 2,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 100.29805522,
                adjusted_volume_24h: 100.29805522,
                reported_volume_7d: 1525.07145761,
                adjusted_volume_7d: 1525.07145761,
                reported_volume_30d: 8233.93579918,
                adjusted_volume_30d: 8233.93579918,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 180000,
        confidence_score: 0,
    },
    {
        id: 'xcrypt',
        name: 'xCrypt',
        description: 'xCrypt describes itself as the first trustful and safety Regulation-Complaint Digital Asset Exchange ready for Digital Assets, FIAT, and ERC721.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/xcryptclub',
            ],
            website: [
                'https://xcrypt.pro',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'binance-jex-futures',
        name: 'Binance JEX Futures',
        description: '',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/BinanceJEX',
            ],
            website: [
                'https://www.jex.com/en',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 50000,
        confidence_score: 0,
    },
    {
        id: 'flaexchange',
        name: 'Flaexchange',
        description: '',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://flacoin.org',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'centex',
        name: 'Centex',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/centexio',
            ],
            website: [
                'https://exchange.centex.io/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 323,
        reported_rank: 359,
        currencies: 5,
        markets: 4,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0.00400692,
                adjusted_volume_7d: 0.00400692,
                reported_volume_30d: 157.99658835,
                adjusted_volume_30d: 157.99658835,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 10000,
        confidence_score: 0,
    },
    {
        id: 'c-cex',
        name: 'C-CEX',
        description: 'C-CEX is a cryptocurrency exchange that supports over 260,000 members and more than 185 cryptocurrencies. The exchange also offers a merchant solution, API support, fiat trading, and more. C-CEX has been around the bitcoin community since 2015.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/CryptoCurrEncyX',
            ],
            website: [
                'https://c-cex.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 10000,
        confidence_score: 0,
    },
    {
        id: 'xcalibra',
        name: 'Xcalibra',
        description: 'Xcalibra claims to be a custom-built cryptocurrency exchange established in Switzerland in 2019. The mission of Xcalibra is said to be  drive mass adoption of cryptocurrencies giving its users a secure, reliable and simple trading experience. Xcalibra claims it has a global reach servicing users across 100+ countries and they can purchase digital assets with 14 different national currencies. On top of that, Xcalibra claims that it was the first exchange which enabled trading cryptocurrencies with Serbian dinars recognizing the potential of this region. The platform claims to employ a combination of security measures to keep digital assets safe and it operates across fiber optic networks providing.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/tradexcalibra',
            ],
            website: [
                'https://xcalibra.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 274,
        reported_rank: 289,
        currencies: 4,
        markets: 4,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 10982.86134162,
                adjusted_volume_24h: 10982.86134162,
                reported_volume_7d: 34083.74027736,
                adjusted_volume_7d: 34083.74027736,
                reported_volume_30d: 119468.10342067,
                adjusted_volume_30d: 119468.10342067,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 100000,
        confidence_score: 0.152909,
    },
    {
        id: 'opendex',
        name: 'OpenDEX',
        description: 'OpenDEX, the most advanced Open Source Digital Asset Exchange with Multi-Blockchain and peer to peer (P2P) trading support. OpenDEX not only provides support for Ethereum based tokens but has the capability to integrate other blockchains as well (i.e. EOS, TRON and many more).',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/OpenDEXMarket',
            ],
            website: [
                'https://opendex.market',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'huobi-korea',
        name: 'Huobi Korea',
        description: '',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/huobi_korea',
            ],
            website: [
                'https://www.huobi.co.kr/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'btse-futures',
        name: 'BTSE Futures',
        description: 'An Innovative Platform for Futures and Spot Trading, which settle profits in any currency or coin that maximize your capital with up to 100x leverage. Post margin with multiple currencies and coins simultaneously. Easily add and remove multiple collateralized assets on the fly that benefits from volatile markets without being susceptible to the volatility of cryptocurrencies. Better liquidity with all currencies sharing the same liquidity pool via one order book.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://www.btse.com/en/futures/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 342,
        reported_rank: 16,
        currencies: 4,
        markets: 4,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 1641846051.96478,
                adjusted_volume_24h: 0,
                reported_volume_7d: 5325887624.671558,
                adjusted_volume_7d: 0,
                reported_volume_30d: 23396763533.1051,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 250000,
        confidence_score: 0.104411,
    },
    {
        id: '3xbit',
        name: '3XBIT',
        description: 'We are more than an exchange.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/3xbit',
            ],
            website: [
                'https://3xbit.com.br',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'bithumb-global',
        name: 'Bithumb Global',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/BithumbGlobal',
            ],
            website: [
                'https://www.bithumb.pro/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 51,
        reported_rank: 58,
        currencies: 135,
        markets: 172,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 223104799.8954497,
                adjusted_volume_24h: 223104799.8954497,
                reported_volume_7d: 1887647360.502699,
                adjusted_volume_7d: 1887647360.502699,
                reported_volume_30d: 6467557765.966969,
                adjusted_volume_30d: 6467557765.966969,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 140000,
        confidence_score: 0.017268,
    },
    {
        id: 'iqfinex',
        name: 'IQFinex',
        description: 'QFinex cryptocurrency exchange is an innovative trading platform that combines a clear interface and a low commission.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://www.iqfinex.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'bgogo',
        name: 'Bgogo',
        description: 'Bgogo is a digital asset platform launched in November, 2018, with supernode self-governance. 50% of total platform token BGG will be used to reward users where users will get trading fees back in the equal amount of BGG. Bgogo aims to become “the cryptocurrency exchange of the community, by the community, and for the community”.  The Bgogo.com domain has its headquarters in California, although it is officially registered in the Cayman Islands. The company was founded by elite members from internet giants such as Alibaba, Facebook, IBM, and Twitter.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/BgogoExchange',
            ],
            website: [
                'https://bgogo.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 254,
        reported_rank: 269,
        currencies: 11,
        markets: 16,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 89266.32856908,
                adjusted_volume_24h: 89266.32856908,
                reported_volume_7d: 801244.36926296,
                adjusted_volume_7d: 801244.36926296,
                reported_volume_30d: 6335981.69959471,
                adjusted_volume_30d: 6335981.69959471,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 10000,
        confidence_score: 0,
    },
    {
        id: 'intercore',
        name: 'Intercore',
        description: 'Intercore has been in development since early 2020, we are working to create the exchange that will revolutionize the market, bringing the international quality standard to national reach.\r\nIts creation was consolidated using vast market research with which we were able to detect the greatest market needs and gather all the solutions in one place.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/intercore_',
            ],
            website: [
                'https://intercore.trade',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 278,
        reported_rank: 293,
        currencies: 6,
        markets: 11,
        fiats: [
            {
                name: 'Brazil Real',
                symbol: 'BRL',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 7969.60079067,
                adjusted_volume_24h: 7969.60079067,
                reported_volume_7d: 62408.98003602,
                adjusted_volume_7d: 62408.98003602,
                reported_volume_30d: 269674.68954098,
                adjusted_volume_30d: 269674.68954098,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'bitmart',
        name: 'BitMart',
        description: 'BitMart is a premier global digital asset trading platform that launched in 2017. Headquartered in the Cayman Islands, featuring branch offices in the United States, China, and South Korea, BitMart currently offers crypto-to-crypto trading for coins and utility tokens only, and serving over 500.000 customers over 180 countries.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/BitMartExchange',
            ],
            website: [
                'https://www.bitmart.com',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 13,
        reported_rank: 18,
        currencies: 257,
        markets: 302,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 1387878644.8349326,
                adjusted_volume_24h: 1387878644.8349326,
                reported_volume_7d: 10712344563.54164,
                adjusted_volume_7d: 10712344563.54164,
                reported_volume_30d: 48528439648.87829,
                adjusted_volume_30d: 48528439648.87829,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 7870000,
        confidence_score: 0.185245,
    },
    {
        id: 'curve-finance',
        name: 'Curve Finance',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://www.curve.fi/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 53,
        reported_rank: 60,
        currencies: 28,
        markets: 56,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 213744013.37302992,
                adjusted_volume_24h: 213744013.37302992,
                reported_volume_7d: 937965598.7352196,
                adjusted_volume_7d: 937965598.7352196,
                reported_volume_30d: 3401842861.6983223,
                adjusted_volume_30d: 3401842861.6983223,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 4120000,
        confidence_score: 0.001664,
    },
    {
        id: 'balancer-v2',
        name: 'Balancer V2',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://balancer.fi/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 89,
        reported_rank: 100,
        currencies: 17,
        markets: 24,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 55269809.39064713,
                adjusted_volume_24h: 55269809.39064713,
                reported_volume_7d: 553540039.1378438,
                adjusted_volume_7d: 553540039.1378438,
                reported_volume_30d: 1253943781.4528913,
                adjusted_volume_30d: 1253943781.4528913,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 1400000,
        confidence_score: 0.000566,
    },
    {
        id: 'tunatrades',
        name: 'TUNATRADES',
        description: 'TunaTrades is a global exchange focused on Blockchain Waves, Tokens Ethereum and Altcoins assets. Its main currency is the asset TUNACOIN - TUNA.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/tunacoinnet',
            ],
            website: [
                'https://tunatrades.tunacoin.net',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 28074.27086304,
                adjusted_volume_30d: 28074.27086304,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'bitfxt',
        name: 'Bitfxt',
        description: '',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/bitfxt',
            ],
            website: [
                'https://www.bitfxt.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 70000,
        confidence_score: 0,
    },
    {
        id: 'lbank',
        name: 'Lbank',
        description: "Founded in October 2016, LBank is a digital asset trading platform for global users to provide professional asset management solutions. At present, LBank offers BTC to BTC, ETH, ZEC, QTUM, VEN's digital asset exchange service and have over 2.6 million of registered users.",
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/LBank_Exchange',
            ],
            website: [
                'https://www.lbank.info/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 27,
        reported_rank: 32,
        currencies: 155,
        markets: 167,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 740087392.5708386,
                adjusted_volume_24h: 740087392.5708386,
                reported_volume_7d: 5137075221.139692,
                adjusted_volume_7d: 5137075221.139692,
                reported_volume_30d: 21803345995.006107,
                adjusted_volume_30d: 21803345995.006107,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 14500000,
        confidence_score: 0.076015,
    },
    {
        id: 'maicoin-asset-exchange',
        name: 'Maicoin Asset Exchange',
        description: 'MAX Exchange was recently launched by MaiCoin which has been the largest one-stop digital asset platform provider in Taiwan. The MAX Digital Asset Exchange is an extension of the business’ over the counter OTC platform, MaiCoin, which has been in operation since 2014.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/Max_exch/',
            ],
            website: [
                'https://maicoin.com',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 183,
        reported_rank: 197,
        currencies: 7,
        markets: 7,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 2937257.89888017,
                adjusted_volume_24h: 2937257.89888017,
                reported_volume_7d: 31179835.29619118,
                adjusted_volume_7d: 31179835.29619118,
                reported_volume_30d: 149288010.25311905,
                adjusted_volume_30d: 149288010.25311905,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 2980000,
        confidence_score: 0.001204,
    },
    {
        id: 'atomars',
        name: 'ATOMARS',
        description: 'ATOMARS is a global digital asset trading platform that bridges the worlds of fiat and cryptocurrencies. As a fast and secure digital assets exchange platform our mission is to make the cryptocurrency trading fast, easy and secure for everyone around the world.\r\n\r\n',
        active: true,
        website_status: true,
        api_status: false,
        message: "The CFO and administrator of exchange has disappeared. Be aware!\n\n<a href='https://atomars.com/news/the-cfo-and-administrator-of-exchange-has-disappeared' target='_blank'>Read more about it</a>",
        links: {
            twitter: [
                'https://twitter.com/AtomarsExchange',
            ],
            website: [
                'https://atomars.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 10000,
        confidence_score: 0,
    },
    {
        id: 'bitmesh',
        name: 'BitMesh',
        description: 'BitMesh is a global digital asset trading platform, offering the people all over the world the service of digital asset exchange, such as BTC, ETH, USDT and other mainstream coins. Our vision is all people could enjoy the facility of digital assets.\r\n',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/BitMeshOfficial',
            ],
            website: [
                'https://bitmesh.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'exmarkets',
        name: 'ExMarkets',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/ex_markets',
            ],
            website: [
                'https://exmarkets.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 82,
        reported_rank: 93,
        currencies: 36,
        markets: 77,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 72779220.06581457,
                adjusted_volume_24h: 72779220.06581457,
                reported_volume_7d: 625041872.2661014,
                adjusted_volume_7d: 625041872.2661014,
                reported_volume_30d: 2722151607.0895243,
                adjusted_volume_30d: 2722151607.0895243,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 590000,
        confidence_score: 0.000238,
    },
    {
        id: 'cointiger',
        name: 'CoinTiger',
        description: 'CoinTiger is a centralized Singapore exchange. They created their own coin - Tiger Cash which is a blockchain digital asset based on Ethereum.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/CoinTigerEX',
            ],
            website: [
                'https://www.cointiger.pro',
                'https://www.cointiger.com/en-us/#/index',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 47,
        reported_rank: 54,
        currencies: 198,
        markets: 234,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 236448796.1616737,
                adjusted_volume_24h: 236448796.1616737,
                reported_volume_7d: 1978789889.2298722,
                adjusted_volume_7d: 1978789889.2298722,
                reported_volume_30d: 6970647659.108313,
                adjusted_volume_30d: 6970647659.108313,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0.451872,
    },
    {
        id: 'inpay',
        name: 'InPay',
        description: 'InPay is a payment processor, that you can use the instant conversion function of bitcoin payments without taking the exchange rate risk against the local currency. ',
        active: false,
        website_status: true,
        api_status: false,
        message: 'Exchange is not active',
        links: {
            twitter: [
                'https://twitter.com/inpayto',
            ],
            website: [
                'https://inpay.pl/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'extrading',
        name: 'Extrading',
        description: '',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://extrading.app',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'tokenomy',
        name: 'Tokenomy',
        description: 'Tokenomy’s primary product is a crypto-to-crypto exchange. It will also offer a platform enabling the issue of tokens for crowdfunding, loyalty programs, donations or other needs as well as exchange and purchase. The team consists of 6 people and 14 advisors.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/tokenomy',
            ],
            website: [
                'https://tokenomy.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 60000,
        confidence_score: 0,
    },
    {
        id: 'coincex',
        name: 'CoinCex',
        description: 'CoinCex was created with the idea of ‘Trading Simplicity’ in mind. We strive to provide a straightforward and easy-to-use trading platform for crypto traders with easy access for anyone to the crypto market.\r\n\r\nWhether you are a pro trader, HODLer, or just starting out, from trading to just buying and selling we provided that simplicity to all levels of users.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/CoinCex',
            ],
            website: [
                'https://coincex.io',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 149,
        reported_rank: 163,
        currencies: 18,
        markets: 18,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 6914164.42591968,
                adjusted_volume_24h: 6914164.42591968,
                reported_volume_7d: 49028119.0462285,
                adjusted_volume_7d: 49028119.0462285,
                reported_volume_30d: 186823330.83952484,
                adjusted_volume_30d: 186823330.83952484,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'zedxion-exchange',
        name: 'ZEDXION EXCHANGE',
        description: 'Zedxion Exchange is a digital currency with a fully functional ecosystem that is comprised of a wallet, trading platform, point of sale platform and more, all intended to provide an alternative to fiat currency solutions.\r\n\r\nWhat Makes Zedxion Unique?\r\nZedxion is a cryptocurrency exchange that was designed to be accessible to both beginners and experienced traders. It allows users to trade major cryptocurrencies such as Bitcoin and Ethereum, as well as the Zedxion token.\r\nThe trading platform has a matching engine for quick transactions at minimum latency and supports security features such as two-factor authentication and SSL encryption.\r\nIt also has a two-level referral program that incentivizes users to refer the platform to more potential customers.\r\nThe platform offers a high transaction-per-second count, secure hot wallet integration, geography-based KYC and AML verification, crypto and fiat support and a user-friendly interface.\r\nZedxion point of sale (POS) system provides a payment gateway solution to merchants. The POS system benefits both businesses and individuals in cross-border payments for goods and services.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/zedxionc',
            ],
            website: [
                'https://www.zedxion.net/en_US/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 7,
        reported_rank: 10,
        currencies: 68,
        markets: 75,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 2670080619.983763,
                adjusted_volume_24h: 2670080619.983763,
                reported_volume_7d: 14269731891.833355,
                adjusted_volume_7d: 14269731891.833355,
                reported_volume_30d: 17292772554.01669,
                adjusted_volume_30d: 17292772554.01669,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 30000,
        confidence_score: 0.000012,
    },
    {
        id: 'the-rock-trading',
        name: 'The Rock Trading',
        description: 'The Rock Trading is an European cryptocurrency exchange that has more than 5 years of experience in the sphere and applies transparent pricing policy. The company operating the Rock Trading brand and website is based in Italy. It started out back in 2007 as a Virtual Insurance Company, and 4 years later it launched Bitcoin trading. In July 2013 it was registered in Malta as a certified Limited Liability Company and later moved out to Italy.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/therocktrading',
            ],
            website: [
                'https://therocktrading.com',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 228,
        reported_rank: 242,
        currencies: 12,
        markets: 19,
        fiats: [
            {
                name: 'Euro',
                symbol: 'EUR',
            },
            {
                name: 'Pound Sterling',
                symbol: 'GBP',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 433830.0227639,
                adjusted_volume_24h: 433830.0227639,
                reported_volume_7d: 3601714.30593759,
                adjusted_volume_7d: 3601714.30593759,
                reported_volume_30d: 184356262.65644076,
                adjusted_volume_30d: 184356262.65644076,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 30000,
        confidence_score: 0.336403,
    },
    {
        id: 'ovis',
        name: 'Ovis',
        description: 'Ovis is a Turkish cryptocurrency exchange. Exchange launched in October 2017. This exchange offers a flat trading fee of 0.20%.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/oviscomtr',
            ],
            website: [
                'https://www.ovis.com.tr/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'credoex',
        name: 'CredoEx',
        description: null,
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/bitbounceio',
            ],
            website: [
                'https://credoex.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'crypto-hub',
        name: 'Crypto Hub',
        description: '',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/CheExchange',
            ],
            website: [
                'https://cryptohubexchange.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'etherdelta',
        name: 'EtherDelta',
        description: 'Etherdelta is the most popular decentralized exchange in the cryptocurrency market, and all of the coins are compliant with Ethereum token standard called ‘ERC20’. ',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://etherdelta.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 64758.71697091,
                adjusted_volume_7d: 64758.71697091,
                reported_volume_30d: 355406.71381745,
                adjusted_volume_30d: 355406.71381745,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 30000,
        confidence_score: 0,
    },
    {
        id: 'tarmex',
        name: 'Tarmex',
        description: 'Tarmex is a multi-functional platform for trading cryptocurrencies. We are providing an advanced order matching algorithm, a high-liquidity order book, and a rich variety of trading tools. Combining an intuitive interface and advanced trading possibilities, it will empower your trading and help you grow your portfolio.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/Tarmexio',
            ],
            website: [
                'https://tarmex.io',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 157,
        reported_rank: 171,
        currencies: 19,
        markets: 29,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 6039248.07002706,
                adjusted_volume_24h: 6039248.07002706,
                reported_volume_7d: 144177084.90981096,
                adjusted_volume_7d: 144177084.90981096,
                reported_volume_30d: 337603192.5855977,
                adjusted_volume_30d: 337603192.5855977,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 240000,
        confidence_score: 0.748455,
    },
    {
        id: 'probitex',
        name: 'ProBitEX',
        description: '',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/Probitex2',
            ],
            website: [
                'https://probitex.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 10000,
        confidence_score: 0,
    },
    {
        id: 'btcsquare',
        name: 'BTCsquare',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/btcsquarenet',
            ],
            website: [
                'https://www.btcsquare.net/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 307,
        reported_rank: 322,
        currencies: 13,
        markets: 12,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 118.75898451,
                adjusted_volume_24h: 118.75898451,
                reported_volume_7d: 924.15950691,
                adjusted_volume_7d: 924.15950691,
                reported_volume_30d: 2001.49504664,
                adjusted_volume_30d: 2001.49504664,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 660000,
        confidence_score: 0.150302,
    },
    {
        id: 'coinspot',
        name: 'CoinSpot',
        description: 'CoinSpot was founded in Melbourne in 2013 which allows trading against the AUD. They are a well known company, which is respected in the local Bitcoin community. CoinSpot is a member of ADCA - the Australian Digital Commerce Association. This may not be a regulatory body, but it shows a long term commitment to the adoption of blockchain technology. ',
        active: false,
        website_status: true,
        api_status: false,
        message: 'Exchange is not active',
        links: {
            website: [
                'https://www.coinspot.com.au',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 19100000,
        confidence_score: 0,
    },
    {
        id: 'polyx',
        name: 'Polyx',
        description: 'Polyx Exchange — buy, sell and store cryptocurrency, such as Bitcoin, Ethereum and much more\r\nPolyx is a platform that makes it easy to work with cryptocurrencies: a secure wallet for storage, an exchange for trading. Cryptoexchange Polyx is equipped with modern technologies that allow the exchange of crypto assets in the most productive way.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/Polyxchange',
            ],
            website: [
                'https://polyx.net/en/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 124,
        reported_rank: 136,
        currencies: 6,
        markets: 6,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 20438527.17652306,
                adjusted_volume_24h: 20438527.17652306,
                reported_volume_7d: 151878380.85240924,
                adjusted_volume_7d: 151878380.85240924,
                reported_volume_30d: 458534054.39209366,
                adjusted_volume_30d: 458534054.39209366,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 410000,
        confidence_score: 0.750166,
    },
    {
        id: 'sparkdex',
        name: 'Sparkdex',
        description: 'Sparkdex is Bitspark’s decentralised exchange, purpose-built for trading cryptocurrencies and local currency stablecoins. Trading decentralised is the safest way to trade crypto as you are in control of your own keys and funds. The most popular markets on the Sparkdex are BTC, ETH, BTS, ZEPH and stablecoins for USD, HKD, CNY, GBP, EUR, SGD, AUD, and PHP. Bitspark is focused on stablecoins beyond the US dollar and with every new stablecoin added to the system, new trading pairs are created that present unique trading opportunities you simply can’t find anywhere else.',
        active: false,
        website_status: false,
        api_status: false,
        message: 'Bitspark closed its doors as of 4 March 2020.',
        links: {
            twitter: [
                'https://twitter.com/sparkdexdotio',
            ],
            website: [
                'https://www.bitspark.io/sparkdex',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'veridex',
        name: 'Veridex',
        description: "Launched in Jul 2019, VeriDex is a decentralized exchange based in Brazil. Veridex describes itself as an open-source DEX that runs on 0x smart contracts and is connected to the 0x mesh network. Veridex provides multiple pairs against its native token Verisafe. Veridex is the main product offered as ''DEX as a service\" for token teams that want to deploy their own DEX.",
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://dex.verisafe.io/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'ampleswap',
        name: 'Ampleswap',
        description: 'The best AMM DEX on Binance Smart Chain (BSC) providing friendly trading and better project support',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://ampleswap.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 50000,
        confidence_score: 0,
    },
    {
        id: 'qbtc',
        name: 'QBTC',
        description: 'QBTC is a Chinese cryptocurrency exchange, which also accept international clients. Trading is then facilitated mainly with USD Tether and CNY Token.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://www.qbtc.ink/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'coinmex',
        name: 'CoinMex',
        description: 'CoinMex is an exchange registered in the Belize. The exchange is affiliated to the company NEWEX Technology Co. Ltd. It describes itself as a “full-featured digital asset trading platform for global users”. CoinMex’s core team comes from a number of different well-known companies, including Microsoft, IBM, Alibaba etc. The ambition of the exchange is to provide its user with a secure, stable and smooth digital asset exchange service.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/CoinMex_OS',
            ],
            website: [
                'https://www.coinmex.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'tokenjar',
        name: 'Tokenjar',
        description: 'Decentralized, transactions happening direct from wallet to wallet, with deposits. No KYC requirement.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/tokenjar_io',
            ],
            website: [
                'https://tokenjar.io',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'nocks',
        name: 'Nocks',
        description: 'Nocks was founded in 2015 by Roel Boer & Patrick Kivits. ',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/nocksapp',
            ],
            website: [
                'https://nocks.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'zaif',
        name: 'Zaif',
        description: 'Zaif exchange is one of the major Japanese cryptocurrency exchanges. It is owned by Tech Bureau, which last year secured a major investment from the Japanese forex brokerage Money Partners Group. Zaif offers trading both in cryptocurrency-for-cryptocurrency and cryptocurrency-for-fiat currencies. The fiat currency, naturally is JPY. ',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://zaif.jp',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 194,
        reported_rank: 208,
        currencies: 10,
        markets: 19,
        fiats: [
            {
                name: 'Japanese Yen',
                symbol: 'JPY',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 1780514.95935795,
                adjusted_volume_24h: 1780514.95935795,
                reported_volume_7d: 16125189.20153125,
                adjusted_volume_7d: 16125189.20153125,
                reported_volume_30d: 90763707.45670867,
                adjusted_volume_30d: 90763707.45670867,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 1600000,
        confidence_score: 0.740788,
    },
    {
        id: 'lintax',
        name: 'LINTAX',
        description: 'LINTAX is one of the fastest growing cryptocurrency derivatives exchange, with more than a lot of registered users. Built on customer-centric values, we endeavor to provide a professional, smart, intuitive and innovative trading experience to better serve our customers in a timely manner.\r\n\r\nWe have added Arbitrage Trading as an Added Feature for our Users, We are working to give a Debit Card to Withdraw funds from our Exchange, and we are also working to give other latest services to the People who are using our Services\r\n\r\nWe are committed to creating a fair, transparent and efficient trading environment, and offer 24/7 multi-language support as part of our service.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/LinTax_exchange',
            ],
            website: [
                'https://lin.tax/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'cross',
        name: 'CROSS',
        description: 'CROSS exchange is a cryptocurrency exchange operated and registered in Azerbaijan as of November 2018.  In addition to being able to make deposits, withdrawals, and host standard trading, CROSS exchange also has features such as trade mining, revenue sharing plans, affiliate partnerships, margin trading (coming soon) and conducting IEOs.  We are heavily invested in security and put our customers first when making decisions for the exchange.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/exchange_cross',
            ],
            website: [
                'https://www.crossexchange.io/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 10000,
        confidence_score: 0,
    },
    {
        id: 'bigone',
        name: 'BigONE',
        description: 'BigONE is a coin-to-coin exchange where users can trade in Bitcoin, Ethereum, Litecoin, and other digital assets. The trading platform launched in November 2017. The CEO is Eric Meltzer. Majority of visitors to the BigONE site are from China, followed by Japan, the United States, Hong Kong and Vietnam.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/BigONEexchange',
            ],
            website: [
                'https://big.one/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 30,
        reported_rank: 36,
        currencies: 51,
        markets: 71,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 644961054.2530296,
                adjusted_volume_24h: 644961054.2530296,
                reported_volume_7d: 4829527257.143138,
                adjusted_volume_7d: 4829527257.143138,
                reported_volume_30d: 23077550487.94158,
                adjusted_volume_30d: 23077550487.94158,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 12600000,
        confidence_score: 0.041224,
    },
    {
        id: 'polonidex',
        name: 'Poloni DEX',
        description: 'Poloni DEX team is originated from the TRON community, with its operational entity in the Caymans and its team at Malta. The project strictly abides by local laws and regulations. Poloni DEX team believes that the TRON network will become the most popularized operating system in the blockchain field, and as a result, decentralized exchanges based on the TRON network will play an irreplaceable part in providing the infrastructure for developers and users on the network and promoting the growth of the entire network.',
        active: true,
        website_status: false,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/PoloniDEX',
            ],
            website: [
                'https://poloniex.org/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 320,
        reported_rank: 335,
        currencies: 22,
        markets: 26,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 10.56716192,
                adjusted_volume_24h: 10.56716192,
                reported_volume_7d: 10.87076996,
                adjusted_volume_7d: 10.87076996,
                reported_volume_30d: 13.09214965,
                adjusted_volume_30d: 13.09214965,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 50000,
        confidence_score: 0,
    },
    {
        id: 'oodlebit',
        name: 'Oodlebit',
        description: "Oodlebit is a U.S. based business founded in 2018 by Nicholas Dooley. It's aiming to provide users with a fast, fair, and secure cryptocurrency exchange by utilizing the best technologies, the most talented people, and by continuously pursuing the input of the community.",
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://www.twitter.com/oodlebit',
            ],
            website: [
                'https://www.oodlebit.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'ixx',
        name: 'IXX',
        description: '',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/exchangeixx',
            ],
            website: [
                'https://ixx.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 10000,
        confidence_score: 0,
    },
    {
        id: 'ascendex',
        name: 'AscendEX (BitMax)',
        description: 'BitMax is – like many other exchanges – registered in Singapore. BitMax is a public chain where all the downstream and upstream economic systems hosted on its blockchain will be empowered to attain further expansion within the autonomous digital economy. BitMax launched an ICO in the second half of 2018. In the ICO, the presented time line detailed that the launch of the “exchange public chain” is to occur in April 2019.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://ascendex.com/?inviteCode=6GB5YHUV',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 72,
        reported_rank: 81,
        currencies: 134,
        markets: 163,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 93507269.50867908,
                adjusted_volume_24h: 93507269.50867908,
                reported_volume_7d: 676751762.1183022,
                adjusted_volume_7d: 676751762.1183022,
                reported_volume_30d: 2969281140.7399015,
                adjusted_volume_30d: 2969281140.7399015,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 7100000,
        confidence_score: 0.707946,
    },
    {
        id: 'exmo',
        name: 'Exmo',
        description: 'Exmo is a cryptocurrency exchange based in the UK and founded in 2013. According to its own site, for the company work developers from Spain, Russia, India and Thailand, in partnership with financial advisors from Great Britain, USA, Lithuania and Singapore.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/Exmo_com',
            ],
            website: [
                'https://exmo.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 88,
        reported_rank: 99,
        currencies: 36,
        markets: 129,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
            {
                name: 'Euro',
                symbol: 'EUR',
            },
            {
                name: 'Polish Zloty',
                symbol: 'PLN',
            },
            {
                name: 'Russian Ruble',
                symbol: 'RUB',
            },
            {
                name: 'Ukrainian Hryvnia',
                symbol: 'UAH',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 55829405.03485735,
                adjusted_volume_24h: 55829405.03485735,
                reported_volume_7d: 431677344.18372226,
                adjusted_volume_7d: 431677344.18372226,
                reported_volume_30d: 2049124369.367748,
                adjusted_volume_30d: 2049124369.367748,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 460000,
        confidence_score: 0.613949,
    },
    {
        id: 'velic',
        name: 'VELIC',
        description: 'VELIC is a security-focused crypto-finance platform, upon which a\r\nrange of advanced products and services are being built and delivered. Besides trading cryptocurrencies,  VELIC offers crypto collateralized loans and provides indexes to its customers.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/velicfinancial',
            ],
            website: [
                'https://www.velic.io/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 347,
        reported_rank: 347,
        currencies: 13,
        markets: 17,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 131.03602167,
                adjusted_volume_7d: 131.03602167,
                reported_volume_30d: 473.97467114,
                adjusted_volume_30d: 473.97467114,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'btrade',
        name: 'Btrade',
        description: '',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://www.btrade.co.kr/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: '1inch-liquidity-protocol',
        name: '1inch Liquidity Protocol',
        description: '',
        active: true,
        website_status: false,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://app.1inch.io/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 276,
        reported_rank: 291,
        currencies: 4,
        markets: 4,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 9386.81115908,
                adjusted_volume_24h: 9386.81115908,
                reported_volume_7d: 489540.61587728,
                adjusted_volume_7d: 489540.61587728,
                reported_volume_30d: 1309467.15170766,
                adjusted_volume_30d: 1309467.15170766,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 7450000,
        confidence_score: 0,
    },
    {
        id: 'coinpulse',
        name: 'Coinpulse',
        description: 'CoinPulse cryptocurrency exchange platform is based in Panama. CoinPulse describes itself as a “global digital currency trading platform".',
        active: true,
        website_status: false,
        api_status: false,
        message: 'Coinpulse suspended their operation <a href="https://medium.com/@CoinPulse/coinpulse-urgent-notice-exchange-headed-for-indefinite-maintenance-a4944fb269a" target="_blank">Medium Article</a>',
        links: {
            twitter: [
                'https://twitter.com/coinpulseex',
            ],
            website: [
                'https://www.coinpulse.io/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'tokenmom',
        name: 'Tokenmom',
        description: 'Tokenmom, a free decentralized crypto exchange created in 2018, aims to be a leader and innovator in its market.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/Token_Mom',
            ],
            website: [
                'https://www.tokenmom.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'coinone-swap',
        name: 'CoinOne Swap',
        description: 'CoinOne is a sublime and exceptional platform with numerous functions such as: swap, lottery, prediction, Lending, financial news, wallet, NFT, game, perpetual contract, etc., the perfect choice for every investor.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/coinoneswap',
            ],
            website: [
                'http://coinone.fi/swap',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'wex',
        name: 'WEX',
        description: '',
        active: false,
        website_status: false,
        api_status: false,
        message: 'WEX was a Russian exchange, which has probably exit-scammed.',
        links: {
            twitter: [
                'https://twitter.com/WEXnz',
            ],
            website: [
                'https://wex.nz/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'coindeal',
        name: 'CoinDeal',
        description: 'CoinDeal is a crypto exchange platform propelled in March 2018. The team behind the project consists of experienced crypto aficionados that have been dynamic in the blockchain and cryptocurrency industry for quite a long time. The main center is involved the Adam Bicz, Filip Dzierzak, and Kajetan Maćkowiak.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/coindealcom',
            ],
            website: [
                'https://coindeal.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 100,
        reported_rank: 112,
        currencies: 22,
        markets: 22,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 38177426.95642649,
                adjusted_volume_24h: 38177426.95642649,
                reported_volume_7d: 303964681.0299298,
                adjusted_volume_7d: 303964681.0299298,
                reported_volume_30d: 1382071323.8887522,
                adjusted_volume_30d: 1382071323.8887522,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 50000,
        confidence_score: 0.000671,
    },
    {
        id: 'ostable',
        name: 'Ostable',
        description: 'Ostable is a decentralized protocol for minting, redeeming, and creating stablecoins pegged to various assets. All trading happens on a two-dimensional bonding curve and is facilitated by Autonomous Agents running on Obyte network. The protocol allows to issue stablecoins that have interest baked-in by targeting a benchmark price plus interest -- stable+ coins.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://ostable.org',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 10000,
        confidence_score: 0,
    },
    {
        id: 'coinbit',
        name: 'Coinbit',
        description: null,
        active: false,
        website_status: true,
        api_status: false,
        message: 'Exchange is not active',
        links: {
            twitter: [
                'https://twitter.com/coinbit_coinbit',
            ],
            website: [
                'https://www.coinbit.co.kr/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'stakecube',
        name: 'StakeCube',
        description: 'Exchange, Earn, Deploy, Learn and Play at your one-stop Crypto ecosystem! Community driven Exchange and Pool. Earn rewards while you trade with PoS and Interest rewards with reduced fees and bonuses by holding the native coin SCC.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/stakecube',
            ],
            website: [
                'https://stakecube.net/app/exchange/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 255,
        reported_rank: 270,
        currencies: 28,
        markets: 92,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 87898.45634644,
                adjusted_volume_24h: 87898.45634644,
                reported_volume_7d: 542594.23890472,
                adjusted_volume_7d: 542594.23890472,
                reported_volume_30d: 2009877.08255136,
                adjusted_volume_30d: 2009877.08255136,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 2790000,
        confidence_score: 0.124815,
    },
    {
        id: 'morcrypto',
        name: 'MorCrypto',
        description: 'MorCrypto claims to be a platform that aims at bridging the crypto market gap between Africa and the rest of the world.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://morcrypto-exchange.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'bithumb',
        name: 'Bithumb',
        description: 'Bithumb is operated by a company called BTC Korea.com Co. Ltd. It was founded in 2013. Company is headquartered in Seoul, South Korea.',
        active: true,
        website_status: true,
        api_status: true,
        message: "Bithumb suffered security breach - <a href='https://www.coindesk.com/crypto-exchange-bithumb-hacked-for-13-million-in-suspected-insider-job' target='_blank'>read more about it</a>",
        links: {
            twitter: [
                'https://twitter.com/BithumbOfficial',
            ],
            website: [
                'https://www.bithumb.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 40,
        reported_rank: 47,
        currencies: 92,
        markets: 117,
        fiats: [
            {
                name: 'South Korea Won',
                symbol: 'KRW',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 450295502.18142927,
                adjusted_volume_24h: 450295502.18142927,
                reported_volume_7d: 3140038764.95615,
                adjusted_volume_7d: 3140038764.95615,
                reported_volume_30d: 18083596112.310436,
                adjusted_volume_30d: 18083596112.310436,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 20600000,
        confidence_score: 0.219973,
    },
    {
        id: 'deribit',
        name: 'Deribit',
        description: 'Deribit is live since June 2016 after several years of development. John Jansen, the original founder teamed up with Marius Jansen, Sebastian Smyczýnski and Andrew Yanovsky. Deribit started as a Bitcoin Futures and Options trading platform going live in the summer of 2016.\r\n\r\nDeribit has been created as an answer to those in search of a professional fully dedicated cryptocurrencies futures and options trading platform. A service that can create a fully liquid marketplace with the same standards as a traditional derivatives market.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/DeribitExchange',
            ],
            website: [
                'https://www.deribit.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 558784566,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 2200000,
        confidence_score: 0,
    },
    {
        id: 'cryptobulls',
        name: 'Cryptobulls',
        description: 'Cryptobulls Exchange enables its users to securely purchase & exchange crypto currencies for Crypto currencies without intermediaries. CBXE coin is Cryptobulls Coin, which makes each CBXE holder a partner of the Global Exchange.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/crypto_bulls',
            ],
            website: [
                'https://www.cryptobulls.exchange/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'coiny',
        name: 'Coiny',
        description: "We are Coiny, a Turkey-based cryptocurrency exchange. We've been giving secure and trustworthy exchange services for more than a year now, and we want people to find us easier.",
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/procoiny',
            ],
            website: [
                'https://pro.coiny.io/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'coinrate',
        name: 'Coinrate',
        description: 'COINRATE LTD is the UK-based company, which stands behind this exchange. Exchange supports Bitcoin and Fargocoin and fiat currencies: USD and EUR',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://coinrate.net/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'ionomy-exchange',
        name: 'Ionomy Exchange',
        description: 'Launched in Oct 2018, Ionomy is a centralized exchange registered in Seychelles. It features major cryptocurrencies, masternode coins, and permissionless gaming tokens built on the ION blockchain. Ionomy Exchange integrates with HaasBot automated trading tools.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://www.twitter.com/ionomics',
            ],
            website: [
                'https://ionomy.com',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 275,
        reported_rank: 290,
        currencies: 17,
        markets: 42,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 9814.83966694,
                adjusted_volume_24h: 9814.83966694,
                reported_volume_7d: 98303.94566168,
                adjusted_volume_7d: 98303.94566168,
                reported_volume_30d: 425746.72019737,
                adjusted_volume_30d: 425746.72019737,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 60000,
        confidence_score: 0,
    },
    {
        id: 'bolddax',
        name: 'Bolddax',
        description: 'Bolddax is an exchange that is backed with excellence. Managed by team of experienced crypto traders with simple user interface for a new bee in the crypto sphere.\r\n\r\n',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/BolddaxE?s=08',
            ],
            website: [
                'http://trade.bolddax.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'coinfloor',
        name: 'Coinfloor',
        description: 'Coinfloor is a bitcoin exchange service found online at Coinfloor.co.uk. The service promises to make it easy to buy bitcoins in minutes. In October 2013 the company announced raising an undisclosed amount of venture capital funding from Passion Capital and Taavet Hinrikus.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/coinfloor',
            ],
            website: [
                'https://coinfloor.co.uk/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'aofex',
        name: 'AOFEX',
        description: 'AOFEX, based in London of the United Kingdom, is a global leading exchange of digital financial derivatives. We provide 24-hour services for 1.46 million users. As one of top 15 crypto exchanges around the world, we have more than 100,000 daily active users and 300+ trading pairs. The daily average trading volume is 15,000,000,000, and the daily average liquidity is 244. Until now, we have obtained MSB license and we have been listed on CMC. Users can find us on Google Play, iOS App Store and HUAWEI AppGallery Connect.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://www.aofex.app/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'nanex',
        name: 'Nanex',
        description: 'Launched in January 2018, Nanex is the premier trading platform for Nano coin and provides crypto-crypto trading service. The Nanex website does not provide any information about the company operating the exchange, its location, nor the manner in which the clients’ assets are stored. In addition, it provides an online wallet where you can keep and transact the coins supported by the exchange, and also uses one of the most effective measures against coin theft - Two-factor authentication (2FA).',
        active: true,
        website_status: false,
        api_status: false,
        message: "Nanex is shutting down April 30th.\n\n<a href='https://medium.com/@nanex/nanex-is-shutting-down-april-30th-9b3f48d52b7f' target='_blank'>Read more</a>",
        links: {
            twitter: [
                'https://twitter.com/nanex_co',
            ],
            website: [
                'https://nanex.co/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'bingx',
        name: 'BingX',
        description: 'Bingbon is a fintech company dedicated to making crypto derivatives market available and accessible to the world and enabling all participants from all walks of life to invest in a simple and transparent way. Established in 2018, Bingbon allows users to trade contracts of Cryptocurrencies, Global Indices, Forex, and Commodities for long and short positions. Bingbon is also the first crypto derivatives exchange to offer copy trading feature for users.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://bingbon.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 344,
        reported_rank: 13,
        currencies: 14,
        markets: 13,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 1970349244.8086047,
                adjusted_volume_24h: 0,
                reported_volume_7d: 15838053704.301208,
                adjusted_volume_7d: 0,
                reported_volume_30d: 91669803712.99554,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 30000,
        confidence_score: 0.050012,
    },
    {
        id: 'bitmarket',
        name: 'BitMarket',
        description: "BitMarket is an European exchange that offers both fiat-to-crypto and crypto-to-crypto trading. Its transaction fees depend on the type of transaction, as well as on the user's trading volume. It also offers leveraged trading and swaps contracts - investments with steady income by providing liquidity to investors trading on margin. It has been in business since 2015.",
        active: false,
        website_status: false,
        api_status: false,
        message: 'Information from the exchange: We regret to inform you that due to the loss of liquidity, since 08/07/2019, Bitmarket.pl/net was forced to cease its operations. We will inform you about further steps.',
        links: {
            website: [
                'https://www.bitmarket.net/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'koinbazar',
        name: 'Koinbazar',
        description: 'Launched in Sep 2020, Koinbazar is a centralized exchange registered in India.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://www.koinbazar.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 108,
        reported_rank: 120,
        currencies: 15,
        markets: 20,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 29559351.3521949,
                adjusted_volume_24h: 29559351.3521949,
                reported_volume_7d: 178879535.17287046,
                adjusted_volume_7d: 178879535.17287046,
                reported_volume_30d: 721816888.2802796,
                adjusted_volume_30d: 721816888.2802796,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 1130000,
        confidence_score: 0.750411,
    },
    {
        id: 'dach-exchange',
        name: 'Dach Exchange',
        description: 'Dach Exchange platform is a cryptocurrency exchange where traders can trade various cryptocurrencies listed on Dach Exchange.\r\nSecurity, reliability and innovation are highly valuated on Dach Exchange.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/dachcoin',
            ],
            website: [
                'https://dach.exchange/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'coinbene',
        name: 'Coinbene',
        description: 'CoinBene is open to users around the world and offers several different languages, making it possible for most people to use the website in a language that they are fluent in. The address for CoinBene is located in Singapore at 1 Coleman St., The Adelphi.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/coinbene',
            ],
            website: [
                'https://www.coinbene.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 30000,
        confidence_score: 0,
    },
    {
        id: 'purcow',
        name: 'PurCow',
        description: '',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/purcow',
            ],
            website: [
                'https://www.purcow.io/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'exchangeassets',
        name: 'ExchangeAssets',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://exchange-assets.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 301,
        reported_rank: 316,
        currencies: 35,
        markets: 56,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 206.68055644,
                adjusted_volume_24h: 206.68055644,
                reported_volume_7d: 3394.07813157,
                adjusted_volume_7d: 3394.07813157,
                reported_volume_30d: 26539.88581399,
                adjusted_volume_30d: 26539.88581399,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 420000,
        confidence_score: 0.095982,
    },
    {
        id: 'bittylicious',
        name: 'Bittylicious',
        description: 'Bittylicious is a UK-based cryptocurrency cantor and exchange, which supports more than 11 cryptocurrencies.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://bittylicious.com',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 266,
        reported_rank: 281,
        currencies: 6,
        markets: 8,
        fiats: [
            {
                name: 'Euro',
                symbol: 'EUR',
            },
            {
                name: 'Pound Sterling',
                symbol: 'GBP',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 34311.3682148,
                adjusted_volume_24h: 34311.3682148,
                reported_volume_7d: 327354.9977789,
                adjusted_volume_7d: 327354.9977789,
                reported_volume_30d: 1940448.81094369,
                adjusted_volume_30d: 1940448.81094369,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 10000,
        confidence_score: 0,
    },
    {
        id: 'sushiswap-polygon-network',
        name: 'SushiSwap (Polygon Network)',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://sushi.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 159,
        reported_rank: 173,
        currencies: 46,
        markets: 99,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 5840524.00378949,
                adjusted_volume_24h: 5840524.00378949,
                reported_volume_7d: 38687453.33483588,
                adjusted_volume_7d: 38687453.33483588,
                reported_volume_30d: 130350035.87403056,
                adjusted_volume_30d: 130350035.87403056,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 9520000,
        confidence_score: 0.003846,
    },
    {
        id: 'hadesswap',
        name: 'HadesSwap',
        description: 'Hades Swap is an automated market-making (AMM) decentralized exchange (DEX) in the Olympus Network.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/HadesSwap',
            ],
            website: [
                'https://hadeswap.finance/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'vbtc',
        name: 'VBTC',
        description: 'VBTC is an entry-level Vietnamese cryptocurrency exchange. This means the company allows locals to exchange their Dongs (VND) into Bitcoin. The project is based on the BLINKTRADE platform, which is utilized by similar companies in Brazil, Chile and Venezuela. ',
        active: false,
        website_status: true,
        api_status: false,
        message: 'Exchange is not active',
        links: {
            website: [
                'https://vbtc.exchange',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'chaoex',
        name: 'ChaoEX',
        description: 'ChaoEX is a Hong Kong based exchange with a focus on Southeast Asian Markets. It offers low-cost trading in wide range of digital currencies. Fiat currencies, like the Chinese Yuan and the US dollar are not accepted at ChaoEX.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/ChaoExHK',
            ],
            website: [
                'https://www.chaoex.com/',
                'https://www.chaoex.io',
                'https://www.chaoex.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'stex',
        name: 'STEX',
        description: 'Launched in September 2017, STEX is a centralized, licensed exchange located in Tallinn, Estonia. It has 3 types of verification that allow users to reduce trading fees by up to 0.05%. It supports crypto-to-crypto and fiat-to-crypto trading with no withdrawal limits.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/stexExchangeR',
            ],
            website: [
                'https://www.stex.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 126,
        reported_rank: 139,
        currencies: 162,
        markets: 211,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 16115901.95015434,
                adjusted_volume_24h: 16115901.95015434,
                reported_volume_7d: 126759978.83470583,
                adjusted_volume_7d: 126759978.83470583,
                reported_volume_30d: 535845020.3090868,
                adjusted_volume_30d: 535845020.3090868,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 770000,
        confidence_score: 0.007779,
    },
    {
        id: 'coinex',
        name: 'CoinEx',
        description: 'Founded in December 2017 with its headquarters in Hong Kong, CoinEx offers low-cost coin-to-coin trading in wide range of cryptocurrencies. CoinEx supports the most popular digital assets, such as Bitcoin, Ethereum, Litecoin, Bitcoin Cash, and several other coins (Bytom, Bitcoin Candy).',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/coinexcom',
            ],
            website: [
                'https://www.coinex.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 91,
        reported_rank: 102,
        currencies: 141,
        markets: 306,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 51456887.89770713,
                adjusted_volume_24h: 51456887.89770713,
                reported_volume_7d: 298505830.56024945,
                adjusted_volume_7d: 298505830.56024945,
                reported_volume_30d: 1478900067.4012306,
                adjusted_volume_30d: 1478900067.4012306,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 16600000,
        confidence_score: 0.650409,
    },
    {
        id: 'cryptaldash',
        name: 'CryptalDash',
        description: 'CryptalDash is an online trading platform that promises to grant a trader access to the largest selection of cryptocurrencies around the world – in one place. CryptalDash is one of the newest exchanges from Ukraine, launched in July 2018. This exchange supports trading in the following cryptocurrencies: Bitcoin, Ethereum, USDT, Dimcoin and the exchange’s own token CryptalDash.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/cryptaldash',
            ],
            website: [
                'https://www.cryptaldash.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 40000,
        confidence_score: 0,
    },
    {
        id: 'chilebit',
        name: 'ChileBit',
        description: 'As its name suggests, ChileBit is a cryptocurrency exchange, operating in Chile, which focuses on the local market. It is a service which simply allows its clients to buy or sell Bitcoin for the local currency, Chilean Pesos (CLP).',
        active: false,
        website_status: true,
        api_status: false,
        message: 'Exchange is not active',
        links: {
            website: [
                'https://chilebit.net',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'bittrex',
        name: 'Bittrex',
        description: 'Bittrex was started in 2014 by Co-Founder and CEO Bill Shihara, who drew on his experience as a security engineer at Amazon and Blackberry when creating the exchange. Bittrex currently lists hundreds of coins and also offers users hundreds of cryptocurrency trading pairs.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/BittrexExchange',
            ],
            website: [
                'https://bittrex.com',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 101,
        reported_rank: 113,
        currencies: 345,
        markets: 712,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
            {
                name: 'Euro',
                symbol: 'EUR',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 37039029.29465508,
                adjusted_volume_24h: 37039029.29465508,
                reported_volume_7d: 288047598.37198496,
                adjusted_volume_7d: 288047598.37198496,
                reported_volume_30d: 1512396491.5951045,
                adjusted_volume_30d: 1512396491.5951045,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 8090000,
        confidence_score: 0.689839,
    },
    {
        id: 'timex',
        name: 'TimeX',
        description: 'TimeX, a Plasma-based hybrid cryptocurrency exchange, combines the speed and privacy of a centralised system with the security and transparency of a decentralised solution.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/ExchangeTimex',
            ],
            website: [
                'https://timex.io',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 162,
        reported_rank: 176,
        currencies: 8,
        markets: 11,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 4889395.34236702,
                adjusted_volume_24h: 4889395.34236702,
                reported_volume_7d: 37068500.22477932,
                adjusted_volume_7d: 37068500.22477932,
                reported_volume_30d: 324230403.0303853,
                adjusted_volume_30d: 324230403.0303853,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 230000,
        confidence_score: 0.723811,
    },
    {
        id: 'sbit500',
        name: 'SBIT500',
        description: 'SBIT500 is an investment platform for increasing income using algorithmic strategies of best traders.\r\nOur mission is to reduce cryptocurrency investment risks to generate passive income.\r\nCreated in 2019, SBIT500 started operating on the principle of a private hedge fund. Since 2021 the company has opened access to the platform for private investors.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/sbit500',
            ],
            website: [
                'https://sbit500.pro/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 358,
        reported_rank: 358,
        currencies: 9,
        markets: 10,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'tidebit',
        name: 'Tidebit',
        description: 'TideBit is a Hong Kong-based crypto exchange, where users from certain countries (Hong Kong, China, Taiwan) can buy or sell Bitcoin, Ethereum and Antshares against Hong Kong or US dollars.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            website: [
                'https://www.tidebit.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 245,
        reported_rank: 260,
        currencies: 9,
        markets: 13,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
            {
                name: 'Hong Kong Dollar',
                symbol: 'HKD',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 142157.69334736,
                adjusted_volume_24h: 142157.69334736,
                reported_volume_7d: 965607.49395802,
                adjusted_volume_7d: 965607.49395802,
                reported_volume_30d: 6367097.58853713,
                adjusted_volume_30d: 6367097.58853713,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 110000,
        confidence_score: 0.193468,
    },
    {
        id: '1inch',
        name: '1inch',
        description: 'Launched in Mar 2019, 1inch is a DeFi aggregator and a decentralized exchange with smart routing. The core protocol connects a large number of decentralized and centralized platforms in order to minimize price slippage and find the optimal trade for the users. 1inch platform provides a variety of features in addition to swaps. Users can trade via limit orders, move coins between different liquidity pools, and this list expands constantly.',
        active: true,
        website_status: false,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/1inchNetwork',
            ],
            website: [
                'https://app.1inch.io/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 181,
        reported_rank: 195,
        currencies: 15,
        markets: 31,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 2998373.79012111,
                adjusted_volume_24h: 2998373.79012111,
                reported_volume_7d: 27066149.11364296,
                adjusted_volume_7d: 27066149.11364296,
                reported_volume_30d: 150867497.45493135,
                adjusted_volume_30d: 150867497.45493135,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 7450000,
        confidence_score: 0.003009,
    },
    {
        id: 'blockchain-financial',
        name: 'Blockchain Financial',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/BCFinancialNews?s=09',
            ],
            website: [
                'https://blockchainfinancial.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 288,
        reported_rank: 303,
        currencies: 5,
        markets: 6,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 2381.44819881,
                adjusted_volume_24h: 2381.44819881,
                reported_volume_7d: 8137.86048681,
                adjusted_volume_7d: 8137.86048681,
                reported_volume_30d: 61756.95581588,
                adjusted_volume_30d: 61756.95581588,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 30000,
        confidence_score: 0,
    },
    {
        id: 'zebitex',
        name: 'ZEBITEX',
        description: 'Located in France, Digital Service is offering crypto-currency services since 2014. More than 95% of cryptocurrencies from ZEBITEX are stored on Ledger Vault.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/ZEBITEX',
            ],
            website: [
                'https://zebitex.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 250,
        reported_rank: 265,
        currencies: 25,
        markets: 67,
        fiats: [
            {
                name: 'Euro',
                symbol: 'EUR',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 108736.40523344,
                adjusted_volume_24h: 108736.40523344,
                reported_volume_7d: 815502.68666261,
                adjusted_volume_7d: 815502.68666261,
                reported_volume_30d: 3382079.56930968,
                adjusted_volume_30d: 3382079.56930968,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 20000,
        confidence_score: 0,
    },
    {
        id: 'coindelta',
        name: 'Coindelta',
        description: 'Coindelta is an Indian cryptocurrency exchange that offers trading in some of the most popular cryptocurrencies against the local currency (INR). Coin-to-coin trading is also available. It was founded by Rajdeep Singh and the entity is called Bitfair Technologies Private Limited.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/coindelta_',
            ],
            website: [
                'https://coindelta.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'richamster',
        name: 'Richamster',
        description: 'We are a team of crypto enthusiasts. Our goal is to create great tool that is convenient to use by. The main part of our team is inspired by the work of the community and we want its widest use in the real economy.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/Richamster_com',
            ],
            website: [
                'https://richamster.com',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 289,
        reported_rank: 304,
        currencies: 21,
        markets: 56,
        fiats: [
            {
                name: 'Ukrainian Hryvnia',
                symbol: 'UAH',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 2269.02810455,
                adjusted_volume_24h: 2269.02810455,
                reported_volume_7d: 11739.22047308,
                adjusted_volume_7d: 11739.22047308,
                reported_volume_30d: 48108.32287709,
                adjusted_volume_30d: 48108.32287709,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 440000,
        confidence_score: 0,
    },
    {
        id: 'cryptoa',
        name: 'Cryptoa',
        description: 'Cryptoa Exchange is a complete packaged solution and a financial product which aims to empower crypto investors to take the lead of their account on their own. Based on DEX model and offering all benefits of a CEX model as well, Cryptoa charges only 0.1% on all transactions (interexchange and withdrawal). To emphasize more, this is the lowest any exchange is charging currently in crypto space.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/CryptoaExchange',
            ],
            website: [
                'https://www.cryptoa.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'tychexchange',
        name: 'TychExchange',
        description: "TychExchange is an Estonia based exchange targeting mainly EU customers.  It claims to be also the first exchange to do many things.  We have a 100% clearing and settlement based system for all deposits, withdrawals and trades, like traditional stocks markets have.  TychExchange also has 100% cold storage wallets (the client's deposits are also direct to cold storage only).  Even with the 100% cold storage, clients’ deposits are still instant in their accounts using our proprietary system.  Most importantly, though everyone claims to be secure, TychExchange claims that it has developed a system where they worked on being \"hack irrelevant\" rather than being hack resistant. In short, their system is claimed to be built in a way where client's funds and private data are secure even if the whole system is hacked.",
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/TycheExchange',
            ],
            website: [
                'https://tyche.exchange/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 169,
        reported_rank: 183,
        currencies: 7,
        markets: 10,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 4122977.76717429,
                adjusted_volume_24h: 4122977.76717429,
                reported_volume_7d: 51175264.2010857,
                adjusted_volume_7d: 51175264.2010857,
                reported_volume_30d: 275943442.123904,
                adjusted_volume_30d: 275943442.123904,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0.528717,
    },
    {
        id: 'coinrail',
        name: 'Coinrail',
        description: 'CoinRail is a platform that allows for exchanges between various cryptocurrencies at a fair rate. The exchange provides a variety of services which registered users can get to enjoy. Coin Rail basically provides a platform to transact virtual currencies at an agreed price. With a strict policy on privacy and security, the platform has attracted many users.',
        active: false,
        website_status: false,
        api_status: false,
        message: 'Exchange is not active',
        links: {
            twitter: [
                'https://twitter.com/coinrail_korea',
            ],
            website: [
                'https://coinrail.co.kr',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'ethex',
        name: 'Ethex',
        description: null,
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/ethexmarket',
            ],
            website: [
                'https://ethex.market/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'paycml',
        name: 'PayCml',
        description: '',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            website: [
                'https://www.paycml.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'bitstamp',
        name: 'Bitstamp',
        description: 'Bitstamp is a bitcoin exchange based in London. It allows trading between USD currency and bitcoin cryptocurrency. It allows USD, EUR, bitcoin, litecoin, ethereum, ripple or bitcoin cash deposits and withdrawals.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/Bitstamp',
            ],
            website: [
                'https://www.bitstamp.net',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 59,
        reported_rank: 67,
        currencies: 34,
        markets: 88,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
            {
                name: 'Euro',
                symbol: 'EUR',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 165518904.8983618,
                adjusted_volume_24h: 165518904.8983618,
                reported_volume_7d: 1358824629.7246282,
                adjusted_volume_7d: 1358824629.7246282,
                reported_volume_30d: 6457704178.041918,
                adjusted_volume_30d: 6457704178.041918,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 3250000,
        confidence_score: 0.801313,
    },
    {
        id: 'bitcointoyou',
        name: 'BitcoinToYou',
        description: 'BitcoinToYou is an exchange based in Brazil. Started in 2010, BitcoinToYou has approximately on boarded 1,50,000 customers on its platforms. Being almost 8 years in the industry, it has established a great trust with its customers.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/bitcointoyou',
            ],
            website: [
                'https://www.bitcointoyou.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'novaexchange',
        name: 'Novaexchange',
        description: 'Nova Exchange operates out of Sweden, which is located within the European Union. Our customers can trade in over 300 different digital assets. We are dedicated people that cover all the worlds time-zones, thus setting a high standard within the crypto world.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'On Monday, October 7, trading on Nova Exchange will cease and close. At the same time the Nova API will be deactivated.',
        links: {
            twitter: [
                'https://twitter.com/nova_exchange',
            ],
            website: [
                'https://novaexchange.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'cointradecx',
        name: 'Cointradecx',
        description: 'In order to attain strategic advantage in the market, Cointradecx has implemented state of the art technology for maximum security and customer satisfaction. This includes running their own blockchain nodes infrastructure, which allows provide great response and up time and improve the commitment to their users security. Cointradecx has also organically grown their social media presence, particularly Instagram and Telegram, bringing users closer to the exchange. And considering that Cointradecx is based in Uruguay, they can offer advantages in regards to privacy for the crypto-community based in most of regulated jurisdictions with the advantages of an improved cryptocurrency regulation.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/cointradeCTX',
            ],
            website: [
                'https://cointradecx.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 305,
        reported_rank: 320,
        currencies: 8,
        markets: 8,
        fiats: [
            {
                name: 'Brazil Real',
                symbol: 'BRL',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 146.89932487,
                adjusted_volume_24h: 146.89932487,
                reported_volume_7d: 5128.53020479,
                adjusted_volume_7d: 5128.53020479,
                reported_volume_30d: 14190.1770634,
                adjusted_volume_30d: 14190.1770634,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'pionex',
        name: 'Pionex',
        description: 'Pionex is the exchange incubated by BitUniverse, which has been invested by top funds with 10M USD. The exchange was launched in June, and is one of the first exchanges which is focusing on quant trading and trading bots. There are 5 in-built trading bots, with which you can auto buy/sell the coins with very good liquidity.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/pionex_com',
            ],
            website: [
                'https://www.pionex.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 68,
        reported_rank: 77,
        currencies: 27,
        markets: 46,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 108386366.54627049,
                adjusted_volume_24h: 108386366.54627049,
                reported_volume_7d: 810926810.2960722,
                adjusted_volume_7d: 810926810.2960722,
                reported_volume_30d: 3475503314.421526,
                adjusted_volume_30d: 3475503314.421526,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 14500000,
        confidence_score: 0.650361,
    },
    {
        id: 'vitex',
        name: 'ViteX',
        description: 'ViteX is decentralized exchange running on the public chain - Vite. It allows mining ViteX coin (VX) in five different ways (trading, listing, making orders, referring, staking). VX holders share income from the DEX. ViteX has an operator concept, where operators can autonomously list coins, set trading fees and earn on these fees. Because of the open operator approach, many interesting altcoins not found in mainstream exchanges found their way into ViteX.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/ViteXExchange',
            ],
            website: [
                'https://vitex.net',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 253,
        reported_rank: 268,
        currencies: 14,
        markets: 16,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 93556.63836769,
                adjusted_volume_24h: 93556.63836769,
                reported_volume_7d: 560925.60683553,
                adjusted_volume_7d: 560925.60683553,
                reported_volume_30d: 3083157.93072243,
                adjusted_volume_30d: 3083157.93072243,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 20000,
        confidence_score: 0,
    },
    {
        id: 'smartfi',
        name: 'SmartFi',
        description: 'Smartfi is an open lending platform that provides lower interest rates and more cash for your loan because of our unique cryptocurrency monetary policy. This monetary policy results in less risk for our token because we can offer a 100% buyback guarantee for your original purchase price. The token is available on the SmartCycle and the SmartExchange.\r\n\r\nSmartPortal is designed for both new and experienced spot market cryptocurrency traders who trade for enhanced yield. Our users can also borrow against their cryptocurrency with a SmartLoan and earn interest with SmartInterest.\r\n\r\nOur SMTF token creates wealth by indexing its price to the amount of the SmartLoans on our platform.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/smartfiportal',
            ],
            website: [
                'https://portal.smartfi.com/trade',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 166,
        reported_rank: 180,
        currencies: 9,
        markets: 19,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 4237298.85890366,
                adjusted_volume_24h: 4237298.85890366,
                reported_volume_7d: 29570566.80317057,
                adjusted_volume_7d: 29570566.80317057,
                reported_volume_30d: 134581854.33832988,
                adjusted_volume_30d: 134581854.33832988,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 480000,
        confidence_score: 0.000194,
    },
    {
        id: 'simex',
        name: 'Simex',
        description: 'SIMEX is a Russian cryptocurrency exchange and equity investment platform registered in the US. It offers trading in Bitcoin, Ethereum, and several ERC-20 tokens and also supports USD & USDT. The SIMEX digital assets exchange offers investors a place to buy and sell investment shares, using a variety of methods to deposit and withdraw funds.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/simexinvest',
            ],
            website: [
                'https://simex.global',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 333,
        reported_rank: 342,
        currencies: 7,
        markets: 14,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 242154396.7874746,
                adjusted_volume_30d: 242154396.7874746,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'alphaex',
        name: 'AlphaEX',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/AlphaExNet',
            ],
            website: [
                'https://alphaex.net/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 337,
        reported_rank: 362,
        currencies: 7,
        markets: 10,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 100000,
        confidence_score: 0,
    },
    {
        id: 'covesting',
        name: 'Covesting',
        description: 'Covesting is a fully licensed digital asset exchange and trading platform, offering a variety of features for both beginners and professional traders.',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/covesting',
            ],
            website: [
                'https://covesting.io',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 83,
        reported_rank: 94,
        currencies: 13,
        markets: 17,
        fiats: [
            {
                name: 'US Dollars',
                symbol: 'USD',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 67660143.24456526,
                adjusted_volume_24h: 67660143.24456526,
                reported_volume_7d: 1255307314.570155,
                adjusted_volume_7d: 1255307314.570155,
                reported_volume_30d: 9900359842.17816,
                adjusted_volume_30d: 9900359842.17816,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0.05,
    },
    {
        id: 'thodex',
        name: 'Thodex',
        description: 'Thodex is a Turkish cryptocurrency exchange founded in 2017 The exchange is only available in the Turkish language. The only fiat currency that you can trade with is the Turkish Lire (TRY). ',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/thodexglobal',
            ],
            website: [
                'https://www.thodex.com/en',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'chainx',
        name: 'ChainX',
        description: null,
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/chainxofficial',
            ],
            website: [
                'https://chainx.kr/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'cryptomate',
        name: 'Cryptomate',
        description: 'Cryptomate.co.uk is a company, which provides a gateway into the world of cryptocurrencies for UK enthusiasts. The company is basically a peer-to-peer network, connecting buyers and sellers of cryptocurrencies. Cryptomate has set a daily limit of £100 for unverified clients. After submitting your details, this level will be increased to £1,000. These levels are set as an anti money laundering (AML) measure.',
        active: true,
        website_status: true,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/cryptomate',
            ],
            website: [
                'https://cryptomate.co.uk',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 10000,
        confidence_score: 0,
    },
    {
        id: 'buyucoin',
        name: 'BuyUcoin',
        description: '',
        active: true,
        website_status: true,
        api_status: true,
        message: null,
        links: {
            twitter: [
                'https://twitter.com/buyucoin',
            ],
            website: [
                'https://www.buyucoin.com/',
            ],
        },
        markets_data_fetched: true,
        adjusted_rank: 216,
        reported_rank: 230,
        currencies: 14,
        markets: 14,
        fiats: [
            {
                name: 'Indian Rupee',
                symbol: 'INR',
            },
        ],
        quotes: {
            USD: {
                reported_volume_24h: 774341.14961953,
                adjusted_volume_24h: 774341.14961953,
                reported_volume_7d: 4521503.63352759,
                adjusted_volume_7d: 4521503.63352759,
                reported_volume_30d: 19090942.31435332,
                adjusted_volume_30d: 19090942.31435332,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        sessions_per_month: 1690000,
        confidence_score: 0,
    },
    {
        id: 'lakebtc',
        name: 'LakeBTC',
        description: 'LakeBTC was founded in 2013, with Bitcoin being its main focus. Nowadays the company behind this exchange is known as Lake Banking Technology Company, which is also involved in other projects.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/LakeBTC',
            ],
            website: [
                'https://lakebtc.com/',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
    {
        id: 'vaultmex',
        name: 'VaultMex',
        description: 'VaultMex provides a wide range of cryptocurrencies to trade against other cryptocurrencies. We do not provide FIAT to Crypto exchange at the moment.\r\nWe offer a secure & user friendly online p2p environment to exchange cryptocurrencies at the best rates available!\r\nMinimum withdrawals fees are used to provide network transaction fee.',
        active: true,
        website_status: false,
        api_status: false,
        message: 'No current data',
        links: {
            twitter: [
                'https://twitter.com/vaultmex',
            ],
            website: [
                'https://vaultmex.com',
            ],
        },
        markets_data_fetched: false,
        adjusted_rank: null,
        reported_rank: null,
        currencies: 1,
        markets: 0,
        fiats: [],
        quotes: {
            USD: {
                reported_volume_24h: 0,
                adjusted_volume_24h: 0,
                reported_volume_7d: 0,
                adjusted_volume_7d: 0,
                reported_volume_30d: 0,
                adjusted_volume_30d: 0,
            },
        },
        last_updated: '2022-04-14T17:59:35Z',
        confidence_score: 0,
    },
];

export default exchangesobject;
